import React, { Component } from 'react';
import ModalCombinationSet from './ModalCombinationSet';
import backIcon from './images/backIcon.png';
import './styles/RMSResults.css';
import VersionService from './VersionService';
// import printIcon from './images/print_icon.png';
// import AWS from 'aws-sdk'

const l1Width = 15;

// const ses = new AWS.SES({
//     apiVersion: '2010-12-01',
//     accessKeyId: 'rms-aws-smtp-user',
//     "secretAccessKey": 'AKIAIJ3ESXFFVZMGHWBQ,AtbbVDSBWCisyk2gug8EcGIRWBueBX9ANa2NKoU+lwgc',
//     "region": "us-east-1",
// });

// const emailParams = {
//     Destination: { ToAddresses: [ 'rpalan@titanplussoftware.net' ] },
//     Message: {
//       Body: { Text: {
//         Data: 'Testing',
//         Charset: 'UTF-8' } },
//       Subject: { Data: 'Testing', Charset: 'UTF-8' }
//     },
//     ReplyToAddresses: ['rpalan@titanplussoftware.net'],
//     Source: 'rms-aws-smtp-user', // this has to be verified email in SES
// };

var styles = {
  wrapper: {
    margin: 'auto',
    paddingBottom: 20,
  },

  resultValueRow: {
    borderBottomWidth: 1,
    borderBottomColor: 'grey',
    borderBottomStyle: 'solid',
  },

  resultValueLabel: {
    display: 'block',
    float: 'left',
    fontWeight: 'bold',
  },

  resultValue: {
    display: 'block',
    float: 'right',
    fontWeight: '500',
    color: 'blue',
  },

  resultValueOffLabel: {
    display: 'block',
    float: 'right',
    fontWeight: '500',
    // color: 'red',
  },

  offLabel: {
    //backgroundColor: 'red',
    // color: 'red',
    // padding: 2,
    fontSize: '13px',
  },

  offLabel2: {
    //backgroundColor: 'red',
    // color: 'red',
    padding: 2,
    fontSize: '16px',
    fontWeight: 'bold',
  },

  insertLink: {
    fontSize: '13px',
  },

  offLabelDisclaimer: {
    color: 'black',
    // padding: 2,
    fontSize: '11px',
    position: 'relative',
    top: '-7px',
  },

  scrollView: {
    height: 120,
    flexDirection: 'row',
    padding: 10,
    marginBottom: 10,
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: l1Width,
    backgroundColor: 'white',
  },

  itemRowContainer: {
    paddingLeft: '7%',
  },

  tubingRowContainer: {
    margin: 'auto',
  },

  list: {
    backgroundColor: 'white',
  },

  g24_needleSetContainer: {
    height: 100,
    width: 150,
    borderColor: '#8F489C',
    borderWidth: 2,
    borderRadius: 10,
    marginRight: 10,
    marginBottom: 5,
    flexDirection: 'row',
    borderStyle: 'solid',
    backgroundColor: 'white',
    cursor: 'pointer',
  },

  g26_needleSetContainer: {
    height: 100,
    width: 150,
    borderColor: '#FBAF42',
    borderWidth: 2,
    borderRadius: 10,
    marginRight: 10,
    marginBottom: 5,
    flexDirection: 'row',
    borderStyle: 'solid',
    backgroundColor: 'white',
    cursor: 'pointer',
  },

  needleSetContainer: {
    height: 100,
    width: 150,
    borderColor: '#1896D0',
    borderWidth: 2,
    borderRadius: 10,
    marginRight: 10,
    marginBottom: 5,
    flexDirection: 'row',
    borderStyle: 'solid',
    backgroundColor: 'white',
    cursor: 'pointer',
  },

  tubingSetCol: {
    marginLeft: '7%',
    // backgroundColor: 'white',
    // opacity: '0.85',
    backgroundColor: 'rgba(255,255,255,0.55)',
    border: '1px solid darkgrey',
    borderRadius: 5,
    borderTop: 'none',
  },

  setDisplayTitle: {
    height: 40,
    //backgroundColor: "#dfdfdf",
    background: 'linear-gradient(to left,#6b80f1 0,#293dad 100%)',
    color: 'white',
    // paddingBottom:15,
    paddingTop: 7,
    // marginTop: 10,
    // marginBottom: 10,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    fontFamily: 'Rubik, sans-serif',
    fontSize: 18,
  },

  resultsTitle: {
    height: 60,
  },

  tubingSetContainer: {
    // height: 100,
    // // width: 100,
    // borderWidth: 2,
    // borderRadius: 10,
    // marginRight: 10,
    // flexDirection: "row",
    // borderStyle: "solid"
    height: 100,
    width: 150,
    borderColor: '#1896D0',
    borderWidth: 2,
    borderRadius: 10,
    marginRight: 10,
    marginBottom: 5,
    flexDirection: 'row',
    borderStyle: 'solid',
    cursor: 'pointer',
  },

  needleSetSizeTitle: {
    marginLeft: 2,
    color: 'white',
    fontSize: 11,
    fontWeight: '900',
  },

  g24_needleSetSizeTitleContainer: {
    backgroundColor: '#8F489C',
    width: 30,
    height: 20,
    left: -2,
    top: -2,
    alignItems: 'center',
    justifyContent: 'center',
    borderTopLeftRadius: 10,
    position: 'relative',
  },

  g26_needleSetSizeTitleContainer: {
    backgroundColor: '#FBAF42',
    width: 30,
    height: 20,
    left: -2,
    alignItems: 'center',
    justifyContent: 'center',
    borderTopLeftRadius: 10,
    position: 'relative',
  },

  needleSetSizeTitleContainer: {
    backgroundColor: '#1896D0',
    width: 40,
    height: 20,
    left: -2,
    top: -2,
    alignItems: 'center',
    justifyContent: 'center',
    borderTopLeftRadius: 10,
    position: 'relative',
  },

  needleSetTitle: {
    color: 'white',
    fontSize: 9,
    fontWeight: '900',
    textAlign: 'center',
    marginLeft: 5,
  },

  needleImage: {
    width: 50,
    height: 50,
    marginTop: -10,
    marginLeft: 25,
    resizeMode: 'contain',
  },

  tubingSetTitle: {
    color: 'white',
    fontSize: 10,
    fontWeight: '900',
  },

  tubingSetType: {
    fontSize: 22,
    color: 'black',
    fontWeight: 'bold',
  },

  tubingSetTypeContainer: {
    height: 80,
    textAlign: 'center',
    paddingTop: 10,
  },

  g24_needleSetTitleContainer: {
    backgroundColor: '#8F489C',
    alignItems: 'center',
    justifyContent: 'center',
    height: 30,
    width: 150,
    left: -2,
    top: -2,
    position: 'relative',
    marginTop: -10,
    borderColor: 'red',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
  },

  g26_needleSetTitleContainer: {
    backgroundColor: '#FBAF42',
    alignItems: 'center',
    justifyContent: 'center',
    height: 30,
    width: 150,
    left: -2,
    top: -2,
    position: 'relative',
    marginTop: -10,
    borderColor: 'red',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
  },

  needleSetTitleContainer: {
    backgroundColor: '#1896D0',
    alignItems: 'center',
    justifyContent: 'center',
    height: 30,
    width: 150,
    left: -2,
    top: -2,
    position: 'relative',
    marginTop: -10,
    borderColor: 'red',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
  },

  tubingSetTitleContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    height: 30,
    width: 148,
    // left: -2,
    marginTop: -10,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    position: 'relative',
    paddingLeft: 5,
  },

  rowContainer: {
    height: 40,
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    backgroundColor: 'white',
    borderBottomColor: 'rgb(230, 230, 230)',
    borderBottomWidth: StyleSheet.hairlineWidth,
  },

  headerSubtitle: {
    padding: 15,
  },

  rowTitle: {
    color: 'black',
  },

  rowResult: {
    alignSelf: 'flex-end',
    marginRight: 15,
    textAlign: 'right',
    color: '#2B3990',
    fontSize: 16,
  },

  lastRow: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#2B3990',
    marginBottom: 15,
  },

  backButton: {
    width: 45,
    height: 50,
  },

  exit: {
    width: 15,
    height: 15,
    marginLeft: 15,
    marginTop: 15,
    resizeMode: 'contain',
  },

  shareIcon: {
    width: 20,
    height: 20,
    resizeMode: 'contain',
    marginRight: 5,
    marginTop: -5,
  },

  progressBar: {
    height: 2,
    width: '(vw / 4) * 3',
    backgroundColor: '#2B3990',
    borderBottomRightRadius: 3,
    borderTopRightRadius: 3,
  },

  sendPatientButton: {
    color: 'white',
    fontSize: 20,
    marginTop: 20,
    height: 50,
    textAlign: 'center',
    paddingTop: 10,
    fontWeight: 500,
    backgroundColor: '#4AB848',
    // backgroundColor: 'rgb(43, 56, 144)',
    cursor: 'pointer',
  },

  referenceText: {
    marginTop: 20,
    fontStyle: 'italic',
    color: '#838383',
  },

  sendEmailButton: {
    color: 'white',
    fontSize: 20,
    marginTop: 20,
    height: 50,
    textAlign: 'center',
    paddingTop: 10,
    fontWeight: 500,
    backgroundColor: '#4AB848',
    // backgroundColor: 'rgb(43, 56, 144)',
    cursor: 'pointer',
  },

  resultsBlock: {
    margin: 'auto',
    marginTop: 30,
  },

  resultGrpHdr: {
    background: 'linear-gradient(to left,#bedf80 0,#94ba5e 100%)',
    color: 'white',
    /*border-radius: 5px;*/
    paddingLeft: '30px',
    marginBottom: '5px',
    marginTop: '15px',
    height: '30px',
  },

  resultGrpHdr24: {
    background: 'linear-gradient(to left,#d19ddb 0,#8f489c 100%)',
    color: 'white',
    /*border-radius: 5px;*/
    paddingLeft: '30px',
    marginBottom: '5px',
    marginTop: '15px',
    height: '30px',
  },

  resultGrpHdr26: {
    background: 'linear-gradient(to left,#ffd599 0,#FBAF42 100%)',
    color: 'white',
    /*border-radius: 5px;*/
    paddingLeft: '30px',
    marginBottom: '5px',
    marginTop: '15px',
    height: '30px',
  },

  resultGrpHdrS26: {
    background: 'linear-gradient(to left,#7BB5CE 0,#1896D0 100%)',
    color: 'white',
    /*border-radius: 5px;*/
    paddingLeft: '30px',
    marginBottom: '5px',
    marginTop: '15px',
    height: '30px',
  },

  resultCombination: {
    background: 'linear-gradient(to left,#99fca6 0,#3ab44a 100%)',
    color: 'white',
    /*border-radius: 5px;*/
    paddingLeft: '30px',
    marginBottom: '5px',
    marginTop: '15px',
    height: '30px',
  },

  resultHighFlow: {
    background: 'linear-gradient(to left,#f79b80 0,#f1592d 100%)',
    color: 'white',
    /*border-radius: 5px;*/
    paddingLeft: '30px',
    marginBottom: '5px',
    marginTop: '15px',
    height: '30px',
  },

  resultVeryHighFlow: {
    background: 'linear-gradient(to left,#d86872 0,#dd1f31 100%)',
    color: 'white',
    /*border-radius: 5px;*/
    paddingLeft: '30px',
    marginBottom: '5px',
    marginTop: '15px',
    height: '30px',
  },
};

class RMSResults extends Component {
  constructor(props) {
    super(props);

    const todData = [
      {
        drugId: 17,
        todValues: [
          {
            NeedleSet: 16,
            F500: '47m (28m-65m)',
            F600: '44m (26m-62m)',
            F900: '38m (22m-54m)',
            F1200: '37m (21m-52m)',
            F2400: '30m (16m-43m)',
          },
          {
            NeedleSet: 17,
            F500: '35m (22m-48m)',
            F600: '33m (20m-45m)',
            F900: '27m (16m-37m)',
            F1200: '25m (14m-36m)',
            F2400: '18m (10m-26m)',
          },
        ],
      },
    ];

    const frpsData = [
      {
        drugId: 12,
        syringeId: 1,
        flowValues: [
          {
            NeedleSet: 33,
            F30: { range: '2.0 - 4.3', max: false },
            F45: { range: '3.2 - 6.6', max: false },
            F60: { range: '4.2 - 8.5', max: false },
            F120: { range: '7.6 (4.4 - 10.7)', max: true },
            F180: { range: '9.8 (6.4 - 13.3)', max: true },
            F275: { range: '14.6 (9.2 - 20.0)', max: true },
            F420: { range: '21.6 (12.6 - 30.5)', max: true },
            F500: { range: '24.8 (16.1 - 33.4)', max: true },
            F600: { range: '28.8 (18.1 - 39.5)', max: true },
            F900: { range: '42.1 (26.4 - 57.8)', max: true },
            F1200: { range: '49.2 (28.8 - 69.5)', max: true },
            F2400: { range: '77.3 (44.2 - 110.3)', max: true },
          },
          {
            NeedleSet: 34,
            F30: { range: '1.0 - 2.2', max: false },
            F45: { range: '1.6 - 3.3', max: false },
            F60: { range: '2.1 - 4.3', max: false },
            F120: { range: '3.9 (2.3 - 5.5)', max: false },
            F180: { range: '5.1 (3.3 - 6.8)', max: false },
            F275: { range: '7.7 (4.9 - 10.5)', max: true },
            F420: { range: '11.5 (6.7 - 16.3)', max: true },
            F500: { range: '13.4 (8.8 - 18.0)', max: true },
            F600: { range: '15.8 (10.0 - 21.6)', max: true },
            F900: { range: '24.2 (15.3 - 33.1)', max: true },
            F1200: { range: '29.0 (16.9 - 41.0)', max: true },
            F2400: { range: '50.8 (28.8 - 72.8)', max: true },
          },
          {
            NeedleSet: 35,
            F30: { range: '0.7 - 1.4', max: false },
            F45: { range: '1.1 - 2.2', max: false },
            F60: { range: '1.4 - 2.9', max: false },
            F120: { range: '2.6 (1.5 - 3.7)', max: false },
            F180: { range: '3.4 (2.2 - 4.6)', max: false },
            F275: { range: '5.2 (3.3 - 7.1)', max: false },
            F420: { range: '7.9 (4.6 - 11.2)', max: true },
            F500: { range: '9.2 (6.1 - 12.3)', max: true },
            F600: { range: '10.9 (6.9 - 14.9)', max: true },
            F900: { range: '17.0 (10.8 - 23.2)', max: true },
            F1200: { range: '20.5 (12.0 - 29.1)', max: true },
            F2400: { range: '37.8 (21.3 - 54.3)', max: true },
          },
          {
            NeedleSet: 36,
            F30: { range: '0.5 - 1.1', max: false },
            F45: { range: '0.8 - 1.7', max: false },
            F60: { range: '1.1 - 2.2', max: false },
            F120: { range: '2.0 (1.1 - 2.8)', max: false },
            F180: { range: '2.6 (1.7 - 3.5)', max: false },
            F275: { range: '3.9 (2.5 - 5.4)', max: false },
            F420: { range: '6.0 (3.5 - 8.5)', max: false },
            F500: { range: '7.0 (4.6 - 9.4)', max: false },
            F600: { range: '8.3 (5.3 - 11.4)', max: true },
            F900: { range: '13.1 (8.3 - 17.9)', max: true },
            F1200: { range: '15.9 (9.3 - 22.5)', max: true },
            F2400: { range: '30.1 (16.9 - 43.3)', max: true },
          },
          {
            NeedleSet: 37,
            F120: { range: '1.6 (0.9 - 2.2)', max: false },
            F180: { range: '2.1 (1.3 - 2.8)', max: false },
            F275: { range: '3.2 (2.0 - 4.3)', max: false },
            F420: { range: '4.8 (2.8 - 6.8)', max: false },
            F500: { range: '5.6 (3.7 - 7.6)', max: false },
            F600: { range: '6.7 (4.3 - 9.2)', max: false },
            F900: { range: '10.6 (6.8 - 14.5)', max: true },
            F1200: { range: '13.0 (7.6 - 18.4)', max: true },
            F2400: { range: '25.0 (14.0 - 36.0)', max: true },
          },
          {
            NeedleSet: 38,
            F120: { range: '1.3 (0.8 - 1.9)', max: false },
            F180: { range: '1.7 (1.1 - 2.3)', max: false },
            F275: { range: '2.6 (1.7 - 3.6)', max: false },
            F420: { range: '4.0 (2.4 - 5.7)', max: false },
            F500: { range: '4.7 (3.1 - 6.3)', max: false },
            F600: { range: '5.6 (3.6 - 7.7)', max: false },
            F900: { range: '9.0 (5.7 - 12.2)', max: true },
            F1200: { range: '11.0 (6.4 - 15.5)', max: true },
            F2400: { range: '21.4 (12.0 - 30.8)', max: true },
          },
          {
            NeedleSet: 16,
            F30: { range: '1.9 - 4.1', max: false },
            F45: { range: '3.0 - 6.1', max: false },
            F60: { range: '4.0 - 7.7', max: false },
            F120: { range: '6.4 (3.7 - 9.1)', max: false },
            F180: { range: '7.9 (4.9 - 10.9)', max: true },
            F275: { range: '10.8 (6.5 - 15.0)', max: true },
            F420: { range: '14.1 (8.0 - 20.3)', max: true },
            F500: { range: '15.4 (9.3 - 21.5)', max: true },
            F600: { range: '16.9 (9.9 - 23.9)', max: true },
            F900: { range: '20.8 (12.0 - 29.6)', max: true },
            F1200: { range: '22.4 (12.5 - 32.4)', max: true },
            F2400: { range: '26.9 (14.7 - 39.1)', max: true },
          },
          {
            NeedleSet: 17,
            F30: { range: '1.0 - 2.1', max: false },
            F45: { range: '1.6 - 3.2', max: false },
            F60: { range: '2.1 - 4.1', max: false },
            F120: { range: '3.5 (2.1 - 5.0)', max: false },
            F180: { range: '4.5 (2.9 - 6.1)', max: false },
            F275: { range: '6.4 (4.0 - 8.9)', max: false },
            F420: { range: '9.0 (5.2 - 12.9)', max: true },
            F500: { range: '10.1 (6.3 - 13.9)', max: true },
            F600: { range: '11.4 (6.9 - 15.9)', max: true },
            F900: { range: '15.2 (9.0 - 21.4)', max: true },
            F1200: { range: '17.0 (9.6 - 24.4)', max: true },
            F2400: { range: '22.7 (12.5 - 33.0)', max: true },
          },
          {
            NeedleSet: 18,
            F30: { range: '0.7 - 1.4', max: false },
            F45: { range: '1.1 - 2.2', max: false },
            F60: { range: '1.4 - 2.8', max: false },
            F120: { range: '2.4 (1.4 - 3.5)', max: false },
            F180: { range: '3.1 (2.0 - 4.3)', max: false },
            F275: { range: '4.6 (2.9 - 6.3)', max: false },
            F420: { range: '6.6 (3.8 - 9.4)', max: false },
            F500: { range: '7.5 (4.8 - 10.2)', max: true },
            F600: { range: '8.6 (5.3 - 12.0)', max: true },
            F900: { range: '12.0 (7.2 - 16.8)', max: true },
            F1200: { range: '13.7 (7.8 - 19.6)', max: true },
            F2400: { range: '19.7 (10.8 - 28.6)', max: true },
          },
          {
            NeedleSet: 19,
            F30: { range: '0.5 - 1.1', max: false },
            F45: { range: '0.8 - 1.6', max: false },
            F60: { range: '1.1 - 2.1', max: false },
            F120: { range: '1.9 (1.1 - 2.7)', max: false },
            F180: { range: '2.4 (1.6 - 3.3)', max: false },
            F275: { range: '3.6 (2.2 - 4.9)', max: false },
            F420: { range: '5.2 (3.0 - 7.4)', max: false },
            F500: { range: '6.0 (3.8 - 8.1)', max: false },
            F600: { range: '6.9 (4.3 - 9.6)', max: false },
            F900: { range: '9.9 (6.0 - 13.8)', max: true },
            F1200: { range: '11.5 (6.5 - 16.4)', max: true },
            F2400: { range: '17.4 (9.6 - 25.2)', max: true },
          },
          {
            NeedleSet: 20,
            F30: { range: '0.4 - 0.9', max: false },
            F45: { range: '0.6 - 1.3', max: false },
            F60: { range: '0.8 - 1.7', max: false },
            F120: { range: '1.5 (0.9 - 2.1)', max: false },
            F180: { range: '2.0 (1.3 - 2.7)', max: false },
            F275: { range: '2.9 (1.8 - 4.0)', max: false },
            F420: { range: '4.3 (2.5 - 6.1)', max: false },
            F500: { range: '5.0 (3.2 - 6.7)', max: false },
            F600: { range: '5.8 (3.6 - 8.0)', max: false },
            F900: { range: '8.4 (5.2 - 11.7)', max: true },
            F1200: { range: '9.9 (5.6 - 14.1)', max: true },
            F2400: { range: '15.6 (8.6 - 22.6)', max: true },
          },
          {
            NeedleSet: 21,
            F30: { range: '0.3 - 0.7', max: false },
            F45: { range: '0.5 - 1.1', max: false },
            F60: { range: '0.7 - 1.4', max: false },
            F120: { range: '1.3 (0.7 - 1.8)', max: false },
            F180: { range: '1.7 (1.1 - 2.2)', max: false },
            F275: { range: '2.5 (1.6 - 3.4)', max: false },
            F420: { range: '3.7 (2.1 - 5.2)', max: false },
            F500: { range: '4.2 (2.7 - 5.7)', max: false },
            F600: { range: '5.0 (3.1 - 6.8)', max: false },
            F900: { range: '7.3 (4.5 - 10.2)', max: true },
            F1200: { range: '8.7 (5.0 - 12.4)', max: true },
            F2400: { range: '14.1 (7.8 - 20.4)', max: true },
          },
          {
            NeedleSet: 22,
            F30: { range: '0.3 - 0.6', max: false },
            F45: { range: '0.5 - 0.9', max: false },
            F60: { range: '0.6 - 1.2', max: false },
            F120: { range: '1.7 (1.1 - 2.2)', max: false },
            F180: { range: '2.2 (1.7 - 2.7)', max: false },
            F275: { range: '3.3 (2.5 - 4.1)', max: false },
            F420: { range: '4.9 (3.4 - 6.4)', max: false },
            F500: { range: '5.8 (4.5 - 7.1)', max: false },
            F600: { range: '6.7 (5.1 - 8.4)', max: false },
            F900: { range: '10.2 (7.7 - 12.7)', max: false },
            F1200: {
              range: '12.1 (8.6 - 15.5)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '20.4 (14.5 - 26.4)',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 23,
            F30: { range: '0.3 - 0.5', max: false },
            F45: { range: '0.4 - 0.8', max: false },
            F60: { range: '0.5 - 1.1', max: false },
            F120: { range: '1.5 (1.0 - 1.9)', max: false },
            F180: { range: '1.9 (1.5 - 2.4)', max: false },
            F275: { range: '2.9 (2.2 - 3.7)', max: false },
            F420: { range: '4.4 (3 - 5.7)', max: false },
            F500: { range: '5.1 (4 - 6.3)', max: false },
            F600: { range: '6.0 (4.5 - 7.5)', max: false },
            F900: { range: '9.1 (6.9 - 11.4)', max: false },
            F1200: { range: '10.8 (7.7 - 13.9)', max: false },
            F2400: {
              range: '18.7 (13.2 - 24.2)',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 25,
            F30: { range: '2 - 4.2', max: false },
            F45: { range: '3.1 - 6.4', max: false },
            F60: { range: '4.1 - 8.2', max: false },
            F120: { range: '7.6 - 14.2', max: false },
            F180: {
              range: '10.8 - 17.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F275: {
              range: '15.3 - 25.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F420: {
              range: '20.4 - 36.6',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '25.5 - 39.5',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '28.2 - 45.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '38.8 - 61.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '41.9 - 70',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '58.3 - 95.5', max: true },
          },
          {
            NeedleSet: 26,
            F30: { range: '1 - 2.1', max: false },
            F45: { range: '1.6 - 3.3', max: false },
            F60: { range: '2.1 - 4.2', max: false },
            F120: { range: '4 - 7.5', max: false },
            F180: { range: '5.7 - 9.3', max: false },
            F275: { range: '8.3 - 13.9', max: false },
            F420: {
              range: '11.4 - 21.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '14.7 - 23',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '16.5 - 27.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: { range: '24.3 - 39.2', max: true },
            F1200: { range: '26.7 - 46.7', max: true },
            F2400: { range: '41.7 - 72.5', max: true },
          },
          {
            NeedleSet: 27,
            F30: { range: '0.7 - 1.4', max: false },
            F45: { range: '1.1 - 2.2', max: false },
            F60: { range: '1.4 - 2.9', max: false },
            F120: { range: '2.7 - 5.1', max: false },
            F180: { range: '3.9 - 6.3', max: false },
            F275: { range: '5.7 - 9.6', max: false },
            F420: { range: '7.9 - 14.8', max: false },
            F500: {
              range: '10.3 - 16.2',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '11.6 - 19.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '17.7 - 28.9',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '19.6 - 35',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '32.5 - 58.4', max: true },
          },
          {
            NeedleSet: 28,
            F30: { range: '0.5 - 1.1', max: false },
            F45: { range: '0.8 - 1.7', max: false },
            F60: { range: '1.1 - 2.1', max: false },
            F120: { range: '2 - 3.9', max: false },
            F180: { range: '2.9 - 4.8', max: false },
            F275: { range: '4.3 - 7.3', max: false },
            F420: { range: '6.1 - 11.4', max: false },
            F500: { range: '7.9 - 12.5', max: false },
            F600: {
              range: '9.0 - 15',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '13.9 - 22.8',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '15.5 - 28',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '26.6 - 48.9', max: true },
          },
          {
            NeedleSet: 29,
            F30: { range: '0.4 - 0.9', max: false },
            F45: { range: '0.6 - 1.3', max: false },
            F60: { range: '0.9 - 1.7', max: false },
            F120: { range: '1.6 - 3.1', max: false },
            F180: { range: '2.4 - 3.9', max: false },
            F275: { range: '3.5 - 5.9', max: false },
            F420: { range: '4.9 - 9.3', max: false },
            F500: { range: '6.4 - 10.2', max: false },
            F600: { range: '7.3 - 12.3', max: false },
            F900: {
              range: '11.4 - 18.9',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '12.8 - 23.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '22.5 - 42.1',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 30,
            F30: { range: '0.3 - 0.7', max: false },
            F45: { range: '0.5 - 1.1', max: false },
            F60: { range: '0.7 - 1.4', max: false },
            F120: { range: '1.4 - 2.6', max: false },
            F180: { range: '2 - 3.2', max: false },
            F275: { range: '2.9 - 5', max: false },
            F420: { range: '4.1 - 7.8', max: false },
            F500: { range: '5.4 - 8.6', max: false },
            F600: { range: '6.2 - 10.4', max: false },
            F900: {
              range: '9.7 - 16.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '10.9 - 20',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '19.5 - 36.9',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 31,
            F30: { range: '0.3 - 0.6', max: false },
            F45: { range: '0.5 - 1', max: false },
            F60: { range: '0.6 - 1.2', max: false },
            F120: { range: '1.2 - 2.2', max: false },
            F180: { range: '1.7 - 2.8', max: false },
            F275: { range: '2.5 - 4.3', max: false },
            F420: { range: '3.6 - 6.7', max: false },
            F500: { range: '4.7 - 7.4', max: false },
            F600: { range: '5.4 - 9', max: false },
            F900: { range: '8.4 - 14', max: false },
            F1200: {
              range: '9.5 - 17.5',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '17.2 - 32.9',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 32,
            F30: { range: '0.3 - 0.5', max: false },
            F45: { range: '0.4 - 0.8', max: false },
            F60: { range: '0.5 - 1.1', max: false },
            F120: { range: '1.0 - 2.0', max: false },
            F180: { range: '1.5 - 2.4', max: false },
            F275: { range: '2.2 - 3.8', max: false },
            F420: { range: '3.1 - 5.9', max: false },
            F500: { range: '4.1 - 6.6', max: false },
            F600: { range: '4.7 - 7.9', max: false },
            F900: { range: '7.5 - 12.4', max: false },
            F1200: {
              range: '8.4 - 15.6',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '15.4 - 29.6',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
        ],
      },
      {
        drugId: 12,
        syringeId: 2,
        flowValues: [
          {
            NeedleSet: 33,
            F120: { range: '8.2 (4.4 - 12.0)', max: true },
            F180: { range: '10.6 (6.4 - 14.8)', max: true },
            F275: { range: '15.8 (9.2 - 22.3)', max: true },
            F420: { range: '23.3 (12.6 - 34)', max: true },
            F500: { range: '26.7 (16.1 - 37.2)', max: true },
            F600: { range: '31.1 (18.0 - 44.1)', max: true },
            F900: { range: '45.4 (26.3 - 64.5)', max: true },
            F1200: { range: '53.1 (28.7 - 77.5)', max: true },
            F2400: { range: '83.6 (44.1 - 123.1)', max: true },
          },
          {
            NeedleSet: 34,
            F120: { range: '4.2 (2.3 - 6.1)', max: false },
            F180: { range: '5.5 (3.3 - 7.6)', max: false },
            F275: { range: '8.3 (4.8 - 11.7)', max: true },
            F420: { range: '12.5 (6.7 - 18.2)', max: true },
            F500: { range: '14.4 (8.8 - 20.1)', max: true },
            F600: { range: '17.1 (10.0 - 24.1)', max: true },
            F900: { range: '26.1 (15.2 - 36.9)', max: true },
            F1200: { range: '31.3 (16.9 - 45.7)', max: true },
            F2400: { range: '54.9 (28.7 - 81.2)', max: true },
          },
          {
            NeedleSet: 35,
            F120: { range: '2.8 (1.5 - 4.1)', max: false },
            F180: { range: '3.7 (2.2 - 5.1)', max: false },
            F275: { range: '5.6 (3.3 - 7.9)', max: false },
            F420: { range: '8.5 (4.6 - 12.4)', max: true },
            F500: { range: '9.9 (6.0 - 13.8)', max: true },
            F600: { range: '11.8 (6.9 - 16.6)', max: true },
            F900: { range: '18.3 (10.7 - 25.9)', max: true },
            F1200: { range: '22.2 (12.0 - 32.4)', max: true },
            F2400: { range: '40.9 (21.2 - 60.5)', max: true },
          },
          {
            NeedleSet: 36,
            F120: { range: '2.1 (1.1 - 3.1)', max: false },
            F180: { range: '2.8 (1.7 - 3.9)', max: false },
            F275: { range: '4.2 (2.5 - 6.0)', max: false },
            F420: { range: '6.5 (3.5 - 9.5)', max: false },
            F500: { range: '7.5 (4.6 - 10.5)', max: true },
            F600: { range: '9.0 (5.3 - 12.7)', max: true },
            F900: { range: '14.1 (8.3 - 19.9)', max: true },
            F1200: { range: '17.2 (9.3 - 25.1)', max: true },
            F2400: { range: '32.6 (16.9 - 48.3)', max: true },
          },
          {
            NeedleSet: 37,
            F120: { range: '1.6 (0.9 - 2.2)', max: false },
            F180: { range: '2.1 (1.3 - 2.8)', max: false },
            F275: { range: '3.2 (2.0 - 4.3)', max: false },
            F420: { range: '4.8 (2.8 - 6.8)', max: false },
            F500: { range: '5.6 (3.7 - 7.6)', max: false },
            F600: { range: '6.7 (4.3 - 9.2)', max: false },
            F900: { range: '10.6 (6.8 - 14.5)', max: true },
            F1200: { range: '13.0 (7.6 - 18.4)', max: true },
            F2400: { range: '25.0 (14.0 - 36.0)', max: true },
          },
          {
            NeedleSet: 38,
            F120: { range: '1.3 (0.8 - 1.9)', max: false },
            F180: { range: '1.7 (1.1 - 2.3)', max: false },
            F275: { range: '2.6 (1.7 - 3.6)', max: false },
            F420: { range: '4.0 (2.4 - 5.7)', max: false },
            F500: { range: '4.7 (3.1 - 6.3)', max: false },
            F600: { range: '5.6 (3.6 - 7.7)', max: false },
            F900: { range: '9.0 (5.7 - 12.2)', max: true },
            F1200: { range: '11.0 (6.4 - 15.5)', max: true },
            F2400: { range: '21.4 (12.0 - 30.8)', max: true },
          },
          {
            NeedleSet: 16,
            F120: { range: '6.9 (3.7 - 10.2)', max: true },
            F180: { range: '8.5 (4.9 - 12.1)', max: true },
            F275: { range: '11.6 (6.5 - 16.8)', max: true },
            F420: { range: '15.3 (8.0 - 22.6)', max: true },
            F500: { range: '16.6 (9.3 - 24.0)', max: true },
            F600: { range: '18.3 (9.9 - 26.7)', max: true },
            F900: { range: '22.5 (11.9 - 33.0)', max: true },
            F1200: { range: '24.3 (12.4 - 36.1)', max: true },
            F2400: { range: '29.1 (14.6 - 43.6)', max: true },
          },
          {
            NeedleSet: 17,
            F120: { range: '3.8 (2.0 - 5.6)', max: false },
            F180: { range: '4.9 (2.9 - 6.9)', max: false },
            F275: { range: '7.0 (4.0 - 9.9)', max: false },
            F420: { range: '9.7 (5.1 - 14.3)', max: true },
            F500: { range: '10.9 (6.3 - 15.5)', max: true },
            F600: { range: '12.3 (6.8 - 17.8)', max: true },
            F900: { range: '16.4 (9.0 - 23.9)', max: true },
            F1200: { range: '18.4 (9.5 - 27.3)', max: true },
            F2400: { range: '24.6 (12.4 - 36.8)', max: true },
          },
          {
            NeedleSet: 18,
            F120: { range: '2.6 (1.4 - 3.9)', max: false },
            F180: { range: '3.4 (2.0 - 4.8)', max: false },
            F275: { range: '5 (2.9 - 7.1)', max: false },
            F420: { range: '7.2 (3.8 - 10.5)', max: true },
            F500: { range: '8.1 (4.7 - 11.4)', max: true },
            F600: { range: '9.3 (5.2 - 13.3)', max: true },
            F900: { range: '13.0 (7.2 - 18.7)', max: true },
            F1200: { range: '14.8 (7.7 - 21.9)', max: true },
            F2400: { range: '21.3 (10.8 - 31.9)', max: true },
          },
          {
            NeedleSet: 19,
            F120: { range: '2.0 (1.1 - 3.0)', max: false },
            F180: { range: '2.6 (1.6 - 3.7)', max: false },
            F275: { range: '3.9 (2.2 - 5.5)', max: false },
            F420: { range: '5.6 (3.0 - 8.3)', max: false },
            F500: { range: '6.4 (3.8 - 9.1)', max: false },
            F600: { range: '7.5 (4.2 - 10.7)', max: true },
            F900: { range: '10.7 (6.0 - 15.4)', max: true },
            F1200: { range: '12.4 (6.5 - 18.3)', max: true },
            F2400: { range: '18.8 (9.5 - 28.1)', max: true },
          },
          {
            NeedleSet: 20,
            F120: { range: '1.6 (0.9 - 2.4)', max: false },
            F180: { range: '2.1 (1.3 - 3.0)', max: false },
            F275: { range: '3.2 (1.8 - 4.5)', max: false },
            F420: { range: '4.7 (2.5 - 6.8)', max: false },
            F500: { range: '5.3 (3.2 - 7.5)', max: false },
            F600: { range: '6.2 (3.6 - 8.9)', max: false },
            F900: { range: '9.1 (5.2 - 13.1)', max: true },
            F1200: { range: '10.7 (5.6 - 15.7)', max: true },
            F2400: { range: '16.9 (8.5 - 25.2)', max: true },
          },
          {
            NeedleSet: 21,
            F120: { range: '1.4 (0.7 - 2.0)', max: false },
            F180: { range: '1.8 (1.1 - 2.5)', max: false },
            F275: { range: '2.7 (1.6 - 3.8)', max: false },
            F420: { range: '4.0 (2.1 - 5.8)', max: false },
            F500: { range: '4.6 (2.7 - 6.4)', max: false },
            F600: { range: '5.3 (3.1 - 7.6)', max: false },
            F900: { range: '7.9 (4.5 - 11.3)', max: true },
            F1200: { range: '9.4 (4.9 - 13.8)', max: true },
            F2400: { range: '15.2 (7.7 - 22.8)', max: true },
          },
          {
            NeedleSet: 22,
            F30: { range: '0.3 - 0.6', max: false },
            F45: { range: '0.5 - 0.9', max: false },
            F60: { range: '0.6 - 1.2', max: false },
            F120: { range: '1.7 (1.1 - 2.2)', max: false },
            F180: { range: '2.2 (1.7 - 2.7)', max: false },
            F275: { range: '3.3 (2.5 - 4.1)', max: false },
            F420: { range: '4.9 (3.4 - 6.4)', max: false },
            F500: { range: '5.8 (4.5 - 7.1)', max: false },
            F600: { range: '6.7 (5.1 - 8.4)', max: false },
            F900: { range: '10.2 (7.7 - 12.7)', max: true },
            F1200: {
              range: '12.1 (8.6 - 15.5)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '20.4 (14.5 - 26.4)',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 23,
            F30: { range: '0.3 - 0.5', max: false },
            F45: { range: '0.4 - 0.8', max: false },
            F60: { range: '0.5 - 1.1', max: false },
            F120: { range: '1.5 (1.0 - 1.9)', max: false },
            F180: { range: '1.9 (1.5 - 2.4)', max: false },
            F275: { range: '2.9 (2.2 - 3.7)', max: false },
            F420: { range: '4.4 (3 - 5.7)', max: false },
            F500: { range: '5.1 (4 - 6.3)', max: false },
            F600: { range: '6.0 (4.5 - 7.5)', max: false },
            F900: { range: '9.1 (6.9 - 11.4)', max: false },
            F1200: { range: '10.8 (7.7 - 13.9)', max: false },
            F2400: {
              range: '18.7 (13.2 - 24.2)',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 25,
            F30: { range: '2 - 4.2', max: false },
            F45: { range: '3.1 - 6.4', max: false },
            F60: { range: '4.1 - 8.2', max: false },
            F120: { range: '7.6 - 14.2', max: false },
            F180: {
              range: '10.8 - 17.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F275: {
              range: '15.3 - 25.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F420: {
              range: '20.4 - 36.6',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '25.5 - 39.5',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '28.2 - 45.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '38.8 - 61.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '41.9 - 70',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '58.3 - 95.5', max: true },
          },
          {
            NeedleSet: 26,
            F30: { range: '1 - 2.1', max: false },
            F45: { range: '1.6 - 3.3', max: false },
            F60: { range: '2.1 - 4.2', max: false },
            F120: { range: '4 - 7.5', max: false },
            F180: { range: '5.7 - 9.3', max: false },
            F275: { range: '8.3 - 13.9', max: false },
            F420: {
              range: '11.4 - 21.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '14.7 - 23',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '16.5 - 27.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: { range: '24.3 - 39.2', max: true },
            F1200: { range: '26.7 - 46.7', max: true },
            F2400: { range: '41.7 - 72.5', max: true },
          },
          {
            NeedleSet: 27,
            F30: { range: '0.7 - 1.4', max: false },
            F45: { range: '1.1 - 2.2', max: false },
            F60: { range: '1.4 - 2.9', max: false },
            F120: { range: '2.7 - 5.1', max: false },
            F180: { range: '3.9 - 6.3', max: false },
            F275: { range: '5.7 - 9.6', max: false },
            F420: { range: '7.9 - 14.8', max: false },
            F500: {
              range: '10.3 - 16.2',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '11.6 - 19.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '17.7 - 28.9',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '19.6 - 35',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '32.5 - 58.4', max: true },
          },
          {
            NeedleSet: 28,
            F30: { range: '0.5 - 1.1', max: false },
            F45: { range: '0.8 - 1.7', max: false },
            F60: { range: '1.1 - 2.1', max: false },
            F120: { range: '2 - 3.9', max: false },
            F180: { range: '2.9 - 4.8', max: false },
            F275: { range: '4.3 - 7.3', max: false },
            F420: { range: '6.1 - 11.4', max: false },
            F500: { range: '7.9 - 12.5', max: false },
            F600: {
              range: '9.0 - 15',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '13.9 - 22.8',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '15.5 - 28',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '26.6 - 48.9', max: true },
          },
          {
            NeedleSet: 29,
            F30: { range: '0.4 - 0.9', max: false },
            F45: { range: '0.6 - 1.3', max: false },
            F60: { range: '0.9 - 1.7', max: false },
            F120: { range: '1.6 - 3.1', max: false },
            F180: { range: '2.4 - 3.9', max: false },
            F275: { range: '3.5 - 5.9', max: false },
            F420: { range: '4.9 - 9.3', max: false },
            F500: { range: '6.4 - 10.2', max: false },
            F600: { range: '7.3 - 12.3', max: false },
            F900: {
              range: '11.4 - 18.9',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '12.8 - 23.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '22.5 - 42.1',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 30,
            F30: { range: '0.3 - 0.7', max: false },
            F45: { range: '0.5 - 1.1', max: false },
            F60: { range: '0.7 - 1.4', max: false },
            F120: { range: '1.4 - 2.6', max: false },
            F180: { range: '2 - 3.2', max: false },
            F275: { range: '2.9 - 5', max: false },
            F420: { range: '4.1 - 7.8', max: false },
            F500: { range: '5.4 - 8.6', max: false },
            F600: { range: '6.2 - 10.4', max: false },
            F900: {
              range: '9.7 - 16.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '10.9 - 20',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '19.5 - 36.9',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 31,
            F30: { range: '0.3 - 0.6', max: false },
            F45: { range: '0.5 - 1', max: false },
            F60: { range: '0.6 - 1.2', max: false },
            F120: { range: '1.2 - 2.2', max: false },
            F180: { range: '1.7 - 2.8', max: false },
            F275: { range: '2.5 - 4.3', max: false },
            F420: { range: '3.6 - 6.7', max: false },
            F500: { range: '4.7 - 7.4', max: false },
            F600: { range: '5.4 - 9', max: false },
            F900: { range: '8.4 - 14', max: false },
            F1200: {
              range: '9.5 - 17.5',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '17.2 - 32.9',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 32,
            F30: { range: '0.3 - 0.5', max: false },
            F45: { range: '0.4 - 0.8', max: false },
            F60: { range: '0.5 - 1.1', max: false },
            F120: { range: '1.0 - 2.0', max: false },
            F180: { range: '1.5 - 2.4', max: false },
            F275: { range: '2.2 - 3.8', max: false },
            F420: { range: '3.1 - 5.9', max: false },
            F500: { range: '4.1 - 6.6', max: false },
            F600: { range: '4.7 - 7.9', max: false },
            F900: { range: '7.5 - 12.4', max: false },
            F1200: {
              range: '8.4 - 15.6',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '15.4 - 29.6',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
        ],
      },
      {
        drugId: 12,
        syringeId: 3,
        flowValues: [
          {
            NeedleSet: 33,
            F120: { range: '6.8 (2.9 - 10.6)', max: false },
            F180: { range: '8.7 (4.2 - 13.1)', max: false },
            F275: { range: '12.9 (6.1 - 19.8)', max: false },
            F420: { range: '19.2 (8.3 - 30.2)', max: false },
            F500: { range: '21.8 (10.6 - 33.0)', max: false },
            F600: { range: '25.5 (11.9 - 39.1)', max: false },
            F900: { range: '37.3 (17.3 - 57.3)', max: false },
            F1200: { range: '43.9 (18.9 - 68.8)', max: false },
            F2400: { range: '69.1 (29.1 - 109.2)', max: false },
          },
          {
            NeedleSet: 34,
            F120: { range: '3.5 (1.5 - 5.4)', max: false },
            F180: { range: '4.5 (2.2 - 6.8)', max: false },
            F275: { range: '6.8 (3.2 - 10.3)', max: false },
            F420: { range: '10.3 (4.4 - 16.2)', max: false },
            F500: { range: '11.8 (5.8 - 17.8)', max: false },
            F600: { range: '14.0 (6.6 - 21.4)', max: false },
            F900: { range: '21.4 (10.1 - 32.8)', max: false },
            F1200: { range: '25.9 (11.1 - 40.6)', max: false },
            F2400: { range: '45.5 (18.9 - 72.0)', max: false },
          },
          {
            NeedleSet: 35,
            F120: { range: '2.3 (1 - 3.7)', max: false },
            F180: { range: '3.0 (1.5 - 4.6)', max: false },
            F275: { range: '4.6 (2.2 - 7.0)', max: false },
            F420: { range: '7.0 (3.0 - 11.0)', max: false },
            F500: { range: '8.1 (4.0 - 12.2)', max: false },
            F600: { range: '9.6 (4.5 - 14.7)', max: false },
            F900: { range: '15.0 (7.1 - 23.0)', max: false },
            F1200: { range: '18.3 (7.9 - 28.8)', max: false },
            F2400: { range: '33.9 (14.0 - 53.7)', max: false },
          },
          {
            NeedleSet: 36,
            F120: { range: '1.8 (0.8 - 2.7)', max: false },
            F180: { range: '2.3 (1.1 - 3.4)', max: false },
            F275: { range: '3.5 (1.6 - 5.3)', max: false },
            F420: { range: '5.3 (2.3 - 8.4)', max: false },
            F500: { range: '6.2 (3.0 - 9.3)', max: false },
            F600: { range: '7.4 (3.5 - 11.2)', max: false },
            F900: { range: '11.6 (5.5 - 17.7)', max: false },
            F1200: { range: '14.2 (6.1 - 22.3)', max: false },
            F2400: { range: '27.0 (11.1 - 42.8)', max: false },
          },
          {
            NeedleSet: 37,
            F120: { range: '1.6 (0.9 - 2.2)', max: false },
            F180: { range: '2.1 (1.3 - 2.8)', max: false },
            F275: { range: '3.2 (2.0 - 4.3)', max: false },
            F420: { range: '4.8 (2.8 - 6.8)', max: false },
            F500: { range: '5.6 (3.7 - 7.6)', max: false },
            F600: { range: '6.7 (4.3 - 9.2)', max: false },
            F900: { range: '10.6 (6.8 - 14.5)', max: true },
            F1200: { range: '13.0 (7.6 - 18.4)', max: true },
            F2400: { range: '25.0 (14.0 - 36.0)', max: true },
          },
          {
            NeedleSet: 38,
            F120: { range: '1.3 (0.8 - 1.9)', max: false },
            F180: { range: '1.7 (1.1 - 2.3)', max: false },
            F275: { range: '2.6 (1.7 - 3.6)', max: false },
            F420: { range: '4.0 (2.4 - 5.7)', max: false },
            F500: { range: '4.7 (3.1 - 6.3)', max: false },
            F600: { range: '5.6 (3.6 - 7.7)', max: false },
            F900: { range: '9.0 (5.7 - 12.2)', max: true },
            F1200: { range: '11.0 (6.4 - 15.5)', max: true },
            F2400: { range: '21.4 (12 - 30.8)', max: true },
          },
          {
            NeedleSet: 16,
            F120: { range: '5.7 (2.4 - 9.0)', max: false },
            F180: { range: '7.0 (3.3 - 10.8)', max: false },
            F275: { range: '9.6 (4.3 - 14.9)', max: false },
            F420: { range: '12.7 (5.3 - 20.1)', max: false },
            F500: { range: '13.7 (6.1 - 21.3)', max: false },
            F600: { range: '15.1 (6.5 - 23.7)', max: false },
            F900: { range: '18.6 (7.9 - 29.3)', max: false },
            F1200: { range: '20.1 (8.2 - 32.0)', max: false },
            F2400: { range: '24.2 (9.7 - 38.7)', max: false },
          },
          {
            NeedleSet: 17,
            F120: { range: '3.2 (1.3 - 5.0)', max: false },
            F180: { range: '4.0 (1.9 - 6.1)', max: false },
            F275: { range: '5.7 (2.6 - 8.8)', max: false },
            F420: { range: '8.1 (3.4 - 12.7)', max: false },
            F500: { range: '8.9 (4.1 - 13.7)', max: false },
            F600: { range: '10.1 (4.5 - 15.8)', max: false },
            F900: { range: '13.6 (5.9 - 21.2)', max: false },
            F1200: { range: '15.2 (6.3 - 24.2)', max: false },
            F2400: { range: '20.4 (8.2 - 32.7)', max: false },
          },
          {
            NeedleSet: 18,
            F120: { range: '2.2 (0.9 - 3.4)', max: false },
            F180: { range: '2.8 (1.3 - 4.2)', max: false },
            F275: { range: '4.1 (1.9 - 6.3)', max: false },
            F420: { range: '5.9 (2.5 - 9.3)', max: false },
            F500: { range: '6.6 (3.1 - 10.1)', max: false },
            F600: { range: '7.6 (3.5 - 11.8)', max: false },
            F900: { range: '10.7 (4.8 - 16.6)', max: false },
            F1200: { range: '12.3 (5.1 - 19.4)', max: false },
            F2400: { range: '17.7 (7.1 - 28.3)', max: false },
          },
          {
            NeedleSet: 19,
            F120: { range: '1.7 (0.7 - 2.6)', max: false },
            F180: { range: '2.1 (1.0 - 3.2)', max: false },
            F275: { range: '3.2 (1.5 - 4.9)', max: false },
            F420: { range: '4.7 (2.0 - 7.4)', max: false },
            F500: { range: '5.3 (2.5 - 8.0)', max: false },
            F600: { range: '6.1 (2.8 - 9.5)', max: false },
            F900: { range: '8.8 (4.0 - 13.6)', max: false },
            F1200: { range: '10.3 (4.3 - 16.2)', max: false },
            F2400: { range: '15.6 (6.3 - 25.0)', max: false },
          },
          {
            NeedleSet: 20,
            F120: { range: '1.4 (0.6 - 2.1)', max: false },
            F180: { range: '1.7 (0.8 - 2.6)', max: false },
            F275: { range: '2.6 (1.2 - 4.0)', max: false },
            F420: { range: '3.9 (1.6 - 6.1)', max: false },
            F500: { range: '4.4 (2.1 - 6.7)', max: false },
            F600: { range: '5.1 (2.3 - 7.9)', max: false },
            F900: { range: '7.5 (3.4 - 11.6)', max: false },
            F1200: { range: '8.8 (3.7 - 14.0)', max: false },
            F2400: { range: '14.0 (5.6 - 22.3)', max: false },
          },
          {
            NeedleSet: 21,
            F120: { range: '1.1 (0.5 - 1.8)', max: false },
            F180: { range: '1.5 (0.7 - 2.2)', max: false },
            F275: { range: '2.2 (1 - 3.4)', max: false },
            F420: { range: '3.3 (1.4 - 5.2)', max: false },
            F500: { range: '3.7 (1.8 - 5.7)', max: false },
            F600: { range: '4.4 (2.0 - 6.8)', max: false },
            F900: { range: '6.5 (3.0 - 10.1)', max: false },
            F1200: { range: '7.7 (3.3 - 12.2)', max: false },
            F2400: { range: '12.7 (5.1 - 20.2)', max: false },
          },
          {
            NeedleSet: 22,
            F30: { range: '0.3 - 0.6', max: false },
            F45: { range: '0.5 - 0.9', max: false },
            F60: { range: '0.6 - 1.2', max: false },
            F120: { range: '1.7 (1.1 - 2.2)', max: false },
            F180: { range: '2.2 (1.7 - 2.7)', max: false },
            F275: { range: '3.3 (2.5 - 4.1)', max: false },
            F420: { range: '4.9 (3.4 - 6.4)', max: false },
            F500: { range: '5.8 (4.5 - 7.1)', max: false },
            F600: { range: '6.7 (5.1 - 8.4)', max: false },
            F900: { range: '10.2 (7.7 - 12.7)', max: true },
            F1200: {
              range: '12.1 (8.6 - 15.5)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '20.4 (14.5 - 26.4)',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 23,
            F30: { range: '0.3 - 0.5', max: false },
            F45: { range: '0.4 - 0.8', max: false },
            F60: { range: '0.5 - 1.1', max: false },
            F120: { range: '1.5 (1.0 - 1.9)', max: false },
            F180: { range: '1.9 (1.5 - 2.4)', max: false },
            F275: { range: '2.9 (2.2 - 3.7)', max: false },
            F420: { range: '4.4 (3 - 5.7)', max: false },
            F500: { range: '5.1 (4 - 6.3)', max: false },
            F600: { range: '6.0 (4.5 - 7.5)', max: false },
            F900: { range: '9.1 (6.9 - 11.4)', max: false },
            F1200: { range: '10.8 (7.7 - 13.9)', max: false },
            F2400: {
              range: '18.7 (13.2 - 24.2)',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 25,
            F30: { range: '2 - 4.2', max: false },
            F45: { range: '3.1 - 6.4', max: false },
            F60: { range: '4.1 - 8.2', max: false },
            F120: { range: '7.6 - 14.2', max: false },
            F180: {
              range: '10.8 - 17.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F275: {
              range: '15.3 - 25.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F420: {
              range: '20.4 - 36.6',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '25.5 - 39.5',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '28.2 - 45.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '38.8 - 61.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '41.9 - 70',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '58.3 - 95.5', max: true },
          },
          {
            NeedleSet: 26,
            F30: { range: '1 - 2.1', max: false },
            F45: { range: '1.6 - 3.3', max: false },
            F60: { range: '2.1 - 4.2', max: false },
            F120: { range: '4 - 7.5', max: false },
            F180: { range: '5.7 - 9.3', max: false },
            F275: { range: '8.3 - 13.9', max: false },
            F420: {
              range: '11.4 - 21.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '14.7 - 23',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '16.5 - 27.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: { range: '24.3 - 39.2', max: true },
            F1200: { range: '26.7 - 46.7', max: true },
            F2400: { range: '41.7 - 72.5', max: true },
          },
          {
            NeedleSet: 27,
            F30: { range: '0.7 - 1.4', max: false },
            F45: { range: '1.1 - 2.2', max: false },
            F60: { range: '1.4 - 2.9', max: false },
            F120: { range: '2.7 - 5.1', max: false },
            F180: { range: '3.9 - 6.3', max: false },
            F275: { range: '5.7 - 9.6', max: false },
            F420: { range: '7.9 - 14.8', max: false },
            F500: {
              range: '10.3 - 16.2',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '11.6 - 19.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '17.7 - 28.9',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '19.6 - 35',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '32.5 - 58.4', max: true },
          },
          {
            NeedleSet: 28,
            F30: { range: '0.5 - 1.1', max: false },
            F45: { range: '0.8 - 1.7', max: false },
            F60: { range: '1.1 - 2.1', max: false },
            F120: { range: '2 - 3.9', max: false },
            F180: { range: '2.9 - 4.8', max: false },
            F275: { range: '4.3 - 7.3', max: false },
            F420: { range: '6.1 - 11.4', max: false },
            F500: { range: '7.9 - 12.5', max: false },
            F600: {
              range: '9.0 - 15',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '13.9 - 22.8',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '15.5 - 28',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '26.6 - 48.9', max: true },
          },
          {
            NeedleSet: 29,
            F30: { range: '0.4 - 0.9', max: false },
            F45: { range: '0.6 - 1.3', max: false },
            F60: { range: '0.9 - 1.7', max: false },
            F120: { range: '1.6 - 3.1', max: false },
            F180: { range: '2.4 - 3.9', max: false },
            F275: { range: '3.5 - 5.9', max: false },
            F420: { range: '4.9 - 9.3', max: false },
            F500: { range: '6.4 - 10.2', max: false },
            F600: { range: '7.3 - 12.3', max: false },
            F900: {
              range: '11.4 - 18.9',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '12.8 - 23.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '22.5 - 42.1',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 30,
            F30: { range: '0.3 - 0.7', max: false },
            F45: { range: '0.5 - 1.1', max: false },
            F60: { range: '0.7 - 1.4', max: false },
            F120: { range: '1.4 - 2.6', max: false },
            F180: { range: '2 - 3.2', max: false },
            F275: { range: '2.9 - 5', max: false },
            F420: { range: '4.1 - 7.8', max: false },
            F500: { range: '5.4 - 8.6', max: false },
            F600: { range: '6.2 - 10.4', max: false },
            F900: {
              range: '9.7 - 16.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '10.9 - 20',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '19.5 - 36.9',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 31,
            F30: { range: '0.3 - 0.6', max: false },
            F45: { range: '0.5 - 1', max: false },
            F60: { range: '0.6 - 1.2', max: false },
            F120: { range: '1.2 - 2.2', max: false },
            F180: { range: '1.7 - 2.8', max: false },
            F275: { range: '2.5 - 4.3', max: false },
            F420: { range: '3.6 - 6.7', max: false },
            F500: { range: '4.7 - 7.4', max: false },
            F600: { range: '5.4 - 9', max: false },
            F900: { range: '8.4 - 14', max: false },
            F1200: {
              range: '9.5 - 17.5',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '17.2 - 32.9',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 32,
            F30: { range: '0.3 - 0.5', max: false },
            F45: { range: '0.4 - 0.8', max: false },
            F60: { range: '0.5 - 1.1', max: false },
            F120: { range: '1.0 - 2.0', max: false },
            F180: { range: '1.5 - 2.4', max: false },
            F275: { range: '2.2 - 3.8', max: false },
            F420: { range: '3.1 - 5.9', max: false },
            F500: { range: '4.1 - 6.6', max: false },
            F600: { range: '4.7 - 7.9', max: false },
            F900: { range: '7.5 - 12.4', max: false },
            F1200: {
              range: '8.4 - 15.6',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '15.4 - 29.6',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
        ],
      },
      {
        drugId: 14,
        flowValues: [
          {
            NeedleSet: 33,
            F120: { range: '7.6 (4.2 - 11.0)', max: true },
            F180: { range: '9.8 (6.0 - 13.6)', max: true },
            F275: { range: '14.7 (8.8 - 20.5)', max: true },
            F420: { range: '21.8 (12.1 - 31.4)', max: true },
            F500: { range: '25.0 (15.6 - 34.3)', max: true },
            F600: { range: '29.2 (17.6 - 40.7)', max: true },
            F900: { range: '42.9 (26.2 - 59.6)', max: true },
            F1200: { range: '50.2 (29.0 - 71.4)', max: true },
            F2400: { range: '80.2 (46.4 - 113.9)', max: true },
          },
          {
            NeedleSet: 34,
            F120: { range: '3.9 (2.1 - 5.6)', max: false },
            F180: { range: '5.1 (3.1 - 7.0)', max: false },
            F275: { range: '7.7 (4.6 - 10.7)', max: true },
            F420: { range: '11.6 (6.4 - 16.8)', max: true },
            F500: { range: '13.5 (8.4 - 18.5)', max: true },
            F600: { range: '15.9 (9.5 - 22.2)', max: true },
            F900: { range: '24.5 (14.8 - 34.1)', max: true },
            F1200: { range: '29.3 (16.5 - 42.1)', max: true },
            F2400: { range: '52.0 (28.9 - 75.0)', max: true },
          },
          {
            NeedleSet: 35,
            F120: { range: '2.6 (1.4 - 3.8)', max: false },
            F180: { range: '3.4 (2.1 - 4.7)', max: false },
            F275: { range: '5.2 (3.1 - 7.3)', max: false },
            F420: { range: '7.9 (4.3 - 11.5)', max: true },
            F500: { range: '9.2 (5.7 - 12.7)', max: true },
            F600: { range: '10.9 (6.5 - 15.3)', max: true },
            F900: { range: '17.1 (10.3 - 23.8)', max: true },
            F1200: { range: '20.7 (11.6 - 29.8)', max: true },
            F2400: { range: '38.5 (21.0 - 55.9)', max: true },
          },
          {
            NeedleSet: 36,
            F120: { range: '2.0 (1.1 - 2.9)', max: false },
            F180: { range: '2.6 (1.6 - 3.6)', max: false },
            F275: { range: '3.9 (2.3 - 5.5)', max: false },
            F420: { range: '6.0 (3.3 - 8.7)', max: false },
            F500: { range: '7.0 (4.3 - 9.6)', max: false },
            F600: { range: '8.4 (5.0 - 11.7)', max: true },
            F900: { range: '13.1 (7.9 - 18.3)', max: true },
            F1200: { range: '16.0 (8.9 - 23.1)', max: true },
            F2400: { range: '30.5 (16.5 - 44.5)', max: true },
          },
          {
            NeedleSet: 37,
            F120: { range: '1.6 (0.9 - 2.3)', max: false },
            F180: { range: '2.1 (1.3 - 2.9)', max: false },
            F275: { range: '3.2 (1.9 - 4.4)', max: false },
            F420: { range: '4.8 (2.6 - 7.0)', max: false },
            F500: { range: '5.7 (3.5 - 7.8)', max: false },
            F600: { range: '6.7 (4.0 - 9.4)', max: false },
            F900: { range: '10.7 (6.4 - 14.9)', max: true },
            F1200: { range: '13.0 (7.2 - 18.8)', max: true },
            F2400: { range: '25.3 (13.5 - 37.0)', max: true },
          },
          {
            NeedleSet: 38,
            F120: { range: '1.3 (0.7 - 1.9)', max: false },
            F180: { range: '1.7 (1.0 - 2.4)', max: false },
            F275: { range: '2.7 (1.6 - 3.7)', max: false },
            F420: { range: '4.1 (2.2 - 5.9)', max: false },
            F500: { range: '4.7 (2.9 - 6.5)', max: false },
            F600: { range: '5.7 (3.4 - 7.9)', max: false },
            F900: { range: '9.0 (5.4 - 12.6)', max: true },
            F1200: { range: '11.0 (6.1 - 15.9)', max: true },
            F2400: { range: '21.6 (11.5 - 31.7)', max: true },
          },
          {
            NeedleSet: 16,
            F120: { range: '6.6 (3.7 - 9.4)', max: false },
            F180: { range: '8.1 (5.0 - 11.2)', max: true },
            F275: { range: '11.2 (6.9 - 15.5)', max: true },
            F420: { range: '14.8 (8.7 - 20.9)', max: true },
            F500: { range: '16.3 (10.4 - 22.2)', max: true },
            F600: { range: '18.0 (11.3 - 24.7)', max: true },
            F900: { range: '22.5 (14.3 - 30.6)', max: true },
            F1200: { range: '24.3 (15.0 - 33.5)', max: true },
            F2400: { range: '29.6 (18.6 - 40.5)', max: true },
          },
          {
            NeedleSet: 17,
            F120: { range: '3.6 (2.0 - 5.2)', max: false },
            F180: { range: '4.6 (2.8 - 6.3)', max: false },
            F275: { range: '6.6 (4.0 - 9.2)', max: false },
            F420: { range: '9.3 (5.3 - 13.3)', max: true },
            F500: { range: '10.5 (6.6 - 14.3)', max: true },
            F600: { range: '11.9 (7.3 - 16.4)', max: true },
            F900: { range: '16.1 (10.0 - 22.1)', max: true },
            F1200: { range: '18.0 (10.8 - 25.2)', max: true },
            F2400: { range: '24.6 (15.0 - 34.2)', max: true },
          },
          {
            NeedleSet: 18,
            F120: { range: '2.5 (1.4 - 3.6)', max: false },
            F180: { range: '3.2 (1.9 - 4.4)', max: false },
            F275: { range: '4.7 (2.8 - 6.5)', max: false },
            F420: { range: '6.8 (3.8 - 9.7)', max: false },
            F500: { range: '7.7 (4.8 - 10.5)', max: true },
            F600: { range: '8.9 (5.4 - 12.3)', max: true },
            F900: { range: '12.5 (7.7 - 17.3)', max: true },
            F1200: { range: '14.3 (8.4 - 20.2)', max: true },
            F2400: { range: '21.1 (12.5 - 29.6)', max: true },
          },
          {
            NeedleSet: 19,
            F120: { range: '1.9 (1.0 - 2.7)', max: false },
            F180: { range: '2.5 (1.5 - 3.4)', max: false },
            F275: { range: '3.7 (2.2 - 5.1)', max: false },
            F420: { range: '5.3 (3.0 - 7.6)', max: false },
            F500: { range: '6.1 (3.8 - 8.4)', max: false },
            F600: { range: '7.1 (4.3 - 9.8)', max: false },
            F900: { range: '10.3 (6.3 - 14.2)', max: true },
            F1200: { range: '11.9 (6.9 - 16.9)', max: true },
            F2400: { range: '18.5 (10.8 - 26.1)', max: true },
          },
          {
            NeedleSet: 20,
            F120: { range: '1.5 (0.8 - 2.2)', max: false },
            F180: { range: '2.0 (1.2 - 2.7)', max: false },
            F275: { range: '3.0 (1.8 - 4.1)', max: false },
            F420: { range: '4.4 (2.4 - 6.3)', max: false },
            F500: { range: '5.0 (3.1 - 6.9)', max: false },
            F600: { range: '5.9 (3.5 - 8.2)', max: false },
            F900: { range: '8.7 (5.3 - 12.1)', max: true },
            F1200: { range: '10.2 (5.9 - 14.5)', max: true },
            F2400: { range: '16.4 (9.4 - 23.3)', max: true },
          },
          {
            NeedleSet: 21,
            F120: { range: '1.3 (0.7 - 1.9)', max: false },
            F180: { range: '1.7 (1.0 - 2.3)', max: false },
            F275: { range: '2.5 (1.5 - 3.5)', max: false },
            F420: { range: '3.8 (2.1 - 5.4)', max: false },
            F500: { range: '4.3 (2.7 - 5.9)', max: false },
            F600: { range: '5.0 (3.0 - 7.0)', max: false },
            F900: { range: '7.6 (4.6 - 10.5)', max: true },
            F1200: { range: '8.9 (5.1 - 12.7)', max: true },
            F2400: { range: '14.8 (8.4 - 21.1)', max: true },
          },
          {
            NeedleSet: 22,
            F30: { range: '0.3 - 0.6', max: false },
            F45: { range: '0.5 - 0.9', max: false },
            F60: { range: '0.6 - 1.2', max: false },
            F120: { range: '1.7 (1.1 - 2.2)', max: false },
            F180: { range: '2.2 (1.7 - 2.7)', max: false },
            F275: { range: '3.3 (2.5 - 4.1)', max: false },
            F420: { range: '4.9 (3.4 - 6.4)', max: false },
            F500: { range: '5.8 (4.5 - 7.1)', max: false },
            F600: { range: '6.7 (5.1 - 8.4)', max: false },
            F900: { range: '10.2 (7.7 - 12.7)', max: false },
            F1200: { range: '12.1 (8.6 - 15.5)', max: false },
            F2400: {
              range: '20.4 (14.5 - 26.4)',
              max:
                this.props.version === 'international' ? false : true,
            },
          },
          {
            NeedleSet: 23,
            F30: { range: '0.3 - 0.5', max: false },
            F45: { range: '0.4 - 0.8', max: false },
            F60: { range: '0.5 - 1.1', max: false },
            F120: { range: '1.5 (1.0 - 1.9)', max: false },
            F180: { range: '1.9 (1.5 - 2.4)', max: false },
            F275: { range: '2.9 (2.2 - 3.7)', max: false },
            F420: { range: '4.4 (3 - 5.7)', max: false },
            F500: { range: '5.1 (4 - 6.3)', max: false },
            F600: { range: '6.0 (4.5 - 7.5)', max: false },
            F900: { range: '9.1 (6.9 - 11.4)', max: false },
            F1200: { range: '10.8 (7.7 - 13.9)', max: false },
            F2400: { range: '18.7 (13.2 - 24.2)', max: false },
          },
          {
            NeedleSet: 25,
            F30: { range: '2 - 4.2', max: false },
            F45: { range: '3.1 - 6.4', max: false },
            F60: { range: '4.1 - 8.2', max: false },
            F120: { range: '7.6 - 14.2', max: false },
            F180: { range: '10.8 - 17.4', max: false },
            F275: { range: '15.3 - 25.3', max: false },
            F420: {
              range: '20.4 - 36.6',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '25.5 - 39.5',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '28.2 - 45.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '38.8 - 61.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '41.9 - 70',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '58.3 - 95.5',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 26,
            F30: { range: '1 - 2.1', max: false },
            F45: { range: '1.6 - 3.3', max: false },
            F60: { range: '2.1 - 4.2', max: false },
            F120: { range: '4 - 7.5', max: false },
            F180: { range: '5.7 - 9.3', max: false },
            F275: { range: '8.3 - 13.9', max: false },
            F420: { range: '11.4 - 21.1', max: false },
            F500: { range: '14.7 - 23', max: false },
            F600: { range: '16.5 - 27.1', max: false },
            F900: { range: '24.3 - 39.2', max: true },
            F1200: { range: '26.7 - 46.7', max: true },
            F2400: { range: '41.7 - 72.5', max: true },
          },
          {
            NeedleSet: 27,
            F30: { range: '0.7 - 1.4', max: false },
            F45: { range: '1.1 - 2.2', max: false },
            F60: { range: '1.4 - 2.9', max: false },
            F120: { range: '2.7 - 5.1', max: false },
            F180: { range: '3.9 - 6.3', max: false },
            F275: { range: '5.7 - 9.6', max: false },
            F420: { range: '7.9 - 14.8', max: false },
            F500: { range: '10.3 - 16.2', max: false },
            F600: { range: '11.6 - 19.3', max: false },
            F900: { range: '17.7 - 28.9', max: false },
            F1200: {
              range: '19.6 - 35',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '32.5 - 58.4', max: true },
          },
          {
            NeedleSet: 28,
            F30: { range: '0.5 - 1.1', max: false },
            F45: { range: '0.8 - 1.7', max: false },
            F60: { range: '1.1 - 2.1', max: false },
            F120: { range: '2 - 3.9', max: false },
            F180: { range: '2.9 - 4.8', max: false },
            F275: { range: '4.3 - 7.3', max: false },
            F420: { range: '6.1 - 11.4', max: false },
            F500: { range: '7.9 - 12.5', max: false },
            F600: { range: '9.0 - 15', max: false },
            F900: { range: '13.9 - 22.8', max: false },
            F1200: { range: '15.5 - 28', max: false },
            F2400: { range: '26.6 - 48.9', max: true },
          },
          {
            NeedleSet: 29,
            F30: { range: '0.4 - 0.9', max: false },
            F45: { range: '0.6 - 1.3', max: false },
            F60: { range: '0.9 - 1.7', max: false },
            F120: { range: '1.6 - 3.1', max: false },
            F180: { range: '2.4 - 3.9', max: false },
            F275: { range: '3.5 - 5.9', max: false },
            F420: { range: '4.9 - 9.3', max: false },
            F500: { range: '6.4 - 10.2', max: false },
            F600: { range: '7.3 - 12.3', max: false },
            F900: { range: '11.4 - 18.9', max: false },
            F1200: { range: '12.8 - 23.4', max: false },
            F2400: {
              range: '22.5 - 42.1',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 30,
            F30: { range: '0.3 - 0.7', max: false },
            F45: { range: '0.5 - 1.1', max: false },
            F60: { range: '0.7 - 1.4', max: false },
            F120: { range: '1.4 - 2.6', max: false },
            F180: { range: '2 - 3.2', max: false },
            F275: { range: '2.9 - 5', max: false },
            F420: { range: '4.1 - 7.8', max: false },
            F500: { range: '5.4 - 8.6', max: false },
            F600: { range: '6.2 - 10.4', max: false },
            F900: { range: '9.7 - 16.1', max: false },
            F1200: { range: '10.9 - 20', max: false },
            F2400: {
              range: '19.5 - 36.9',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 31,
            F30: { range: '0.3 - 0.6', max: false },
            F45: { range: '0.5 - 1', max: false },
            F60: { range: '0.6 - 1.2', max: false },
            F120: { range: '1.2 - 2.2', max: false },
            F180: { range: '1.7 - 2.8', max: false },
            F275: { range: '2.5 - 4.3', max: false },
            F420: { range: '3.6 - 6.7', max: false },
            F500: { range: '4.7 - 7.4', max: false },
            F600: { range: '5.4 - 9', max: false },
            F900: { range: '8.4 - 14', max: false },
            F1200: { range: '9.5 - 17.5', max: false },
            F2400: { range: '17.2 - 32.9', max: false },
          },
          {
            NeedleSet: 32,
            F30: { range: '0.3 - 0.5', max: false },
            F45: { range: '0.4 - 0.8', max: false },
            F60: { range: '0.5 - 1.1', max: false },
            F120: { range: '1.0 - 2.0', max: false },
            F180: { range: '1.5 - 2.4', max: false },
            F275: { range: '2.2 - 3.8', max: false },
            F420: { range: '3.1 - 5.9', max: false },
            F500: { range: '4.1 - 6.6', max: false },
            F600: { range: '4.7 - 7.9', max: false },
            F900: { range: '7.5 - 12.4', max: false },
            F1200: { range: '8.4 - 15.6', max: false },
            F2400: { range: '15.4 - 29.6', max: false },
          },
        ],
      },
      {
        drugId: 13,
        flowValues: [
          {
            NeedleSet: 33,
            F30: { range: '2 - 4.3', max: false },
            F45: { range: '3.2 - 6.6', max: false },
            F60: { range: '4.2 - 8.5', max: false },
            F120: {
              range: '11.7 (7.4 - 15.9)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F180: {
              range: '15.3 (10.8 - 19.7)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F275: {
              range: '22.7 (15.7 - 29.6)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F420: {
              range: '33.4 (21.6 - 45.2)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '38.8 (28.0 - 49.5)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '45.1 (31.5 - 58.7)',
              max: true,
            },
            F900: {
              range: '66.5 (47 - 85.9)',
              max: true,
            },
            F1200: {
              range: '77.5 (51.9 - 103.0)',
              max: true,
            },
            F2400: { range: '123.7 (83 - 164.3)', max: true },
          },
          {
            NeedleSet: 34,
            F30: { range: '1 - 2.2', max: false },
            F45: { range: '1.6 - 3.3', max: false },
            F60: { range: '2.1 - 4.3', max: false },
            F120: { range: '6.0 (3.8 - 8.1)', max: false },
            F180: { range: '7.8 (5.5 - 10.1)', max: false },
            F275: {
              range: '11.9 (8.2 - 15.5)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F420: {
              range: '17.8 (11.4 - 24.2)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '20.9 (15 - 26.7)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '24.6 (17 - 32.1)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '37.8 (26.4 - 49.1)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: { range: '45.2 (29.6 - 60.7)', max: true },
            F2400: { range: '79.9 (51.7 - 108.1)', max: true },
          },
          {
            NeedleSet: 35,
            F30: { range: '0.7 - 1.4', max: false },
            F45: { range: '1.1 - 2.2', max: false },
            F60: { range: '1.4 - 2.9', max: false },
            F120: { range: '4.0 (2.5 - 5.5)', max: false },
            F180: { range: '5.3 (3.7 - 6.8)', max: false },
            F275: { range: '8.0 (5.5 - 10.5)', max: false },
            F420: {
              range: '12.1 (7.7 - 16.5)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '14.3 (10.2 - 18.3)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '16.9 (11.7 - 22.1)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '26.4 (18.4 - 34.4)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '31.9 (20.7 - 43)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '59.1 (37.5 - 80.6)', max: true },
          },
          {
            NeedleSet: 36,
            F30: { range: '0.5 - 1.1', max: false },
            F45: { range: '0.8 - 1.7', max: false },
            F60: { range: '1.1 - 2.2', max: false },
            F120: { range: '3.0 (1.9 - 4.1)', max: false },
            F180: { range: '4.0 (2.8 - 5.1)', max: false },
            F275: { range: '6.1 (4.2 - 7.9)', max: false },
            F420: { range: '9.3 (5.9 - 12.6)', max: false },
            F500: { range: '10.9 (7.8 - 13.9)', max: false },
            F600: {
              range: '12.9 (8.9 - 16.8)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '20.3 (14.1 - 26.5)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '24.6 (15.9 - 33.3)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '46.8 (29.4 - 64.2)', max: true },
          },
          {
            NeedleSet: 37,
            F120: { range: '2.4 (1.5 - 3.3)', max: false },
            F180: { range: '3.2 (2.2 - 4.1)', max: false },
            F275: { range: '4.9 (3.3 - 6.4)', max: false },
            F420: { range: '7.4 (4.7 - 10.1)', max: false },
            F500: { range: '8.7 (6.3 - 11.2)', max: false },
            F600: { range: '10.4 (7.2 - 13.6)', max: false },
            F900: {
              range: '16.5 (11.4 - 21.5)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '20 (12.9 - 27.2)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '38.8 (24.2 - 53.4)',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 38,
            F120: { range: '2 (1.3 - 2.8)', max: false },
            F180: { range: '2.7 (1.9 - 3.4)', max: false },
            F275: { range: '4.1 (2.8 - 5.3)', max: false },
            F420: { range: '6.2 (3.9 - 8.5)', max: false },
            F500: { range: '7.3 (5.2 - 9.4)', max: false },
            F600: { range: '8.7 (6.0 - 11.4)', max: false },
            F900: {
              range: '13.9 (9.6 - 18.1)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '16.9 (10.9 - 22.9)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '33.1 (20.6 - 45.7)',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 16,
            F30: { range: '1.9 - 4.1', max: false },
            F45: { range: '3 - 6.1', max: false },
            F60: { range: '4 - 7.7', max: false },
            F120: { range: '10.1 (6.6 - 13.5)', max: false },
            F180: {
              range: '12.6 (9.0 - 16.2)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F275: {
              range: '17.3 (12.3 - 22.3)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F420: {
              range: '22.9 (15.6 - 30.2)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '25.3 (18.6 - 32.0)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '27.9 (20.2 - 35.6)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '34.8 (25.5 - 44.1)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '37.6 (26.9 - 48.3)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '46.0 (33.4 - 58.5)',
              max: true,
            },
          },
          {
            NeedleSet: 17,
            F30: { range: '1 - 2.1', max: false },
            F45: { range: '1.6 - 3.2', max: false },
            F60: { range: '2.1 - 4.1', max: false },
            F120: { range: '5.5 (3.5 - 7.5)', max: false },
            F180: { range: '7.1 (5.0 - 9.1)', max: false },
            F275: { range: '10.2 (7.1 - 13.2)', max: false },
            F420: {
              range: '14.3 (9.5 - 19.1)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '16.2 (11.8 - 20.6)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '18.4 (13.1 - 23.7)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '24.9 (17.9 - 31.9)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '27.9 (19.3 - 36.4)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '38.1 (26.8 - 49.3)',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 18,
            F30: { range: '0.7 - 1.4', max: false },
            F45: { range: '1.1 - 2.2', max: false },
            F60: { range: '1.4 - 2.8', max: false },
            F120: { range: '3.8 (2.4 - 5.2)', max: false },
            F180: { range: '4.9 (3.5 - 6.3)', max: false },
            F275: { range: '7.2 (5.0 - 9.4)', max: false },
            F420: { range: '10.4 (6.8 - 14)', max: false },
            F500: {
              range: '11.9 (8.6 - 15.2)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '13.8 (9.7 - 17.8)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '19.4 (13.8 - 24.9)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '22.2 (15.1 - 29.2)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '32.6 (22.4 - 42.7)',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 19,
            F30: { range: '0.5 - 1.1', max: false },
            F45: { range: '0.8 - 1.6', max: false },
            F60: { range: '1.1 - 2.1', max: false },
            F120: { range: '2.9 (1.8 - 3.9)', max: false },
            F180: { range: '3.8 (2.7 - 4.9)', max: false },
            F275: { range: '5.6 (3.9 - 7.3)', max: false },
            F420: { range: '8.2 (5.3 - 11.0)', max: false },
            F500: { range: '9.4 (6.8 - 12.0)', max: false },
            F600: { range: '11.0 (7.7 - 14.2)', max: false },
            F900: {
              range: '15.9 (11.3 - 20.5)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '18.4 (12.4 - 24.4)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '28.5 (19.3 - 37.6)',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 20,
            F30: { range: '0.4 - 0.9', max: false },
            F45: { range: '0.6 - 1.3', max: false },
            F60: { range: '0.8 - 1.7', max: false },
            F120: { range: '2.4 (1.5 - 3.2)', max: false },
            F180: { range: '3.1 (2.2 - 3.9)', max: false },
            F275: { range: '4.6 (3.2 - 6.0)', max: false },
            F420: { range: '6.7 (4.3 - 9.1)', max: false },
            F500: { range: '7.8 (5.6 - 10.0)', max: false },
            F600: { range: '9.1 (6.4 - 11.8)', max: false },
            F900: {
              range: '13.5 (9.5 - 17.4)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '15.7 (10.5 - 20.9)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '25.3 (16.9 - 33.6)',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 21,
            F30: { range: '0.3 - 0.7', max: false },
            F45: { range: '0.5 - 1.1', max: false },
            F60: { range: '0.7 - 1.4', max: false },
            F120: { range: '2.0 (1.2 - 2.7)', max: false },
            F180: { range: '2.6 (1.8 - 3.3)', max: false },
            F275: { range: '3.9 (2.7 - 5.0)', max: false },
            F420: { range: '5.7 (3.7 - 7.7)', max: false },
            F500: { range: '6.7 (4.8 - 8.5)', max: false },
            F600: { range: '7.8 (5.4 - 10.1)', max: false },
            F900: {
              range: '11.7 (8.2 - 15.1)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '13.7 (9.1 - 18.3)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '22.7 (15 - 30.4)',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 22,
            F30: { range: '0.3 - 0.6', max: false },
            F45: { range: '0.5 - 0.9', max: false },
            F60: { range: '0.6 - 1.2', max: false },
            F120: { range: '1.7 (1.1 - 2.2)', max: false },
            F180: { range: '2.2 (1.7 - 2.7)', max: false },
            F275: { range: '3.3 (2.5 - 4.1)', max: false },
            F420: { range: '4.9 (3.4 - 6.4)', max: false },
            F500: { range: '5.8 (4.5 - 7.1)', max: false },
            F600: { range: '6.7 (5.1 - 8.4)', max: false },
            F900: { range: '10.2 (7.7 - 12.7)', max: false },
            F1200: {
              range: '12.1 (8.6 - 15.5)',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '20.4 (14.5 - 26.4)',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 23,
            F30: { range: '0.3 - 0.5', max: false },
            F45: { range: '0.4 - 0.8', max: false },
            F60: { range: '0.5 - 1.1', max: false },
            F120: { range: '1.5 (1.0 - 1.9)', max: false },
            F180: { range: '1.9 (1.5 - 2.4)', max: false },
            F275: { range: '2.9 (2.2 - 3.7)', max: false },
            F420: { range: '4.4 (3 - 5.7)', max: false },
            F500: { range: '5.1 (4 - 6.3)', max: false },
            F600: { range: '6.0 (4.5 - 7.5)', max: false },
            F900: { range: '9.1 (6.9 - 11.4)', max: false },
            F1200: { range: '10.8 (7.7 - 13.9)', max: false },
            F2400: {
              range: '18.7 (13.2 - 24.2)',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 25,
            F30: { range: '2 - 4.2', max: false },
            F45: { range: '3.1 - 6.4', max: false },
            F60: { range: '4.1 - 8.2', max: false },
            F120: { range: '7.6 - 14.2', max: false },
            F180: {
              range: '10.8 - 17.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F275: {
              range: '15.3 - 25.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F420: {
              range: '20.4 - 36.6',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '25.5 - 39.5',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '28.2 - 45.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '38.8 - 61.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '41.9 - 70',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '58.3 - 95.5', max: true },
          },
          {
            NeedleSet: 26,
            F30: { range: '1 - 2.1', max: false },
            F45: { range: '1.6 - 3.3', max: false },
            F60: { range: '2.1 - 4.2', max: false },
            F120: { range: '4 - 7.5', max: false },
            F180: { range: '5.7 - 9.3', max: false },
            F275: { range: '8.3 - 13.9', max: false },
            F420: {
              range: '11.4 - 21.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '14.7 - 23',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '16.5 - 27.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: { range: '24.3 - 39.2', max: true },
            F1200: { range: '26.7 - 46.7', max: true },
            F2400: { range: '41.7 - 72.5', max: true },
          },
          {
            NeedleSet: 27,
            F30: { range: '0.7 - 1.4', max: false },
            F45: { range: '1.1 - 2.2', max: false },
            F60: { range: '1.4 - 2.9', max: false },
            F120: { range: '2.7 - 5.1', max: false },
            F180: { range: '3.9 - 6.3', max: false },
            F275: { range: '5.7 - 9.6', max: false },
            F420: { range: '7.9 - 14.8', max: false },
            F500: {
              range: '10.3 - 16.2',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '11.6 - 19.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '17.7 - 28.9',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '19.6 - 35',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '32.5 - 58.4', max: true },
          },
          {
            NeedleSet: 28,
            F30: { range: '0.5 - 1.1', max: false },
            F45: { range: '0.8 - 1.7', max: false },
            F60: { range: '1.1 - 2.1', max: false },
            F120: { range: '2 - 3.9', max: false },
            F180: { range: '2.9 - 4.8', max: false },
            F275: { range: '4.3 - 7.3', max: false },
            F420: { range: '6.1 - 11.4', max: false },
            F500: { range: '7.9 - 12.5', max: false },
            F600: {
              range: '9.0 - 15',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '13.9 - 22.8',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '15.5 - 28',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '26.6 - 48.9', max: true },
          },
          {
            NeedleSet: 29,
            F30: { range: '0.4 - 0.9', max: false },
            F45: { range: '0.6 - 1.3', max: false },
            F60: { range: '0.9 - 1.7', max: false },
            F120: { range: '1.6 - 3.1', max: false },
            F180: { range: '2.4 - 3.9', max: false },
            F275: { range: '3.5 - 5.9', max: false },
            F420: { range: '4.9 - 9.3', max: false },
            F500: { range: '6.4 - 10.2', max: false },
            F600: { range: '7.3 - 12.3', max: false },
            F900: {
              range: '11.4 - 18.9',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '12.8 - 23.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '22.5 - 42.1',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 30,
            F30: { range: '0.3 - 0.7', max: false },
            F45: { range: '0.5 - 1.1', max: false },
            F60: { range: '0.7 - 1.4', max: false },
            F120: { range: '1.4 - 2.6', max: false },
            F180: { range: '2 - 3.2', max: false },
            F275: { range: '2.9 - 5', max: false },
            F420: { range: '4.1 - 7.8', max: false },
            F500: { range: '5.4 - 8.6', max: false },
            F600: { range: '6.2 - 10.4', max: false },
            F900: {
              range: '9.7 - 16.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '10.9 - 20',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '19.5 - 36.9',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 31,
            F30: { range: '0.3 - 0.6', max: false },
            F45: { range: '0.5 - 1', max: false },
            F60: { range: '0.6 - 1.2', max: false },
            F120: { range: '1.2 - 2.2', max: false },
            F180: { range: '1.7 - 2.8', max: false },
            F275: { range: '2.5 - 4.3', max: false },
            F420: { range: '3.6 - 6.7', max: false },
            F500: { range: '4.7 - 7.4', max: false },
            F600: { range: '5.4 - 9', max: false },
            F900: { range: '8.4 - 14', max: false },
            F1200: {
              range: '9.5 - 17.5',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '17.2 - 32.9',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 32,
            F30: { range: '0.3 - 0.5', max: false },
            F45: { range: '0.4 - 0.8', max: false },
            F60: { range: '0.5 - 1.1', max: false },
            F120: { range: '1.0 - 2.0', max: false },
            F180: { range: '1.5 - 2.4', max: false },
            F275: { range: '2.2 - 3.8', max: false },
            F420: { range: '3.1 - 5.9', max: false },
            F500: { range: '4.1 - 6.6', max: false },
            F600: { range: '4.7 - 7.9', max: false },
            F900: { range: '7.5 - 12.4', max: false },
            F1200: {
              range: '8.4 - 15.6',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '15.4 - 29.6',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
        ],
      },
      {
        drugId: 15,
        flowValues: [
          {
            NeedleSet: 33,
            F30: { range: '2 - 4.3', max: false },
            F45: { range: '3.2 - 6.6', max: false },
            F60: { range: '4.2 - 8.5', max: false },
            F120: { range: '11.5 (8.0 - 15.1)', max: false },
            F180: { range: '15.1 (11.5 - 18.7)', max: false },
            F275: { range: '22.5 (16.8 - 28.2)', max: false },
            F420: { range: '33.1 (23.2 - 43)', max: false },
            F500: { range: '38.5 (29.9 - 47.1)', max: false },
            F600: { range: '44.8 (33.8 - 55.8)', max: true },
            F900: { range: '66 (50.3 - 81.7)', max: true },
            F1200: { range: '76.8 (55.6 - 98)', max: true },
            F2400: { range: '122.5 (88.8 - 156.3)', max: true },
          },
          {
            NeedleSet: 34,
            F30: { range: '1 - 2.2', max: false },
            F45: { range: '1.6 - 3.3', max: false },
            F60: { range: '2.1 - 4.3', max: false },
            F120: { range: '5.9 (4.0 - 7.7)', max: false },
            F180: { range: '7.8 (5.9 - 9.6)', max: false },
            F275: { range: '11.7 (8.7 - 14.7)', max: false },
            F420: { range: '17.6 (12.2 - 23.0)', max: false },
            F500: { range: '20.7 (16.0 - 25.4)', max: false },
            F600: { range: '24.4 (18.2 - 30.5)', max: false },
            F900: { range: '37.5 (28.3 - 46.7)', max: false },
            F1200: { range: '44.7 (31.7 - 57.7)', max: true },
            F2400: { range: '79.1 (55.3 - 102.8)', max: true },
          },
          {
            NeedleSet: 35,
            F30: { range: '0.7 - 1.4', max: false },
            F45: { range: '1.1 - 2.2', max: false },
            F60: { range: '1.4 - 2.9', max: false },
            F120: { range: '4.0 (2.7 - 5.2)', max: false },
            F180: { range: '5.2 (4.0 - 6.5)', max: false },
            F275: { range: '7.9 (5.9 - 10.0)', max: false },
            F420: { range: '12 (8.3 - 15.7)', max: false },
            F500: { range: '14.2 (11.0 - 17.4)', max: false },
            F600: { range: '16.7 (12.5 - 21.0)', max: false },
            F900: { range: '26.2 (19.7 - 32.7)', max: false },
            F1200: { range: '31.5 (22.2 - 40.9)', max: false },
            F2400: { range: '58.4 (40.2 - 76.6)', max: true },
          },
          {
            NeedleSet: 36,
            F30: { range: '0.5 - 1.1', max: false },
            F45: { range: '0.8 - 1.7', max: false },
            F60: { range: '1.1 - 2.2', max: false },
            F120: { range: '3.0 (2.0 - 3.9)', max: false },
            F180: { range: '3.9 (3.0 - 4.9)', max: false },
            F275: { range: '6.0 (4.5 - 7.5)', max: false },
            F420: { range: '9.1 (6.3 - 11.9)', max: false },
            F500: { range: '10.8 (8.3 - 13.2)', max: false },
            F600: { range: '12.8 (9.5 - 16.0)', max: false },
            F900: { range: '20.1 (15.1 - 25.2)', max: false },
            F1200: { range: '24.3 (17.0 - 31.7)', max: false },
            F2400: { range: '46.3 (31.5 - 61.1)', max: true },
          },
          {
            NeedleSet: 37,
            F120: { range: '2.4 (1.6 - 3.1)', max: false },
            F180: { range: '3.2 (2.4 - 3.9)', max: false },
            F275: { range: '4.8 (3.6 - 6.1)', max: false },
            F420: { range: '7.3 (5.1 - 9.6)', max: false },
            F500: { range: '8.7 (6.7 - 10.7)', max: false },
            F600: { range: '10.3 (7.7 - 12.9)', max: false },
            F900: { range: '16.3 (10.2 - 20.4)', max: false },
            F1200: { range: '19.8 (13.8 - 25.8)', max: false },
            F2400: { range: '38.4 (26 - 50.8)', max: true },
          },
          {
            NeedleSet: 38,
            F120: { range: '2.0 (1.4 - 2.6)', max: false },
            F180: { range: '2.6 (2.0 - 3.3)', max: false },
            F275: { range: '4.0 (3.0 - 5.1)', max: false },
            F420: { range: '6.1 (4.2 - 8.1)', max: false },
            F500: { range: '7.3 (5.6 - 8.9)', max: false },
            F600: { range: '8.6 (6.4 - 10.8)', max: false },
            F900: { range: '13.8 (10.3 - 17.2)', max: false },
            F1200: { range: '16.7 (11.7 - 21.8)', max: false },
            F2400: { range: '32.7 (22 - 43.4)', max: false },
          },
          {
            NeedleSet: 39,
            F120: { range: '1.7 (1.2 - 2.2)', max: false },
            F180: { range: '2.3 (1.7 - 2.8)', max: false },
            F275: { range: '3.5 (2.6 - 4.3)', max: false },
            F420: { range: '5.3 (3.6 - 6.9)', max: false },
            F500: { range: '6.3 (4.8 - 7.7)', max: false },
            F600: { range: '7.4 (5.5 - 9.3)', max: false },
            F900: { range: '11.9 (8.9 - 14.9)', max: false },
            F1200: { range: '14.5 (10.1 - 18.9)', max: false },
            F2400: { range: '28.6 (19.2 - 38)', max: false },
          },
          {
            NeedleSet: 40,
            F120: { range: '1.5 (1.0 - 2.0)', max: false },
            F180: { range: '2.0 (1.5 - 2.5)', max: false },
            F275: { range: '3.0 (2.3 - 3.8)', max: false },
            F420: { range: '4.6 (3.2 - 6.1)', max: false },
            F500: { range: '5.5 (4.2 - 6.7)', max: false },
            F600: { range: '6.5 (4.9 - 8.2)', max: false },
            F900: { range: '10.5 (7.8 - 13.1)', max: false },
            F1200: { range: '12.7 (8.9 - 16.6)', max: false },
            F2400: { range: '25.3 (17 - 33.7)', max: false },
          },
          {
            NeedleSet: 16,
            F30: { range: '1.9 - 4.1', max: false },
            F45: { range: '3.0 - 6.1', max: false },
            F60: { range: '4.0 - 7.7', max: false },
            F120: { range: '9.9 (7.0 - 12.9)', max: false },
            F180: { range: '12.5 (9.7 - 15.4)', max: false },
            F275: { range: '17.2 (13.1 - 21.2)', max: false },
            F420: { range: '22.7 (16.7 - 28.7)', max: false },
            F500: { range: '25.2 (19.9 - 30.5)', max: false },
            F600: { range: '27.7 (21.6 - 33.9)', max: false },
            F900: { range: '34.6 (27.3 - 42)', max: false },
            F1200: { range: '37.3 (28.8 - 45.9)', max: false },
            F2400: { range: '45.7 (35.7 - 55.6)', max: true },
          },
          {
            NeedleSet: 17,
            F30: { range: '1 - 2.1', max: false },
            F45: { range: '1.6 - 3.2', max: false },
            F60: { range: '2.1 - 4.1', max: false },
            F120: { range: '5.4 (3.8 - 7.1)', max: false },
            F180: { range: '7.0 (5.4 - 8.7)', max: false },
            F275: { range: '10.1 (7.6 - 12.6)', max: false },
            F420: { range: '14.2 (10.1 - 18.2)', max: false },
            F500: { range: '16.1 (12.6 - 19.6)', max: false },
            F600: { range: '18.3 (14.0 - 22.5)', max: false },
            F900: { range: '24.8 (19.2 - 30.3)', max: false },
            F1200: { range: '27.6 (20.7 - 34.6)', max: false },
            F2400: { range: '37.8 (28.7 - 46.9)', max: false },
          },
          {
            NeedleSet: 18,
            F30: { range: '0.7 - 1.4', max: false },
            F45: { range: '1.1 - 2.2', max: false },
            F60: { range: '1.4 - 2.8', max: false },
            F120: { range: '3.7 (2.6 - 4.9)', max: false },
            F180: { range: '4.9 (3.7 - 6.0)', max: false },
            F275: { range: '7.2 (5.4 - 8.9)', max: false },
            F420: { range: '10.3 (7.3 - 13.3)', max: false },
            F500: { range: '11.9 (9.3 - 14.5)', max: false },
            F600: { range: '13.6 (10.3 - 16.9)', max: false },
            F900: { range: '19.3 (14.8 - 23.7)', max: false },
            F1200: { range: '22 (16.2 - 27.7)', max: false },
            F2400: { range: '32.3 (24.0 - 40.6)', max: false },
          },
          {
            NeedleSet: 19,
            F30: { range: '0.5 - 1.1', max: false },
            F45: { range: '0.8 - 1.6', max: false },
            F60: { range: '1.1 - 2.1', max: false },
            F120: { range: '2.9 (2.0 - 3.7)', max: false },
            F180: { range: '3.7 (2.9 - 4.6)', max: false },
            F275: { range: '5.5 (4.2 - 6.9)', max: false },
            F420: { range: '8.1 (5.7 - 10.5)', max: false },
            F500: { range: '9.4 (7.3 - 11.5)', max: false },
            F600: { range: '10.9 (8.2 - 13.5)', max: false },
            F900: { range: '15.8 (12.1 - 19.5)', max: false },
            F1200: { range: '18.2 (13.3 - 23.2)', max: false },
            F2400: { range: '28.2 (20.6 - 35.8)', max: false },
          },
          {
            NeedleSet: 20,
            F30: { range: '0.4 - 0.9', max: false },
            F45: { range: '0.6 - 1.3', max: false },
            F60: { range: '0.8 - 1.7', max: false },
            F120: { range: '2.3 (1.6 - 3.0)', max: false },
            F180: { range: '3.0 (2.3 - 3.8)', max: false },
            F275: { range: '4.5 (3.4 - 5.7)', max: false },
            F420: { range: '6.7 (4.7 - 8.7)', max: false },
            F500: { range: '7.8 (6.0 - 9.5)', max: false },
            F600: { range: '9.0 (6.8 - 11.2)', max: false },
            F900: { range: '13.3 (10.2 - 16.5)', max: false },
            F1200: { range: '15.6 (11.2 - 19.9)', max: false },
            F2400: { range: '25 (18.1 - 32)', max: false },
          },
          {
            NeedleSet: 21,
            F30: { range: '0.3 - 0.7', max: false },
            F45: { range: '0.5 - 1.1', max: false },
            F60: { range: '0.7 - 1.4', max: false },
            F120: { range: '1.9 (1.3 - 2.5)', max: false },
            F180: { range: '2.5 (1.9 - 3.2)', max: false },
            F275: { range: '3.8 (2.9 - 4.8)', max: false },
            F420: { range: '5.7 (3.9 - 7.4)', max: false },
            F500: { range: '6.6 (5.1 - 8.1)', max: false },
            F600: { range: '7.7 (5.8 - 9.6)', max: false },
            F900: { range: '11.6 (8.8 - 14.4)', max: false },
            F1200: { range: '13.6 (9.8 - 17.4)', max: false },
            F2400: { range: '22.5 (16.1 - 28.9)', max: false },
          },
          {
            NeedleSet: 22,
            F30: { range: '0.3 - 0.6', max: false },
            F45: { range: '0.5 - 0.9', max: false },
            F60: { range: '0.6 - 1.2', max: false },
            F120: { range: '1.7 (1.1 - 2.2)', max: false },
            F180: { range: '2.2 (1.7 - 2.7)', max: false },
            F275: { range: '3.3 (2.5 - 4.1)', max: false },
            F420: { range: '4.9 (3.4 - 6.4)', max: false },
            F500: { range: '5.8 (4.5 - 7.1)', max: false },
            F600: { range: '6.7 (5.1 - 8.4)', max: false },
            F900: { range: '10.2 (7.7 - 12.7)', max: false },
            F1200: { range: '12.1 (8.6 - 15.5)', max: false },
            F2400: { range: '20.4 (14.5 - 26.4)', max: false },
          },
          {
            NeedleSet: 23,
            F30: { range: '0.3 - 0.5', max: false },
            F45: { range: '0.4 - 0.8', max: false },
            F60: { range: '0.5 - 1.1', max: false },
            F120: { range: '1.5 (1.0 - 1.9)', max: false },
            F180: { range: '1.9 (1.5 - 2.4)', max: false },
            F275: { range: '2.9 (2.2 - 3.7)', max: false },
            F420: { range: '4.4 (3.0 - 5.7)', max: false },
            F500: { range: '5.1 (4.0 - 6.3)', max: false },
            F600: { range: '6.0 (4.5 - 7.5)', max: false },
            F900: { range: '9.1 (6.9 - 11.4)', max: false },
            F1200: { range: '10.8 (7.7 - 13.9)', max: false },
            F2400: { range: '18.7 (13.2 - 24.2)', max: false },
          },
          {
            NeedleSet: 25,
            F30: { range: '2 - 4.2', max: false },
            F45: { range: '3.1 - 6.4', max: false },
            F60: { range: '4.1 - 8.2', max: false },
            F120: { range: '7.6 - 14.2', max: false },
            F180: { range: '10.8 - 17.4', max: false },
            F275: { range: '15.3 - 25.3', max: false },
            F420: { range: '20.4 - 36.6', max: false },
            F500: { range: '25.5 - 39.5', max: false },
            F600: { range: '28.2 - 45.4', max: false },
            F900: { range: '38.8 - 61.3', max: false },
            F1200: { range: '41.9 - 70', max: false },
            F2400: { range: '58.3 - 95.5', max: false },
          },
          {
            NeedleSet: 26,
            F30: { range: '1 - 2.1', max: false },
            F45: { range: '1.6 - 3.3', max: false },
            F60: { range: '2.1 - 4.2', max: false },
            F120: { range: '4 - 7.5', max: false },
            F180: { range: '5.7 - 9.3', max: false },
            F275: { range: '8.3 - 13.9', max: false },
            F420: { range: '11.4 - 21.1', max: false },
            F500: { range: '14.7 - 23', max: false },
            F600: { range: '16.5 - 27.1', max: false },
            F900: { range: '24.3 - 39.2', max: true },
            F1200: { range: '26.7 - 46.7', max: true },
            F2400: { range: '41.7 - 72.5', max: true },
          },
          {
            NeedleSet: 27,
            F30: { range: '0.7 - 1.4', max: false },
            F45: { range: '1.1 - 2.2', max: false },
            F60: { range: '1.4 - 2.9', max: false },
            F120: { range: '2.7 - 5.1', max: false },
            F180: { range: '3.9 - 6.3', max: false },
            F275: { range: '5.7 - 9.6', max: false },
            F420: { range: '7.9 - 14.8', max: false },
            F500: { range: '10.3 - 16.2', max: false },
            F600: { range: '11.6 - 19.3', max: false },
            F900: { range: '17.7 - 28.9', max: false },
            F1200: { range: '19.6 - 35', max: false },
            F2400: { range: '32.5 - 58.4', max: true },
          },
          {
            NeedleSet: 28,
            F30: { range: '0.5 - 1.1', max: false },
            F45: { range: '0.8 - 1.7', max: false },
            F60: { range: '1.1 - 2.1', max: false },
            F120: { range: '2 - 3.9', max: false },
            F180: { range: '2.9 - 4.8', max: false },
            F275: { range: '4.3 - 7.3', max: false },
            F420: { range: '6.1 - 11.4', max: false },
            F500: { range: '7.9 - 12.5', max: false },
            F600: { range: '9.0 - 15', max: false },
            F900: { range: '13.9 - 22.8', max: false },
            F1200: { range: '15.5 - 28', max: false },
            F2400: { range: '26.6 - 48.9', max: true },
          },
          {
            NeedleSet: 29,
            F30: { range: '0.4 - 0.9', max: false },
            F45: { range: '0.6 - 1.3', max: false },
            F60: { range: '0.9 - 1.7', max: false },
            F120: { range: '1.6 - 3.1', max: false },
            F180: { range: '2.4 - 3.9', max: false },
            F275: { range: '3.5 - 5.9', max: false },
            F420: { range: '4.9 - 9.3', max: false },
            F500: { range: '6.4 - 10.2', max: false },
            F600: { range: '7.3 - 12.3', max: false },
            F900: { range: '11.4 - 18.9', max: false },
            F1200: { range: '12.8 - 23.4', max: false },
            F2400: { range: '22.5 - 42.1', max: false },
          },
          {
            NeedleSet: 30,
            F30: { range: '0.3 - 0.7', max: false },
            F45: { range: '0.5 - 1.1', max: false },
            F60: { range: '0.7 - 1.4', max: false },
            F120: { range: '1.4 - 2.6', max: false },
            F180: { range: '2 - 3.2', max: false },
            F275: { range: '2.9 - 5', max: false },
            F420: { range: '4.1 - 7.8', max: false },
            F500: { range: '5.4 - 8.6', max: false },
            F600: { range: '6.2 - 10.4', max: false },
            F900: { range: '9.7 - 16.1', max: false },
            F1200: { range: '10.9 - 20', max: false },
            F2400: { range: '19.5 - 36.9', max: false },
          },
          {
            NeedleSet: 31,
            F30: { range: '0.3 - 0.6', max: false },
            F45: { range: '0.5 - 1', max: false },
            F60: { range: '0.6 - 1.2', max: false },
            F120: { range: '1.2 - 2.2', max: false },
            F180: { range: '1.7 - 2.8', max: false },
            F275: { range: '2.5 - 4.3', max: false },
            F420: { range: '3.6 - 6.7', max: false },
            F500: { range: '4.7 - 7.4', max: false },
            F600: { range: '5.4 - 9', max: false },
            F900: { range: '8.4 - 14', max: false },
            F1200: { range: '9.5 - 17.5', max: false },
            F2400: { range: '17.2 - 32.9', max: false },
          },
          {
            NeedleSet: 32,
            F30: { range: '0.3 - 0.5', max: false },
            F45: { range: '0.4 - 0.8', max: false },
            F60: { range: '0.5 - 1.1', max: false },
            F120: { range: '1.0 - 2.0', max: false },
            F180: { range: '1.5 - 2.4', max: false },
            F275: { range: '2.2 - 3.8', max: false },
            F420: { range: '3.1 - 5.9', max: false },
            F500: { range: '4.1 - 6.6', max: false },
            F600: { range: '4.7 - 7.9', max: false },
            F900: { range: '7.5 - 12.4', max: false },
            F1200: { range: '8.4 - 15.6', max: false },
            F2400: { range: '15.4 - 29.6', max: false },
          },
        ],
      },
      {
        drugId: 18,
        syringeId: 1,
        flowValues: [
          {
            NeedleSet: 33,
            F120: { range: '9.3 (5.7 - 12.9)', max: false },
            F180: { range: '12.1 (8.2 - 16.0)', max: false },
            F275: { range: '18 (11.9 - 24.1)', max: true },
            F420: { range: '26.4 (16.2 - 36.7)', max: true },
            F500: { range: '30.5 (20.7 - 40.2)', max: true },
            F600: { range: '35.4 (23.3 - 47.6)', max: true },
            F900: { range: '51.7 (33.9 - 69.6)', max: true },
            F1200: { range: '60.3 (37.0 - 83.6)', max: true },
            F2400: { range: '94.8 (56.8 - 132.8)', max: true },
          },
          {
            NeedleSet: 34,
            F120: { range: '4.8 (2.9 - 6.6)', max: false },
            F180: { range: '6.2 (4.2 - 8.2)', max: false },
            F275: { range: '9.4 (6.2 - 12.6)', max: false },
            F420: { range: '14.2 (8.7 - 19.7)', max: false },
            F500: { range: '16.5 (11.3 - 21.7)', max: true },
            F600: { range: '19.4 (12.8 - 26.0)', max: true },
            F900: { range: '29.7 (19.7 - 39.8)', max: true },
            F1200: { range: '35.6 (21.8 - 49.3)', max: true },
            F2400: { range: '62.2 (36.9 - 87.5)', max: true },
          },
          {
            NeedleSet: 35,
            F120: { range: '3.2 (2.0 - 4.4)', max: false },
            F180: { range: '4.2 (2.9 - 5.5)', max: false },
            F275: { range: '6.4 (4.2 - 8.5)', max: false },
            F420: { range: '9.7 (5.9 - 13.4)', max: false },
            F500: { range: '11.3 (7.8 - 14.8)', max: false },
            F600: { range: '13.4 (8.9 - 17.9)', max: false },
            F900: { range: '20.9 (13.8 - 27.9)', max: true },
            F1200: { range: '25.2 (15.4 - 35)', max: true },
            F2400: { range: '46.3 (27.4 - 65.3)', max: true },
          },
          {
            NeedleSet: 36,
            F120: { range: '2.4 (1.5 - 3.3)', max: false },
            F180: { range: '3.2 (2.2 - 4.2)', max: false },
            F275: { range: '4.8 (3.2 - 6.4)', max: false },
            F420: { range: '7.3 (4.5 - 10.2)', max: false },
            F500: { range: '8.6 (5.9 - 11.3)', max: false },
            F600: { range: '10.2 (6.8 - 13.7)', max: false },
            F900: { range: '16.1 (10.7 - 21.5)', max: true },
            F1200: { range: '19.5 (11.9 - 27.1)', max: true },
            F2400: { range: '36.9 (21.7 - 52.1)', max: true },
          },
          {
            NeedleSet: 37,
            F120: { range: '1.9 (1.2 - 2.7)', max: false },
            F180: { range: '2.5 (1.7 - 3.4)', max: false },
            F275: { range: '3.9 (2.6 - 5.2)', max: false },
            F420: { range: '5.9 (3.6 - 8.2)', max: false },
            F500: { range: '6.9 (4.8 - 9.1)', max: false },
            F600: { range: '8.3 (5.5 - 11.0)', max: false },
            F900: { range: '13.1 (8.7 - 17.5)', max: false },
            F1200: { range: '15.9 (9.7 - 22.1)', max: true },
            F2400: { range: '30.7 (18.0 - 43.3)', max: true },
          },
          {
            NeedleSet: 38,
            F120: { range: '1.6 (1.0 - 2.2)', max: false },
            F180: { range: '2.1 (1.4 - 2.8)', max: false },
            F275: { range: '3.2 (2.2 - 4.3)', max: false },
            F420: { range: '5.0 (3.0 - 6.9)', max: false },
            F500: { range: '5.8 (4.0 - 7.6)', max: false },
            F600: { range: '6.9 (4.6 - 9.3)', max: false },
            F900: { range: '11.0 (7.3 - 14.7)', max: false },
            F1200: { range: '13.5 (8.2 - 18.7)', max: false },
            F2400: { range: '26.2 (15.4 - 37.1)', max: false },
          },
          {
            NeedleSet: 39,
            F120: { range: '1.4 (0.8 - 1.9)', max: false },
            F180: { range: '1.8 (1.2 - 2.4)', max: false },
            F275: { range: '2.8 (1.9 - 3.7)', max: false },
            F420: { range: '4.3 (2.6 - 5.9)', max: false },
            F500: { range: '5.0 (3.5 - 6.6)', max: false },
            F600: { range: '6.0 (4.0 - 8.0)', max: false },
            F900: { range: '9.5 (6.3 - 12.7)', max: false },
            F1200: { range: '11.6 (7.1 - 16.2)', max: false },
            F2400: { range: '22.9 (13.4 - 32.4)', max: true },
          },
          {
            NeedleSet: 40,
            F120: { range: '1.2 (0.7 - 1.7)', max: false },
            F180: { range: '1.6 (1.1 - 2.1)', max: false },
            F275: { range: '2.4 (1.6 - 3.3)', max: false },
            F420: { range: '3.7 (2.3 - 5.2)', max: false },
            F500: { range: '4.4 (3.0 - 5.8)', max: false },
            F600: { range: '5.2 (3.5 - 7.0)', max: false },
            F900: { range: '8.4 (5.6 - 11.2)', max: false },
            F1200: { range: '10.3 (6.3 - 14.3)', max: false },
            F2400: { range: '20.3 (11.9 - 28.8)', max: true },
          },
          {
            NeedleSet: 16,
            F120: { range: '7.8 (4.7 - 11.0)', max: false },
            F180: { range: '9.7 (6.4 - 13.1)', max: false },
            F275: { range: '13.2 (8.4 - 18.1)', max: false },
            F420: { range: '17.3 (10.3 - 24.4)', max: true },
            F500: { range: '18.9 (12.0 - 25.9)', max: true },
            F600: { range: '20.8 (12.8 - 28.8)', max: true },
            F900: { range: '25.5 (15.4 - 35.6)', max: true },
            F1200: { range: '27.5 (16.0 - 38.9)', max: true },
            F2400: { range: '32.9 (18.9 - 47.0)', max: true },
          },
          {
            NeedleSet: 17,
            F120: { range: '4.3 (2.6 - 6.1)', max: false },
            F180: { range: '5.5 (3.7 - 7.4)', max: false },
            F275: { range: '7.9 (5.1 - 10.7)', max: false },
            F420: { range: '11.1 (6.6 - 15.5)', max: false },
            F500: { range: '12.4 (8.1 - 16.7)', max: false },
            F600: { range: '14.0 (8.8 - 19.2)', max: false },
            F900: { range: '18.7 (11.6 - 25.8)', max: true },
            F1200: { range: '20.9 (12.3 - 29.4)', max: true },
            F2400: { range: '27.9 (16.0 - 39.8)', max: true },
          },
          {
            NeedleSet: 18,
            F120: { range: '3.0 (1.8 - 4.2)', max: false },
            F180: { range: '3.9 (2.6 - 5.1)', max: false },
            F275: { range: '5.7 (3.7 - 7.6)', max: false },
            F420: { range: '8.1 (4.9 - 11.3)', max: false },
            F500: { range: '9.2 (6.1 - 12.3)', max: false },
            F600: { range: '10.6 (6.8 - 14.4)', max: false },
            F900: { range: '14.7 (9.3 - 20.2)', max: true },
            F1200: { range: '16.8 (10.0- 23.6)', max: true },
            F2400: { range: '24.2 (13.9 - 34.4)', max: true },
          },
          {
            NeedleSet: 19,
            F120: { range: '2.3 (1.4 - 3.2)', max: false },
            F180: { range: '3.0 (2.0 - 3.9)', max: false },
            F275: { range: '4.4 (2.9 - 5.9)', max: false },
            F420: { range: '6.4 (3.9 - 8.9)', max: false },
            F500: { range: '7.3 (4.9 - 9.8)', max: false },
            F600: { range: '8.5 (5.5 - 11.5)', max: false },
            F900: { range: '12.2 (7.7 - 16.6)', max: false },
            F1200: { range: '14.1 (8.4 - 19.8)', max: false },
            F2400: { range: '21.3 (12.3 - 30.4)', max: true },
          },
          {
            NeedleSet: 20,
            F120: { range: '1.9 (1.1 - 2.6)', max: false },
            F180: { range: '2.4 (1.6 - 3.2)', max: false },
            F275: { range: '3.6 (2.4 - 4.8)', max: false },
            F420: { range: '5.3 (3.2 - 7.4)', max: false },
            F500: { range: '6.1 (4.1 - 8.1)', max: false },
            F600: { range: '7.1 (4.6 - 9.6)', max: false },
            F900: { range: '10.4 (6.6 - 14.1)', max: false },
            F1200: { range: '12.1 (7.2 - 17.0)', max: false },
            F2400: { range: '19.1 (11.0 - 27.2)', max: true },
          },
          {
            NeedleSet: 21,
            F120: { range: '1.6 (1.0 - 2.2)', max: false },
            F180: { range: '2.0 (1.4 - 2.7)', max: false },
            F275: { range: '3.0 (2.0 - 4.1)', max: false },
            F420: { range: '4.5 (2.7 - 6.3)', max: false },
            F500: { range: '5.2 (3.5 - 6.9)', max: false },
            F600: { range: '6.1 (4.0 - 8.2)', max: false },
            F900: { range: '9.0 (5.8 - 12.2)', max: false },
            F1200: { range: '10.6 (6.4 - 14.9)', max: false },
            F2400: { range: '17.3 (10.0 - 24.6)', max: true },
          },
          {
            NeedleSet: 22,
            F120: { range: '1.3 (0.8 - 1.9)', max: false },
            F180: { range: '1.8 (1.2 - 2.3)', max: false },
            F275: { range: '2.6 (1.7 - 3.5)', max: false },
            F420: { range: '3.9 (2.4 - 5.5)', max: false },
            F500: { range: '4.6 (3.1 - 6.0)', max: false },
            F600: { range: '5.4 (3.5 - 7.2)', max: false },
            F900: { range: '8.0 (5.2 - 10.8)', max: false },
            F1200: { range: '9.5 (5.7 - 13.2)', max: false },
            F2400: { range: '15.8 (9.1 - 22.4)', max: true },
          },
          {
            NeedleSet: 23,
            F120: { range: '1.2 (0.7 - 1.6)', max: false },
            F180: { range: '1.5 (1.0 - 2.0)', max: false },
            F275: { range: '2.3 (1.5 - 3.1)', max: false },
            F420: { range: '3.5 (2.1 - 4.8)', max: false },
            F500: { range: '4.0 (2.7 - 5.3)', max: false },
            F600: { range: '4.8 (3.1 - 6.4)', max: false },
            F900: { range: '7.2 (4.7 - 9.7)', max: false },
            F1200: { range: '8.5 (5.1 - 11.9)', max: false },
            F2400: { range: '14.5 (8.4 - 20.6)', max: true },
          },
          {
            NeedleSet: 25,
            F30: { range: '2 - 4.2', max: false },
            F45: { range: '3.1 - 6.4', max: false },
            F60: { range: '4.1 - 8.2', max: false },
            F120: { range: '7.6 - 14.2', max: false },
            F180: {
              range: '10.8 - 17.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F275: {
              range: '15.3 - 25.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F420: {
              range: '20.4 - 36.6',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '25.5 - 39.5',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '28.2 - 45.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '38.8 - 61.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '41.9 - 70',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '58.3 - 95.5', max: true },
          },
          {
            NeedleSet: 26,
            F30: { range: '1 - 2.1', max: false },
            F45: { range: '1.6 - 3.3', max: false },
            F60: { range: '2.1 - 4.2', max: false },
            F120: { range: '4 - 7.5', max: false },
            F180: { range: '5.7 - 9.3', max: false },
            F275: { range: '8.3 - 13.9', max: false },
            F420: {
              range: '11.4 - 21.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '14.7 - 23',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '16.5 - 27.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: { range: '24.3 - 39.2', max: true },
            F1200: { range: '26.7 - 46.7', max: true },
            F2400: { range: '41.7 - 72.5', max: true },
          },
          {
            NeedleSet: 27,
            F30: { range: '0.7 - 1.4', max: false },
            F45: { range: '1.1 - 2.2', max: false },
            F60: { range: '1.4 - 2.9', max: false },
            F120: { range: '2.7 - 5.1', max: false },
            F180: { range: '3.9 - 6.3', max: false },
            F275: { range: '5.7 - 9.6', max: false },
            F420: { range: '7.9 - 14.8', max: false },
            F500: {
              range: '10.3 - 16.2',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '11.6 - 19.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '17.7 - 28.9',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '19.6 - 35',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '32.5 - 58.4', max: true },
          },
          {
            NeedleSet: 28,
            F30: { range: '0.5 - 1.1', max: false },
            F45: { range: '0.8 - 1.7', max: false },
            F60: { range: '1.1 - 2.1', max: false },
            F120: { range: '2 - 3.9', max: false },
            F180: { range: '2.9 - 4.8', max: false },
            F275: { range: '4.3 - 7.3', max: false },
            F420: { range: '6.1 - 11.4', max: false },
            F500: { range: '7.9 - 12.5', max: false },
            F600: {
              range: '9.0 - 15',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '13.9 - 22.8',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '15.5 - 28',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '26.6 - 48.9', max: true },
          },
          {
            NeedleSet: 29,
            F30: { range: '0.4 - 0.9', max: false },
            F45: { range: '0.6 - 1.3', max: false },
            F60: { range: '0.9 - 1.7', max: false },
            F120: { range: '1.6 - 3.1', max: false },
            F180: { range: '2.4 - 3.9', max: false },
            F275: { range: '3.5 - 5.9', max: false },
            F420: { range: '4.9 - 9.3', max: false },
            F500: { range: '6.4 - 10.2', max: false },
            F600: { range: '7.3 - 12.3', max: false },
            F900: {
              range: '11.4 - 18.9',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '12.8 - 23.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '22.5 - 42.1',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 30,
            F30: { range: '0.3 - 0.7', max: false },
            F45: { range: '0.5 - 1.1', max: false },
            F60: { range: '0.7 - 1.4', max: false },
            F120: { range: '1.4 - 2.6', max: false },
            F180: { range: '2 - 3.2', max: false },
            F275: { range: '2.9 - 5', max: false },
            F420: { range: '4.1 - 7.8', max: false },
            F500: { range: '5.4 - 8.6', max: false },
            F600: { range: '6.2 - 10.4', max: false },
            F900: {
              range: '9.7 - 16.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '10.9 - 20',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '19.5 - 36.9',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 31,
            F30: { range: '0.3 - 0.6', max: false },
            F45: { range: '0.5 - 1', max: false },
            F60: { range: '0.6 - 1.2', max: false },
            F120: { range: '1.2 - 2.2', max: false },
            F180: { range: '1.7 - 2.8', max: false },
            F275: { range: '2.5 - 4.3', max: false },
            F420: { range: '3.6 - 6.7', max: false },
            F500: { range: '4.7 - 7.4', max: false },
            F600: { range: '5.4 - 9', max: false },
            F900: { range: '8.4 - 14', max: false },
            F1200: {
              range: '9.5 - 17.5',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '17.2 - 32.9',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 32,
            F30: { range: '0.3 - 0.5', max: false },
            F45: { range: '0.4 - 0.8', max: false },
            F60: { range: '0.5 - 1.1', max: false },
            F120: { range: '1.0 - 2.0', max: false },
            F180: { range: '1.5 - 2.4', max: false },
            F275: { range: '2.2 - 3.8', max: false },
            F420: { range: '3.1 - 5.9', max: false },
            F500: { range: '4.1 - 6.6', max: false },
            F600: { range: '4.7 - 7.9', max: false },
            F900: { range: '7.5 - 12.4', max: false },
            F1200: {
              range: '8.4 - 15.6',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '15.4 - 29.6',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
        ],
      },
      {
        drugId: 18,
        syringeId: 2,
        flowValues: [
          {
            NeedleSet: 33,
            F120: { range: '10.0 (5.7 - 14.4)', max: false },
            F180: { range: '13.0 (8.2 - 17.8)', max: false },
            F275: { range: '19.3 (11.8 - 26.8)', max: true },
            F420: { range: '28.5 (16.1 - 40.9)', max: true },
            F500: { range: '32.7 (20.7 - 44.8)', max: true },
            F600: { range: '38.1 (23.2 - 53.1)', max: true },
            F900: { range: '55.7 (33.8 - 77.6)', max: true },
            F1200: { range: '65.1 (36.9 - 93.3)', max: true },
            F2400: { range: '102.4 (56.6 - 148.1)', max: true },
          },
          {
            NeedleSet: 34,
            F120: { range: '5.1 (2.9 - 7.4)', max: false },
            F180: { range: '6.7 (4.2 - 9.2)', max: false },
            F275: { range: '10.1 (6.2 - 14.0)', max: false },
            F420: { range: '15.3 (8.6 - 21.9)', max: true },
            F500: { range: '17.7 (11.3 - 24.2)', max: true },
            F600: { range: '20.9 (12.8 - 29.0)', max: true },
            F900: { range: '32.0 (19.6 - 44.4)', max: true },
            F1200: { range: '38.4 (21.7 - 55.0)', max: true },
            F2400: { range: '67.2 (36.8 - 97.6)', max: true },
          },
          {
            NeedleSet: 35,
            F120: { range: '3.4 (1.9 - 4.9)', max: false },
            F180: { range: '4.5 (2.9 - 6.2)', max: false },
            F275: { range: '6.9 (4.2 - 9.5)', max: false },
            F420: { range: '10.4 (5.9 - 15.0)', max: false },
            F500: { range: '12.2 (7.8 - 16.5)', max: false },
            F600: { range: '14.4 (8.8 - 20.0)', max: true },
            F900: { range: '22.5 (13.8 - 31.1)', max: true },
            F1200: { range: '27.2 (15.4 - 39.0)', max: true },
            F2400: { range: '50.1 (27.3 - 72.8)', max: true },
          },
          {
            NeedleSet: 36,
            F120: { range: '2.6 (1.5 - 3.7)', max: false },
            F180: { range: '3.4 (2.2 - 4.7)', max: false },
            F275: { range: '5.2 (3.2 - 7.2)', max: false },
            F420: { range: '7.9 (4.5 - 11.4)', max: false },
            F500: { range: '9.2 (5.9 - 12.6)', max: false },
            F600: { range: '11.0 (6.8 - 15.2)', max: false },
            F900: { range: '17.3 (10.6 - 24.0)', max: true },
            F1200: { range: '21.1 (11.9 - 30.2)', max: true },
            F2400: { range: '39.9 (21.7 - 58.1)', max: true },
          },
          {
            NeedleSet: 37,
            F120: { range: '1.9 (1.2 - 2.7)', max: false },
            F180: { range: '2.5 (1.7 - 3.4)', max: false },
            F275: { range: '3.9 (2.6 - 5.2)', max: false },
            F420: { range: '5.9 (3.6 - 8.2)', max: false },
            F500: { range: '6.9 (4.8 - 9.1)', max: false },
            F600: { range: '8.3 (5.5 - 11.0)', max: false },
            F900: { range: '13.1 (8.7 - 17.5)', max: false },
            F1200: { range: '15.9 (9.7 - 22.1)', max: true },
            F2400: { range: '30.7 (18.0 - 43.3)', max: true },
          },
          {
            NeedleSet: 38,
            F120: { range: '1.6 (1.0 - 2.2)', max: false },
            F180: { range: '2.1 (1.4 - 2.8)', max: false },
            F275: { range: '3.2 (2.2 - 4.3)', max: false },
            F420: { range: '5.0 (3.0 - 6.9)', max: false },
            F500: { range: '5.8 (4.0 - 7.6)', max: false },
            F600: { range: '6.9 (4.6 - 9.3)', max: false },
            F900: { range: '11.0 (7.3 - 14.7)', max: false },
            F1200: { range: '13.5 (8.2 - 18.7)', max: false },
            F2400: { range: '26.2 (15.4 - 37.1)', max: false },
          },
          {
            NeedleSet: 39,
            F120: { range: '1.4 (0.8 - 1.9)', max: false },
            F180: { range: '1.8 (1.2 - 2.4)', max: false },
            F275: { range: '2.8 (1.9 - 3.7)', max: false },
            F420: { range: '4.3 (2.6 - 5.9)', max: false },
            F500: { range: '5.0 (3.5 - 6.6)', max: false },
            F600: { range: '6.0 (4.0 - 8.0)', max: false },
            F900: { range: '9.5 (6.3 - 12.7)', max: false },
            F1200: { range: '11.6 (7.1 - 16.2)', max: false },
            F2400: { range: '22.9 (13.4 - 32.4)', max: true },
          },
          {
            NeedleSet: 40,
            F120: { range: '1.2 (0.7 - 1.7)', max: false },
            F180: { range: '1.6 (1.1 - 2.1)', max: false },
            F275: { range: '2.4 (1.6 - 3.3)', max: false },
            F420: { range: '3.7 (2.3 - 5.2)', max: false },
            F500: { range: '4.4 (3.0 - 5.8)', max: false },
            F600: { range: '5.2 (3.5 - 7.0)', max: false },
            F900: { range: '8.4 (5.6 - 11.2)', max: false },
            F1200: { range: '10.3 (6.3 - 14.3)', max: false },
            F2400: { range: '20.3 (11.9 - 28.8)', max: true },
          },
          {
            NeedleSet: 16,
            F120: { range: '8.5 (4.7 - 12.2)', max: false },
            F180: { range: '10.5 (6.3 - 14.6)', max: false },
            F275: { range: '14.3 (8.3 - 20.2)', max: true },
            F420: { range: '18.7 (10.3 - 27.2)', max: true },
            F500: { range: '20.4 (11.9 - 28.9)', max: true },
            F600: { range: '22.4 (12.7 - 32.1)', max: true },
            F900: { range: '27.5 (15.4 - 39.7)', max: true },
            F1200: { range: '29.7 (16.0 - 43.4)', max: true },
            F2400: { range: '35.6 (18.8 - 52.4)', max: true },
          },
          {
            NeedleSet: 17,
            F120: { range: '4.7 (2.6 - 6.8)', max: false },
            F180: { range: '6.0 (3.7 - 8.2)', max: false },
            F275: { range: '8.5 (5.1 - 12.0)', max: false },
            F420: { range: '11.9 (6.6 - 17.3)', max: false },
            F500: { range: '13.3 (8.1 - 18.6)', max: false },
            F600: { range: '15.1 (8.8 - 21.4)', max: true },
            F900: { range: '20.1 (11.5 - 28.7)', max: true },
            F1200: { range: '22.5 (12.3 - 32.8)', max: true },
            F2400: { range: '30.1 (16.0 - 44.3)', max: true },
          },
          {
            NeedleSet: 18,
            F120: { range: '3.2 (1.8 - 4.7)', max: false },
            F180: { range: '4.2 (2.6 - 5.7)', max: false },
            F275: { range: '6.1 (3.7 - 8.5)', max: false },
            F420: { range: '8.8 (4.9 - 12.6)', max: false },
            F500: { range: '9.9 (6.1 - 13.7)', max: false },
            F600: { range: '11.4 (6.7 - 16.0)', max: false },
            F900: { range: '15.9 (9.3 - 22.5)', max: true },
            F1200: { range: '18.1 (9.9 - 26.4)', max: true },
            F2400: { range: '26.1 (13.9 - 38.4)', max: true },
          },
          {
            NeedleSet: 19,
            F120: { range: '2.5 (1.4 - 3.6)', max: false },
            F180: { range: '3.2 (2.0 - 4.4)', max: false },
            F275: { range: '4.7 (2.9 - 6.6)', max: false },
            F420: { range: '6.9 (3.9 - 10.0)', max: false },
            F500: { range: '7.9 (4.9 - 10.9)', max: false },
            F600: { range: '9.1 (5.4 - 12.8)', max: false },
            F900: { range: '13.1 (7.7 - 18.5)', max: false },
            F1200: { range: '15.2 (8.4 - 22.0)', max: true },
            F2400: { range: '23.1 (12.2 - 33.9)', max: true },
          },
          {
            NeedleSet: 20,
            F120: { range: '2.0 (1.1 - 2.9)', max: false },
            F180: { range: '2.6 (1.6 - 3.6)', max: false },
            F275: { range: '3.9 (2.4 - 5.4)', max: false },
            F420: { range: '5.7 (3.2 - 8.2)', max: false },
            F500: { range: '6.6 (4.1 - 9.0)', max: false },
            F600: { range: '7.6 (4.6 - 10.7)', max: false },
            F900: { range: '11.2 (6.6 - 15.7)', max: false },
            F1200: { range: '13.1 (7.2 - 18.9)', max: true },
            F2400: { range: '20.6 (11.0 - 30.3)', max: true },
          },
          {
            NeedleSet: 21,
            F120: { range: '1.7 (0.9 - 2.4)', max: false },
            F180: { range: '2.2 (1.4 - 3.0)', max: false },
            F275: { range: '3.3 (2.0 - 4.6)', max: false },
            F420: { range: '4.9 (2.7 - 7.0)', max: false },
            F500: { range: '5.6 (3.5 - 7.7)', max: false },
            F600: { range: '6.6 (3.9 - 9.2)', max: false },
            F900: { range: '9.7 (5.8 - 13.6)', max: false },
            F1200: { range: '11.5 (6.4 - 16.6)', max: false },
            F2400: { range: '18.7 (9.9 - 27.4)', max: true },
          },
          {
            NeedleSet: 22,
            F120: { range: '1.3 (0.8 - 1.9)', max: false },
            F180: { range: '1.8 (1.2 - 2.3)', max: false },
            F275: { range: '2.6 (1.7 - 3.5)', max: false },
            F420: { range: '3.9 (2.4 - 5.5)', max: false },
            F500: { range: '4.6 (3.1 - 6.0)', max: false },
            F600: { range: '5.4 (3.5 - 7.2)', max: false },
            F900: { range: '8.0 (5.2 - 10.8)', max: false },
            F1200: { range: '9.5 (5.7 - 13.2)', max: false },
            F2400: { range: '15.8 (9.1 - 22.4)', max: true },
          },
          {
            NeedleSet: 23,
            F120: { range: '1.2 (0.7 - 1.6)', max: false },
            F180: { range: '1.5 (1.0 - 2.0)', max: false },
            F275: { range: '2.3 (1.5 - 3.1)', max: false },
            F420: { range: '3.5 (2.1 - 4.8)', max: false },
            F500: { range: '4.0 (2.7 - 5.3)', max: false },
            F600: { range: '4.8 (3.1 - 6.4)', max: false },
            F900: { range: '7.2 (4.7 - 9.7)', max: false },
            F1200: { range: '8.5 (5.1 - 11.9)', max: false },
            F2400: { range: '14.5 (8.4 - 20.6)', max: true },
          },
          {
            NeedleSet: 25,
            F30: { range: '2 - 4.2', max: false },
            F45: { range: '3.1 - 6.4', max: false },
            F60: { range: '4.1 - 8.2', max: false },
            F120: { range: '7.6 - 14.2', max: false },
            F180: {
              range: '10.8 - 17.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F275: {
              range: '15.3 - 25.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F420: {
              range: '20.4 - 36.6',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '25.5 - 39.5',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '28.2 - 45.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '38.8 - 61.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '41.9 - 70',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '58.3 - 95.5', max: true },
          },
          {
            NeedleSet: 26,
            F30: { range: '1 - 2.1', max: false },
            F45: { range: '1.6 - 3.3', max: false },
            F60: { range: '2.1 - 4.2', max: false },
            F120: { range: '4 - 7.5', max: false },
            F180: { range: '5.7 - 9.3', max: false },
            F275: { range: '8.3 - 13.9', max: false },
            F420: {
              range: '11.4 - 21.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '14.7 - 23',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '16.5 - 27.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: { range: '24.3 - 39.2', max: true },
            F1200: { range: '26.7 - 46.7', max: true },
            F2400: { range: '41.7 - 72.5', max: true },
          },
          {
            NeedleSet: 27,
            F30: { range: '0.7 - 1.4', max: false },
            F45: { range: '1.1 - 2.2', max: false },
            F60: { range: '1.4 - 2.9', max: false },
            F120: { range: '2.7 - 5.1', max: false },
            F180: { range: '3.9 - 6.3', max: false },
            F275: { range: '5.7 - 9.6', max: false },
            F420: { range: '7.9 - 14.8', max: false },
            F500: {
              range: '10.3 - 16.2',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '11.6 - 19.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '17.7 - 28.9',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '19.6 - 35',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '32.5 - 58.4', max: true },
          },
          {
            NeedleSet: 28,
            F30: { range: '0.5 - 1.1', max: false },
            F45: { range: '0.8 - 1.7', max: false },
            F60: { range: '1.1 - 2.1', max: false },
            F120: { range: '2 - 3.9', max: false },
            F180: { range: '2.9 - 4.8', max: false },
            F275: { range: '4.3 - 7.3', max: false },
            F420: { range: '6.1 - 11.4', max: false },
            F500: { range: '7.9 - 12.5', max: false },
            F600: {
              range: '9.0 - 15',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '13.9 - 22.8',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '15.5 - 28',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '26.6 - 48.9', max: true },
          },
          {
            NeedleSet: 29,
            F30: { range: '0.4 - 0.9', max: false },
            F45: { range: '0.6 - 1.3', max: false },
            F60: { range: '0.9 - 1.7', max: false },
            F120: { range: '1.6 - 3.1', max: false },
            F180: { range: '2.4 - 3.9', max: false },
            F275: { range: '3.5 - 5.9', max: false },
            F420: { range: '4.9 - 9.3', max: false },
            F500: { range: '6.4 - 10.2', max: false },
            F600: { range: '7.3 - 12.3', max: false },
            F900: {
              range: '11.4 - 18.9',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '12.8 - 23.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '22.5 - 42.1',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 30,
            F30: { range: '0.3 - 0.7', max: false },
            F45: { range: '0.5 - 1.1', max: false },
            F60: { range: '0.7 - 1.4', max: false },
            F120: { range: '1.4 - 2.6', max: false },
            F180: { range: '2 - 3.2', max: false },
            F275: { range: '2.9 - 5', max: false },
            F420: { range: '4.1 - 7.8', max: false },
            F500: { range: '5.4 - 8.6', max: false },
            F600: { range: '6.2 - 10.4', max: false },
            F900: {
              range: '9.7 - 16.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '10.9 - 20',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '19.5 - 36.9',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 31,
            F30: { range: '0.3 - 0.6', max: false },
            F45: { range: '0.5 - 1', max: false },
            F60: { range: '0.6 - 1.2', max: false },
            F120: { range: '1.2 - 2.2', max: false },
            F180: { range: '1.7 - 2.8', max: false },
            F275: { range: '2.5 - 4.3', max: false },
            F420: { range: '3.6 - 6.7', max: false },
            F500: { range: '4.7 - 7.4', max: false },
            F600: { range: '5.4 - 9', max: false },
            F900: { range: '8.4 - 14', max: false },
            F1200: {
              range: '9.5 - 17.5',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '17.2 - 32.9',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 32,
            F30: { range: '0.3 - 0.5', max: false },
            F45: { range: '0.4 - 0.8', max: false },
            F60: { range: '0.5 - 1.1', max: false },
            F120: { range: '1.0 - 2.0', max: false },
            F180: { range: '1.5 - 2.4', max: false },
            F275: { range: '2.2 - 3.8', max: false },
            F420: { range: '3.1 - 5.9', max: false },
            F500: { range: '4.1 - 6.6', max: false },
            F600: { range: '4.7 - 7.9', max: false },
            F900: { range: '7.5 - 12.4', max: false },
            F1200: {
              range: '8.4 - 15.6',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '15.4 - 29.6',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
        ],
      },
      {
        drugId: 18,
        syringeId: 3,
        flowValues: [
          {
            NeedleSet: 33,
            F120: { range: '8.2 (3.7 - 12.8)', max: false },
            F180: { range: '10.6 (5.4 - 15.8)', max: false },
            F275: { range: '15.8 (7.8 - 23.8)', max: true },
            F420: { range: '23.5 (10.7 - 36.3)', max: true },
            F500: { range: '26.7 (13.6 - 39.8)', max: true },
            F600: { range: '31.2 (15.3 - 47.1)', max: true },
            F900: { range: '45.6 (22.3 - 68.9)', max: true },
            F1200: { range: '53.6 (24.3 - 82.8)', max: true },
            F2400: { range: '84.4 (37.4 - 131.4)', max: true },
          },
          {
            NeedleSet: 34,
            F120: { range: '4.2 (1.9 - 6.5)', max: false },
            F180: { range: '5.5 (2.8 - 8.1)', max: false },
            F275: { range: '8.3 (4.1 - 12.5)', max: false },
            F420: { range: '12.6 (5.7 - 19.5)', max: false },
            F500: { range: '14.4 (7.4 - 21.5)', max: true },
            F600: { range: '17.1 (8.4 - 25.8)', max: true },
            F900: { range: '26.2 (12.9 - 39.4)', max: true },
            F1200: { range: '31.6 (14.3 - 48.8)', max: true },
            F2400: { range: '55.5 (24.3 - 86.6)', max: true },
          },
          {
            NeedleSet: 35,
            F120: { range: '2.8 (1.3 - 4.4)', max: false },
            F180: { range: '3.7 (1.9 - 5.5)', max: false },
            F275: { range: '5.6 (2.8 - 8.4)', max: false },
            F420: { range: '8.6 (3.9 - 13.3)', max: false },
            F500: { range: '9.9 (5.1 - 14.7)', max: false },
            F600: { range: '11.8 (5.8 - 17.7)', max: false },
            F900: { range: '18.4 (9.1 - 27.6)', max: true },
            F1200: { range: '22.4 (10.1 - 34.6)', max: true },
            F2400: { range: '41.3 (18.0 - 64.6)', max: true },
          },
          {
            NeedleSet: 36,
            F120: { range: '2.1 (1.0 - 3.3)', max: false },
            F180: { range: '2.8 (1.4 - 4.1)', max: false },
            F275: { range: '4.2 (2.1 - 6.4)', max: false },
            F420: { range: '6.5 (3.0 - 10.1)', max: false },
            F500: { range: '7.5 (3.9 - 11.2)', max: false },
            F600: { range: '9.0 (4.5 - 13.5)', max: false },
            F900: { range: '14.1 (7.0 - 21.3)', max: true },
            F1200: { range: '17.3 (7.9 - 26.8)', max: true },
            F2400: { range: '32.9 (14.3 - 51.5)', max: true },
          },
          {
            NeedleSet: 37,
            F120: { range: '1.9 (1.2 - 2.7)', max: false },
            F180: { range: '2.5 (1.7 - 3.4)', max: false },
            F275: { range: '3.9 (2.6 - 5.2)', max: false },
            F420: { range: '5.9 (3.6 - 8.2)', max: false },
            F500: { range: '6.9 (4.8 - 9.1)', max: false },
            F600: { range: '8.3 (5.5 - 11.0)', max: false },
            F900: { range: '13.1 (8.7 - 17.5)', max: false },
            F1200: { range: '15.9 (9.7 - 22.1)', max: true },
            F2400: { range: '30.7 (18.0 - 43.3)', max: true },
          },
          {
            NeedleSet: 38,
            F120: { range: '1.6 (1.0 - 2.2)', max: false },
            F180: { range: '2.1 (1.4 - 2.8)', max: false },
            F275: { range: '3.2 (2.2 - 4.3)', max: false },
            F420: { range: '5.0 (3.0 - 6.9)', max: false },
            F500: { range: '5.8 (4.0 - 7.6)', max: false },
            F600: { range: '6.9 (4.6 - 9.3)', max: false },
            F900: { range: '11.0 (7.3 - 14.7)', max: false },
            F1200: { range: '13.5 (8.2 - 18.7)', max: false },
            F2400: { range: '26.2 (15.4 - 37.1)', max: false },
          },
          {
            NeedleSet: 39,
            F120: { range: '1.4 (0.8 - 1.9)', max: false },
            F180: { range: '1.8 (1.2 - 2.4)', max: false },
            F275: { range: '2.8 (1.9 - 3.7)', max: false },
            F420: { range: '4.3 (2.6 - 5.9)', max: false },
            F500: { range: '5.0 (3.5 - 6.6)', max: false },
            F600: { range: '6.0 (4.0 - 8.0)', max: false },
            F900: { range: '9.5 (6.3 - 12.7)', max: false },
            F1200: { range: '11.6 (7.1 - 16.2)', max: false },
            F2400: { range: '22.9 (13.4 - 32.4)', max: true },
          },
          {
            NeedleSet: 40,
            F120: { range: '1.2 (0.7 - 1.7)', max: false },
            F180: { range: '1.6 (1.1 - 2.1)', max: false },
            F275: { range: '2.4 (1.6 - 3.3)', max: false },
            F420: { range: '3.7 (2.3 - 5.2)', max: false },
            F500: { range: '4.4 (3.0 - 5.8)', max: false },
            F600: { range: '5.2 (3.5 - 7.0)', max: false },
            F900: { range: '8.4 (5.6 - 11.2)', max: false },
            F1200: { range: '10.3 (6.3 - 14.3)', max: false },
            F2400: { range: '20.3 (11.9 - 28.8)', max: true },
          },
          {
            NeedleSet: 16,
            F120: { range: '7.0 (3.1 - 10.8)', max: false },
            F180: { range: '8.6 (4.2 - 13.0)', max: false },
            F275: { range: '11.7 (5.5 - 17.9)', max: false },
            F420: { range: '15.5 (6.8 - 24.1)', max: true },
            F500: { range: '16.7 (7.9 - 25.6)', max: true },
            F600: { range: '18.4 (8.4 - 28.5)', max: true },
            F900: { range: '22.7 (10.1 - 35.2)', max: true },
            F1200: { range: '24.5 (10.5 - 38.5)', max: true },
            F2400: { range: '29.5 (12.4 - 46.5)', max: true },
          },
          {
            NeedleSet: 17,
            F120: { range: '3.9 (1.7 - 6.0)', max: false },
            F180: { range: '4.9 (2.4 - 7.3)', max: false },
            F275: { range: '7.0 (3.4 - 10.6)', max: false },
            F420: { range: '9.8 (4.4 - 15.3)', max: false },
            F500: { range: '10.9 (5.3 - 16.5)', max: false },
            F600: { range: '12.4 (5.8 - 19.0)', max: false },
            F900: { range: '16.6 (7.6 - 25.5)', max: true },
            F1200: { range: '18.6 (8.1 - 29.1)', max: true },
            F2400: { range: '24.9 (10.5 - 39.3)', max: true },
          },
          {
            NeedleSet: 18,
            F120: { range: '2.7 (1.2 - 4.1)', max: false },
            F180: { range: '3.4 (1.7 - 5.1)', max: false },
            F275: { range: '5.0 (2.4 - 7.5)', max: false },
            F420: { range: '7.2 (3.2 - 11.2)', max: false },
            F500: { range: '8.1 (4.0 - 12.2)', max: false },
            F600: { range: '9.3 (4.4 - 14.2)', max: false },
            F900: { range: '13.0 (6.1 - 20.0)', max: true },
            F1200: { range: '15.0 (6.6 - 23.4)', max: true },
            F2400: { range: '21.6 (9.1 - 34.1)', max: true },
          },
          {
            NeedleSet: 19,
            F120: { range: '2.0 (0.9 - 3.2)', max: false },
            F180: { range: '2.6 (1.3 - 3.9)', max: false },
            F275: { range: '3.9 (1.9 - 5.9)', max: false },
            F420: { range: '5.7 (2.5 - 8.9)', max: false },
            F500: { range: '6.4 (3.2 - 9.7)', max: false },
            F600: { range: '7.5 (3.6 - 11.4)', max: false },
            F900: { range: '10.8 (5.1 - 16.4)', max: false },
            F1200: { range: '12.5 (5.5 - 19.6)', max: false },
            F2400: { range: '19.1 (8.1 - 30.1)', max: true },
          },
          {
            NeedleSet: 20,
            F120: { range: '1.7 (0.7 - 2.6)', max: false },
            F180: { range: '2.1 (1.1 - 3.2)', max: false },
            F275: { range: '3.2 (1.6 - 4.8)', max: false },
            F420: { range: '4.7 (2.1 - 7.3)', max: false },
            F500: { range: '5.4 (2.7 - 8.0)', max: false },
            F600: { range: '6.3 (3.0 - 9.5)', max: false },
            F900: { range: '9.2 (4.4 - 13.9)', max: false },
            F1200: { range: '10.8 (4.8 - 16.8)', max: false },
            F2400: { range: '17.1 (7.2 - 26.9)', max: true },
          },
          {
            NeedleSet: 21,
            F120: { range: '1.4 (0.6 - 2.1)', max: false },
            F180: { range: '1.8 (0.9 - 2.7)', max: false },
            F275: { range: '2.7 (1.3 - 4.0)', max: false },
            F420: { range: '4.0 (1.8 - 6.2)', max: false },
            F500: { range: '4.6 (2.3 - 6.8)', max: false },
            F600: { range: '5.4 (2.6 - 8.1)', max: false },
            F900: { range: '8.0 (3.8 - 12.1)', max: false },
            F1200: { range: '9.5 (4.2 - 14.7)', max: false },
            F2400: { range: '15.4 (6.6 - 24.3)', max: true },
          },
          {
            NeedleSet: 22,
            F120: { range: '1.3 (0.8 - 1.9)', max: false },
            F180: { range: '1.8 (1.2 - 2.3)', max: false },
            F275: { range: '2.6 (1.7 - 3.5)', max: false },
            F420: { range: '3.9 (2.4 - 5.5)', max: false },
            F500: { range: '4.6 (3.1 - 6.0)', max: false },
            F600: { range: '5.4 (3.5 - 7.2)', max: false },
            F900: { range: '8.0 (5.2 - 10.8)', max: false },
            F1200: { range: '9.5 (5.7 - 13.2)', max: false },
            F2400: { range: '15.8 (9.1 - 22.4)', max: true },
          },
          {
            NeedleSet: 23,
            F120: { range: '1.2 (0.7 - 1.6)', max: false },
            F180: { range: '1.5 (1.0 - 2.0)', max: false },
            F275: { range: '2.3 (1.5 - 3.1)', max: false },
            F420: { range: '3.5 (2.1 - 4.8)', max: false },
            F500: { range: '4.0 (2.7 - 5.3)', max: false },
            F600: { range: '4.8 (3.1 - 6.4)', max: false },
            F900: { range: '7.2 (4.7 - 9.7)', max: false },
            F1200: { range: '8.5 (5.1 - 11.9)', max: false },
            F2400: { range: '14.5 (8.4 - 20.6)', max: true },
          },
          {
            NeedleSet: 25,
            F30: { range: '2 - 4.2', max: false },
            F45: { range: '3.1 - 6.4', max: false },
            F60: { range: '4.1 - 8.2', max: false },
            F120: { range: '7.6 - 14.2', max: false },
            F180: {
              range: '10.8 - 17.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F275: {
              range: '15.3 - 25.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F420: {
              range: '20.4 - 36.6',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '25.5 - 39.5',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '28.2 - 45.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '38.8 - 61.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '41.9 - 70',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '58.3 - 95.5', max: true },
          },
          {
            NeedleSet: 26,
            F30: { range: '1 - 2.1', max: false },
            F45: { range: '1.6 - 3.3', max: false },
            F60: { range: '2.1 - 4.2', max: false },
            F120: { range: '4 - 7.5', max: false },
            F180: { range: '5.7 - 9.3', max: false },
            F275: { range: '8.3 - 13.9', max: false },
            F420: {
              range: '11.4 - 21.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '14.7 - 23',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '16.5 - 27.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: { range: '24.3 - 39.2', max: true },
            F1200: { range: '26.7 - 46.7', max: true },
            F2400: { range: '41.7 - 72.5', max: true },
          },
          {
            NeedleSet: 27,
            F30: { range: '0.7 - 1.4', max: false },
            F45: { range: '1.1 - 2.2', max: false },
            F60: { range: '1.4 - 2.9', max: false },
            F120: { range: '2.7 - 5.1', max: false },
            F180: { range: '3.9 - 6.3', max: false },
            F275: { range: '5.7 - 9.6', max: false },
            F420: { range: '7.9 - 14.8', max: false },
            F500: {
              range: '10.3 - 16.2',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '11.6 - 19.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '17.7 - 28.9',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '19.6 - 35',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '32.5 - 58.4', max: true },
          },
          {
            NeedleSet: 28,
            F30: { range: '0.5 - 1.1', max: false },
            F45: { range: '0.8 - 1.7', max: false },
            F60: { range: '1.1 - 2.1', max: false },
            F120: { range: '2 - 3.9', max: false },
            F180: { range: '2.9 - 4.8', max: false },
            F275: { range: '4.3 - 7.3', max: false },
            F420: { range: '6.1 - 11.4', max: false },
            F500: { range: '7.9 - 12.5', max: false },
            F600: {
              range: '9.0 - 15',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '13.9 - 22.8',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '15.5 - 28',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '26.6 - 48.9', max: true },
          },
          {
            NeedleSet: 29,
            F30: { range: '0.4 - 0.9', max: false },
            F45: { range: '0.6 - 1.3', max: false },
            F60: { range: '0.9 - 1.7', max: false },
            F120: { range: '1.6 - 3.1', max: false },
            F180: { range: '2.4 - 3.9', max: false },
            F275: { range: '3.5 - 5.9', max: false },
            F420: { range: '4.9 - 9.3', max: false },
            F500: { range: '6.4 - 10.2', max: false },
            F600: { range: '7.3 - 12.3', max: false },
            F900: {
              range: '11.4 - 18.9',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '12.8 - 23.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '22.5 - 42.1',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 30,
            F30: { range: '0.3 - 0.7', max: false },
            F45: { range: '0.5 - 1.1', max: false },
            F60: { range: '0.7 - 1.4', max: false },
            F120: { range: '1.4 - 2.6', max: false },
            F180: { range: '2 - 3.2', max: false },
            F275: { range: '2.9 - 5', max: false },
            F420: { range: '4.1 - 7.8', max: false },
            F500: { range: '5.4 - 8.6', max: false },
            F600: { range: '6.2 - 10.4', max: false },
            F900: {
              range: '9.7 - 16.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '10.9 - 20',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '19.5 - 36.9',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 31,
            F30: { range: '0.3 - 0.6', max: false },
            F45: { range: '0.5 - 1', max: false },
            F60: { range: '0.6 - 1.2', max: false },
            F120: { range: '1.2 - 2.2', max: false },
            F180: { range: '1.7 - 2.8', max: false },
            F275: { range: '2.5 - 4.3', max: false },
            F420: { range: '3.6 - 6.7', max: false },
            F500: { range: '4.7 - 7.4', max: false },
            F600: { range: '5.4 - 9', max: false },
            F900: { range: '8.4 - 14', max: false },
            F1200: {
              range: '9.5 - 17.5',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '17.2 - 32.9',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 32,
            F30: { range: '0.3 - 0.5', max: false },
            F45: { range: '0.4 - 0.8', max: false },
            F60: { range: '0.5 - 1.1', max: false },
            F120: { range: '1.0 - 2.0', max: false },
            F180: { range: '1.5 - 2.4', max: false },
            F275: { range: '2.2 - 3.8', max: false },
            F420: { range: '3.1 - 5.9', max: false },
            F500: { range: '4.1 - 6.6', max: false },
            F600: { range: '4.7 - 7.9', max: false },
            F900: { range: '7.5 - 12.4', max: false },
            F1200: {
              range: '8.4 - 15.6',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '15.4 - 29.6',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
        ],
      },
      {
        drugId: 19,
        flowValues: [
          {
            NeedleSet: 33,
            F120: { range: '11.5 (8.0 - 15.1)', max: false },
            F180: { range: '15.1 (11.5 - 18.7)', max: false },
            F275: { range: '22.5 (16.8 - 28.2)', max: true },
            F420: { range: '33.1 (23.2 - 43.0)', max: true },
            F500: { range: '38.5 (29.9 - 47.1)', max: true },
            F600: { range: '44.8 (33.8 - 55.8)', max: true },
            F900: { range: '66.0 (50.3 - 81.7)', max: true },
            F1200: { range: '76.8 (55.6 - 98.0)', max: true },
            F2400: { range: '122.5 (88.8 - 156.3)', max: true },
          },
          {
            NeedleSet: 34,
            F120: { range: '5.9 (4.0 - 7.7)', max: false },
            F180: { range: '7.8 (5.9 - 9.6)', max: false },
            F275: { range: '11.7 (8.7 - 14.7)', max: false },
            F420: { range: '17.6 (12.2 - 23.0)', max: true },
            F500: { range: '20.7 (16.0 - 25.4)', max: true },
            F600: { range: '24.4 (18.2 - 30.5)', max: true },
            F900: { range: '37.5 (28.3 - 46.7)', max: true },
            F1200: { range: '44.7 (31.7 - 57.7)', max: true },
            F2400: { range: '79.1 (55.3 - 102.8)', max: true },
          },
          {
            NeedleSet: 35,
            F120: { range: '4.0 (2.7 - 5.2)', max: false },
            F180: { range: '5.2 (4.0 - 6.5)', max: false },
            F275: { range: '7.9 (5.9 - 10.0)', max: false },
            F420: { range: '12.0 (8.3 - 15.7)', max: false },
            F500: { range: '14.2 (11.0 - 17.4)', max: false },
            F600: { range: '16.7 (12.5 - 21.0)', max: true },
            F900: { range: '26.2 (19.7 - 32.7)', max: true },
            F1200: { range: '31.5 (22.2 - 40.9)', max: true },
            F2400: { range: '58.4 (40.2 - 76.6)', max: true },
          },
          {
            NeedleSet: 36,
            F120: { range: '3.0 (2.0 - 3.9)', max: false },
            F180: { range: '3.9 (3.0 - 4.9)', max: false },
            F275: { range: '6.0 (4.5 - 7.5)', max: false },
            F420: { range: '9.1 (6.3 - 11.9)', max: false },
            F500: { range: '10.8 (8.3 - 13.2)', max: false },
            F600: { range: '12.8 (9.5 - 16.0)', max: false },
            F900: { range: '20.1 (15.1 - 25.2)', max: true },
            F1200: { range: '24.3 (17.0 - 31.7)', max: true },
            F2400: { range: '46.3 (31.5 - 61.1)', max: true },
          },
          {
            NeedleSet: 37,
            F120: { range: '2.4 (1.6 - 3.1)', max: false },
            F180: { range: '3.2 (2.4 - 3.9)', max: false },
            F275: { range: '4.8 (3.6 - 6.1)', max: false },
            F420: { range: '7.3 (5.1 - 9.6)', max: false },
            F500: { range: '8.7 (6.7 - 10.7)', max: false },
            F600: { range: '10.3 (7.7 - 12.9)', max: false },
            F900: { range: '16.3 (12.2 - 20.4)', max: true },
            F1200: { range: '19.8 (13.8 - 25.8)', max: true },
            F2400: { range: '38.4 (26.0 - 50.8)', max: true },
          },
          {
            NeedleSet: 38,
            F120: { range: '2.0 (1.4 - 2.6)', max: false },
            F180: { range: '2.6 (2.0 - 3.3)', max: false },
            F275: { range: '4.0 (3.0 - 5.1)', max: false },
            F420: { range: '6.1 (4.2 - 8.1)', max: false },
            F500: { range: '7.3 (5.6 - 8.9)', max: false },
            F600: { range: '8.6 (6.4 - 10.8)', max: false },
            F900: { range: '13.8 (10.3 - 17.2)', max: false },
            F1200: { range: '16.7 (11.7 - 21.8)', max: true },
            F2400: { range: '32.7 (22.0 - 43.4)', max: true },
          },
          {
            NeedleSet: 39,
            F120: { range: '1.7 (1.2 - 2.2)', max: false },
            F180: { range: '2.3 (1.7 - 2.8)', max: false },
            F275: { range: '3.5 (2.6 - 4.3)', max: false },
            F420: { range: '5.3 (3.6 - 6.9)', max: false },
            F500: { range: '6.3 (4.8 - 7.7)', max: false },
            F600: { range: '7.4 (5.5 - 9.3)', max: false },
            F900: { range: '11.9 (8.9 - 14.9)', max: false },
            F1200: { range: '14.5 (10.1 - 18.9)', max: false },
            F2400: { range: '28.6 (19.2 - 38.0)', max: true },
          },
          {
            NeedleSet: 40,
            F120: { range: '1.5 (1.0 - 2.0)', max: false },
            F180: { range: '2.0 (1.5 - 2.5)', max: false },
            F275: { range: '3.0 (2.3 - 3.8)', max: false },
            F420: { range: '4.6 (3.2 - 6.1)', max: false },
            F500: { range: '5.5 (4.2 - 6.7)', max: false },
            F600: { range: '6.5 (4.9 - 8.2)', max: false },
            F900: { range: '10.5 (7.8 - 13.1)', max: false },
            F1200: { range: '12.7 (8.9 - 16.6)', max: false },
            F2400: { range: '25.3 (17.0 - 33.7)', max: true },
          },
          {
            NeedleSet: 16,
            F120: { range: '9.9 (7.0 - 12.9)', max: false },
            F180: { range: '12.5 (9.7 - 15.4)', max: false },
            F275: { range: '17.2 (13.1 - 21.2)', max: true },
            F420: { range: '22.7 (16.7 - 28.7)', max: true },
            F500: { range: '25.2 (19.9 - 30.5)', max: true },
            F600: { range: '27.7 (21.6 - 33.9)', max: true },
            F900: { range: '34.6 (27.3 - 42.0)', max: true },
            F1200: { range: '37.3 (28.8 - 45.9)', max: true },
            F2400: { range: '45.7 (35.7 - 55.6)', max: true },
          },
          {
            NeedleSet: 17,
            F120: { range: '5.4 (3.8 - 7.1)', max: false },
            F180: { range: '7.0 (5.4 - 8.7)', max: false },
            F275: { range: '10.1 (7.6 - 12.6)', max: false },
            F420: { range: '14.2 (10.1 - 18.2)', max: false },
            F500: { range: '16.1 (12.6 - 19.6)', max: false },
            F600: { range: '18.3 (14.0 - 22.5)', max: true },
            F900: { range: '24.8 (19.2 - 30.3)', max: true },
            F1200: { range: '27.6 (20.7 - 34.6)', max: true },
            F2400: { range: '37.8 (28.7 - 46.9)', max: true },
          },
          {
            NeedleSet: 18,
            F120: { range: '3.7 (2.6 - 4.9)', max: false },
            F180: { range: '4.9 (3.7 - 6.0)', max: false },
            F275: { range: '7.2 (5.4 - 8.9)', max: false },
            F420: { range: '10.3 (7.3 - 13.3)', max: false },
            F500: { range: '11.9 (9.3 - 14.5)', max: false },
            F600: { range: '13.6 (10.3 - 16.9)', max: false },
            F900: { range: '19.3 (14.8 - 23.7)', max: true },
            F1200: { range: '22.0 (16.2 - 27.7)', max: true },
            F2400: { range: '32.3 (24.0 - 40.6)', max: true },
          },
          {
            NeedleSet: 19,
            F120: { range: '2.9 (2.0 - 3.7)', max: false },
            F180: { range: '3.7 (2.9 - 4.6)', max: false },
            F275: { range: '5.5 (4.2 - 6.9)', max: false },
            F420: { range: '8.1 (5.7 - 10.5)', max: false },
            F500: { range: '9.4 (7.3 - 11.5)', max: false },
            F600: { range: '10.9 (8.2 - 13.5)', max: false },
            F900: { range: '15.8 (12.1 - 19.5)', max: false },
            F1200: { range: '18.2 (13.3 - 23.2)', max: true },
            F2400: { range: '28.2 (20.6 - 35.8)', max: true },
          },
          {
            NeedleSet: 20,
            F120: { range: '2.3 (1.6 - 3.0)', max: false },
            F180: { range: '3.0 (2.3 - 3.8)', max: false },
            F275: { range: '4.5 (3.4 - 5.7)', max: false },
            F420: { range: '6.7 (4.7 - 8.7)', max: false },
            F500: { range: '7.8 (6.0 - 9.5)', max: false },
            F600: { range: '9.0 (6.8 - 11.2)', max: false },
            F900: { range: '13.3 (10.2 - 16.5)', max: false },
            F1200: { range: '15.6 (11.2 - 19.9)', max: false },
            F2400: { range: '25.0 (18.1 - 32.0)', max: true },
          },
          {
            NeedleSet: 21,
            F120: { range: '1.9 (1.3 - 2.5)', max: false },
            F180: { range: '2.5 (1.9 - 3.2)', max: false },
            F275: { range: '3.8 (2.9 - 4.8)', max: false },
            F420: { range: '5.7 (3.9 - 7.4)', max: false },
            F500: { range: '6.6 (5.1 - 8.1)', max: false },
            F600: { range: '7.7 (5.8 - 9.6)', max: false },
            F900: { range: '11.6 (8.8 - 14.4)', max: false },
            F1200: { range: '13.6 (9.8 - 17.4)', max: false },
            F2400: { range: '22.5 (16.1 - 28.9)', max: true },
          },
          {
            NeedleSet: 22,
            F120: { range: '1.7 (1.1 - 2.2)', max: false },
            F180: { range: '2.2 (1.7 - 2.7)', max: false },
            F275: { range: '3.3 (2.5 - 4.1)', max: false },
            F420: { range: '4.9 (3.4 - 6.4)', max: false },
            F500: { range: '5.8 (4.5 - 7.1)', max: false },
            F600: { range: '6.7 (5.1 - 8.4)', max: false },
            F900: { range: '10.2 (7.7 - 12.7)', max: false },
            F1200: { range: '12.1 (8.6 - 15.5)', max: false },
            F2400: { range: '20.4 (14.5 - 26.4)', max: true },
          },
          {
            NeedleSet: 23,
            F120: { range: '1.5 (1.0 - 1.9)', max: false },
            F180: { range: '1.9 (1.5 - 2.4)', max: false },
            F275: { range: '2.9 (2.2 - 3.7)', max: false },
            F420: { range: '4.4 (3.0 - 5.7)', max: false },
            F500: { range: '5.1 (4.0 - 6.3)', max: false },
            F600: { range: '6.0 (4.5 - 7.5)', max: false },
            F900: { range: '9.1 (6.9 - 11.4)', max: false },
            F1200: { range: '10.8 (7.7 - 13.9)', max: false },
            F2400: { range: '18.7 (13.2 - 24.2)', max: true },
          },
        ],
      },
      {
        drugId: 16,
        flowValues: [
          {
            NeedleSet: 33,
            F30: { range: '2 - 4.3', max: false },
            F45: { range: '3.2 - 6.6', max: false },
            F60: { range: '4.2 - 8.5', max: false },
            F120: { range: '11.5 (8.0 - 15.1)', max: false },
            F180: { range: '15.1 (11.5 - 18.7)', max: false },
            F275: { range: '22.5 (16.8 - 28.2)', max: true },
            F420: { range: '33.1 (23.2 - 43)', max: true },
            F500: { range: '38.5 (29.9 - 47.1)', max: true },
            F600: { range: '44.8 (33.8 - 55.8)', max: true },
            F900: { range: '66 (50.3 - 81.7)', max: true },
            F1200: { range: '76.8 (55.6 - 98)', max: true },
            F2400: { range: '122.5 (88.8 - 156.3)', max: true },
          },
          {
            NeedleSet: 34,
            F30: { range: '1 - 2.2', max: false },
            F45: { range: '1.6 - 3.3', max: false },
            F60: { range: '2.1 - 4.3', max: false },
            F120: { range: '5.9 (4.0 - 7.7)', max: false },
            F180: { range: '7.8 (5.9 - 9.6)', max: false },
            F275: { range: '11.7 (8.7 - 14.7)', max: false },
            F420: { range: '17.6 (12.2 - 23.0)', max: false },
            F500: { range: '20.7 (16.0 - 25.4)', max: true },
            F600: { range: '24.4 (18.2 - 30.5)', max: true },
            F900: { range: '37.5 (28.3 - 46.7)', max: true },
            F1200: { range: '44.7 (31.7 - 57.7)', max: true },
            F2400: { range: '79.1 (55.3 - 102.8)', max: true },
          },
          {
            NeedleSet: 35,
            F30: { range: '0.7 - 1.4', max: false },
            F45: { range: '1.1 - 2.2', max: false },
            F60: { range: '1.4 - 2.9', max: false },
            F120: { range: '4.0 (2.7 - 5.2)', max: false },
            F180: { range: '5.2 (4.0 - 6.5)', max: false },
            F275: { range: '7.9 (5.9 - 10)', max: false },
            F420: { range: '12.0 (8.3 - 15.7)', max: false },
            F500: { range: '14.2 (11.0 - 17.4)', max: false },
            F600: { range: '16.7 (12.5 - 21)', max: false },
            F900: { range: '26.2 (19.7 - 32.7)', max: true },
            F1200: { range: '31.5 (22.2 - 40.9)', max: true },
            F2400: { range: '58.4 (40.2 - 76.6)', max: true },
          },
          {
            NeedleSet: 36,
            F30: { range: '0.5 - 1.1', max: false },
            F45: { range: '0.8 - 1.7', max: false },
            F60: { range: '1.1 - 2.2', max: false },
            F120: { range: '3.0 (2 - 3.9)', max: false },
            F180: { range: '3.9 (3 - 4.9)', max: false },
            F275: { range: '6.0 (4.5 - 7.5)', max: false },
            F420: { range: '9.1 (6.3 - 11.9)', max: false },
            F500: { range: '10.8 (8.3 - 13.2)', max: false },
            F600: { range: '12.8 (9.5 - 16)', max: false },
            F900: { range: '20.1 (15.1 - 25.2)', max: true },
            F1200: { range: '24.3 (17 - 31.7)', max: true },
            F2400: { range: '46.3 (31.5 - 61.1)', max: true },
          },
          {
            NeedleSet: 37,
            F120: { range: '2.4 (1.6 - 3.1)', max: false },
            F180: { range: '3.2 (2.4 - 3.9)', max: false },
            F275: { range: '4.8 (3.6 - 6.1)', max: false },
            F420: { range: '7.3 (5.1 - 9.6)', max: false },
            F500: { range: '8.7 (6.7 - 10.7)', max: false },
            F600: { range: '10.3 (7.7 - 12.9)', max: false },
            F900: { range: '16.3 (12.2 - 20.4)', max: false },
            F1200: { range: '19.8 (13.8 - 25.8)', max: true },
            F2400: { range: '38.4 (26 - 50.8)', max: true },
          },
          {
            NeedleSet: 38,
            F120: { range: '2.0 (1.4 - 2.6)', max: false },
            F180: { range: '2.6 (2.0 - 3.3)', max: false },
            F275: { range: '4.0 (3.0 - 5.1)', max: false },
            F420: { range: '6.1 (4.2 - 8.1)', max: false },
            F500: { range: '7.3 (5.6 - 8.9)', max: false },
            F600: { range: '8.6 (6.4 - 10.8)', max: false },
            F900: { range: '13.8 (10.3 - 17.2)', max: false },
            F1200: { range: '16.7 (11.7 - 21.8)', max: false },
            F2400: { range: '32.7 (22 - 43.4)', max: true },
          },
          {
            NeedleSet: 39,
            F120: { range: '1.7 (1.2 - 2.2)', max: false },
            F180: { range: '2.3 (1.7 - 2.8)', max: false },
            F275: { range: '3.5 (2.6 - 4.3)', max: false },
            F420: { range: '5.3 (3.6 - 6.9)', max: false },
            F500: { range: '6.3 (4.8 - 7.7)', max: false },
            F600: { range: '7.4 (5.5 - 9.3)', max: false },
            F900: { range: '11.9 (8.9 - 14.9)', max: false },
            F1200: { range: '14.5 (10.1 - 18.9)', max: false },
            F2400: { range: '28.6 (19.2 - 38)', max: true },
          },
          {
            NeedleSet: 40,
            F120: { range: '1.5 (1.0 - 2.0)', max: false },
            F180: { range: '2.0 (1.5 - 2.5)', max: false },
            F275: { range: '3.0 (2.3 - 3.8)', max: false },
            F420: { range: '4.6 (3.2 - 6.1)', max: false },
            F500: { range: '5.5 (4.2 - 6.7)', max: false },
            F600: { range: '6.5 (4.9 - 8.2)', max: false },
            F900: { range: '10.5 (7.8 - 13.1)', max: false },
            F1200: { range: '12.7 (8.9 - 16.6)', max: false },
            F2400: { range: '25.3 (17 - 33.7)', max: true },
          },
          {
            NeedleSet: 16,
            F30: { range: '1.9 - 4.1', max: false },
            F45: { range: '3.0 - 6.1', max: false },
            F60: { range: '4.0 - 7.7', max: false },
            F120: { range: '9.9 (7.0 - 12.9)', max: false },
            F180: { range: '12.5 (9.7 - 15.4)', max: false },
            F275: { range: '17.2 (13.1 - 21.2)', max: false },
            F420: { range: '22.7 (16.7 - 28.7)', max: true },
            F500: { range: '25.2 (19.9 - 30.5)', max: true },
            F600: { range: '27.7 (21.6 - 33.9)', max: true },
            F900: { range: '34.6 (27.3 - 42)', max: true },
            F1200: { range: '37.3 (28.8 - 45.9)', max: true },
            F2400: { range: '45.7 (35.7 - 55.6)', max: true },
          },
          {
            NeedleSet: 17,
            F30: { range: '1 - 2.1', max: false },
            F45: { range: '1.6 - 3.2', max: false },
            F60: { range: '2.1 - 4.1', max: false },
            F120: { range: '5.4 (3.8 - 7.1)', max: false },
            F180: { range: '7.0 (5.4 - 8.7)', max: false },
            F275: { range: '10.1 (7.6 - 12.6)', max: false },
            F420: { range: '14.2 (10.1 - 18.2)', max: false },
            F500: { range: '16.1 (12.6 - 19.6)', max: false },
            F600: { range: '18.3 (14.0 - 22.5)', max: false },
            F900: { range: '24.8 (19.2 - 30.3)', max: true },
            F1200: { range: '27.6 (20.7 - 34.6)', max: true },
            F2400: { range: '37.8 (28.7 - 46.9)', max: true },
          },
          {
            NeedleSet: 18,
            F30: { range: '0.7 - 1.4', max: false },
            F45: { range: '1.1 - 2.2', max: false },
            F60: { range: '1.4 - 2.8', max: false },
            F120: { range: '3.7 (2.6 - 4.9)', max: false },
            F180: { range: '4.9 (3.7 - 6.0)', max: false },
            F275: { range: '7.2 (5.4 - 8.9)', max: false },
            F420: { range: '10.3 (7.3 - 13.3)', max: false },
            F500: { range: '11.9 (9.3 - 14.5)', max: false },
            F600: { range: '13.6 (10.3 - 16.9)', max: false },
            F900: { range: '19.3 (14.8 - 23.7)', max: false },
            F1200: { range: '22.0 (16.2 - 27.7)', max: true },
            F2400: { range: '32.3 (24 - 40.6)', max: true },
          },
          {
            NeedleSet: 19,
            F30: { range: '0.5 - 1.1', max: false },
            F45: { range: '0.8 - 1.6', max: false },
            F60: { range: '1.1 - 2.1', max: false },
            F120: { range: '2.9 (2.0 - 3.7)', max: false },
            F180: { range: '3.7 (2.9 - 4.6)', max: false },
            F275: { range: '5.5 (4.2 - 6.9)', max: false },
            F420: { range: '8.1 (5.7 - 10.5)', max: false },
            F500: { range: '9.4 (7.3 - 11.5)', max: false },
            F600: { range: '10.9 (8.2 - 13.5)', max: false },
            F900: { range: '15.8 (12.1 - 19.5)', max: false },
            F1200: { range: '18.2 (13.3 - 23.2)', max: false },
            F2400: { range: '28.2 (20.6 - 35.8)', max: true },
          },
          {
            NeedleSet: 20,
            F30: { range: '0.4 - 0.9', max: false },
            F45: { range: '0.6 - 1.3', max: false },
            F60: { range: '0.8 - 1.7', max: false },
            F120: { range: '2.3 (1.6 - 3.0)', max: false },
            F180: { range: '3.0 (2.3 - 3.8)', max: false },
            F275: { range: '4.5 (3.4 - 5.7)', max: false },
            F420: { range: '6.7 (4.7 - 8.7)', max: false },
            F500: { range: '7.8 (6.0 - 9.5)', max: false },
            F600: { range: '9.0 (6.8 - 11.2)', max: false },
            F900: { range: '13.3 (10.2 - 16.5)', max: false },
            F1200: { range: '15.6 (11.2 - 19.9)', max: false },
            F2400: { range: '25 (18.1 - 32)', max: true },
          },
          {
            NeedleSet: 21,
            F30: { range: '0.3 - 0.7', max: false },
            F45: { range: '0.5 - 1.1', max: false },
            F60: { range: '0.7 - 1.4', max: false },
            F120: { range: '1.9 (1.3 - 2.5)', max: false },
            F180: { range: '2.5 (1.9 - 3.2)', max: false },
            F275: { range: '3.8 (2.9 - 4.8)', max: false },
            F420: { range: '5.7 (3.9 - 7.4)', max: false },
            F500: { range: '6.6 (5.1 - 8.1)', max: false },
            F600: { range: '7.7 (5.8 - 9.6)', max: false },
            F900: { range: '11.6 (8.8 - 14.4)', max: false },
            F1200: { range: '13.6 (9.8 - 17.4)', max: false },
            F2400: { range: '22.5 (16.1 - 28.9)', max: true },
          },
          {
            NeedleSet: 22,
            F30: { range: '0.3 - 0.6', max: false },
            F45: { range: '0.5 - 0.9', max: false },
            F60: { range: '0.6 - 1.2', max: false },
            F120: { range: '1.7 (1.1 - 2.2)', max: false },
            F180: { range: '2.2 (1.7 - 2.7)', max: false },
            F275: { range: '3.3 (2.5 - 4.1)', max: false },
            F420: { range: '4.9 (3.4 - 6.4)', max: false },
            F500: { range: '5.8 (4.5 - 7.1)', max: false },
            F600: { range: '6.7 (5.1 - 8.4)', max: false },
            F900: { range: '10.2 (7.7 - 12.7)', max: false },
            F1200: { range: '12.1 (8.6 - 15.5)', max: false },
            F2400: { range: '20.4 (14.5 - 26.4)', max: true },
          },
          {
            NeedleSet: 23,
            F30: { range: '0.3 - 0.5', max: false },
            F45: { range: '0.4 - 0.8', max: false },
            F60: { range: '0.5 - 1.1', max: false },
            F120: { range: '1.5 (1.0 - 1.9)', max: false },
            F180: { range: '1.9 (1.5 - 2.4)', max: false },
            F275: { range: '2.9 (2.2 - 3.7)', max: false },
            F420: { range: '4.4 (3.0 - 5.7)', max: false },
            F500: { range: '5.1 (4.0 - 6.3)', max: false },
            F600: { range: '6.0 (4.5 - 7.5)', max: false },
            F900: { range: '9.1 (6.9 - 11.4)', max: false },
            F1200: { range: '10.8 (7.7 - 13.9)', max: false },
            F2400: { range: '18.7 (13.2 - 24.2)', max: false },
          },
          {
            NeedleSet: 25,
            F30: { range: '2 - 4.2', max: false },
            F45: { range: '3.1 - 6.4', max: false },
            F60: { range: '4.1 - 8.2', max: false },
            F120: { range: '7.6 - 14.2', max: false },
            F180: { range: '10.8 - 17.4', max: false },
            F275: { range: '15.3 - 25.3', max: false },
            F420: { range: '20.4 - 36.6', max: false },
            F500: { range: '25.5 - 39.5', max: false },
            F600: { range: '28.2 - 45.4', max: false },
            F900: { range: '38.8 - 61.3', max: false },
            F1200: { range: '41.9 - 70', max: false },
            F2400: { range: '58.3 - 95.5', max: false },
          },
          {
            NeedleSet: 26,
            F30: { range: '1 - 2.1', max: false },
            F45: { range: '1.6 - 3.3', max: false },
            F60: { range: '2.1 - 4.2', max: false },
            F120: { range: '4 - 7.5', max: false },
            F180: { range: '5.7 - 9.3', max: false },
            F275: { range: '8.3 - 13.9', max: false },
            F420: { range: '11.4 - 21.1', max: false },
            F500: { range: '14.7 - 23', max: false },
            F600: { range: '16.5 - 27.1', max: false },
            F900: { range: '24.3 - 39.2', max: true },
            F1200: { range: '26.7 - 46.7', max: true },
            F2400: { range: '41.7 - 72.5', max: true },
          },
          {
            NeedleSet: 27,
            F30: { range: '0.7 - 1.4', max: false },
            F45: { range: '1.1 - 2.2', max: false },
            F60: { range: '1.4 - 2.9', max: false },
            F120: { range: '2.7 - 5.1', max: false },
            F180: { range: '3.9 - 6.3', max: false },
            F275: { range: '5.7 - 9.6', max: false },
            F420: { range: '7.9 - 14.8', max: false },
            F500: { range: '10.3 - 16.2', max: false },
            F600: { range: '11.6 - 19.3', max: false },
            F900: { range: '17.7 - 28.9', max: false },
            F1200: { range: '19.6 - 35', max: false },
            F2400: { range: '32.5 - 58.4', max: true },
          },
          {
            NeedleSet: 28,
            F30: { range: '0.5 - 1.1', max: false },
            F45: { range: '0.8 - 1.7', max: false },
            F60: { range: '1.1 - 2.1', max: false },
            F120: { range: '2 - 3.9', max: false },
            F180: { range: '2.9 - 4.8', max: false },
            F275: { range: '4.3 - 7.3', max: false },
            F420: { range: '6.1 - 11.4', max: false },
            F500: { range: '7.9 - 12.5', max: false },
            F600: { range: '9.0 - 15', max: false },
            F900: { range: '13.9 - 22.8', max: false },
            F1200: { range: '15.5 - 28', max: false },
            F2400: { range: '26.6 - 48.9', max: true },
          },
          {
            NeedleSet: 29,
            F30: { range: '0.4 - 0.9', max: false },
            F45: { range: '0.6 - 1.3', max: false },
            F60: { range: '0.9 - 1.7', max: false },
            F120: { range: '1.6 - 3.1', max: false },
            F180: { range: '2.4 - 3.9', max: false },
            F275: { range: '3.5 - 5.9', max: false },
            F420: { range: '4.9 - 9.3', max: false },
            F500: { range: '6.4 - 10.2', max: false },
            F600: { range: '7.3 - 12.3', max: false },
            F900: { range: '11.4 - 18.9', max: false },
            F1200: { range: '12.8 - 23.4', max: false },
            F2400: { range: '22.5 - 42.1', max: false },
          },
          {
            NeedleSet: 30,
            F30: { range: '0.3 - 0.7', max: false },
            F45: { range: '0.5 - 1.1', max: false },
            F60: { range: '0.7 - 1.4', max: false },
            F120: { range: '1.4 - 2.6', max: false },
            F180: { range: '2 - 3.2', max: false },
            F275: { range: '2.9 - 5', max: false },
            F420: { range: '4.1 - 7.8', max: false },
            F500: { range: '5.4 - 8.6', max: false },
            F600: { range: '6.2 - 10.4', max: false },
            F900: { range: '9.7 - 16.1', max: false },
            F1200: { range: '10.9 - 20', max: false },
            F2400: { range: '19.5 - 36.9', max: false },
          },
          {
            NeedleSet: 31,
            F30: { range: '0.3 - 0.6', max: false },
            F45: { range: '0.5 - 1', max: false },
            F60: { range: '0.6 - 1.2', max: false },
            F120: { range: '1.2 - 2.2', max: false },
            F180: { range: '1.7 - 2.8', max: false },
            F275: { range: '2.5 - 4.3', max: false },
            F420: { range: '3.6 - 6.7', max: false },
            F500: { range: '4.7 - 7.4', max: false },
            F600: { range: '5.4 - 9', max: false },
            F900: { range: '8.4 - 14', max: false },
            F1200: { range: '9.5 - 17.5', max: false },
            F2400: { range: '17.2 - 32.9', max: false },
          },
          {
            NeedleSet: 32,
            F30: { range: '0.3 - 0.5', max: false },
            F45: { range: '0.4 - 0.8', max: false },
            F60: { range: '0.5 - 1.1', max: false },
            F120: { range: '1.0 - 2.0', max: false },
            F180: { range: '1.5 - 2.4', max: false },
            F275: { range: '2.2 - 3.8', max: false },
            F420: { range: '3.1 - 5.9', max: false },
            F500: { range: '4.1 - 6.6', max: false },
            F600: { range: '4.7 - 7.9', max: false },
            F900: { range: '7.5 - 12.4', max: false },
            F1200: { range: '8.4 - 15.6', max: false },
            F2400: { range: '15.4 - 29.6', max: false },
          },
        ],
      },
      {
        drugId: 17,
        flowValues: [
          {
            NeedleSet: 16,
            F500: { range: '25.2 (19.9 - 30.5)', max: false },
            F600: { range: '27.7 (21.6 - 33.9)', max: false },
            F900: { range: '34.6 (27.3 - 42)', max: false },
            F1200: { range: '37.3 (28.8 - 45.9)', max: false },
            F2400: { range: '45.7 (35.7 - 55.6)', max: false },
          },
          {
            NeedleSet: 17,
            F500: { range: '16.1 (12.6 - 19.6)', max: false },
            F600: { range: '18.3 (14 - 22.5)', max: false },
            F900: { range: '24.8 (19.2 - 30.3)', max: false },
            F1200: { range: '27.6 (20.7 - 34.6)', max: false },
            F2400: { range: '37.8 (28.7 - 46.9)', max: false },
          },
        ],
      },
      {
        drugId: 20,
        flowValues: [
          {
            NeedleSet: 16,
            F60: { range: '3.6 (1.4 - 5.7)', max: false },
            F120: { range: '6.0 (2.4 - 9.5)', max: false },
            F180: { range: '7.3 (3.2 - 11.4)', max: false },
            F275: { range: '10.0 (4.2 - 15.7)', max: false },
            F420: { range: '13.2 (5.2 - 21.2)', max: false },
            F500: { range: '14.3 (6.0 - 22.5)', max: false },
            F600: { range: '0.0 (0.0 - 0.0)', max: false },
            F900: { range: '0.0 (0.0 - 0.0)', max: false },
            F1200: { range: '0.0 (0.0 - 0.0)', max: false },
            F2400: { range: '0.0 (0.0 - 0.0)', max: false },
          },
          {
            NeedleSet: 17,
            F60: { range: '1.9 (0.7 - 3.0)', max: false },
            F120: { range: '3.3 (1.3 - 5.3)', max: false },
            F180: { range: '4.1 (1.9 - 6.4)', max: false },
            F275: { range: '6.0 (2.6 - 9.3)', max: false },
            F420: { range: '8.4 (3.3 - 13.5)', max: false },
            F500: { range: '9.3 (4.1 - 14.5)', max: false },
            F600: { range: '10.6 (4.4 - 16.7)', max: false },
            F900: { range: '14.1 (5.8 - 22.4)', max: false },
            F1200: { range: '0.0 (0.0 - 0.0)', max: false },
            F2400: { range: '0.0 (0.0 - 0.0)', max: false },
          },
          {
            NeedleSet: 18,
            F60: { range: '1.3 (0.5 - 2.1)', max: false },
            F120: { range: '2.3 (0.9 - 3.6)', max: false },
            F180: { range: '2.9 (1.3 - 4.5)', max: false },
            F275: { range: '4.2 (1.9 - 6.6)', max: false },
            F420: { range: '6.2 (2.5 - 9.9)', max: false },
            F500: { range: '6.9 (3.1 - 10.7)', max: false },
            F600: { range: '8.0 (3.4 - 12.5)', max: false },
            F900: { range: '11.1 (4.7 - 17.5)', max: false },
            F1200: { range: '12.8 (5 - 20.5)', max: false },
            F2400: { range: '0.0 (0.0 - 0.0)', max: false },
          },
          {
            NeedleSet: 19,
            F60: { range: '1.0 (0.4 - 1.6)', max: false },
            F120: { range: '1.7 (0.7 - 2.8)', max: false },
            F180: { range: '2.2 (1.0 - 3.4)', max: false },
            F275: { range: '3.3 (1.4 - 5.1)', max: false },
            F420: { range: '4.9 (2.0 -7.8)', max: false },
            F500: { range: '5.5 (2.5 - 8.5)', max: false },
            F600: { range: '6.4 (2.8 - 10.0)', max: false },
            F900: { range: '9.2 (3.9 - 14.4)', max: false },
            F1200: { range: '10.7 (4.2 - 17.2)', max: false },
            F2400: { range: '0.0 (0.0 - 0.0)', max: false },
          },
          {
            NeedleSet: 20,
            F60: { range: '0.8 (0.3 - 1.3)', max: false },
            F120: { range: '1.4 (0.6 - 2.2)', max: false },
            F180: { range: '1.8 (0.8 - 2.8)', max: false },
            F275: { range: '2.7 (1.2 - 4.2)', max: false },
            F420: { range: '4.0 (1.6 - 6.4)', max: false },
            F500: { range: '4.5 (2.1 - 7.0)', max: false },
            F600: { range: '5.3 (2.3 - 8.3)', max: false },
            F900: { range: '7.8 (3.3 - 12.2)', max: false },
            F1200: { range: '9.2 (3.6 - 14.8)', max: false },
            F2400: { range: '14.6 (5.5 - 23.6)', max: false },
          },
          {
            NeedleSet: 21,
            F60: { range: '0.7 (0.3 - 1.1)', max: false },
            F120: { range: '1.2 (0.5 - 1.9)', max: false },
            F180: { range: '1.5 (0.7 - 2.3)', max: false },
            F275: { range: '2.3 (1.0 - 3.5)', max: false },
            F420: { range: '3.4 (1.4 - 5.5)', max: false },
            F500: { range: '3.9 (1.8 - 6.0)', max: false },
            F600: { range: '4.6 (2.0 - 7.1)', max: false },
            F900: { range: '6.8 (2.9 - 10.6)', max: false },
            F1200: { range: '8.1 (3.2 - 12.9)', max: false },
            F2400: { range: '13.2 (5.0 - 21.4)', max: false },
          },
          {
            NeedleSet: 33,
            F60: { range: '3.9 (1.5 - 6.3)', max: false },
            F120: { range: '7.0 (2.9 - 11.2)', max: false },
            F180: { range: '9.0 (4.1 - 13.9)', max: false },
            F275: { range: '13.5 (6.0 - 20.9)', max: false },
            F420: { range: '0.0 (0.0 - 0.0)', max: false },
            F500: { range: '0.0 (0.0 - 0.0)', max: false },
            F600: { range: '0.0 (0.0 - 0.0)', max: false },
            F900: { range: '0.0 (0.0 - 0.0)', max: false },
            F1200: { range: '0.0 (0.0 - 0.0)', max: false },
            F2400: { range: '0.0 (0.0 - 0.0)', max: false },
          },
          {
            NeedleSet: 34,
            F60: { range: '2.0 (0.8 - 3.2)', max: false },
            F120: { range: '3.6 (1.5 - 5.7)', max: false },
            F180: { range: '4.6 (2.1 - 7.2)', max: false },
            F275: { range: '7.0 (3.1 - 10.9)', max: false },
            F420: { range: '10.7 (4.4 - 17.1)', max: false },
            F500: { range: '12.3 (5.7 - 18.8)', max: false },
            F600: { range: '14.6 (6.5 - 22.6)', max: false },
            F900: { range: '0.0 (0.0 - 0.0)', max: false },
            F1200: { range: '0.0 (0.0 - 0.0)', max: false },
            F2400: { range: '0.0 (0.0 - 0.0)', max: false },
          },
          {
            NeedleSet: 35,
            F60: { range: '1.3 (0.65 - 2.1)', max: false },
            F120: { range: '2.4 (1.0 - 3.9)', max: false },
            F180: { range: '3.1 (1.4 - 4.8)', max: false },
            F275: { range: '4.8 (2.1 - 7.4)', max: false },
            F420: { range: '7.3 (3.0 - 11.7)', max: false },
            F500: { range: '8.4 (3.9 - 12.9)', max: false },
            F600: { range: '10.0 (4.5 - 15.6)', max: false },
            F900: { range: '15.6 (7.0 - 24.3)', max: false },
            F1200: { range: '0.0 (0.0 - 0.0)', max: false },
            F2400: { range: '0.0 (0.0 - 0.0)', max: false },
          },
          {
            NeedleSet: 36,
            F60: { range: '1.0 (0.4 - 1.6)', max: false },
            F120: { range: '1.8 (0.7 - 2.9)', max: false },
            F180: { range: '2.4 (1.1 - 3.6)', max: false },
            F275: { range: '3.6 (1.6 - 5.6)', max: false },
            F420: { range: '5.6 (2.3 - 8.9)', max: false },
            F500: { range: '6.4 (3.0 - 9.8)', max: false },
            F600: { range: '7.6 (3.4 - 11.9)', max: false },
            F900: { range: '12.0 (5.4 - 18.7)', max: false },
            F1200: { range: '14.8 (6.0 - 23.6)', max: false },
            F2400: { range: '0.0 (0.0 - 0.0)', max: false },
          },
          {
            NeedleSet: 37,
            F60: { range: '0.8 (0.3 - 1.3)', max: false },
            F120: { range: '1.5 (0.6 - 2.3)', max: false },
            F180: { range: '1.9 (0.9 -2.9)', max: false },
            F275: { range: '2.9 (1.3 - 4.5)', max: false },
            F420: { range: '4.5 (1.8 - 7.1)', max: false },
            F500: { range: '5.2 (2.4 - 7.9)', max: false },
            F600: { range: '6.2 (2.8 - 9.6)', max: false },
            F900: { range: '9.8 (4.4 - 15.2)', max: false },
            F1200: { range: '12.1 (4.9 - 19.2)', max: false },
            F2400: { range: '0.0 (0.0 - 0.0)', max: false },
          },
          {
            NeedleSet: 38,
            F60: { range: '0.7 (0.3 - 1.1)', max: false },
            F120: { range: '1.2 (0.5 - 1.9)', max: false },
            F180: { range: '1.6 (0.7 - 2.4)', max: false },
            F275: { range: '2.4 (1.1 - 3.8)', max: false },
            F420: { range: '3.8 (1.5 - 6.0)', max: false },
            F500: { range: '4.3 (2.0 - 6.6)', max: false },
            F600: { range: '5.2 (2.3 - 8.1)', max: false },
            F900: { range: '8.2 (3.7 - 12.8)', max: false },
            F1200: { range: '10.2 (4.1 - 16.2)', max: false },
            F2400: { range: '0.0 (0.0 - 0.0)', max: false },
          },
        ],
      },
      {
        drugId: 21,
        flowValues: [
          {
            NeedleSet: 16,
            F60: { range: '3.6 (1.4 - 5.7)', max: false },
            F120: { range: '6.0 (2.4 - 9.5)', max: false },
            F180: { range: '7.3 (3.2 - 11.4)', max: false },
            F275: { range: '10.0 (4.2 - 15.7)', max: false },
            F420: { range: '13.2 (5.2 - 21.2)', max: false },
            F500: { range: '14.3 (6.0 - 22.5)', max: false },
            F600: { range: '15.7 (6.4 - 25.0)', max: false },
            F900: { range: '19.3 (7.8 - 30.9)', max: false },
            F1200: { range: '21.0 (8.1 - 33.8)', max: false },
            F2400: { range: '25.2 (9.5 - 40.9)', max: false },
          },
          {
            NeedleSet: 17,
            F60: { range: '1.9 (0.7 - 3.0)', max: false },
            F120: { range: '3.3 (1.3 - 5.3)', max: false },
            F180: { range: '4.1 (1.9 - 6.4)', max: false },
            F275: { range: '6.0 (2.6 - 9.3)', max: false },
            F420: { range: '8.4 (3.3 - 13.5)', max: false },
            F500: { range: '9.3 (4.1 - 14.5)', max: false },
            F600: { range: '10.6 (4.4 - 16.7)', max: false },
            F900: { range: '14.1 (5.8 - 22.4)', max: false },
            F1200: { range: '15.9 (6.2 - 25.6)', max: false },
            F2400: { range: '21.3 (8.1 - 34.6)', max: false },
          },
          {
            NeedleSet: 18,
            F60: { range: '1.3 (0.5 - 2.1)', max: false },
            F120: { range: '2.3 (0.9 - 3.6)', max: false },
            F180: { range: '2.9 (1.3 - 4.5)', max: false },
            F275: { range: '4.2 (1.9 - 6.6)', max: false },
            F420: { range: '6.2 (2.5 - 9.9)', max: false },
            F500: { range: '6.9 (3.1 - 10.7)', max: false },
            F600: { range: '8.0 (3.4 - 12.5)', max: false },
            F900: { range: '11.1 (4.7 - 17.5)', max: false },
            F1200: { range: '12.8 (5.0 - 20.5)', max: false },
            F2400: { range: '18.5 (7.0 - 29.9)', max: false },
          },
          {
            NeedleSet: 19,
            F60: { range: '1.0 (0.4 - 1.6)', max: false },
            F120: { range: '1.7 (0.7 - 2.8)', max: false },
            F180: { range: '2.2 (1.0 - 3.4)', max: false },
            F275: { range: '3.3 (1.4 - 5.1)', max: false },
            F420: { range: '4.9 (2.0 -7.8)', max: false },
            F500: { range: '5.5 (2.5 - 8.5)', max: false },
            F600: { range: '6.4 (2.8 - 10.0)', max: false },
            F900: { range: '9.2 (3.9 - 14.4)', max: false },
            F1200: { range: '10.7 (4.2 - 17.2)', max: false },
            F2400: { range: '16.3 (6.2 - 26.4)', max: false },
          },
          {
            NeedleSet: 20,
            F60: { range: '0.8 (0.3 - 1.3)', max: false },
            F120: { range: '1.4 (0.6 - 2.2)', max: false },
            F180: { range: '1.8 (0.8 - 2.8)', max: false },
            F275: { range: '2.7 (1.2 - 4.2)', max: false },
            F420: { range: '4.0 (1.6 - 6.4)', max: false },
            F500: { range: '4.5 (2.1 - 7.0)', max: false },
            F600: { range: '5.3 (2.3 - 8.3)', max: false },
            F900: { range: '7.8 (3.3 - 12.2)', max: false },
            F1200: { range: '9.2 (3.6 - 14.8)', max: false },
            F2400: { range: '14.6 (5.5 - 23.6)', max: false },
          },
          {
            NeedleSet: 21,
            F60: { range: '0.7 (0.3 - 1.1)', max: false },
            F120: { range: '1.2 (0.5 - 1.9)', max: false },
            F180: { range: '1.5 (0.7 - 2.3)', max: false },
            F275: { range: '2.3 (1.0 - 3.50', max: false },
            F420: { range: '3.4 (1.4 - 5.5)', max: false },
            F500: { range: '3.9 (1.8 - 6.0)', max: false },
            F600: { range: '4.6 (2.0 - 7.1)', max: false },
            F900: { range: '6.8 (2.9 - 10.6)', max: false },
            F1200: { range: '8.1 (3.2 - 12.9)', max: false },
            F2400: { range: '13.2 (5.0 - 21.4)', max: false },
          },
          {
            NeedleSet: 33,
            F60: { range: '3.9 (1.5 - 6.3)', max: false },
            F120: { range: '7.0 (2.9 - 11.2)', max: false },
            F180: { range: '9.0 (4.1 - 13.9)', max: false },
            F275: { range: '13.5 (6.0 - 20.9)', max: false },
            F420: { range: '20.0 (8.2 - 31.9)', max: false },
            F500: { range: '22.7 (10.4 - 34.9)', max: false },
            F600: { range: '26.5 (11.7 - 41.4)', max: false },
            F900: { range: '0.0 (0.0 - 0.0)', max: false },
            F1200: { range: '0.0 (0.0 - 0.0)', max: false },
            F2400: { range: '0.0 (0.0 - 0.0)', max: false },
          },
          {
            NeedleSet: 34,
            F60: { range: '2.0 (0.8 - 3.2)', max: false },
            F120: { range: '3.6 (1.5 - 5.7)', max: false },
            F180: { range: '4.6 (2.1 - 7.2)', max: false },
            F275: { range: '7.0 (3.1 - 10.9)', max: false },
            F420: { range: '10.7 (4.4 - 17.1)', max: false },
            F500: { range: '12.3 (5.7 - 18.8)', max: false },
            F600: { range: '14.6 (6.5 - 22.6)', max: false },
            F900: { range: '22.3 (9.9 - 34.6)', max: false },
            F1200: { range: '26.9 (11.0 - 42.9)', max: false },
            F2400: { range: '0.0 (0.0 - 0.0)', max: false },
          },
          {
            NeedleSet: 35,
            F60: { range: '1.3 (0.65 - 2.1)', max: false },
            F120: { range: '2.4 (1.0 - 3.9)', max: false },
            F180: { range: '3.1 (1.4 - 4.8)', max: false },
            F275: { range: '4.8 (2.1 - 7.4)', max: false },
            F420: { range: '7.3 (3.0 - 11.7)', max: false },
            F500: { range: '8.4 (3.9 - 12.9)', max: false },
            F600: { range: '10.0 (4.5 - 15.6)', max: false },
            F900: { range: '15.6 (7.0 - 24.3)', max: false },
            F1200: { range: '19.1 (7.8 - 30.4)', max: false },
            F2400: { range: '0.0 (0.0 - 0.0)', max: false },
          },
          {
            NeedleSet: 36,
            F60: { range: '1.0 (0.4 - 1.6)', max: false },
            F120: { range: '1.8 (0.7 - 2.9)', max: false },
            F180: { range: '2.4 (1.1 - 3.6)', max: false },
            F275: { range: '3.6 (1.6 - 5.6)', max: false },
            F420: { range: '5.6 (2.3 - 8.9)', max: false },
            F500: { range: '6.4 (3.0 - 9.8)', max: false },
            F600: { range: '7.6 (3.4 - 11.9)', max: false },
            F900: { range: '12.0 (5.4 - 18.7)', max: false },
            F1200: { range: '14.8 (6.0 - 23.6)', max: false },
            F2400: { range: '28.1 (10.9 - 45.3)', max: false },
          },
          {
            NeedleSet: 37,
            F60: { range: '0.8 (0.3 - 1.3)', max: false },
            F120: { range: '1.5 (0.6 - 2.3)', max: false },
            F180: { range: '1.9 (0.9 - 2.9)', max: false },
            F275: { range: '2.9 (1.3 - 4.5)', max: false },
            F420: { range: '4.5 (1.8 - 7.1)', max: false },
            F500: { range: '5.2 (2.4 - 7.9)', max: false },
            F600: { range: '6.2 (2.8 - 9.6)', max: false },
            F900: { range: '9.8 (4.4 - 15.2)', max: false },
            F1200: { range: '12.1 (4.9 - 19.2)', max: false },
            F2400: { range: '23.4 (9.1 - 37.6)', max: false },
          },
          {
            NeedleSet: 38,
            F60: { range: '0.7 (0.3 - 1.1)', max: false },
            F120: { range: '1.2 (0.5 - 1.9)', max: false },
            F180: { range: '1.6 (0.7 - 2.4)', max: false },
            F275: { range: '2.4 (1.1 - 3.8)', max: false },
            F420: { range: '3.8 (1.5 - 6.0)', max: false },
            F500: { range: '4.3 (2.0 - 6.6)', max: false },
            F600: { range: '5.2 (2.3 - 8.1)', max: false },
            F900: { range: '8.2 (3.7 - 12.8)', max: false },
            F1200: { range: '10.2 (4.1 - 16.2)', max: false },
            F2400: { range: '20.0 (7.8 - 32.2)', max: false },
          },
        ],
      },
      {
        drugId: 4,
        flowValues: [
          {
            NeedleSet: 33,
            F120: { range: '15.2', max: false },
            F180: { range: '20.5', max: false },
            F275: { range: '30.2', max: false },
            F420: { range: '43.8', max: false },
            F500: { range: '50.7', max: false },
            F600: { range: '58.8', max: false },
            F900: { range: '80.2', max: false },
            F1200: { range: '98.0', max: false },
            F2400: { range: '146.9', max: false },
          },
          {
            NeedleSet: 34,
            F120: { range: '7.8', max: false },
            F180: { range: '10.6', max: false },
            F275: { range: '15.9', max: false },
            F420: { range: '23.7', max: false },
            F500: { range: '27.7', max: false },
            F600: { range: '32.7', max: false },
            F900: { range: '46.4', max: false },
            F1200: { range: '58.8', max: false },
            F2400: { range: '97.9', max: false },
          },
          {
            NeedleSet: 35,
            F120: { range: '5.3', max: false },
            F180: { range: '7.2', max: false },
            F275: { range: '10.8', max: false },
            F420: { range: '16.2', max: false },
            F500: { range: '19.1', max: false },
            F600: { range: '22.6', max: false },
            F900: { range: '32.7', max: false },
            F1200: { range: '42.0', max: false },
            F2400: { range: '73.4', max: false },
          },
          {
            NeedleSet: 36,
            F120: { range: '4.0', max: false },
            F180: { range: '5.4', max: false },
            F275: { range: '8.2', max: false },
            F420: { range: '12.3', max: false },
            F500: { range: '14.6', max: false },
            F600: { range: '17.3', max: false },
            F900: { range: '25.2', max: false },
            F1200: { range: '32.7', max: false },
            F2400: { range: '58.8', max: false },
          },
          {
            NeedleSet: 16,
            F120: { range: '12.6', max: false },
            F180: { range: '16.1', max: false },
            F275: { range: '21.5', max: false },
            F420: { range: '27.6', max: false },
            F500: { range: '30.2', max: false },
            F600: { range: '32.9', max: false },
            F900: { range: '38.6', max: false },
            F1200: { range: '42.3', max: false },
            F2400: { range: '49.4', max: false },
          },
          {
            NeedleSet: 17,
            F120: { range: '7.1', max: false },
            F180: { range: '9.3', max: false },
            F275: { range: '13.1', max: false },
            F420: { range: '18.0', max: false },
            F500: { range: '20.2', max: false },
            F600: { range: '22.7', max: false },
            F900: { range: '28.6', max: false },
            F1200: { range: '32.9', max: false },
            F2400: { range: '42.3', max: false },
          },
          {
            NeedleSet: 18,
            F120: { range: '4.9', max: false },
            F180: { range: '6.5', max: false },
            F275: { range: '9.4', max: false },
            F420: { range: '13.3', max: false },
            F500: { range: '15.2', max: false },
            F600: { range: '17.4', max: false },
            F900: { range: '22.7', max: false },
            F1200: { range: '26.9', max: false },
            F2400: { range: '37.0', max: false },
          },
          {
            NeedleSet: 19,
            F120: { range: '3.8', max: false },
            F180: { range: '5.1', max: false },
            F275: { range: '7.4', max: false },
            F420: { range: '10.6', max: false },
            F500: { range: '12.2', max: false },
            F600: { range: '14.0', max: false },
            F900: { range: '18.8', max: false },
            F1200: { range: '22.7', max: false },
            F2400: { range: '32.9', max: false },
          },
          {
            NeedleSet: 20,
            F120: { range: '3.1', max: false },
            F180: { range: '4.1', max: false },
            F275: { range: '6.1', max: false },
            F420: { range: '8.8', max: false },
            F500: { range: '10.2', max: false },
            F600: { range: '11.8', max: false },
            F900: { range: '16.1', max: false },
            F1200: { range: '19.7', max: false },
            F2400: { range: '29.6', max: false },
          },
          {
            NeedleSet: 21,
            F120: { range: '2.6', max: false },
            F180: { range: '3.5', max: false },
            F275: { range: '5.1', max: false },
            F420: { range: '7.5', max: false },
            F500: { range: '8.7', max: false },
            F600: { range: '10.2', max: false },
            F900: { range: '14.0', max: false },
            F1200: { range: '17.4', max: false },
            F2400: { range: '26.9', max: false },
          },
        ],
      },
      {
        drugId: 24,
        syringeId: 1,
        flowValues: [
          {
            NeedleSet: 33,
            F120: { range: '7.0 (2.9 - 11.2)', max: false },
            F180: { range: '9.0 (4.1 - 13.9)', max: false },
            F275: { range: '13.5 (6.0 - 20.9)', max: true },
            F420: { range: '20.0 (8.2 - 31.9)', max: true },
            F500: { range: '22.7 (10.4 - 34.9)', max: true },
            F600: { range: '26.5 (11.7 - 41.4)', max: true },
            F900: { range: '38.8 (17.1 - 60.5)', max: true },
            F1200: { range: '45.7 (18.6 - 72.7)', max: true },
            F2400: { range: '72.0 (28.6 - 115.4)', max: true },
          },
          {
            NeedleSet: 34,
            F120: { range: '3.6 (1.5 - 5.7)', max: false },
            F180: { range: '4.6 (2.1 - 7.2)', max: false },
            F275: { range: '7.0 (3.1 - 10.9)', max: false },
            F420: { range: '10.7 (4.4 - 17.1)', max: false },
            F500: { range: '12.3 (5.7 - 18.8)', max: false },
            F600: { range: '14.6 (6.5 - 22.6)', max: true },
            F900: { range: '22.3 (9.9 - 34.6)', max: true },
            F1200: { range: '26.9 (11.0 - 42.9)', max: true },
            F2400: { range: '47.4 (18.6 - 76.1)', max: true },
          },
          {
            NeedleSet: 35,
            F120: { range: '2.4 (1.0 - 3.9)', max: false },
            F180: { range: '3.1 (1.4 - 4.8)', max: false },
            F275: { range: '4.8 (2.1 - 7.4)', max: false },
            F420: { range: '7.3 (3.0 - 11.7)', max: false },
            F500: { range: '8.4 (3.9 - 12.9)', max: false },
            F600: { range: '10.0 (4.5 - 15.6)', max: false },
            F900: { range: '15.6 (7.0 - 24.3)', max: true },
            F1200: { range: '19.1 (7.8 - 30.4)', max: true },
            F2400: { range: '35.3 (13.8 - 56.8)', max: true },
          },
          {
            NeedleSet: 36,
            F120: { range: '1.8 (0.7 - 2.9)', max: false },
            F180: { range: '2.4 (1.1 - 3.6)', max: false },
            F275: { range: '3.6 (1.6 - 5.6)', max: false },
            F420: { range: '5.6 (2.3 - 8.9)', max: false },
            F500: { range: '6.4 (3.0 - 9.8)', max: false },
            F600: { range: '7.6 (3.4 - 11.9)', max: false },
            F900: { range: '12.0 (5.4 - 18.7)', max: false },
            F1200: { range: '14.8 (6.0 - 23.6)', max: true },
            F2400: { range: '28.1 (10.9 - 45.3)', max: true },
          },
          {
            NeedleSet: 37,
            F120: { range: '1.5 (0.6 - 2.3)', max: false },
            F180: { range: '1.9 (0.9 - 2.9)', max: false },
            F275: { range: '2.9 (1.3 - 4.5)', max: false },
            F420: { range: '4.5 (1.8 - 7.1)', max: false },
            F500: { range: '5.2 (2.4 - 7.9)', max: false },
            F600: { range: '6.2 (2.8 - 9.6)', max: false },
            F900: { range: '9.8 (4.4 - 15.2)', max: false },
            F1200: { range: '12.1 (4.9 - 19.2)', max: false },
            F2400: { range: '23.4 (9.1 - 37.6)', max: true },
          },
          {
            NeedleSet: 38,
            F120: { range: '1.2 (0.5 - 1.9)', max: false },
            F180: { range: '1.6 (0.7 - 2.4)', max: false },
            F275: { range: '2.4 (1.1 - 3.8)', max: false },
            F420: { range: '3.8 (1.5 - 6.0)', max: false },
            F500: { range: '4.3 (2.0 - 6.6)', max: false },
            F600: { range: '5.2 (2.3 - 8.1)', max: false },
            F900: { range: '8.2 (3.7 - 12.8)', max: false },
            F1200: { range: '10.2 (4.1 - 16.2)', max: false },
            F2400: { range: '20.0 (7.8 - 32.2)', max: true },
          },
          {
            NeedleSet: 39,
            F120: { range: '1.0 (0.4 - 1.7)', max: false },
            F180: { range: '1.4 (0.6 - 2.1)', max: false },
            F275: { range: '2.1 (0.9 - 3.2)', max: false },
            F420: { range: '3.2 (1.3 - 5.1)', max: false },
            F500: { range: '3.7 (1.7 - 5.7)', max: false },
            F600: { range: '4.5 (2.0 - 6.9)', max: false },
            F900: { range: '7.1 (3.2 - 11.0)', max: false },
            F1200: { range: '8.8 (3.6 - 14.1)', max: false },
            F2400: { range: '17.5 (6.8 - 28.2)', max: true },
          },
          {
            NeedleSet: 40,
            F120: { range: '0.9 (0.4 - 1.5)', max: false },
            F180: { range: '1.2 (0.5 - 1.8)', max: false },
            F275: { range: '1.8 (0.8 - 2.8)', max: false },
            F420: { range: '2.8 (1.2 - 4.5)', max: false },
            F500: { range: '3.3 (1.5 - 5.0)', max: false },
            F600: { range: '3.9 (1.8 - 6.1)', max: false },
            F900: { range: '6.3 (2.8 - 9.7)', max: false },
            F1200: { range: '7.8 (3.2 - 12.4)', max: false },
            F2400: { range: '15.5 (6.0 - 25.0)', max: true },
          },
          {
            NeedleSet: 16,
            F120: { range: '6.0 (2.4 - 9.5)', max: false },
            F180: { range: '7.3 (3.2 - 11.4)', max: false },
            F275: { range: '10.0 (4.2 - 15.7)', max: false },
            F420: { range: '13.2 (5.2 - 21.2)', max: true },
            F500: { range: '14.3 (6.0 - 22.5)', max: true },
            F600: { range: '15.7 (6.4 - 25.0)', max: true },
            F900: { range: '19.3 (7.8 - 30.9)', max: true },
            F1200: { range: '21.0 (8.1 - 33.8)', max: true },
            F2400: { range: '25.2 (9.5 - 40.9)', max: true },
          },
          {
            NeedleSet: 17,
            F120: { range: '3.3 (1.3 - 5.3)', max: false },
            F180: { range: '4.1 (1.9 - 6.4)', max: false },
            F275: { range: '6.0 (2.6 - 9.3)', max: false },
            F420: { range: '8.4 (3.3 - 13.5)', max: false },
            F500: { range: '9.3 (4.1 - 14.5)', max: false },
            F600: { range: '10.6 (4.4 - 16.7)', max: false },
            F900: { range: '14.1 (5.8 - 22.4)', max: true },
            F1200: { range: '15.9 (6.2 - 25.6)', max: true },
            F2400: { range: '21.3 (8.1 - 34.6)', max: true },
          },
          {
            NeedleSet: 18,
            F120: { range: '2.3 (0.9 - 3.6)', max: false },
            F180: { range: '2.9 (1.3 - 4.5)', max: false },
            F275: { range: '4.2 (1.9 - 6.6)', max: false },
            F420: { range: '6.2 (2.5 - 9.9)', max: false },
            F500: { range: '6.9 (3.1 - 10.7)', max: false },
            F600: { range: '8.0 (3.4 - 12.5)', max: false },
            F900: { range: '11.1 (4.7 - 17.5)', max: false },
            F1200: { range: '12.8 (5.0 - 20.5)', max: true },
            F2400: { range: '18.5 (7.0 - 29.9)', max: true },
          },
          {
            NeedleSet: 19,
            F120: { range: '1.7 (0.7 - 2.8)', max: false },
            F180: { range: '2.2 (1.0 - 3.4)', max: false },
            F275: { range: '3.3 (1.4 - 5.1)', max: false },
            F420: { range: '4.9 (2.0 - 7.8)', max: false },
            F500: { range: '5.5 (2.5 - 8.5)', max: false },
            F600: { range: '6.4 (2.8 - 10.0)', max: false },
            F900: { range: '9.2 (3.9 - 14.4)', max: false },
            F1200: { range: '10.7 (4.2 - 17.2)', max: false },
            F2400: { range: '16.3 (6.2 - 26.4)', max: true },
          },
          {
            NeedleSet: 20,
            F120: { range: '1.4 (0.6 - 2.2)', max: false },
            F180: { range: '1.8 (0.8 - 2.8)', max: false },
            F275: { range: '2.7 (1.2 - 4.2)', max: false },
            F420: { range: '4.0 (1.6 - 6.4)', max: false },
            F500: { range: '4.5 (2.1 - 7.0)', max: false },
            F600: { range: '5.3 (2.3 - 8.3)', max: false },
            F900: { range: '7.8 (3.3 - 12.2)', max: false },
            F1200: { range: '9.2 (3.6 - 14.8)', max: false },
            F2400: { range: '14.6 (5.5 - 23.6)', max: true },
          },
          {
            NeedleSet: 21,
            F120: { range: '1.2 (0.5 - 1.9)', max: false },
            F180: { range: '1.5 (0.7 - 2.3)', max: false },
            F275: { range: '2.3 (1.0 - 3.5)', max: false },
            F420: { range: '3.4 (1.4 - 5.5)', max: false },
            F500: { range: '3.9 (1.8 - 6.0)', max: false },
            F600: { range: '4.6 (2.0 - 7.1)', max: false },
            F900: { range: '6.8 (2.9 - 10.6)', max: false },
            F1200: { range: '8.1 (3.2 - 12.9)', max: false },
            F2400: { range: '13.2 (5.0 - 21.4)', max: true },
          },
          {
            NeedleSet: 22,
            F120: { range: '1.0 (0.4 - 1.6)', max: false },
            F180: { range: '1.3 (0.6 - 2.0)', max: false },
            F275: { range: '2.0 (0.9 - 3.1)', max: false },
            F420: { range: '3.0 (1.2 - 4.8)', max: false },
            F500: { range: '3.4 (1.6 - 5.2)', max: false },
            F600: { range: '4.0 (1.8 - 6.3)', max: false },
            F900: { range: '6.0 (2.6 - 9.4)', max: false },
            F1200: { range: '7.2 (2.9 - 11.5)', max: false },
            F2400: { range: '12.0 (4.6 - 19.5)', max: false },
          },
          {
            NeedleSet: 23,
            F120: { range: '0.9 (0.4 - 1.4)', max: false },
            F180: { range: '1.2 (0.5 - 1.8)', max: false },
            F275: { range: '1.7 (0.8 - 2.7)', max: false },
            F420: { range: '2.6 (1.1 - 4.2)', max: false },
            F500: { range: '3.0 (1.4 - 4.6)', max: false },
            F600: { range: '3.6 (1.6 - 5.6)', max: false },
            F900: { range: '5.4 (2.3 - 8.4)', max: false },
            F1200: { range: '6.5 (2.6 - 10.4)', max: false },
            F2400: { range: '11.1 (4.2 - 17.9)', max: false },
          },
          {
            NeedleSet: 25,
            F30: { range: '2 - 4.2', max: false },
            F45: { range: '3.1 - 6.4', max: false },
            F60: { range: '4.1 - 8.2', max: false },
            F120: { range: '7.6 - 14.2', max: false },
            F180: {
              range: '10.8 - 17.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F275: {
              range: '15.3 - 25.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F420: {
              range: '20.4 - 36.6',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '25.5 - 39.5',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '28.2 - 45.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '38.8 - 61.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '41.9 - 70',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '58.3 - 95.5', max: true },
          },
          {
            NeedleSet: 26,
            F30: { range: '1 - 2.1', max: false },
            F45: { range: '1.6 - 3.3', max: false },
            F60: { range: '2.1 - 4.2', max: false },
            F120: { range: '4 - 7.5', max: false },
            F180: { range: '5.7 - 9.3', max: false },
            F275: { range: '8.3 - 13.9', max: false },
            F420: {
              range: '11.4 - 21.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F500: {
              range: '14.7 - 23',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '16.5 - 27.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: { range: '24.3 - 39.2', max: true },
            F1200: { range: '26.7 - 46.7', max: true },
            F2400: { range: '41.7 - 72.5', max: true },
          },
          {
            NeedleSet: 27,
            F30: { range: '0.7 - 1.4', max: false },
            F45: { range: '1.1 - 2.2', max: false },
            F60: { range: '1.4 - 2.9', max: false },
            F120: { range: '2.7 - 5.1', max: false },
            F180: { range: '3.9 - 6.3', max: false },
            F275: { range: '5.7 - 9.6', max: false },
            F420: { range: '7.9 - 14.8', max: false },
            F500: {
              range: '10.3 - 16.2',
              max:
                this.props.version === 'international' ? true : false,
            },
            F600: {
              range: '11.6 - 19.3',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '17.7 - 28.9',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '19.6 - 35',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '32.5 - 58.4', max: true },
          },
          {
            NeedleSet: 28,
            F30: { range: '0.5 - 1.1', max: false },
            F45: { range: '0.8 - 1.7', max: false },
            F60: { range: '1.1 - 2.1', max: false },
            F120: { range: '2 - 3.9', max: false },
            F180: { range: '2.9 - 4.8', max: false },
            F275: { range: '4.3 - 7.3', max: false },
            F420: { range: '6.1 - 11.4', max: false },
            F500: { range: '7.9 - 12.5', max: false },
            F600: {
              range: '9.0 - 15',
              max:
                this.props.version === 'international' ? true : false,
            },
            F900: {
              range: '13.9 - 22.8',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '15.5 - 28',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: { range: '26.6 - 48.9', max: true },
          },
          {
            NeedleSet: 29,
            F30: { range: '0.4 - 0.9', max: false },
            F45: { range: '0.6 - 1.3', max: false },
            F60: { range: '0.9 - 1.7', max: false },
            F120: { range: '1.6 - 3.1', max: false },
            F180: { range: '2.4 - 3.9', max: false },
            F275: { range: '3.5 - 5.9', max: false },
            F420: { range: '4.9 - 9.3', max: false },
            F500: { range: '6.4 - 10.2', max: false },
            F600: { range: '7.3 - 12.3', max: false },
            F900: {
              range: '11.4 - 18.9',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '12.8 - 23.4',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '22.5 - 42.1',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 30,
            F30: { range: '0.3 - 0.7', max: false },
            F45: { range: '0.5 - 1.1', max: false },
            F60: { range: '0.7 - 1.4', max: false },
            F120: { range: '1.4 - 2.6', max: false },
            F180: { range: '2 - 3.2', max: false },
            F275: { range: '2.9 - 5', max: false },
            F420: { range: '4.1 - 7.8', max: false },
            F500: { range: '5.4 - 8.6', max: false },
            F600: { range: '6.2 - 10.4', max: false },
            F900: {
              range: '9.7 - 16.1',
              max:
                this.props.version === 'international' ? true : false,
            },
            F1200: {
              range: '10.9 - 20',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '19.5 - 36.9',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 31,
            F30: { range: '0.3 - 0.6', max: false },
            F45: { range: '0.5 - 1', max: false },
            F60: { range: '0.6 - 1.2', max: false },
            F120: { range: '1.2 - 2.2', max: false },
            F180: { range: '1.7 - 2.8', max: false },
            F275: { range: '2.5 - 4.3', max: false },
            F420: { range: '3.6 - 6.7', max: false },
            F500: { range: '4.7 - 7.4', max: false },
            F600: { range: '5.4 - 9', max: false },
            F900: { range: '8.4 - 14', max: false },
            F1200: {
              range: '9.5 - 17.5',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '17.2 - 32.9',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
          {
            NeedleSet: 32,
            F30: { range: '0.3 - 0.5', max: false },
            F45: { range: '0.4 - 0.8', max: false },
            F60: { range: '0.5 - 1.1', max: false },
            F120: { range: '1.0 - 2.0', max: false },
            F180: { range: '1.5 - 2.4', max: false },
            F275: { range: '2.2 - 3.8', max: false },
            F420: { range: '3.1 - 5.9', max: false },
            F500: { range: '4.1 - 6.6', max: false },
            F600: { range: '4.7 - 7.9', max: false },
            F900: { range: '7.5 - 12.4', max: false },
            F1200: {
              range: '8.4 - 15.6',
              max:
                this.props.version === 'international' ? true : false,
            },
            F2400: {
              range: '15.4 - 29.6',
              max:
                this.props.version === 'international' ? true : false,
            },
          },
        ],
      },
    ];

    const flowData = [
      {
        drugId: 15,
        flowValues: [
          {
            NeedleSet: 33,
            F120: '11.5 (8.0 - 15.1)',
            F180: '15.1 (11.5 - 18.7)',
            F275: '22.5 (16.8 - 28.2)',
            F420: '33.1 (23.2 - 43)',
            F500: '38.5 (29.9 - 47.1)',
            F600: '44.8 (33.8 - 55.8)',
            F900: '66 (50.3 - 81.7)',
            F1200: '76.8 (55.6 - 98)',
            F2400: '122.5 (88.8 - 156.3)',
          },
          {
            NeedleSet: 34,
            F120: '11.8 (8.0 - 15.4)',
            F180: '15.6 (11.8 - 19.2)',
            F275: '23.4 (17.4 - 29.4)',
            F420: '35.2 (24.4 - 46.0)',
            F500: '41.4 (32.0 - 50.8)',
            F600: '48.8 (36.4 - 61.0)',
            F900: '75.0 (56.6 - 93.4)',
            F1200: '89.4 (63.4 - 115.4)',
            F2400: '158.2 (110.6 - 205.6)',
          },
          {
            NeedleSet: 35,
            F120: '12.0 (8.1 - 15.6)',
            F180: '15.6 (12.0 - 19.5)',
            F275: '23.7 (17.7 - 30.0)',
            F420: '36.0 (24.9 - 47.1)',
            F500: '42.6 (33.0 - 52.2)',
            F600: '50.1 (37.5 - 63.0)',
            F900: '78.6 (59.1 - 98.1)',
            F1200: '94.5 (66.6 - 122.7)',
            F2400: '175.2 (120.6 - 229.8)',
          },
          {
            NeedleSet: 36,
            F120: '12.0 (8.0 - 15.6)',
            F180: '15.6 (12.0 - 19.6)',
            F275: '24.0 (18.0 - 30.0)',
            F420: '36.4 (25.2 - 47.6)',
            F500: '43.2 (33.2 - 52.8)',
            F600: '51.2 (38.0 - 64.0)',
            F900: '80.4 (60.4 - 100.8)',
            F1200: '97.2 (68.0 - 126.8)',
            F2400: '185.2 (126.0 - 244.4)',
          },
          {
            NeedleSet: 37,
            F120: '12.0 (8.0 - 15.5)',
            F180: '16.0 (12.0 - 19.5)',
            F275: '24.0 (18.0 - 30.5)',
            F420: '36.5 (25.5 - 48.0)',
            F500: '43.5 (33.5 - 53.5)',
            F600: '51.5 (38.5 - 64.5)',
            F900: '81.5 (51.0 - 102.0)',
            F1200: '99.0 (69.0 - 129.0)',
            F2400: '191.8 (129.8 - 253.8)',
          },
          {
            NeedleSet: 38,
            F120: '12.0 (8.4 - 15.6)',
            F180: '15.6 (12.0 - 19.8)',
            F275: '24.0 (18.0 - 30.6)',
            F420: '36.6 (25.2 - 48.6)',
            F500: '43.8 (33.6 - 53.4)',
            F600: '51.6 (38.4 - 64.8)',
            F900: '82.8 (61.8 - 103.2)',
            F1200: '100.2 (70.2 - 130.8)',
            F2400: '196.2 (132.0 - 260.4)',
          },
          {
            NeedleSet: 39,
            F120: '11.9 (8.4 - 15.4)',
            F180: '16.1 (11.9 - 19.6)',
            F275: '24.5 (18.2 - 30.1)',
            F420: '37.1 (25.2 - 48.3)',
            F500: '44.1 (33.6 - 53.9)',
            F600: '51.8 (38.5 - 65.1)',
            F900: '83.3 (62.3 - 104.3)',
            F1200: '101.5 (70.7 - 132.3)',
            F2400: '200.2 (134.4 - 266.0)',
          },
          {
            NeedleSet: 40,
            F120: '12.0 (8.0 - 16.0)',
            F180: '16.0 (12.0 - 20.0)',
            F275: '24.0 (18.4 - 30.4)',
            F420: '36.8 (25.6 - 48.8)',
            F500: '44.0 (33.6 - 53.6)',
            F600: '52.0 (39.2 - 65.6)',
            F900: '84.0 (62.4 - 104.8)',
            F1200: '101.6 (71.2 - 132.8)',
            F2400: '202.4 (136.0 - 269.6)',
          },
          {
            NeedleSet: 16,
            F120: '9.9 (7.0 - 12.9)',
            F180: '12.5 (9.7 - 15.4)',
            F275: '17.2 (13.1 - 21.2)',
            F420: '22.7 (16.7 - 28.7)',
            F500: '25.2 (19.9 - 30.5)',
            F600: '27.7 (21.6 - 33.9)',
            F900: '34.6 (27.3 - 42)',
            F1200: '37.3 (28.8 - 45.9)',
            F2400: '45.7 (35.7 - 55.6)',
          },
          {
            NeedleSet: 17,
            F120: '10.8 (7.6 - 14.2)',
            F180: '14.0 (10.8 - 17.4)',
            F275: '20.2 (15.2 - 25.2)',
            F420: '28.4 (20.2 - 36.4)',
            F500: '32.2 (25.2 - 39.2)',
            F600: '36.6 (28.0 - 45.0)',
            F900: '49.6 (38.4 - 60.6)',
            F1200: '55.2 (41.4 - 69.2)',
            F2400: '75.6 (57.4 - 93.8)',
          },
          {
            NeedleSet: 18,
            F120: '11.1 (7.8 - 14.7)',
            F180: '14.7 (11.1 - 18.0)',
            F275: '21.6 (16.2 - 26.7)',
            F420: '30.9 (21.9 - 39.9)',
            F500: '35.7 (27.9 - 43.5)',
            F600: '40.8 (30.9 - 50.7)',
            F900: '57.9 (44.4 - 71.1)',
            F1200: '66.0 (48.6 - 83.1)',
            F2400: '96.9 (72.0 - 121.8)',
          },
          {
            NeedleSet: 19,
            F120: '11.6 (8.0 - 14.8)',
            F180: '14.8 (11.6 - 18.4)',
            F275: '22.0 (16.8 - 27.6)',
            F420: '32.4 (22.8 - 42.0)',
            F500: '37.6 (29.2 - 46.0)',
            F600: '43.6 (32.8 - 54.0)',
            F900: '63.2 (48.4 - 78.0)',
            F1200: '72.8 (53.2 - 92.8)',
            F2400: '112.8 (82.4 - 143.2)',
          },
          {
            NeedleSet: 20,
            F120: '11.5 (8.0 - 15.0)',
            F180: '15.0 (11.5 - 19.0)',
            F275: '22.5 (17.0 - 28.5)',
            F420: '33.5 (23.5 - 43.5)',
            F500: '39.0 (30.0 - 47.5)',
            F600: '45.0 (34.0 - 56.0)',
            F900: '66.5 (51.0 - 82.5)',
            F1200: '78.0 (56.0 - 99.5)',
            F2400: '125.0 (90.5 - 160.0)',
          },
          {
            NeedleSet: 21,
            F120: '11.4 (7.8 - 15.0)',
            F180: '15.0 (11.4 - 19.2)',
            F275: '22.8 (17.4 - 28.8)',
            F420: '34.2 (23.4 - 44.4)',
            F500: '39.6 (30.6 - 48.6)',
            F600: '46.2 (34.8 - 57.6)',
            F900: '69.6 (52.8 - 86.4)',
            F1200: '81.6 (58.8 - 104.4)',
            F2400: '135.0 (96.6 - 173.4)',
          },
          {
            NeedleSet: 22,
            F120: '11.9 (7.7 - 15.4)',
            F180: '15.4 (11.9 - 18.9)',
            F275: '23.1 (17.5 - 28.7)',
            F420: '34.3 (23.8 - 44.8)',
            F500: '40.6 (31.5 - 49.7)',
            F600: '46.9 (35.7 - 58.8)',
            F900: '71.4 (53.9 - 88.9)',
            F1200: '84.7 (60.2 - 108.5)',
            F2400: '142.8 (101.5 - 184.8)',
          },
          {
            NeedleSet: 23,
            F120: '12.0 (8.0 - 15.2)',
            F180: '15.2 (12.0 - 19.2)',
            F275: '23.2 (17.6 - 29.6)',
            F420: '35.2 (24.0 - 45.6)',
            F500: '40.8 (32.0 - 50.4)',
            F600: '48.0 (36.0 - 60.0)',
            F900: '72.8 (55.2 - 91.2)',
            F1200: '86.4 (61.6 - 111.2)',
            F2400: '149.6 (105.6 - 193.6)',
          },
          {
            NeedleSet: 25,
            F60: 6.4,
            F120: 10.3,
            F180: 14.7,
            F275: 22,
            F420: 30.3,
            F500: 35.2,
            F600: 38.7,
            F900: 47.7,
            F1200: 52.7,
            F2400: 75.4,
          },
          {
            NeedleSet: 26,
            F60: 6.6,
            F120: 10.9,
            F180: 15.9,
            F275: 24.7,
            F420: 35.7,
            F500: 42.6,
            F600: 47.9,
            F900: 62.4,
            F1200: 71.4,
            F2400: 120.2,
          },
          {
            NeedleSet: 27,
            F60: 6.6,
            F120: 11.1,
            F180: 16.3,
            F275: 25.8,
            F420: 38,
            F500: 45.8,
            F600: 52,
            F900: 69.6,
            F1200: 80.9,
            F2400: 150,
          },
          {
            NeedleSet: 28,
            F60: 6.7,
            F120: 11.2,
            F180: 16.5,
            F275: 26.4,
            F420: 39.2,
            F500: 47.6,
            F600: 54.3,
            F900: 73.8,
            F1200: 86.7,
            F2400: 171.2,
          },
          {
            NeedleSet: 29,
            F60: 6.7,
            F120: 11.2,
            F180: 16.6,
            F275: 26.7,
            F420: 40,
            F500: 48.8,
            F600: 55.8,
            F900: 76.6,
            F1200: 90.6,
            F2400: 187,
          },
          {
            NeedleSet: 30,
            F60: 6.7,
            F120: 11.3,
            F180: 16.7,
            F275: 26.9,
            F420: 40.5,
            F500: 49.6,
            F600: 56.8,
            F900: 78.6,
            F1200: 93.4,
            F2400: 199.3,
          },
          {
            NeedleSet: 31,
            F60: 6.7,
            F120: 11.3,
            F180: 16.8,
            F275: 27.1,
            F420: 40.9,
            F500: 50.2,
            F600: 57.6,
            F900: 80.1,
            F1200: 95.5,
            F2400: 209.1,
          },
          {
            NeedleSet: 32,
            F60: 6.7,
            F120: 11.3,
            F180: 16.9,
            F275: 27.2,
            F420: 41.2,
            F500: 50.6,
            F600: 58.2,
            F900: 81.2,
            F1200: 97.1,
            F2400: 217.2,
          },
        ],
      },
      {
        drugId: 16,
        flowValues: [
          {
            NeedleSet: 33,
            F120: '11.5 (8.0 - 15.1)',
            F180: '15.1 (11.5 - 18.7)',
            F275: '22.5 (16.8 - 28.2)',
            F420: '33.1 (23.2 - 43)',
            F500: '38.5 (29.9 - 47.1)',
            F600: '44.8 (33.8 - 55.8)',
            F900: '66 (50.3 - 81.7)',
            F1200: '76.8 (55.6 - 98)',
            F2400: '122.5 (88.8 - 156.3)',
          },
          {
            NeedleSet: 34,
            F120: '11.8 (8.1 - 15.5)',
            F180: '15.5 (11.8 - 19.3)',
            F275: '23.5 (17.5 - 29.5)',
            F420: '35.2 (24.4 - 46.1)',
            F500: '41.4 (32.1 - 50.8)',
            F600: '48.8 (36.5 - 61)',
            F900: '75 (56.6 - 93.4)',
            F1200: '89.4 (63.4 - 115.4)',
            F2400: '158.2 (110.6 - 205.7)',
          },
          {
            NeedleSet: 35,
            F120: '11.9 (8.1 - 15.6)',
            F180: '15.7 (11.9 - 19.4)',
            F275: '23.8 (17.7 - 29.9)',
            F420: '36 (24.9 - 47.2)',
            F500: '42.5 (32.9 - 52.1)',
            F600: '50.2 (37.5 - 63)',
            F900: '78.6 (59.1 - 98.1)',
            F1200: '94.6 (66.5 - 122.6)',
            F2400: '175.2 (120.5 - 229.9)',
          },
          {
            NeedleSet: 36,
            F120: '11.9 (8.2 - 15.7)',
            F180: '15.8 (12 - 19.5)',
            F275: '24 (17.8 - 30.1)',
            F420: '36.4 (25.1 - 47.7)',
            F500: '43 (33.3 - 52.8)',
            F600: '51 (38 - 64)',
            F900: '80.5 (60.4 - 100.7)',
            F1200: '97.4 (68.2 - 126.6)',
            F2400: '185.2 (126.1 - 244.3)',
          },
          {
            NeedleSet: 37,
            F120: '11.9 (8.2 - 15.7)',
            F180: '15.8 (12 - 19.6)',
            F275: '24.1 (17.9 - 30.3)',
            F420: '36.7 (25.3 - 48.1)',
            F500: '43.4 (33.5 - 53.3)',
            F600: '51.5 (38.4 - 64.7)',
            F900: '81.7 (61.2 - 102.2)',
            F1200: '99.2 (69.2 - 129.1)',
            F2400: '191.8 (129.8 - 253.8)',
          },
          {
            NeedleSet: 38,
            F120: '12 (8.2 - 15.7)',
            F180: '15.8 (12.1 - 19.6)',
            F275: '24.2 (18 - 30.4)',
            F420: '36.8 (25.3 - 48.3)',
            F500: '43.6 (33.7 - 53.6)',
            F600: '51.8 (38.6 - 65.1)',
            F900: '82.6 (61.8 - 103.3)',
            F1200: '100.4 (69.9 - 130.9)',
            F2400: '196.5 (132.3 - 260.6)',
          },
          {
            NeedleSet: 39,
            F120: '12 (8.2 - 15.7)',
            F180: '15.9 (12.1 - 19.7)',
            F275: '24.2 (18 - 30.4)',
            F420: '37 (25.4 - 48.5)',
            F500: '43.8 (33.8 - 53.8)',
            F600: '52.1 (38.7 - 65.4)',
            F900: '83.2 (62.2 - 104.1)',
            F1200: '101.3 (70.5 - 132.1)',
            F2400: '199.9 (134.2 - 265.7)',
          },
          {
            NeedleSet: 40,
            F120: '12 (8.2 - 15.7)',
            F180: '15.9 (12.1 - 19.7)',
            F275: '24.3 (18 - 30.5)',
            F420: '37.1 (25.5 - 48.6)',
            F500: '43.9 (33.9 - 53.9)',
            F600: '52.2 (38.9 - 65.6)',
            F900: '83.6 (62.5 - 104.7)',
            F1200: '102 (70.8 - 133.1)',
            F2400: '202.6 (135.6 - 269.6)',
          },
          {
            NeedleSet: 16,
            F120: '9.9 (7.0 - 12.9)',
            F180: '12.5 (9.7 - 15.4)',
            F275: '17.2 (13.1 - 21.2)',
            F420: '22.7 (16.7 - 28.7)',
            F500: '25.2 (19.9 - 30.5)',
            F600: '27.7 (21.6 - 33.9)',
            F900: '34.6 (27.3 - 42)',
            F1200: '37.3 (28.8 - 45.9)',
            F2400: '45.7 (35.7 - 55.6)',
          },
          {
            NeedleSet: 17,
            F120: '10.9 (7.6 - 14.2)',
            F180: '14 (10.8 - 17.3)',
            F275: '20.2 (15.3 - 25.2)',
            F420: '28.3 (20.3 - 36.4)',
            F500: '32.3 (25.3 - 39.2)',
            F600: '36.5 (28 - 45.1)',
            F900: '49.5 (38.4 - 60.6)',
            F1200: '55.3 (41.4 - 69.2)',
            F2400: '75.7 (57.5 - 93.9)',
          },
          {
            NeedleSet: 18,
            F120: '11.2 (7.8 - 14.7)',
            F180: '14.6 (11.2 - 18.1)',
            F275: '21.5 (16.1 - 26.8)',
            F420: '30.9 (21.8 - 39.9)',
            F500: '35.6 (27.8 - 43.4)',
            F600: '40.8 (31 - 50.7)',
            F900: '57.8 (44.4 - 71.2)',
            F1200: '65.9 (48.5 - 83.2)',
            F2400: '96.9 (72.1 - 121.8)',
          },
          {
            NeedleSet: 19,
            F120: '11.4 (7.9 - 15)',
            F180: '15 (11.4 - 18.5)',
            F275: '22.2 (16.6 - 27.7)',
            F420: '32.3 (22.7 - 41.9)',
            F500: '37.5 (29.2 - 45.8)',
            F600: '43.4 (32.8 - 54)',
            F900: '63.1 (48.2 - 77.9)',
            F1200: '72.8 (53 - 92.6)',
            F2400: '112.8 (82.6 - 143.1)',
          },
          {
            NeedleSet: 20,
            F120: '11.6 (8 - 15.1)',
            F180: '15.2 (11.6 - 18.8)',
            F275: '22.6 (16.9 - 28.3)',
            F420: '33.3 (23.3 - 43.3)',
            F500: '38.8 (30.1 - 47.4)',
            F600: '45.1 (34 - 56.2)',
            F900: '66.7 (50.8 - 82.7)',
            F1200: '77.8 (56.2 - 99.4)',
            F2400: '125.2 (90.5 - 159.8)',
          },
          {
            NeedleSet: 21,
            F120: '11.6 (8 - 15.3)',
            F180: '15.3 (11.7 - 18.9)',
            F275: '22.9 (17.1 - 28.7)',
            F420: '33.9 (23.7 - 44.2)',
            F500: '39.7 (30.8 - 48.5)',
            F600: '46.3 (34.8 - 57.8)',
            F900: '69.4 (52.7 - 86.1)',
            F1200: '81.5 (58.5 - 104.5)',
            F2400: '135 (96.6 - 173.4)',
          },
          {
            NeedleSet: 22,
            F120: '11.7 (8 - 15.3)',
            F180: '15.4 (11.7 - 19.1)',
            F275: '23.1 (17.3 - 29)',
            F420: '34.4 (24 - 44.9)',
            F500: '40.3 (31.3 - 49.4)',
            F600: '47.2 (35.5 - 59)',
            F900: '71.5 (54.2 - 88.8)',
            F1200: '84.4 (60.3 - 108.4)',
            F2400: '143.1 (101.6 - 184.5)',
          },
          {
            NeedleSet: 23,
            F120: '11.7 (8.1 - 15.4)',
            F180: '15.5 (11.8 - 19.1)',
            F275: '23.3 (17.4 - 29.2)',
            F420: '34.8 (24.2 - 45.4)',
            F500: '40.8 (31.6 - 50)',
            F600: '47.9 (35.9 - 59.9)',
            F900: '73.1 (55.3 - 90.9)',
            F1200: '86.6 (61.7 - 111.6)',
            F2400: '149.8 (105.7 - 193.9)',
          },
          {
            NeedleSet: 25,
            F60: 6.4,
            F120: 10.3,
            F180: 14.7,
            F275: 22,
            F420: 30.3,
            F500: 35.2,
            F600: 38.7,
            F900: 47.7,
            F1200: 52.7,
            F2400: 75.4,
          },
          {
            NeedleSet: 26,
            F60: 6.6,
            F120: 10.9,
            F180: 15.9,
            F275: 24.7,
            F420: 35.7,
            F500: 42.6,
            F600: 47.9,
            F900: 62.4,
            F1200: 71.4,
            F2400: 120.2,
          },
          {
            NeedleSet: 27,
            F60: 6.6,
            F120: 11.1,
            F180: 16.3,
            F275: 25.8,
            F420: 38,
            F500: 45.8,
            F600: 52,
            F900: 69.6,
            F1200: 80.9,
            F2400: 150,
          },
          {
            NeedleSet: 28,
            F60: 6.7,
            F120: 11.2,
            F180: 16.5,
            F275: 26.4,
            F420: 39.2,
            F500: 47.6,
            F600: 54.3,
            F900: 73.8,
            F1200: 86.7,
            F2400: 171.2,
          },
          {
            NeedleSet: 29,
            F60: 6.7,
            F120: 11.2,
            F180: 16.6,
            F275: 26.7,
            F420: 40,
            F500: 48.8,
            F600: 55.8,
            F900: 76.6,
            F1200: 90.6,
            F2400: 187,
          },
          {
            NeedleSet: 30,
            F60: 6.7,
            F120: 11.3,
            F180: 16.7,
            F275: 26.9,
            F420: 40.5,
            F500: 49.6,
            F600: 56.8,
            F900: 78.6,
            F1200: 93.4,
            F2400: 199.3,
          },
          {
            NeedleSet: 31,
            F60: 6.7,
            F120: 11.3,
            F180: 16.8,
            F275: 27.1,
            F420: 40.9,
            F500: 50.2,
            F600: 57.6,
            F900: 80.1,
            F1200: 95.5,
            F2400: 209.1,
          },
          {
            NeedleSet: 32,
            F60: 6.7,
            F120: 11.3,
            F180: 16.9,
            F275: 27.2,
            F420: 41.2,
            F500: 50.6,
            F600: 58.2,
            F900: 81.2,
            F1200: 97.1,
            F2400: 217.2,
          },
        ],
      },
      {
        drugId: 13,
        flowValues: [
          {
            NeedleSet: 33,
            F120: '11.7 (7.4 - 15.9)',
            F180: '15.2 (10.8 - 19.7)',
            F275: '22.7 (15.7 - 29.6)',
            F420: '33.4 (21.6 - 45.2)',
            F500: '38.7 (28 - 49.5)',
            F600: '45.1 (31.5 - 58.7)',
            F900: '66.4 (47 - 85.9)',
            F1200: '77.5 (51.9 - 103.0)',
            F2400: '123.6 (83 - 164.3)',
          },
          {
            NeedleSet: 34,
            F120: '12.0 (7.6 - 16.2)',
            F180: '15.6 (11.0 - 20.2)',
            F275: '23.6 (16.4 - 31.0)',
            F420: '35.6 (22.8 - 48.4)',
            F500: '41.6 (30.0 - 53.4)',
            F600: '49.2 (34.0 - 64.2)',
            F900: '75.6 (52.8 - 98.2)',
            F1200: '90.2 (59.2 - 121.4)',
            F2400: '159.8 (103.4 - 216.2)',
          },
          {
            NeedleSet: 35,
            F120: '12.0 (7.5 - 16.5)',
            F180: '15.9 (11.1 - 20.4)',
            F275: '24.0 (16.5 - 31.5)',
            F420: '36.3 (23.1 - 49.5)',
            F500: '42.6 (30.6 - 55.0)',
            F600: '50.7 (35.1 - 66.3)',
            F900: '79.2 (55.2 - 103.2)',
            F1200: '95.4 (62.1 - 129.0)',
            F2400: '177.0 (112.5 - 241.8)',
          },
          {
            NeedleSet: 36,
            F120: '12.0 (7.6 - 16.4)',
            F180: '16.0 (11.2 - 20.4)',
            F275: '24.0 (16.8 - 31.6)',
            F420: '36.8 (23.6 - 50.4)',
            F500: '43.2 (31.2 - 55.6)',
            F600: '51.6 (35.6 - 67.2)',
            F900: '81.2 (56.4 - 106.0)',
            F1200: '98.4 (63.6 - 133.2)',
            F2400: '187.2 (117.6 - 256.8)',
          },
          {
            NeedleSet: 37,
            F120: '12.1 (7.6 - 16.5)',
            F180: '15.9 (11.2 - 20.6)',
            F275: '24.3 (16.7 - 31.8)',
            F420: '37.1 (23.6 - 50.6)',
            F500: '43.7 (31.3 - 56)',
            F600: '51.9 (35.8 - 68)',
            F900: '82.3 (57.2 - 107.5)',
            F1200: '100.2 (64.6 - 135.8)',
            F2400: '194 (121.2 - 266.9)',
          },
          {
            NeedleSet: 38,
            F120: '12.1 (7.7 - 16.5)',
            F180: '16 (11.3 - 20.7)',
            F275: '24.4 (16.8 - 31.9)',
            F420: '37.2 (23.7 - 50.8)',
            F500: '43.9 (31.5 - 56.3)',
            F600: '52.2 (36 - 68.4)',
            F900: '83.2 (57.7 - 108.6)',
            F1200: '101.5 (65.3 - 137.6)',
            F2400: '198.8 (123.6 - 274)',
          },
          {
            NeedleSet: 16,
            F120: '10.0 (6.6 - 13.5)',
            F180: '12.6 (9.0 - 16.2)',
            F275: '17.3 (12.3 - 22.3)',
            F420: '22.9 (15.6 - 30.2)',
            F500: '25.3 (18.6 - 32.0)',
            F600: '27.9 (20.2 - 35.6)',
            F900: '34.8 (25.5 - 44.1)',
            F1200: '37.6 (26.9 - 48.3)',
            F2400: '45.9 (33.4 - 58.5)',
          },
          {
            NeedleSet: 17,
            F120: '11.0 (7.1 - 15.0)',
            F180: '14.2 (10.0 - 18.2)',
            F275: '20.4 (14.2 - 26.4)',
            F420: '28.6 (19.0 - 38.2)',
            F500: '32.4 (23.6 - 41.2)',
            F600: '36.8 (26.2 - 47.4)',
            F900: '49.8 (35.8 - 63.8)',
            F1200: '55.6 (38.6 - 72.8)',
            F2400: '76.2 (53.6 - 98.6)',
          },
          {
            NeedleSet: 18,
            F120: '11.4 (7.2 - 15.6)',
            F180: '14.7 (10.5 - 18.9)',
            F275: '21.6 (15.0 - 28.2)',
            F420: '31.2 (20.4 - 42.0)',
            F500: '35.7 (25.8 - 45.6)',
            F600: '41.1 (29.1 - 53.4)',
            F900: '58.2 (41.4 - 74.7)',
            F1200: '66.3 (45.3 - 87.6)',
            F2400: '97.8 (67.2 - 128.1)',
          },
          {
            NeedleSet: 19,
            F120: '11.6 (7.2 - 15.6)',
            F180: '15.2 (10.8 - 19.6)',
            F275: '22.4 (15.6 - 29.2)',
            F420: '32.8 (21.2 - 44.0)',
            F500: '37.6 (27.2 - 48.0)',
            F600: '43.6 (30.8 - 56.8)',
            F900: '63.6 (45.2 - 82.0)',
            F1200: '73.6 (49.6 - 97.6)',
            F2400: '113.6 (77.2 - 150.4)',
          },
          {
            NeedleSet: 20,
            F120: '11.5 (7.5 - 16.0)',
            F180: '15.5 (11.0 - 19.5)',
            F275: '23.0 (16.0 - 30.0)',
            F420: '33.5 (21.5 - 45.5)',
            F500: '39.0 (28.0 - 50.0)',
            F600: '45.5 (32.0 - 59.0)',
            F900: '67.0 (47.5 - 87.0)',
            F1200: '78.5 (52.5 - 104.5)',
            F2400: '126.5 (84.5 - 168.0)',
          },
          {
            NeedleSet: 21,
            F120: '12.0 (7.2 - 16.2)',
            F180: '15.6 (10.8 - 19.8)',
            F275: '22.8 (16.2 - 30.0)',
            F420: '34.2 (22.2 - 46.2)',
            F500: '39.6 (28.8 - 51.0)',
            F600: '46.8 (32.4 - 60.6)',
            F900: '70.2 (49.2 - 90.6)',
            F1200: '82.2 (54.6 - 109.8)',
            F2400: '136.2 (90.0 - 182.4)',
          },
          {
            NeedleSet: 22,
            F60: 6.996045229,
            F120: 12.58835506,
            F180: 16.52132487,
            F275: 24.61727986,
            F420: 37.4704458,
            F500: 46.48535897,
            F600: 53.40364067,
            F900: 78.4096836,
            F1200: 87.74251287,
            F2400: 166.556874,
          },
          {
            NeedleSet: 23,
            F60: 7.013221264,
            F120: 12.64407477,
            F180: 16.61743332,
            F275: 24.831269,
            F420: 37.96848658,
            F500: 47.25433105,
            F600: 54.42103764,
            F900: 80.62267467,
            F1200: 90.52300578,
            F2400: 176.8694748,
          },
          {
            NeedleSet: 25,
            F60: 6.678893326,
            F120: 11.59742971,
            F180: 14.85545513,
            F275: 21.09287322,
            F420: 29.87285642,
            F500: 35.33611938,
            F600: 39.19597946,
            F900: 51.1743687,
            F1200: 54.99192044,
            F2400: 78.17715381,
          },
          {
            NeedleSet: 26,
            F60: 6.899817107,
            F120: 12.28018828,
            F180: 15.99454568,
            F275: 23.46572189,
            F420: 34.86606983,
            F500: 42.54300036,
            F600: 48.26535556,
            F900: 67.81037218,
            F1200: 74.6800136,
            F2400: 125.0400931,
          },
          {
            NeedleSet: 27,
            F60: 6.976742442,
            F120: 12.52599652,
            F180: 16.41408009,
            F275: 24.37993094,
            F420: 36.92329873,
            F500: 45.64621651,
            F600: 52.29910475,
            F900: 76.05142314,
            F1200: 84.79998512,
            F2400: 156.2640096,
          },
          {
            NeedleSet: 28,
            F60: 7.015851939,
            F120: 12.65262814,
            F180: 16.63221021,
            F275: 24.8642789,
            F420: 38.04571878,
            F500: 47.37401921,
            F600: 54.57984421,
            F900: 80.97170232,
            F1200: 90.96325064,
            F2400: 178.5579764,
          },
          {
            NeedleSet: 29,
            F60: 7.039528815,
            F120: 12.72984358,
            F180: 16.76589348,
            F275: 25.16423659,
            F420: 38.75253465,
            F500: 48.47494472,
            F600: 56.04633691,
            F900: 84.24180441,
            F1200: 95.11084618,
            F2400: 195.2736247,
          },
          {
            NeedleSet: 30,
            F60: 7.055402381,
            F120: 12.78184627,
            F180: 16.85621597,
            F275: 25.36826169,
            F420: 39.23851849,
            F500: 49.23776954,
            F600: 57.06857817,
            F900: 86.572672,
            F1200: 98.09262569,
            F2400: 208.2718252,
          },
          {
            NeedleSet: 31,
            F60: 7.066784542,
            F120: 12.81925193,
            F180: 16.92133017,
            F275: 25.51603123,
            F420: 39.59318002,
            F500: 49.7975105,
            F600: 57.82188233,
            F900: 88.31813972,
            F1200: 100.3395561,
            F2400: 218.6685849,
          },
          {
            NeedleSet: 32,
            F60: 7.075345292,
            F120: 12.84745017,
            F180: 16.97049691,
            F275: 25.62799308,
            F420: 39.86341228,
            F500: 50.22573975,
            F600: 58.40004192,
            F900: 89.67413906,
            F1200: 102.0934873,
            F2400: 227.1738342,
          },
        ],
      },
      {
        drugId: 14,
        flowValues: [
          {
            NeedleSet: 33,
            F120: '7.6 (4.2 - 11)',
            F180: '9.8 (6 - 13.6)',
            F275: '14.7 (8.8 - 20.5)',
            F420: '21.7 (12.1 - 31.4)',
            F500: '25 (15.6 - 34.3)',
            F600: '29.1 (17.6 - 40.7)',
            F900: '42.9 (26.2 - 59.6)',
            F1200: '50.2 (29 - 71.4)',
            F2400: '80.1 (46.4 - 113.9)',
          },
          {
            NeedleSet: 34,
            F120: '7.8 (4.2 - 11.3)',
            F180: '10.1 (6.2 - 14)',
            F275: '15.3 (9.1 - 21.5)',
            F420: '23.2 (12.8 - 33.6)',
            F500: '26.9 (16.7 - 37)',
            F600: '31.8 (19 - 44.5)',
            F900: '48.8 (29.5 - 68.1)',
            F1200: '58.6 (33.1 - 84.1)',
            F2400: '103.8 (57.7 - 149.9)',
          },
          {
            NeedleSet: 35,
            F120: '7.8 (4.3 - 11.4)',
            F180: '10.2 (6.2 - 14.2)',
            F275: '15.5 (9.3 - 21.8)',
            F420: '23.7 (13 - 34.4)',
            F500: '27.6 (17.1 - 38)',
            F600: '32.7 (19.6 - 45.9)',
            F900: '51.2 (30.8 - 71.5)',
            F1200: '62.1 (34.7 - 89.4)',
            F2400: '115.2 (62.9 - 167.6)',
          },
          {
            NeedleSet: 36,
            F120: '7.8 (4.3 - 11.4)',
            F180: '10.3 (6.3 - 14.3)',
            F275: '15.6 (9.3 - 22)',
            F420: '24 (13.1 - 34.8)',
            F500: '27.9 (17.4 - 38.5)',
            F600: '33.3 (19.9 - 46.7)',
            F900: '52.5 (31.5 - 73.4)',
            F1200: '63.9 (35.6 - 92.3)',
            F2400: '122 (65.8 - 178.1)',
          },
          {
            NeedleSet: 37,
            F120: '7.9 (4.3 - 11.4)',
            F180: '10.3 (6.3 - 14.3)',
            F275: '15.7 (9.3 - 22.1)',
            F420: '24.1 (13.2 - 35.1)',
            F500: '28.2 (17.5 - 38.8)',
            F600: '33.6 (20 - 47.1)',
            F900: '53.2 (32 - 74.5)',
            F1200: '65.1 (36.1 - 94.1)',
            F2400: '126.4 (67.7 - 185.1)',
          },
          {
            NeedleSet: 38,
            F120: '7.9 (4.3 - 11.5)',
            F180: '10.3 (6.3 - 14.3)',
            F275: '15.8 (9.4 - 22.1)',
            F420: '24.2 (13.2 - 35.2)',
            F500: '28.3 (17.6 - 39)',
            F600: '33.8 (20.1 - 47.4)',
            F900: '53.8 (32.3 - 75.3)',
            F1200: '66 (36.5 - 95.4)',
            F2400: '129.5 (69 - 190)',
          },
          {
            NeedleSet: 16,
            F120: '6.5 (3.7 - 9.4)',
            F180: '8.1 (5 - 11.2)',
            F275: '11.2 (6.9 - 15.5)',
            F420: '14.8 (8.7 - 20.9)',
            F500: '16.3 (10.4 - 22.2)',
            F600: '18 (11.3 - 24.7)',
            F900: '22.4 (14.3 - 30.6)',
            F1200: '24.2 (15 - 33.5)',
            F2400: '29.6 (18.6 - 40.5)',
          },
          {
            NeedleSet: 17,
            F120: '7.2 (4 - 10.3)',
            F180: '9.1 (5.6 - 12.6)',
            F275: '13.2 (8 - 18.3)',
            F420: '18.5 (10.6 - 26.5)',
            F500: '20.9 (13.2 - 28.6)',
            F600: '23.7 (14.6 - 32.9)',
            F900: '32.1 (20.1 - 44.2)',
            F1200: '36 (21.6 - 50.4)',
            F2400: '49.2 (30 - 68.4)',
          },
          {
            NeedleSet: 18,
            F120: '7.4 (4.1 - 10.7)',
            F180: '9.5 (5.8 - 13.2)',
            F275: '14 (8.4 - 19.5)',
            F420: '20.2 (11.4 - 29.1)',
            F500: '23.1 (14.5 - 31.6)',
            F600: '26.6 (16.2 - 36.9)',
            F900: '37.5 (23.2 - 51.9)',
            F1200: '43 (25.3 - 60.7)',
            F2400: '63.2 (37.6 - 88.8)',
          },
          {
            NeedleSet: 19,
            F120: '7.5 (4.1 - 10.9)',
            F180: '9.7 (6 - 13.5)',
            F275: '14.4 (8.7 - 20.2)',
            F420: '21.2 (11.9 - 30.6)',
            F500: '24.3 (15.2 - 33.4)',
            F600: '28.2 (17.1 - 39.4)',
            F900: '41 (25.2 - 56.8)',
            F1200: '47.6 (27.7 - 67.5)',
            F2400: '73.7 (43.1 - 104.3)',
          },
          {
            NeedleSet: 20,
            F120: '7.6 (4.2 - 11)',
            F180: '9.9 (6 - 13.7)',
            F275: '14.7 (8.8 - 20.6)',
            F420: '21.8 (12.2 - 31.5)',
            F500: '25.1 (15.7 - 34.6)',
            F600: '29.4 (17.7 - 41)',
            F900: '43.4 (26.5 - 60.3)',
            F1200: '50.9 (29.3 - 72.5)',
            F2400: '81.9 (47.2 - 116.5)',
          },
          {
            NeedleSet: 21,
            F120: '7.7 (4.2 - 11.1)',
            F180: '9.9 (6.1 - 13.8)',
            F275: '14.9 (8.9 - 20.9)',
            F420: '22.3 (12.4 - 32.2)',
            F500: '25.7 (16.1 - 35.4)',
            F600: '30.2 (18.2 - 42.1)',
            F900: '45.2 (27.5 - 62.8)',
            F1200: '53.4 (30.5 - 76.2)',
            F2400: '88.4 (50.4 - 126.4)',
          },
          {
            NeedleSet: 22,
            F60: 5.79672319,
            F120: 10.43035134,
            F180: 13.68909775,
            F275: 20.39717474,
            F420: 31.0469408,
            F500: 38.51644029,
            F600: 44.24873084,
            F900: 64.96802355,
            F1200: 72.70093923,
            F2400: 138.004267,
          },
          {
            NeedleSet: 23,
            F60: 5.810954761,
            F120: 10.47651909,
            F180: 13.76873046,
            F275: 20.57448003,
            F420: 31.45960316,
            F500: 39.15358858,
            F600: 45.0917169,
            F900: 66.80164473,
            F1200: 75.00477622,
            F2400: 146.5489934,
          },
          {
            NeedleSet: 25,
            F60: 5.533940185,
            F120: 9.609298906,
            F180: 12.30880568,
            F275: 17.4769521,
            F420: 24.75179532,
            F500: 29.27849892,
            F600: 32.4766687,
            F900: 42.40161978,
            F1200: 45.56473408,
            F2400: 64.77535602,
          },
          {
            NeedleSet: 26,
            F60: 5.716991317,
            F120: 10.17501314,
            F180: 13.25262357,
            F275: 19.44302671,
            F420: 28.88902929,
            F500: 35.24991458,
            F600: 39.99129461,
            F900: 56.18573695,
            F1200: 61.87772555,
            F2400: 103.6046485,
          },
          {
            NeedleSet: 27,
            F60: 5.780729452,
            F120: 10.37868283,
            F180: 13.60023779,
            F275: 20.20051421,
            F420: 30.59359037,
            F500: 37.82115082,
            F600: 43.33354393,
            F900: 63.01403631,
            F1200: 70.26284481,
            F2400: 129.4758937,
          },
          {
            NeedleSet: 28,
            F60: 5.813134464,
            F120: 10.48360617,
            F180: 13.78097418,
            F275: 20.60183109,
            F420: 31.52359556,
            F500: 39.25275878,
            F600: 45.22329949,
            F900: 67.09083906,
            F1200: 75.36955053,
            F2400: 147.9480376,
          },
          {
            NeedleSet: 29,
            F60: 5.832752447,
            F120: 10.54758468,
            F180: 13.89174031,
            F275: 20.85036746,
            F420: 32.10924299,
            F500: 40.1649542,
            F600: 46.43839344,
            F900: 69.80035222,
            F1200: 78.80612969,
            F2400: 161.7981462,
          },
          {
            NeedleSet: 30,
            F60: 5.84590483,
            F120: 10.59067262,
            F180: 13.96657895,
            F275: 21.01941683,
            F420: 32.51191532,
            F500: 40.79700905,
            F600: 47.28539334,
            F900: 71.73164252,
            F1200: 81.276747,
            F2400: 172.5680838,
          },
          {
            NeedleSet: 31,
            F60: 5.855335763,
            F120: 10.62166589,
            F180: 14.02053071,
            F275: 21.14185445,
            F420: 32.80577773,
            F500: 41.26079442,
            F600: 47.90955965,
            F900: 73.17788719,
            F1200: 83.13848934,
            F2400: 181.1825417,
          },
          {
            NeedleSet: 32,
            F60: 5.862428956,
            F120: 10.64503014,
            F180: 14.06126886,
            F275: 21.23462284,
            F420: 33.02968446,
            F500: 41.61561293,
            F600: 48.38860616,
            F900: 74.3014295,
            F1200: 84.59174665,
            F2400: 188.2297484,
          },
        ],
      },
      {
        drugId: 7,
        flowValues: [
          {
            NeedleSet: 33,
            F60: 5.475623624,
            F120: 9.8,
            F180: 12.8,
            F275: 18.9,
            F420: 28.3,
            F500: 34.8,
            F600: 39.7,
            F900: 56.7,
            F1200: 62.8,
            F2400: 109.9,
          },
          {
            NeedleSet: 34,
            F60: 5.552232685,
            F120: 10.0,
            F180: 13.2,
            F275: 19.8,
            F420: 30.6,
            F500: 38.2,
            F600: 44.0,
            F900: 66.0,
            F1200: 74.6,
            F2400: 152.0,
          },
          {
            NeedleSet: 35,
            F60: 5.57824764,
            F120: 10.2,
            F180: 13.5,
            F275: 20.1,
            F420: 31.2,
            F500: 39.3,
            F600: 45.9,
            F900: 69.9,
            F1200: 79.5,
            F2400: 174.3,
          },
          {
            NeedleSet: 36,
            F60: 5.591346752,
            F120: 10.0,
            F180: 13.6,
            F275: 20.4,
            F420: 31.6,
            F500: 40.0,
            F600: 46.8,
            F900: 72.0,
            F1200: 82.4,
            F2400: 188.0,
          },
          {
            NeedleSet: 37,
            F60: 5.591346752,
            F120: 10.0,
            F180: 13.5,
            F275: 20.5,
            F420: 32.0,
            F500: 40.5,
            F600: 47.0,
            F900: 73.5,
            F1200: 84.0,
            F2400: 187.9900835,
          },
          {
            NeedleSet: 38,
            F60: 5.591346752,
            F120: 10.2,
            F180: 13.8,
            F275: 20.4,
            F420: 32.4,
            F500: 40.8,
            F600: 47.4,
            F900: 74.4,
            F1200: 85.2,
            F2400: 187.9900835,
          },
          {
            NeedleSet: 39,
            F60: 10.5,
            F120: 10.5,
            F180: 13.3,
            F275: 20.3,
            F420: 32.2,
            F500: 40.6,
            F600: 47.6,
            F900: 74.9,
            F1200: 86.1,
            F2400: 187.9900835,
          },
          {
            NeedleSet: 40,
            F60: 5.591346752,
            F120: 10.4,
            F180: 13.6,
            F275: 20.8,
            F420: 32.0,
            F500: 40.8,
            F600: 48.0,
            F900: 75.2,
            F1200: 86.4,
            F2400: 187.9900835,
          },
          {
            NeedleSet: 16,
            F60: 4.939963938,
            F120: 8.2,
            F180: 10.2,
            F275: 13.7,
            F420: 18.1,
            F500: 20.6,
            F600: 22.2,
            F900: 26.7,
            F1200: 28.0,
            F2400: 34.6,
          },
          {
            NeedleSet: 17,
            F60: 5.262901971,
            F120: 9.2,
            F180: 11.6,
            F275: 16.6,
            F420: 23.4,
            F500: 27.6,
            F600: 30.6,
            F900: 40.0,
            F1200: 42.8,
            F2400: 60.6,
          },
          {
            NeedleSet: 18,
            F60: 5.380139788,
            F120: 9.6,
            F180: 12.3,
            F275: 17.7,
            F420: 25.8,
            F500: 31.2,
            F600: 35.1,
            F900: 48.0,
            F1200: 52.2,
            F2400: 81.0,
          },
          {
            NeedleSet: 19,
            F60: 5.440739474,
            F120: 9.6,
            F180: 12.4,
            F275: 18.4,
            F420: 27.6,
            F500: 33.6,
            F600: 38.0,
            F900: 53.2,
            F1200: 58.4,
            F2400: 97.2,
          },
          {
            NeedleSet: 20,
            F60: 5.477759011,
            F120: 10.0,
            F180: 13.0,
            F275: 19.0,
            F420: 28.5,
            F500: 35.0,
            F600: 40.0,
            F900: 57.0,
            F1200: 63.0,
            F2400: 111.0,
          },
          {
            NeedleSet: 21,
            F60: 5.502719852,
            F120: 9.6,
            F180: 13.2,
            F275: 19.2,
            F420: 28.8,
            F500: 36.0,
            F600: 41.4,
            F900: 59.4,
            F1200: 66.6,
            F2400: 121.8,
          },
          {
            NeedleSet: 22,
            F60: 5.520688752,
            F120: 9.8,
            F180: 13.3,
            F275: 19.6,
            F420: 29.4,
            F500: 36.4,
            F600: 42.0,
            F900: 61.6,
            F1200: 69.3,
            F2400: 131.6,
          },
          {
            NeedleSet: 23,
            F60: 5.53424263,
            F120: 9.6,
            F180: 12.8,
            F275: 19.2,
            F420: 29.6,
            F500: 37.6,
            F600: 43.2,
            F900: 64.0,
            F1200: 71.2,
            F2400: 139.2,
          },
          {
            NeedleSet: 25,
            F60: 5.270419223,
            F120: 9.151713244,
            F180: 11.72267207,
            F275: 16.64471628,
            F420: 23.5731384,
            F500: 27.88428468,
            F600: 30.93016066,
            F900: 40.38249503,
            F1200: 43.39498484,
            F2400: 61.69081525,
          },
          {
            NeedleSet: 26,
            F60: 5.444753635,
            F120: 9.690488708,
            F180: 12.62154625,
            F275: 18.5171683,
            F420: 27.51336123,
            F500: 33.57134722,
            F600: 38.08694725,
            F900: 53.51022567,
            F1200: 58.93116719,
            F2400: 98.67109384,
          },
          {
            NeedleSet: 27,
            F60: 5.505456621,
            F120: 9.884459837,
            F180: 12.95260742,
            F275: 19.23858496,
            F420: 29.13675274,
            F500: 36.02014364,
            F600: 41.27004184,
            F900: 60.01336792,
            F1200: 66.91699506,
            F2400: 123.310375,
          },
          {
            NeedleSet: 28,
            F60: 5.536318537,
            F120: 9.984386829,
            F180: 13.12473731,
            F275: 19.62079151,
            F420: 30.02247196,
            F500: 37.38357979,
            F600: 43.06980904,
            F900: 63.8960372,
            F1200: 71.78052432,
            F2400: 140.902893,
          },
          {
            NeedleSet: 29,
            F60: 5.55500233,
            F120: 10.04531875,
            F180: 13.23022887,
            F275: 19.85749282,
            F420: 30.58023142,
            F500: 38.25233733,
            F600: 44.22704137,
            F900: 66.47652593,
            F1200: 75.05345685,
            F2400: 154.0934726,
          },
          {
            NeedleSet: 30,
            F60: 5.567528409,
            F120: 10.08635488,
            F180: 13.30150376,
            F275: 20.01849222,
            F420: 30.96372888,
            F500: 38.85429433,
            F600: 45.03370795,
            F900: 68.31585001,
            F1200: 77.40642572,
            F2400: 164.350556,
          },
          {
            NeedleSet: 31,
            F60: 5.576510251,
            F120: 10.11587227,
            F180: 13.35288639,
            F275: 20.13509947,
            F420: 31.24359784,
            F500: 39.29599468,
            F600: 45.62815204,
            F900: 69.6932259,
            F1200: 79.17951365,
            F2400: 172.5548017,
          },
          {
            NeedleSet: 32,
            F60: 5.583265673,
            F120: 10.13812395,
            F180: 13.39168463,
            F275: 20.22345032,
            F420: 31.45684235,
            F500: 39.63391708,
            F600: 46.08438682,
            F900: 70.7632662,
            F1200: 80.56356824,
            F2400: 179.266427,
          },
        ],
      },
      {
        drugId: 18,
        flowValues: [
          {
            NeedleSet: 33,
            F60: 5.475623624,
            F120: 9.8,
            F180: 12.8,
            F275: 18.9,
            F420: 28.3,
            F500: 34.8,
            F600: 39.7,
            F900: 56.7,
            F1200: 62.8,
            F2400: 109.9,
          },
          {
            NeedleSet: 34,
            F60: 5.552232685,
            F120: 10.0,
            F180: 13.2,
            F275: 19.8,
            F420: 30.6,
            F500: 38.2,
            F600: 44.0,
            F900: 66.0,
            F1200: 74.6,
            F2400: 152.0,
          },
          {
            NeedleSet: 35,
            F60: 5.57824764,
            F120: 10.2,
            F180: 13.5,
            F275: 20.1,
            F420: 31.2,
            F500: 39.3,
            F600: 45.9,
            F900: 69.9,
            F1200: 79.5,
            F2400: 174.3,
          },
          {
            NeedleSet: 36,
            F60: 5.591346752,
            F120: 10.0,
            F180: 13.6,
            F275: 20.4,
            F420: 31.6,
            F500: 40.0,
            F600: 46.8,
            F900: 72.0,
            F1200: 82.4,
            F2400: 188.0,
          },
          {
            NeedleSet: 37,
            F60: 5.591346752,
            F120: 10.0,
            F180: 13.5,
            F275: 20.5,
            F420: 32.0,
            F500: 40.5,
            F600: 47.0,
            F900: 73.5,
            F1200: 84.0,
            F2400: 187.9900835,
          },
          {
            NeedleSet: 38,
            F60: 5.591346752,
            F120: 10.2,
            F180: 13.8,
            F275: 20.4,
            F420: 32.4,
            F500: 40.8,
            F600: 47.4,
            F900: 74.4,
            F1200: 85.2,
            F2400: 187.9900835,
          },
          {
            NeedleSet: 39,
            F60: 10.5,
            F120: 10.5,
            F180: 13.3,
            F275: 20.3,
            F420: 32.2,
            F500: 40.6,
            F600: 47.6,
            F900: 74.9,
            F1200: 86.1,
            F2400: 187.9900835,
          },
          {
            NeedleSet: 40,
            F60: 5.591346752,
            F120: 10.4,
            F180: 13.6,
            F275: 20.8,
            F420: 32.0,
            F500: 40.8,
            F600: 48.0,
            F900: 75.2,
            F1200: 86.4,
            F2400: 187.9900835,
          },
          {
            NeedleSet: 16,
            F60: 4.939963938,
            F120: 8.2,
            F180: 10.2,
            F275: 13.7,
            F420: 18.1,
            F500: 20.6,
            F600: 22.2,
            F900: 26.7,
            F1200: 28.0,
            F2400: 34.6,
          },
          {
            NeedleSet: 17,
            F60: 5.262901971,
            F120: 9.2,
            F180: 11.6,
            F275: 16.6,
            F420: 23.4,
            F500: 27.6,
            F600: 30.6,
            F900: 40.0,
            F1200: 42.8,
            F2400: 60.6,
          },
          {
            NeedleSet: 18,
            F60: 5.380139788,
            F120: 9.6,
            F180: 12.3,
            F275: 17.7,
            F420: 25.8,
            F500: 31.2,
            F600: 35.1,
            F900: 48.0,
            F1200: 52.2,
            F2400: 81.0,
          },
          {
            NeedleSet: 19,
            F60: 5.440739474,
            F120: 9.6,
            F180: 12.4,
            F275: 18.4,
            F420: 27.6,
            F500: 33.6,
            F600: 38.0,
            F900: 53.2,
            F1200: 58.4,
            F2400: 97.2,
          },
          {
            NeedleSet: 20,
            F60: 5.477759011,
            F120: 10.0,
            F180: 13.0,
            F275: 19.0,
            F420: 28.5,
            F500: 35.0,
            F600: 40.0,
            F900: 57.0,
            F1200: 63.0,
            F2400: 111.0,
          },
          {
            NeedleSet: 21,
            F60: 5.502719852,
            F120: 9.6,
            F180: 13.2,
            F275: 19.2,
            F420: 28.8,
            F500: 36.0,
            F600: 41.4,
            F900: 59.4,
            F1200: 66.6,
            F2400: 121.8,
          },
          {
            NeedleSet: 22,
            F60: 5.520688752,
            F120: 9.8,
            F180: 13.3,
            F275: 19.6,
            F420: 29.4,
            F500: 36.4,
            F600: 42.0,
            F900: 61.6,
            F1200: 69.3,
            F2400: 131.6,
          },
          {
            NeedleSet: 23,
            F60: 5.53424263,
            F120: 9.6,
            F180: 12.8,
            F275: 19.2,
            F420: 29.6,
            F500: 37.6,
            F600: 43.2,
            F900: 64.0,
            F1200: 71.2,
            F2400: 139.2,
          },
          {
            NeedleSet: 25,
            F60: 5.270419223,
            F120: 9.151713244,
            F180: 11.72267207,
            F275: 16.64471628,
            F420: 23.5731384,
            F500: 27.88428468,
            F600: 30.93016066,
            F900: 40.38249503,
            F1200: 43.39498484,
            F2400: 61.69081525,
          },
          {
            NeedleSet: 26,
            F60: 5.444753635,
            F120: 9.690488708,
            F180: 12.62154625,
            F275: 18.5171683,
            F420: 27.51336123,
            F500: 33.57134722,
            F600: 38.08694725,
            F900: 53.51022567,
            F1200: 58.93116719,
            F2400: 98.67109384,
          },
          {
            NeedleSet: 27,
            F60: 5.505456621,
            F120: 9.884459837,
            F180: 12.95260742,
            F275: 19.23858496,
            F420: 29.13675274,
            F500: 36.02014364,
            F600: 41.27004184,
            F900: 60.01336792,
            F1200: 66.91699506,
            F2400: 123.310375,
          },
          {
            NeedleSet: 28,
            F60: 5.536318537,
            F120: 9.984386829,
            F180: 13.12473731,
            F275: 19.62079151,
            F420: 30.02247196,
            F500: 37.38357979,
            F600: 43.06980904,
            F900: 63.8960372,
            F1200: 71.78052432,
            F2400: 140.902893,
          },
          {
            NeedleSet: 29,
            F60: 5.55500233,
            F120: 10.04531875,
            F180: 13.23022887,
            F275: 19.85749282,
            F420: 30.58023142,
            F500: 38.25233733,
            F600: 44.22704137,
            F900: 66.47652593,
            F1200: 75.05345685,
            F2400: 154.0934726,
          },
          {
            NeedleSet: 30,
            F60: 5.567528409,
            F120: 10.08635488,
            F180: 13.30150376,
            F275: 20.01849222,
            F420: 30.96372888,
            F500: 38.85429433,
            F600: 45.03370795,
            F900: 68.31585001,
            F1200: 77.40642572,
            F2400: 164.350556,
          },
          {
            NeedleSet: 31,
            F60: 5.576510251,
            F120: 10.11587227,
            F180: 13.35288639,
            F275: 20.13509947,
            F420: 31.24359784,
            F500: 39.29599468,
            F600: 45.62815204,
            F900: 69.6932259,
            F1200: 79.17951365,
            F2400: 172.5548017,
          },
          {
            NeedleSet: 32,
            F60: 5.583265673,
            F120: 10.13812395,
            F180: 13.39168463,
            F275: 20.22345032,
            F420: 31.45684235,
            F500: 39.63391708,
            F600: 46.08438682,
            F900: 70.7632662,
            F1200: 80.56356824,
            F2400: 179.266427,
          },
        ],
      },
      {
        drugId: 19,
        flowValues: [
          {
            NeedleSet: 33,
            F120: '11.5 (8.0 - 15.1)',
            F180: '15.1 (11.5 - 18.7)',
            F275: '22.5 (16.8 - 28.2)',
            F420: '33.1 (23.2 - 43.0)',
            F500: '38.5 (29.9 - 47.1)',
            F600: '44.8 (33.8 - 55.8)',
            F900: '66.0 (50.3 - 81.7)',
            F1200: '76.8 (55.6 - 98.0)',
            F2400: '122.5 (88.8 - 156.3)',
          },
          {
            NeedleSet: 34,
            F120: '11.8 (8.0 - 15.4)',
            F180: '15.6 (11.8 - 19.2)',
            F275: '23.4 (17.4 - 29.4)',
            F420: '35.2 (24.4 - 46.0)',
            F500: '41.4 (32.0 - 50.8)',
            F600: '48.8 (36.4 - 61.0)',
            F900: '75.0 (56.6 - 93.4)',
            F1200: '89.4 (63.4 - 115.4)',
            F2400: '158.2 (110.6 - 205.6)',
          },
          {
            NeedleSet: 35,
            F120: '12.0 (8.1 - 15.6)',
            F180: '15.6 (12.0 - 19.5)',
            F275: '23.7 (17.7 - 30.0)',
            F420: '36.0 (24.9 - 47.1)',
            F500: '42.6 (33.0 - 52.2)',
            F600: '50.1 (37.5 - 63.0)',
            F900: '78.6 (59.1 - 98.1)',
            F1200: '94.5 (66.6 - 122.7)',
            F2400: '175.2 (120.6 - 229.8)',
          },
          {
            NeedleSet: 36,
            F120: '12.0 (8.0 - 15.6)',
            F180: '15.6 (12.0 - 19.6)',
            F275: '24.0 (18.0 - 30.0)',
            F420: '36.4 (25.2 - 47.6)',
            F500: '43.2 (33.2 - 52.8)',
            F600: '51.2 (38.0 - 64.0)',
            F900: '80.4 (60.4 - 100.8)',
            F1200: '97.2 (68.0 - 126.8)',
            F2400: '185.2 (126.0 - 244.4)',
          },
          {
            NeedleSet: 37,
            F120: '39.5 (21.5 - 57.0)',
            F180: '51.5 (31.5 - 71.5)',
            F275: '78.5 (46.5 - 110.5)',
            F420: '120.5 (66.0 - 175.5)',
            F500: '141.0 (87.5 - 194.0)',
            F600: '168.0 (100.0 - 235.5)',
            F900: '266.0 (160.0 - 372.5)',
            F1200: '325.5 (180.5 - 470.5)',
            F2400: '632.0 (338.5 - 925.5)',
          },
          {
            NeedleSet: 38,
            F120: '47.4 (25.8 - 69.0)',
            F180: '61.8 (37.8 - 85.8)',
            F275: '94.8 (56.4 - 132.6)',
            F420: '145.2 (79.2 - 211.2)',
            F500: '169.8 (105.6 - 234)',
            F600: '202.8 (120.6 - 284.4)',
            F900: '322.8 (193.8 - 451.8)',
            F1200: '396 (219 - 572.4)',
            F2400: '777 (414 - 1140)',
          },
          {
            NeedleSet: 16,
            F120: '9.9 (7.0 - 12.9)',
            F180: '12.5 (9.7 - 15.4)',
            F275: '17.2 (13.1 - 21.2)',
            F420: '22.7 (16.7 - 28.7)',
            F500: '25.2 (19.9 - 30.5)',
            F600: '27.7 (21.6 - 33.9)',
            F900: '34.6 (27.3 - 42.0)',
            F1200: '37.3 (28.8 - 45.9)',
            F2400: '45.7 (35.7 - 55.6)',
          },
          {
            NeedleSet: 17,
            F120: '10.8 (7.6 - 14.2)',
            F180: '14.0 (10.8 - 17.4)',
            F275: '20.2 (15.2 - 25.2)',
            F420: '28.4 (20.2 - 36.4)',
            F500: '32.2 (25.2 - 39.2)',
            F600: '36.6 (28.0 - 45.0)',
            F900: '49.6 (38.4 - 60.6)',
            F1200: '55.2 (41.4 - 69.2)',
            F2400: '75.6 (57.4 - 93.8)',
          },
          {
            NeedleSet: 18,
            F120: '11.1 (7.8 - 14.7)',
            F180: '14.7 (11.1 - 18.0)',
            F275: '21.6 (16.2 - 26.7)',
            F420: '30.9 (21.9 - 39.9)',
            F500: '35.7 (27.9 - 43.5)',
            F600: '40.8 (30.9 - 50.7)',
            F900: '57.9 (44.4 - 71.1)',
            F1200: '66.0 (48.6 - 83.1)',
            F2400: '96.9 (72.0 - 121.8)',
          },
          {
            NeedleSet: 19,
            F120: '11.6 (8.0 - 14.8)',
            F180: '14.8 (11.6 - 18.4)',
            F275: '22.0 (16.8 - 27.6)',
            F420: '32.4 (22.8 - 42.0)',
            F500: '37.6 (29.2 - 46.0)',
            F600: '43.6 (32.8 - 54.0)',
            F900: '63.2 (48.4 - 78.0)',
            F1200: '72.8 (53.2 - 92.8)',
            F2400: '112.8 (82.4 - 143.2)',
          },
          {
            NeedleSet: 20,
            F120: '11.5 (8.0 - 15.0)',
            F180: '15.0 (11.5 - 19.0)',
            F275: '22.5 (17.0 - 28.5)',
            F420: '33.5 (23.5 - 43.5)',
            F500: '39.0 (30.0 - 47.5)',
            F600: '45.0 (34.0 - 56.0)',
            F900: '66.5 (51.0 - 82.5)',
            F1200: '78.0 (56.0 - 99.5)',
            F2400: '125.0 (90.5 - 160.0)',
          },
          {
            NeedleSet: 21,
            F120: '11.4 (7.8 - 15.0)',
            F180: '15.0 (11.4 - 19.2)',
            F275: '22.8 (17.4 - 28.8)',
            F420: '34.2 (23.4 - 44.4)',
            F500: '39.6 (30.6 - 48.6)',
            F600: '46.2 (34.8 - 57.6)',
            F900: '69.6 (52.8 - 86.4)',
            F1200: '81.6 (58.8 - 104.4)',
            F2400: '135.0 (96.6 - 173.4)',
          },
          {
            NeedleSet: 22,
            F60: 5.79672319,
            F120: 10.43035134,
            F180: 13.68909775,
            F275: 20.39717474,
            F420: 31.0469408,
            F500: 38.51644029,
            F600: 44.24873084,
            F900: 64.96802355,
            F1200: 72.70093923,
            F2400: 138.004267,
          },
          {
            NeedleSet: 23,
            F60: 5.810954761,
            F120: 10.47651909,
            F180: 13.76873046,
            F275: 20.57448003,
            F420: 31.45960316,
            F500: 39.15358858,
            F600: 45.0917169,
            F900: 66.80164473,
            F1200: 75.00477622,
            F2400: 146.5489934,
          },
          {
            NeedleSet: 25,
            F60: 5.533940185,
            F120: 9.609298906,
            F180: 12.30880568,
            F275: 17.4769521,
            F420: 24.75179532,
            F500: 29.27849892,
            F600: 32.4766687,
            F900: 42.40161978,
            F1200: 45.56473408,
            F2400: 64.77535602,
          },
          {
            NeedleSet: 26,
            F60: 5.716991317,
            F120: 10.17501314,
            F180: 13.25262357,
            F275: 19.44302671,
            F420: 28.88902929,
            F500: 35.24991458,
            F600: 39.99129461,
            F900: 56.18573695,
            F1200: 61.87772555,
            F2400: 103.6046485,
          },
          {
            NeedleSet: 27,
            F60: 5.780729452,
            F120: 10.37868283,
            F180: 13.60023779,
            F275: 20.20051421,
            F420: 30.59359037,
            F500: 37.82115082,
            F600: 43.33354393,
            F900: 63.01403631,
            F1200: 70.26284481,
            F2400: 129.4758937,
          },
          {
            NeedleSet: 28,
            F60: 5.813134464,
            F120: 10.48360617,
            F180: 13.78097418,
            F275: 20.60183109,
            F420: 31.52359556,
            F500: 39.25275878,
            F600: 45.22329949,
            F900: 67.09083906,
            F1200: 75.36955053,
            F2400: 147.9480376,
          },
          {
            NeedleSet: 29,
            F60: 5.832752447,
            F120: 10.54758468,
            F180: 13.89174031,
            F275: 20.85036746,
            F420: 32.10924299,
            F500: 40.1649542,
            F600: 46.43839344,
            F900: 69.80035222,
            F1200: 78.80612969,
            F2400: 161.7981462,
          },
          {
            NeedleSet: 30,
            F60: 5.84590483,
            F120: 10.59067262,
            F180: 13.96657895,
            F275: 21.01941683,
            F420: 32.51191532,
            F500: 40.79700905,
            F600: 47.28539334,
            F900: 71.73164252,
            F1200: 81.276747,
            F2400: 172.5680838,
          },
          {
            NeedleSet: 31,
            F60: 5.855335763,
            F120: 10.62166589,
            F180: 14.02053071,
            F275: 21.14185445,
            F420: 32.80577773,
            F500: 41.26079442,
            F600: 47.90955965,
            F900: 73.17788719,
            F1200: 83.13848934,
            F2400: 181.1825417,
          },
          {
            NeedleSet: 32,
            F60: 5.862428956,
            F120: 10.64503014,
            F180: 14.06126886,
            F275: 21.23462284,
            F420: 33.02968446,
            F500: 41.61561293,
            F600: 48.38860616,
            F900: 74.3014295,
            F1200: 84.59174665,
            F2400: 188.2297484,
          },
        ],
      },
      {
        drugId: 6,
        flowValues: [
          {
            NeedleSet: 33,
            F60: 5.475623624,
            F120: 9.8,
            F180: 12.8,
            F275: 18.9,
            F420: 28.3,
            F500: 34.8,
            F600: 39.7,
            F900: 56.7,
            F1200: 62.8,
            F2400: 109.9,
          },
          {
            NeedleSet: 34,
            F60: 5.552232685,
            F120: 10.0,
            F180: 13.2,
            F275: 19.8,
            F420: 30.4,
            F500: 38.2,
            F600: 44.0,
            F900: 66.0,
            F1200: 74.6,
            F2400: 152.0,
          },
          {
            NeedleSet: 35,
            F60: 5.57824764,
            F120: 10.2,
            F180: 13.5,
            F275: 20.1,
            F420: 31.2,
            F500: 39.3,
            F600: 45.9,
            F900: 69.9,
            F1200: 79.5,
            F2400: 174.3,
          },
          {
            NeedleSet: 36,
            F60: 5.591346752,
            F120: 10.0,
            F180: 13.6,
            F275: 20.4,
            F420: 31.6,
            F500: 40.0,
            F600: 46.8,
            F900: 72.0,
            F1200: 82.4,
            F2400: 188.0,
          },
          {
            NeedleSet: 37,
            F60: 5.591346752,
            F120: 10.0,
            F180: 13.5,
            F275: 20.5,
            F420: 32.0,
            F500: 40.5,
            F600: 47.0,
            F900: 73.5,
            F1200: 84.0,
            F2400: 197.5,
          },
          {
            NeedleSet: 38,
            F60: 5.591346752,
            F120: 10.2,
            F180: 13.8,
            F275: 20.4,
            F420: 32.4,
            F500: 40.8,
            F600: 47.4,
            F900: 74.4,
            F1200: 85.2,
            F2400: 204.0,
          },
          {
            NeedleSet: 39,
            F60: 5.591346752,
            F120: 10.5,
            F180: 13.3,
            F275: 20.3,
            F420: 32.2,
            F500: 40.6,
            F600: 47.6,
            F900: 74.9,
            F1200: 86.1,
            F2400: 209.3,
          },
          {
            NeedleSet: 40,
            F60: 5.591346752,
            F120: 10.4,
            F180: 13.6,
            F275: 20.8,
            F420: 32.0,
            F500: 40.8,
            F600: 48.0,
            F900: 75.2,
            F1200: 86.4,
            F2400: 213.6,
          },
          {
            NeedleSet: 16,
            F60: 4.939963938,
            F120: 8.2,
            F180: 10.2,
            F275: 13.7,
            F420: 18.1,
            F500: 20.6,
            F600: 22.2,
            F900: 26.7,
            F1200: 28.0,
            F2400: 34.6,
          },
          {
            NeedleSet: 17,
            F60: 5.262901971,
            F120: 9.2,
            F180: 11.6,
            F275: 16.6,
            F420: 23.4,
            F500: 27.6,
            F600: 30.6,
            F900: 40.0,
            F1200: 42.8,
            F2400: 60.6,
          },
          {
            NeedleSet: 18,
            F60: 5.380139788,
            F120: 9.6,
            F180: 12.3,
            F275: 17.7,
            F420: 25.8,
            F500: 31.2,
            F600: 35.1,
            F900: 48.0,
            F1200: 52.2,
            F2400: 81.0,
          },
          {
            NeedleSet: 19,
            F60: 5.440739474,
            F120: 9.6,
            F180: 12.4,
            F275: 18.4,
            F420: 27.6,
            F500: 33.6,
            F600: 38.0,
            F900: 53.2,
            F1200: 58.4,
            F2400: 97.2,
          },
          {
            NeedleSet: 20,
            F60: 5.477759011,
            F120: 10.0,
            F180: 13.0,
            F275: 19.0,
            F420: 28.5,
            F500: 35.0,
            F600: 40.0,
            F900: 57.0,
            F1200: 63.0,
            F2400: 110.0,
          },
          {
            NeedleSet: 21,
            F60: 5.502719852,
            F120: 9.6,
            F180: 13.2,
            F275: 19.2,
            F420: 28.8,
            F500: 36.0,
            F600: 41.4,
            F900: 59.4,
            F1200: 66.6,
            F2400: 121.8,
          },
          {
            NeedleSet: 22,
            F60: 5.520688752,
            F120: 9.8,
            F180: 13.3,
            F275: 19.6,
            F420: 29.4,
            F500: 36.4,
            F600: 42.0,
            F900: 61.6,
            F1200: 69.3,
            F2400: 131.6,
          },
          {
            NeedleSet: 23,
            F60: 5.53424263,
            F120: 9.6,
            F180: 12.8,
            F275: 19.2,
            F420: 29.6,
            F500: 37.6,
            F600: 43.2,
            F900: 64.0,
            F1200: 71.2,
            F2400: 139.2,
          },
          {
            NeedleSet: 25,
            F60: 5.270419223,
            F120: 9.151713244,
            F180: 11.72267207,
            F275: 16.64471628,
            F420: 23.5731384,
            F500: 27.88428468,
            F600: 30.93016066,
            F900: 40.38249503,
            F1200: 43.39498484,
            F2400: 61.69081525,
          },
          {
            NeedleSet: 26,
            F60: 5.444753635,
            F120: 9.690488708,
            F180: 12.62154625,
            F275: 18.5171683,
            F420: 27.51336123,
            F500: 33.57134722,
            F600: 38.08694725,
            F900: 53.51022567,
            F1200: 58.93116719,
            F2400: 98.67109384,
          },
          {
            NeedleSet: 27,
            F60: 5.505456621,
            F120: 9.884459837,
            F180: 12.95260742,
            F275: 19.23858496,
            F420: 29.13675274,
            F500: 36.02014364,
            F600: 41.27004184,
            F900: 60.01336792,
            F1200: 66.91699506,
            F2400: 123.310375,
          },
          {
            NeedleSet: 28,
            F60: 5.536318537,
            F120: 9.984386829,
            F180: 13.12473731,
            F275: 19.62079151,
            F420: 30.02247196,
            F500: 37.38357979,
            F600: 43.06980904,
            F900: 63.8960372,
            F1200: 71.78052432,
            F2400: 140.902893,
          },
          {
            NeedleSet: 29,
            F60: 5.55500233,
            F120: 10.04531875,
            F180: 13.23022887,
            F275: 19.85749282,
            F420: 30.58023142,
            F500: 38.25233733,
            F600: 44.22704137,
            F900: 66.47652593,
            F1200: 75.05345685,
            F2400: 154.0934726,
          },
          {
            NeedleSet: 30,
            F60: 5.567528409,
            F120: 10.08635488,
            F180: 13.30150376,
            F275: 20.01849222,
            F420: 30.96372888,
            F500: 38.85429433,
            F600: 45.03370795,
            F900: 68.31585001,
            F1200: 77.40642572,
            F2400: 164.350556,
          },
          {
            NeedleSet: 31,
            F60: 5.576510251,
            F120: 10.11587227,
            F180: 13.35288639,
            F275: 20.13509947,
            F420: 31.24359784,
            F500: 39.29599468,
            F600: 45.62815204,
            F900: 69.6932259,
            F1200: 79.17951365,
            F2400: 172.5548017,
          },
          {
            NeedleSet: 32,
            F60: 5.583265673,
            F120: 10.13812395,
            F180: 13.39168463,
            F275: 20.22345032,
            F420: 31.45684235,
            F500: 39.63391708,
            F600: 46.08438682,
            F900: 70.7632662,
            F1200: 80.56356824,
            F2400: 179.266427,
          },
        ],
      },
      {
        drugId: 12,
        flowValues: [
          {
            NeedleSet: 33,
            F60: 5.589699116,
            F120: 10.0,
            F180: 13.1,
            F275: 19.3,
            F420: 28.9,
            F500: 35.5,
            F600: 40.5,
            F900: 57.8,
            F1200: 64.1,
            F2400: 112.2,
          },
          {
            NeedleSet: 34,
            F60: 5.667904199,
            F120: 10.2,
            F180: 13.6,
            F275: 20.2,
            F420: 31.2,
            F500: 39.0,
            F600: 45.0,
            F900: 67.4,
            F1200: 76.2,
            F2400: 155.2,
          },
          {
            NeedleSet: 35,
            F60: 5.694461132,
            F120: 10.2,
            F180: 13.8,
            F275: 20.7,
            F420: 32.1,
            F500: 40.2,
            F600: 46.8,
            F900: 71.4,
            F1200: 81.3,
            F2400: 177.9,
          },
          {
            NeedleSet: 36,
            F60: 5.707833143,
            F120: 10.4,
            F180: 13.6,
            F275: 20.8,
            F420: 32.4,
            F500: 40.8,
            F600: 47.6,
            F900: 73.6,
            F1200: 84.0,
            F2400: 192.0,
          },
          {
            NeedleSet: 16,
            F60: 5.042879854,
            F120: 8.4,
            F180: 10.4,
            F275: 14.0,
            F420: 18.5,
            F500: 21.0,
            F600: 22.7,
            F900: 27.3,
            F1200: 28.6,
            F2400: 35.3,
          },
          {
            NeedleSet: 17,
            F60: 5.372545762,
            F120: 9.4,
            F180: 12.0,
            F275: 17.0,
            F420: 24.0,
            F500: 28.2,
            F600: 31.4,
            F900: 40.8,
            F1200: 43.8,
            F2400: 62.0,
          },
          {
            NeedleSet: 18,
            F60: 5.492226033,
            F120: 9.6,
            F180: 12.6,
            F275: 18.3,
            F420: 26.4,
            F500: 31.8,
            F600: 36.0,
            F900: 48.9,
            F1200: 53.1,
            F2400: 82.8,
          },
          {
            NeedleSet: 19,
            F60: 5.554088213,
            F120: 10.0,
            F180: 12.8,
            F275: 18.8,
            F420: 28.0,
            F500: 34.0,
            F600: 38.8,
            F900: 54.4,
            F1200: 59.6,
            F2400: 99.2,
          },
          {
            NeedleSet: 20,
            F60: 5.591878991,
            F120: 10.0,
            F180: 13.0,
            F275: 19.5,
            F420: 29.0,
            F500: 35.5,
            F600: 40.5,
            F900: 58.0,
            F1200: 64.5,
            F2400: 113.0,
          },
          {
            NeedleSet: 21,
            F60: 5.617359849,
            F120: 10.2,
            F180: 13.2,
            F275: 19.8,
            F420: 29.4,
            F500: 36.6,
            F600: 42.0,
            F900: 61.2,
            F1200: 67.8,
            F2400: 124.2,
          },
          {
            NeedleSet: 22,
            F60: 5.635703101,
            F120: 10.14061936,
            F180: 13.30884503,
            F275: 19.83058655,
            F420: 30.18452578,
            F500: 37.44653917,
            F600: 43.01959942,
            F900: 63.16335623,
            F1200: 70.6814687,
            F2400: 134.1708151,
          },
          {
            NeedleSet: 23,
            F60: 5.649539351,
            F120: 10.18550467,
            F180: 13.38626573,
            F275: 20.0029667,
            F420: 30.5857253,
            F500: 38.0659889,
            F600: 43.83916921,
            F900: 64.94604348,
            F1200: 72.92131021,
            F2400: 142.478188,
          },
          {
            NeedleSet: 25,
            F60: 5.380219624,
            F120: 9.342373936,
            F180: 11.96689441,
            F275: 16.9914812,
            F420: 24.06424545,
            F500: 28.46520728,
            F600: 31.57453901,
            F900: 41.22379701,
            F1200: 44.29904702,
            F2400: 62.97604057,
          },
          {
            NeedleSet: 26,
            F60: 5.558186003,
            F120: 9.89237389,
            F180: 12.88449514,
            F275: 18.90294264,
            F420: 28.08655625,
            F500: 34.27075029,
            F600: 38.88042531,
            F900: 54.62502204,
            F1200: 60.15889984,
            F2400: 100.7267416,
          },
          {
            NeedleSet: 27,
            F60: 5.620153634,
            F120: 10.09038608,
            F180: 13.22245341,
            F275: 19.63938881,
            F420: 29.74376842,
            F500: 36.7705633,
            F600: 42.12983438,
            F900: 61.26364642,
            F1200: 68.31109912,
            F2400: 125.8793411,
          },
          {
            NeedleSet: 28,
            F60: 5.651658507,
            F120: 10.19239489,
            F180: 13.39816934,
            F275: 20.029558,
            F420: 30.64794013,
            F500: 38.16240437,
            F600: 43.96709673,
            F900: 65.22720464,
            F1200: 73.27595191,
            F2400: 143.8383699,
          },
          {
            NeedleSet: 29,
            F60: 5.670731545,
            F120: 10.25459622,
            F180: 13.50585864,
            F275: 20.27119059,
            F420: 31.21731958,
            F500: 39.04926103,
            F600: 45.14843807,
            F900: 67.86145355,
            F1200: 76.61707053,
            F2400: 157.3037532,
          },
          {
            NeedleSet: 30,
            F60: 5.683518584,
            F120: 10.29648727,
            F180: 13.57861842,
            F275: 20.43554414,
            F420: 31.60880656,
            F500: 39.6637588,
            F600: 45.9719102,
            F900: 69.73909689,
            F1200: 79.01905958,
            F2400: 167.7745259,
          },
          {
            NeedleSet: 31,
            F60: 5.692687547,
            F120: 10.32661961,
            F180: 13.63107152,
            F275: 20.55458071,
            F420: 31.89450612,
            F500: 40.11466124,
            F600: 46.57873854,
            F900: 71.14516811,
            F1200: 80.82908686,
            F2400: 176.1496934,
          },
          {
            NeedleSet: 32,
            F60: 5.699583708,
            F120: 10.34933486,
            F180: 13.67067806,
            F275: 20.6447722,
            F420: 32.11219323,
            F500: 40.45962369,
            F600: 47.04447821,
            F900: 72.23750091,
            F1200: 82.24197591,
            F2400: 183.0011443,
          },
        ],
      },
      {
        drugId: 2,
        flowValues: [
          {
            NeedleSet: 17,
            F120: 22.4 * 2,
            F180: 28.6 * 2,
          },
          {
            NeedleSet: 18,
            F120: 15.5 * 3,
            F180: 20.1 * 3,
            F275: 29.1 * 3,
          },
          {
            NeedleSet: 19,
            F120: 11.9 * 4,
            F180: 15.4 * 4,
            F275: 22.6 * 4,
          },
          {
            NeedleSet: 20,
            F120: 9.6 * 5,
            F180: 12.5 * 5,
            F275: 18.5 * 5,
            F420: 27.8 * 5,
          },
          {
            NeedleSet: 21,
            F120: 8.1 * 6,
            F180: 10.6 * 6,
            F275: 15.7 * 6,
            F420: 23.7 * 6,
            F500: 29.3 * 6,
          },
          {
            NeedleSet: 22,
            F120: 7.0 * 7,
            F180: 9.1 * 7,
            F275: 13.6 * 7,
            F420: 20.7 * 7,
            F500: 25.7 * 7,
            F600: 29.5 * 7,
          },
          {
            NeedleSet: 23,
            F120: 6.1 * 8,
            F180: 8.0 * 8,
            F275: 12.0 * 8,
            F420: 18.4 * 8,
            F500: 22.8 * 8,
            F600: 26.3 * 8,
          },
          {
            NeedleSet: 35,
            F120: 15.5 * 3,
            F180: 20.1 * 3,
          },
          {
            NeedleSet: 36,
            F120: 11.9 * 4,
            F180: 15.4 * 4,
          },
          {
            NeedleSet: 37,
            F120: 9.6 * 5,
            F180: 12.5 * 5,
            F275: 18.5 * 5,
          },
          {
            NeedleSet: 38,
            F120: 8.1 * 6,
            F180: 10.6 * 6,
            F275: 15.7 * 6,
          },
          {
            NeedleSet: 39,
            F120: 7.0 * 7,
            F180: 9.1 * 7,
            F275: 13.6 * 7,
          },
          {
            NeedleSet: 40,
            F120: 6.1 * 8,
            F180: 8.0 * 8,
            F275: 12.0 * 8,
            F420: 18.4 * 8,
          },
        ],
      },
      {
        drugId: 22,
        flowValues: [
          {
            NeedleSet: 16,
            F45: 14.2,
          },
          {
            NeedleSet: 17,
            F120: 39.8,
          },
          {
            NeedleSet: 18,
            F120: 15.5 * 3,
            F180: 20.1 * 3,
            F275: 29.1 * 3,
          },
          {
            NeedleSet: 19,
            F420: 119.1,
          },
          {
            NeedleSet: 20,
            F120: 9.6 * 5,
            F180: 12.5 * 5,
            F275: 18.5 * 5,
            F420: 27.8 * 5,
          },
          {
            NeedleSet: 21,
            F120: 8.1 * 6,
            F180: 10.6 * 6,
            F275: 15.7 * 6,
            F420: 23.7 * 6,
            F500: 29.3 * 6,
          },
          {
            NeedleSet: 22,
            F120: 7.0 * 7,
            F180: 9.1 * 7,
            F275: 13.6 * 7,
            F420: 20.7 * 7,
            F500: 25.7 * 7,
            F600: 29.5 * 7,
          },
          {
            NeedleSet: 23,
            F120: 6.1 * 8,
            F180: 8.0 * 8,
            F275: 12.0 * 8,
            F420: 18.4 * 8,
            F500: 22.8 * 8,
            F600: 26.3 * 8,
          },
          {
            NeedleSet: 35,
            F120: 15.5 * 3,
            F180: 20.1 * 3,
          },
          {
            NeedleSet: 36,
            F120: 11.9 * 4,
            F180: 15.4 * 4,
          },
          {
            NeedleSet: 37,
            F120: 9.6 * 5,
            F180: 12.5 * 5,
            F275: 18.5 * 5,
          },
          {
            NeedleSet: 38,
            F120: 8.1 * 6,
            F180: 10.6 * 6,
            F275: 15.7 * 6,
          },
          {
            NeedleSet: 39,
            F120: 7.0 * 7,
            F180: 9.1 * 7,
            F275: 13.6 * 7,
          },
          {
            NeedleSet: 40,
            F120: 6.1 * 8,
            F180: 8.0 * 8,
            F275: 12.0 * 8,
            F420: 18.4 * 8,
          },
        ],
      },
      {
        drugId: 23,
        flowValues: [
          {
            NeedleSet: 16,
            F120: 27.0,
          },
          {
            NeedleSet: 17,
            F120: 30.0,
            F180: 39.8,
          },
          {
            NeedleSet: 18,
            F120: 15.5 * 3,
            F180: 20.1 * 3,
            F275: 29.1 * 3,
          },
          {
            NeedleSet: 19,
            F420: 119.1,
          },
          {
            NeedleSet: 20,
            F120: 9.6 * 5,
            F180: 12.5 * 5,
            F275: 18.5 * 5,
            F420: 27.8 * 5,
          },
          {
            NeedleSet: 21,
            F120: 8.1 * 6,
            F180: 10.6 * 6,
            F275: 15.7 * 6,
            F420: 23.7 * 6,
            F500: 29.3 * 6,
          },
          {
            NeedleSet: 22,
            F120: 7.0 * 7,
            F180: 9.1 * 7,
            F275: 13.6 * 7,
            F420: 20.7 * 7,
            F500: 25.7 * 7,
            F600: 29.5 * 7,
          },
          {
            NeedleSet: 23,
            F120: 6.1 * 8,
            F180: 8.0 * 8,
            F275: 12.0 * 8,
            F420: 18.4 * 8,
            F500: 22.8 * 8,
            F600: 26.3 * 8,
          },
          {
            NeedleSet: 35,
            F120: 15.5 * 3,
            F180: 20.1 * 3,
          },
          {
            NeedleSet: 36,
            F120: 11.9 * 4,
            F180: 15.4 * 4,
          },
          {
            NeedleSet: 37,
            F120: 9.6 * 5,
            F180: 12.5 * 5,
            F275: 18.5 * 5,
          },
          {
            NeedleSet: 38,
            F120: 8.1 * 6,
            F180: 10.6 * 6,
            F275: 15.7 * 6,
          },
          {
            NeedleSet: 39,
            F120: 7.0 * 7,
            F180: 9.1 * 7,
            F275: 13.6 * 7,
          },
          {
            NeedleSet: 40,
            F120: 6.1 * 8,
            F180: 8.0 * 8,
            F275: 12.0 * 8,
            F420: 18.4 * 8,
          },
        ],
      },
      {
        drugId: 17,
        flowValues: [
          {
            NeedleSet: 16,
            F500: '25.2 (19.9 - 30.5)',
            F600: '27.7 (21.6 - 33.9)',
            F900: '34.6 (27.3 - 42)',
            F1200: '37.3 (28.8 - 45.9)',
            F2400: '45.7 (35.7 - 55.6)',
          },
          {
            NeedleSet: 17,
            F500: '32.2 (25.2 - 39.2)',
            F600: '36.6 (28 - 45)',
            F900: '49.6 (38.4 - 60.6)',
            F1200: '55.2 (41.4 - 69.2)',
            F2400: '75.6 (57.4 - 93.8)',
          },
        ],
      },
      {
        drugId: 20,
        flowValues: [
          {
            NeedleSet: 16,
            F60: '3.6 (1.4 - 5.7)',
            F120: '6.0 (2.4 - 9.5)',
            F180: '7.3 (3.2 - 11.4)',
            F275: '10.0 (4.2 - 15.7)',
            F420: '13.2 (5.2 - 21.2)',
            F500: '14.3 (6.0 - 22.5)',
            F600: '0.0 (0.0 - 0.0)',
            F900: '0.0 (0.0 - 0.0)',
            F1200: '0.0 (0.0 - 0.0)',
            F2400: '0.0 (0.0 - 0.0)',
          },
          {
            NeedleSet: 17,
            F60: '3.8 (1.4 - 5.7)',
            F120: '6.6 (2.6 - 10.6)',
            F180: '8.2 (3.8 - 12.8)',
            F275: '12.0 (5.2 - 18.6)',
            F420: '16.8 (6.6 - 27.0)',
            F500: '18.6 (8.2 - 28.6)',
            F600: '21.2 (8.8 - 33.4)',
            F900: '28.2 (11.6 - 44.8)',
            F1200: '0.0 (0.0 - 0.0)',
            F2400: '0.0 (0.0 - 0.0)',
          },
          {
            NeedleSet: 18,
            F60: '3.9 (1.5 - 6.3)',
            F120: '6.9 (2.7 - 11.0)',
            F180: '8.7 (4.0 - 13.2)',
            F275: '12.6 (5.7 - 19.8)',
            F420: '18.6 (7.5 - 29.7)',
            F500: '20.7 (9.3 - 32.1)',
            F600: '24.0 (10.2 - 37.5)',
            F900: '33.3 (14.1 - 52.5)',
            F1200: '38.4 (15.0 - 61.2)',
            F2400: '0.0 (0.0 - 0.0)',
          },
          {
            NeedleSet: 19,
            F60: '4.0 (1.6 - 6.4)',
            F120: '6.8 (2.8 - 11.2)',
            F180: '8.8 (4.0 - 13.6)',
            F275: '13.2 (5.6 - 20.4)',
            F420: '19.6 (8.0 - 31.2)',
            F500: '22.0 (10.0 - 34.0)',
            F600: '25.6 (11.2 - 40.0)',
            F900: '36.8 (14.0 - 57.6)',
            F1200: '42.8 (16.8 - 68.8)',
            F2400: '0.0 (0.0 - 0.0)',
          },
          {
            NeedleSet: 20,
            F60: '4.0 (1.6 - 6.4)',
            F120: '7.0 (2.8 - 11.0)',
            F180: '8.8 (4.0 - 13.6)',
            F275: '13.2 (5.6 - 20.4)',
            F420: '19.6 (8.0 - 31.2)',
            F500: '22.0 (10.0 - 34.0)',
            F600: '25.6 (11.2 - 40.0)',
            F900: '36.8 (14.0 - 57.6)',
            F1200: '42.8 (16.8 - 68.8)',
            F2400: '68.0 (26.0 - 109.6)',
          },
          {
            NeedleSet: 21,
            F60: '4.2 (1.6 - 6.6)',
            F120: '7.2 (3.0 - 11.4)',
            F180: '9.0 (4.2 - 13.8)',
            F275: '13.8 (6.0 - 21.0)',
            F420: '20.4 (8.4 - 33.0)',
            F500: '23.4 (10.8 - 36.0)',
            F600: '27.6 (12.0 - 42.6)',
            F900: '40.8 (17.4 - 63.6)',
            F1200: '48.6 (19.2 - 77.4)',
            F2400: '79.2 (30.0 - 128.4)',
          },
          {
            NeedleSet: 33,
            F60: '3.9 (1.5 - 6.3)',
            F120: '7.0 (2.9 - 11.2)',
            F180: '9.0 (4.1 - 13.9)',
            F275: '13.5 (6.0 - 20.9)',
            F420: '0.0 (0.0 - 0.0)',
            F500: '0.0 (0.0 - 0.0)',
            F600: '0.0 (0.0 - 0.0)',
            F900: '0.0 (0.0 - 0.0)',
            F1200: '0.0 (0.0 - 0.0)',
            F2400: '0.0 (0.0 - 0.0)',
          },
          {
            NeedleSet: 34,
            F60: '4.0 (1.6 - 6.4)',
            F120: '7.2 (3.0 - 11.4)',
            F180: '9.2 (4.2 - 14.4)',
            F275: '14.0 (6.2 - 21.8)',
            F420: '21.4 (8.8 - 34.2)',
            F500: '24.6 (11.4 - 37.6)',
            F600: '29.2 (13.0 - 45.2)',
            F900: '0.0 (0.0 - 0.0)',
            F1200: '0.0 (0.0 - 0.0)',
            F2400: '0.0 (0.0 - 0.0)',
          },
          {
            NeedleSet: 35,
            F60: '3.9 (1.95 - 6.3)',
            F120: '7.2 (3.0 - 11.7)',
            F180: '9.3 (4.2 - 14.4)',
            F275: '14.4 (6.3 - 22.2)',
            F420: '21.9 (9.0 - 35.1)',
            F500: '25.2 (11.4 - 38.7)',
            F600: '30.0 (13.5 - 46.5)',
            F900: '46.8 (21.0 - 73.2)',
            F1200: '0.0 (0.0 - 0.0)',
            F2400: '0.0 (0.0 - 0.0)',
          },
          {
            NeedleSet: 36,
            F60: '4.0 (1.6 - 6.4)',
            F120: '7.2 (2.9 - 11.4)',
            F180: '9.6 (4.3 - 15.1)',
            F275: '14.4 (6.4 - 22.4)',
            F420: '22.4 (9.2 - 35.6)',
            F500: '25.6 (12.0 - 39.2)',
            F600: '30.4 (13.6 - 47.4)',
            F900: '48.0 (21.6 - 75.0)',
            F1200: '59.2 (24.0 - 94.4)',
            F2400: '0.0 (0.0 - 0.0)',
          },
          {
            NeedleSet: 37,
            F60: '3.2 (1.2 - 5.2)',
            F120: '6.0 (2.4 - 9.4)',
            F180: '7.6 (3.6 - 11.8)',
            F275: '11.6 (5.0 - 18.2)',
            F420: '18.0 (7.2 - 28.2)',
            F500: '20.8 (9.6 - 32.0)',
            F600: '24.8 (11.2 - 38.8)',
            F900: '39.2 (17.6 - 61.6)',
            F1200: '48.4 (19.6 - 77.6)',
            F2400: '0.0 (0.0 - 0.0)',
          },
          {
            NeedleSet: 38,
            F60: '2.8 (1.1 - 4.2)',
            F120: '4.8 (2.0 - 7.6)',
            F180: '6.4 (2.8 - 9.6)',
            F275: '9.6 (4.3 - 15.2)',
            F420: '15.2 (6.0 - 24.0)',
            F500: '17.2 (8.0 - 26.4)',
            F600: '20.8 (9.2 - 32.4)',
            F900: '32.8 (14.8 - 51.2)',
            F1200: '40.8 (16.4 - 64.8)',
            F2400: '0.0 (0.0 - 0.0)',
          },
        ],
      },
      {
        drugId: 21,
        flowValues: [
          {
            NeedleSet: 16,
            F60: '3.6 (1.4 - 5.7)',
            F120: '6.0 (2.4 - 9.5)',
            F180: '7.3 (3.2 - 11.4)',
            F275: '10.0 (4.2 - 15.7)',
            F420: '13.2 (5.2 - 21.2)',
            F500: '14.3 (6.0 - 22.5)',
            F600: '15.7 (6.4 - 25.0)',
            F900: '19.3 (7.8 - 30.9)',
            F1200: '21.0 (8.1 - 33.8)',
            F2400: '25.2 (9.5 - 40.9)',
          },
          {
            NeedleSet: 17,
            F60: '3.8 (1.4 - 6.0)',
            F120: '6.6 (2.6 - 10.6)',
            F180: '8.2 (3.8 - 12.8)',
            F275: '12.0 (5.2 - 18.6)',
            F420: '16.8 (6.6 - 27.0)',
            F500: '18.6 (8.2 - 29.0)',
            F600: '21.2 (8.8 - 33.4)',
            F900: '28.2 (11.6 - 44.8)',
            F1200: '31.8 (12.4 - 51.2)',
            F2400: '42.6 (16.2 - 69.2)',
          },
          {
            NeedleSet: 18,
            F60: '3.9 (1.5 - 6.3)',
            F120: '6.9 (2.7 - 10.8)',
            F180: '8.7 (3.9 - 13.5)',
            F275: '12.6 (5.7 - 19.8)',
            F420: '18.6 (7.5 - 29.7)',
            F500: '20.7 (9.3 - 32.1)',
            F600: '24.0 (10.2 - 37.5)',
            F900: '33.3 (14.1 - 52.5)',
            F1200: '38.4 (15.0 - 61.5)',
            F2400: '55.5 (21.0 - 89.7)',
          },
          {
            NeedleSet: 19,
            F60: '4.0 (1.6 - 6.4)',
            F120: '6.8 (2.8 - 11.2)',
            F180: '8.8 (4.0 - 13.6)',
            F275: '13.2 (5.6 - 20.4)',
            F420: '19.6 (8.0 - 31.2)',
            F500: '22.0 (10.0 - 34.0)',
            F600: '25.6 (11.2 - 40.0)',
            F900: '36.8 (14.0 - 57.6)',
            F1200: '42.8 (16.8 - 68.8)',
            F2400: '65.2 (24.8 - 105.6)',
          },
          {
            NeedleSet: 20,
            F60: '4.0 (1.5 - 6.5)',
            F120: '7.0 (3.0 - 11.0)',
            F180: '9.0 (4.0 - 14.0)',
            F275: '13.5 (6.0 - 21.0)',
            F420: '20.0 (8.0 - 32.0)',
            F500: '22.5 (10.5 - 35.0)',
            F600: '26.5 (11.5 - 41.5)',
            F900: '39.0 (16.5 - 61.0)',
            F1200: '46.0 (18.0 - 74.0)',
            F2400: '73.0 (27.5 - 118.0)',
          },
          {
            NeedleSet: 21,
            F60: '4.2 (1.8 - 6.6)',
            F120: '7.2 (3.0 - 11.4)',
            F180: '9.0 (4.2 - 13.8)',
            F275: '13.8 (6.0 - 21.0)',
            F420: '20.4 (8.4 - 33.0)',
            F500: '23.4 (10.8 - 36.0)',
            F600: '27.6 (12.0 - 42.6)',
            F900: '40.8 (17.4 - 63.6)',
            F1200: '48.6 (19.2 - 77.4)',
            F2400: '79.2 (30.0 - 128.4)',
          },
          {
            NeedleSet: 33,
            F60: '3.9 (1.5 - 6.3)',
            F120: '7.0 (2.9 - 11.2)',
            F180: '9.0 (4.1 - 13.9)',
            F275: '13.5 (6.0 - 20.9)',
            F420: '20.0 (8.2 - 31.9)',
            F500: '22.7 (10.4 - 34.9)',
            F600: '26.5 (11.7 - 41.4)',
            F900: '0.0 (0.0 - 0.0)',
            F1200: '0.0 (0.0 - 0.0)',
            F2400: '0.0 (0.0 - 0.0)',
          },
          {
            NeedleSet: 34,
            F60: '4.0 (1.6 - 6.4)',
            F120: '7.2 (3.0 - 11.4)',
            F180: '9.2 (4.2 - 14.4)',
            F275: '14.0 (6.2 - 21.8)',
            F420: '21.4 (8.8 - 34.2)',
            F500: '24.6 (11.4 - 37.6)',
            F600: '29.2 (13.0 - 45.2)',
            F900: '44.6 (19.8 - 69.2)',
            F1200: '53.8 (22.0 - 85.8)',
            F2400: '0.0 (0.0 - 0.0)',
          },
          {
            NeedleSet: 35,
            F60: '3.9 (1.95 - 6.3)',
            F120: '7.2 (3.0 - 11.7)',
            F180: '9.3 (4.2 - 14.4)',
            F275: '14.4 (6.3 - 22.2)',
            F420: '21.9 (9.0 - 35.1)',
            F500: '25.2 (9.0 - 38.7)',
            F600: '30.0 (13.5 - 46.8)',
            F900: '46.8 (21.0 - 72.9)',
            F1200: '57.3 (23.4 - 91.2)',
            F2400: '0.0 (0.0 - 0.0)',
          },
          {
            NeedleSet: 36,
            F60: '4.0 (1.6 - 6.4)',
            F120: '7.2 (2.8 - 11.6)',
            F180: '9.6 (4.4 - 14.4)',
            F275: '14.4 (6.4 - 22.4)',
            F420: '22.4 (9.2 - 35.6)',
            F500: '25.6 (12.0 - 39.2)',
            F600: '30.4 (13.6 - 47.6)',
            F900: '48.0 (21.6 - 74.8)',
            F1200: '59.2 (24.0 - 94.4)',
            F2400: '112.4 (43.6 - 181.2)',
          },
          {
            NeedleSet: 37,
            F60: '4.0 (1.5 - 6.5)',
            F120: '7.5 (3.0 - 11.5)',
            F180: '9.5 (4.5 - 14.5)',
            F275: '14.5 (6.5 - 22.5)',
            F420: '22.5 (9.0 - 35.5)',
            F500: '26.0 (12.0 - 39.5)',
            F600: '31.0 (14.0 - 48.0)',
            F900: '49.0 (22.0 - 76.0)',
            F1200: '60.5 (24.5 - 96.0)',
            F2400: '117.0 (45.5 - 188.0)',
          },
          {
            NeedleSet: 38,
            F60: '4.2 (1.8 - 6.6)',
            F120: '7.2 (3.0 - 11.4)',
            F180: '9.6 (4.2 - 14.4)',
            F275: '14.4 (6.6 - 22.8)',
            F420: '22.8 (9.0 - 36.0)',
            F500: '25.8 (12.0 - 39.6)',
            F600: '31.2 (13.8 - 48.6)',
            F900: '49.2 (22.2 - 76.8)',
            F1200: '61.2 (24.6 - 97.2)',
            F2400: '120.0 (46.8 - 193.2)',
          },
        ],
      },
    ];

    const needleSet = [
      {
        id: {
          c1: 33,
          c2: 1,
          ct: '24g1n',
        },
        size: '24G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\n1 Needle',
        url: require('./images/reg_1leg/reg_1leg.png'),
        needleSetContainer: styles.g24_needleSetContainer,
        needleSetSizeTitleContainer:
          styles.g24_needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.g24_needleSetTitleContainer,
        selectedNeedleSet: 'rgb(250, 221, 255)',
      },
      {
        id: {
          c1: 34,
          c2: 2,
          ct: '24g2n',
        },
        size: '24G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\n2 Needles',
        url: require('./images/reg_2leg/reg_2leg.png'),
        needleSetContainer: styles.g24_needleSetContainer,
        needleSetSizeTitleContainer:
          styles.g24_needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.g24_needleSetTitleContainer,
        selectedNeedleSet: 'rgb(250, 221, 255)',
      },
      {
        id: {
          c1: 35,
          c2: 3,
          ct: '24g3n',
        },
        size: '24G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\n3 Needles',
        url: require('./images/reg_3leg/reg_3leg.png'),
        needleSetContainer: styles.g24_needleSetContainer,
        needleSetSizeTitleContainer:
          styles.g24_needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.g24_needleSetTitleContainer,
        selectedNeedleSet: 'rgb(250, 221, 255)',
      },
      {
        id: {
          c1: 36,
          c2: 4,
          ct: '24g4n',
        },
        size: '24G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\n4 Needles',
        url: require('./images/reg_4leg/reg_4leg.png'),
        needleSetContainer: styles.g24_needleSetContainer,
        needleSetSizeTitleContainer:
          styles.g24_needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.g24_needleSetTitleContainer,
        selectedNeedleSet: 'rgb(250, 221, 255)',
      },
      {
        id: {
          c1: 37,
          c2: 5,
          ct: '24g5n',
        },
        size: '24G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\n5 Needles',
        url: require('./images/reg_5leg/reg_5leg.png'),
        needleSetContainer: styles.g24_needleSetContainer,
        needleSetSizeTitleContainer:
          styles.g24_needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.g24_needleSetTitleContainer,
        selectedNeedleSet: 'rgb(250, 221, 255)',
      },
      {
        id: {
          c1: 38,
          c2: 6,
          ct: '24g6n',
        },
        size: '24G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\n6 Needles',
        url: require('./images/reg_6leg/reg_6leg.png'),
        needleSetContainer: styles.g24_needleSetContainer,
        needleSetSizeTitleContainer:
          styles.g24_needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.g24_needleSetTitleContainer,
        selectedNeedleSet: 'rgb(250, 221, 255)',
      },
      {
        id: {
          c1: 39,
          c2: 7,
          ct: '24g7n',
        },
        size: '24G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\n7 Needles',
        url: require('./images/reg_7leg/reg_7leg.png'),
        needleSetContainer: styles.g24_needleSetContainer,
        needleSetSizeTitleContainer:
          styles.g24_needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.g24_needleSetTitleContainer,
        selectedNeedleSet: 'rgb(250, 221, 255)',
      },
      {
        id: {
          c1: 40,
          c2: 8,
          ct: '24g8n',
        },
        size: '24G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\n8 Needles',
        url: require('./images/reg_8leg/reg_8leg.png'),
        needleSetContainer: styles.g24_needleSetContainer,
        needleSetSizeTitleContainer:
          styles.g24_needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.g24_needleSetTitleContainer,
        selectedNeedleSet: 'rgb(250, 221, 255)',
      },
      {
        id: {
          c1: 16,
          c2: 1,
          ct: '26g1n',
        },
        size: '26G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\n1 Needle',
        url: require('./images/reg_1leg/reg_1leg.png'),
        needleSetContainer: styles.g26_needleSetContainer,
        needleSetSizeTitleContainer:
          styles.g26_needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.g26_needleSetTitleContainer,
        selectedNeedleSet: 'rgb(253, 214, 158)',
      },
      {
        id: {
          c1: 17,
          c2: 2,
          ct: '26g2n',
        },
        size: '26G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\n2 Needles',
        url: require('./images/reg_2leg/reg_2leg.png'),
        needleSetContainer: styles.g26_needleSetContainer,
        needleSetSizeTitleContainer:
          styles.g26_needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.g26_needleSetTitleContainer,
        selectedNeedleSet: 'rgb(253, 214, 158)',
      },
      {
        id: {
          c1: 18,
          c2: 3,
          ct: '26g3n',
        },
        size: '26G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\n3 Needles',
        url: require('./images/reg_3leg/reg_3leg.png'),
        needleSetContainer: styles.g26_needleSetContainer,
        needleSetSizeTitleContainer:
          styles.g26_needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.g26_needleSetTitleContainer,
        selectedNeedleSet: 'rgb(253, 214, 158)',
      },
      {
        id: {
          c1: 19,
          c2: 4,
          ct: '26g4n',
        },
        size: '26G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\n4 Needles',
        url: require('./images/reg_4leg/reg_4leg.png'),
        needleSetContainer: styles.g26_needleSetContainer,
        needleSetSizeTitleContainer:
          styles.g26_needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.g26_needleSetTitleContainer,
        selectedNeedleSet: 'rgb(253, 214, 158)',
      },
      {
        id: {
          c1: 20,
          c2: 5,
          ct: '26g5n',
        },
        size: '26G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\n5 Needles',
        url: require('./images/reg_5leg/reg_5leg.png'),
        needleSetContainer: styles.g26_needleSetContainer,
        needleSetSizeTitleContainer:
          styles.g26_needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.g26_needleSetTitleContainer,
        selectedNeedleSet: 'rgb(253, 214, 158)',
      },
      {
        id: {
          c1: 21,
          c2: 6,
          ct: '26g6n',
        },
        size: '26G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\n6 Needles',
        url: require('./images/reg_6leg/reg_6leg.png'),
        needleSetContainer: styles.g26_needleSetContainer,
        needleSetSizeTitleContainer:
          styles.g26_needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.g26_needleSetTitleContainer,
        selectedNeedleSet: 'rgb(253, 214, 158)',
      },
      {
        id: {
          c1: 22,
          c2: 7,
          ct: '26g7n',
        },
        size: '26G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\n7 Needles',
        url: require('./images/reg_7leg/reg_7leg.png'),
        needleSetContainer: styles.g26_needleSetContainer,
        needleSetSizeTitleContainer:
          styles.g26_needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.g26_needleSetTitleContainer,
        selectedNeedleSet: 'rgb(253, 214, 158)',
      },
      {
        id: {
          c1: 23,
          c2: 8,
          ct: '26g8n',
        },
        size: '26G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\n8 Needles',
        url: require('./images/reg_8leg/reg_8leg.png'),
        needleSetContainer: styles.g26_needleSetContainer,
        needleSetSizeTitleContainer:
          styles.g26_needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.g26_needleSetTitleContainer,
        selectedNeedleSet: 'rgb(253, 214, 158)',
      },
      {
        id: {
          c1: 25,
          c2: 1,
          ct: 'S_26g1n',
        },
        size: 'S26G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\nSUPER26 1',
        url: require('./images/1leg/1leg.png'),
        needleSetContainer: styles.needleSetContainer,
        needleSetSizeTitleContainer:
          styles.needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.needleSetTitleContainer,
        selectedNeedleSet: 'rgba(24,150,208,0.4)',
        titleStyle: { fontSize: 8 },
      },
      {
        id: {
          c1: 26,
          c2: 2,
          ct: 'S_26g2n',
        },
        size: 'S26G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\nSUPER26 2',
        url: require('./images/2leg/2leg.png'),
        needleSetContainer: styles.needleSetContainer,
        needleSetSizeTitleContainer:
          styles.needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.needleSetTitleContainer,
        selectedNeedleSet: 'rgba(24,150,208,0.4)',
        titleStyle: { fontSize: 8 },
      },
      {
        id: {
          c1: 27,
          c2: 3,
          ct: 'S_26g3n',
        },
        size: 'S26G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\nSUPER26 3',
        url: require('./images/3leg/3leg.png'),
        needleSetContainer: styles.needleSetContainer,
        needleSetSizeTitleContainer:
          styles.needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.needleSetTitleContainer,
        selectedNeedleSet: 'rgba(24,150,208,0.4)',
        titleStyle: { fontSize: 8 },
      },
      {
        id: {
          c1: 28,
          c2: 4,
          ct: 'S_26g4n',
        },
        size: 'S26G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\nSUPER26 4',
        url: require('./images/4leg/4leg.png'),
        needleSetContainer: styles.needleSetContainer,
        needleSetSizeTitleContainer:
          styles.needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.needleSetTitleContainer,
        selectedNeedleSet: 'rgba(24,150,208,0.4)',
        titleStyle: { fontSize: 8 },
      },
      {
        id: {
          c1: 29,
          c2: 5,
          ct: 'S_26g5n',
        },
        size: 'S26G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\nSUPER26 5',
        url: require('./images/5leg/5leg.png'),
        needleSetContainer: styles.needleSetContainer,
        needleSetSizeTitleContainer:
          styles.needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.needleSetTitleContainer,
        selectedNeedleSet: 'rgba(24,150,208,0.4)',
        titleStyle: { fontSize: 8 },
      },
      {
        id: {
          c1: 30,
          c2: 6,
          ct: 'S_26g6n',
        },
        size: 'S26G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\nSUPER26 6',
        url: require('./images/6leg/6leg.png'),
        needleSetContainer: styles.needleSetContainer,
        needleSetSizeTitleContainer:
          styles.needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.needleSetTitleContainer,
        selectedNeedleSet: 'rgba(24,150,208,0.4)',
        titleStyle: { fontSize: 8 },
      },
      {
        id: {
          c1: 31,
          c2: 7,
          ct: 'S_26g7n',
        },
        size: 'S26G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\nSUPER26 7',
        url: require('./images/7leg/7leg.png'),
        needleSetContainer: styles.needleSetContainer,
        needleSetSizeTitleContainer:
          styles.needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.needleSetTitleContainer,
        selectedNeedleSet: 'rgba(24,150,208,0.4)',
        titleStyle: { fontSize: 8 },
      },
      {
        id: {
          c1: 32,
          c2: 8,
          ct: 'S_26g8n',
        },
        size: 'S26G',
        //imageSrc: require(""),
        title: 'HIgH-Flo\nSUPER26 8',
        url: require('./images/8leg/8leg.png'),
        needleSetContainer: styles.needleSetContainer,
        needleSetSizeTitleContainer:
          styles.needleSetSizeTitleContainer,
        needleSetTitleContainer: styles.needleSetTitleContainer,
        selectedNeedleSet: 'rgba(24,150,208,0.4)',
        titleStyle: { fontSize: 8 },
      },
    ];

    const tubingSet = [
      // {
      //   groupType: 'Combination',
      //   type: 'Combination\nSet',
      //   title: 'Enter Amount',
      //   color: '#3AB44A',
      //   underlayColor: 'rgba(58,180,74,0.4)',
      //   tubingSetType: { fontSize: 14, fontWeight: 'bold' },
      //   data: [
      //     391.5, 320.8, 307.22, 557.2012403, 871.9269156, 1052.994141,
      //     1367.392019, 1598.204236, 1578, 2132.95, 1956.45, 678.17,
      //     955.63, 1260.41, 2110.34, 485, 970, 1455.0, 1940.0, 2425,
      //     2910, 3395, 3880, 1171.215, 1506.4065, 3012.813, 4519.2195,
      //     6025.626, 7381.39185, 8887.79835, 10394.20485, 11900.61135,
      //     2397.2, 4777.3, 7170.4, 9575.9,
      //   ],
      // },
      {
        groupType: 'Low Flow',
        type: 'F30',
        title:
          'Low Flow\n≤ 0.16m' +
          (this.props.version === 'international' ? 'l' : 'L'),
        color: '#3AB44A',
        underlayColor: 'rgba(58,180,74,0.4)',
        tubingSetType: styles.tubingSetType,
        data: [
          30, 27.86476868, 27.43443558, 27.33108251, 28.46730569,
          29.00213644, 29.16897057, 29.35594308, 29.44724379,
          29.44029851, 29.58390162, 29.54693045, 28.72911871,
          29.08687844, 29.30254725, 29.57950606, 28.25242718, 29.1,
          29.39393939, 29.54314721, 29.63340122, 29.69387755,
          29.73722628, 29.76982097, 29.25075861, 29.41421753,
          29.70422106, 29.80216387, 29.85137788, 29.87856532,
          29.89907823, 29.91366248, 29.9245638, 29.62920237,
          29.81278472, 29.87500694, 29.90630758,
        ],
      },
      {
        groupType: 'Low Flow',
        type: 'F45',
        title:
          'Low Flow\n≤ 0.16m' +
          (this.props.version === 'international' ? 'l' : 'L'),
        color: '#3AB44A',
        underlayColor: 'rgba(58,180,74,0.4)',
        tubingSetType: styles.tubingSetType,
        data: [
          45, 40.36082474, 39.46418808, 39.2506768, 41.63733672,
          42.79153609, 43.15572786, 43.56626208, 43.76765167,
          43.75231054, 44.07022659, 43.98823353, 42.19982853,
          42.97627495, 43.44876322, 44.06047306, 41.17924528,
          43.00492611, 43.65, 43.97984887, 44.18016194, 44.31472081,
          44.41133721, 44.48407643, 43.33499833, 43.69473281,
          44.33776199, 44.55633159, 44.66642649, 44.72732384,
          44.77330732, 44.80601971, 44.83048168, 44.17082958,
          44.5800759, 44.71935028, 44.78952073,
        ],
      },
      {
        groupType: 'Low Flow',
        type: 'F60',
        title:
          'Low Flow\n≤ 0.16m' +
          (this.props.version === 'international' ? 'l' : 'L'),
        color: '#3AB44A',
        underlayColor: 'rgba(58,180,74,0.4)',
        tubingSetType: styles.tubingSetType,
        data: [
          71, 60.10054054, 58.1337417, 57.67161518, 62.97550136,
          65.65388047, 66.51510118, 67.49539212, 67.97999808,
          67.94299576, 68.71274303, 68.51362549, 64.27122015,
          66.0897597, 67.21378839, 68.68903518, 61.93345324,
          66.15754083, 67.6965924, 68.49328692, 68.98036859,
          69.30895673, 69.54558569, 69.72412048, 66.94192632,
          67.80424799, 69.36533538, 69.90179544, 70.17314921,
          70.32357287, 70.43731293, 70.51830852, 70.57892051,
          68.95762094, 69.96025411, 70.30386389, 70.47744871,
        ],
      },
      {
        groupType: 'Low Flow',
        type: 'F120',
        title:
          'Low Flow\n≤ 0.16m' +
          (this.props.version === 'international' ? 'l' : 'L'),
        color: '#3AB44A',
        underlayColor: 'rgba(58,180,74,0.4)',
        tubingSetType: styles.tubingSetType,
        data: [
          131, 98.15598086, 93.01637893, 91.83889073, 106.0639798,
          113.8890822, 116.5058404, 119.5470559, 121.0757819,
          120.9584552, 123.4198856, 122.7789648, 109.7918484,
          115.2071358, 118.6664678, 123.3434196, 103.1412338,
          115.4132607, 120.1796974, 122.7136649, 124.2859937,
          125.3567905, 126.1330119, 126.7215158, 117.8216846,
          120.5194016, 125.541342, 127.3096366, 128.2125966,
          128.715641, 129.0971966, 129.3695329, 129.573674,
          124.2121668, 127.5036774, 128.6496288, 129.2320823,
        ],
      },
      {
        groupType: 'Low Flow',
        type: 'F180',
        title:
          'Low Flow\n≤ 0.16m' +
          (this.props.version === 'international' ? 'l' : 'L'),
        color: '#3AB44A',
        underlayColor: 'rgba(58,180,74,0.4)',
        tubingSetType: styles.tubingSetType,
        data: [
          180, 123.3070866, 115.3035144, 113.4996349, 136.0499926,
          149.1993811, 153.7225029, 159.0615438, 161.7793708,
          161.5699659, 165.9919151, 164.8346556, 142.2452428,
          151.4695808, 157.5064044, 165.8536287, 131.2781955,
          151.826087, 160.1834862, 164.7169811, 167.56238,
          169.5145631, 170.9370629, 172.0197044, 156.0215806,
          160.7875503, 169.8522087, 173.105238, 174.7789312,
          175.7150746, 176.4269166, 176.9359398, 177.3180165,
          167.4282167, 173.4641841, 175.5920766, 176.6789327,
        ],
      },
      {
        groupType: 'High Flow',
        type: 'F275',
        title:
          'High Flow\n≤ 0.15m' +
          (this.props.version === 'international' ? 'l' : 'L'),
        color: '#F1592D',
        underlayColor: 'rgba(241,81,45,0.4)',
        tubingSetType: styles.tubingSetType,
        data: [
          275, 161.5341335, 148.0698221, 145.1082042, 184.1265474,
          209.0629303, 218.0532126, 228.9543549, 234.6280008,
          234.1878036, 243.593617, 241.1094804, 195.6594836,
          213.5477357, 225.7460548, 243.2959243, 175.4934211,
          214.2570281, 231.2861272, 240.8577878, 246.9907407,
          251.255887, 254.393733, 256.7990373, 222.7083283,
          232.5475895, 251.9983877, 259.2257953, 262.9972244,
          265.122632, 266.746517, 267.9118429, 268.7888129,
          246.6993489, 260.0315698, 264.8427217, 267.3230365,
        ],
      },
      {
        groupType: 'High Flow',
        type: 'F420',
        title:
          'High Flow\n≤ 0.15m' +
          (this.props.version === 'international' ? 'l' : 'L'),
        color: '#F1592D',
        underlayColor: 'rgba(241,81,45,0.4)',
        tubingSetType: styles.tubingSetType,
        data: [
          420, 202.6247689, 181.8790497, 177.4308696, 239.4844698,
          283.4597686, 300.2439229, 321.3087235, 332.5955655,
          331.7117117, 350.9034646, 345.7716342, 259.3691323,
          291.7678446, 315.0256187, 350.2860485, 225.0828729,
          293.0935252, 325.92, 345.2542373, 357.9964851, 367.027027,
          373.7614679, 378.9767442, 309.1413165, 328.4305415,
          368.6135714, 384.2858553, 392.6326039, 397.3886502,
          401.0481498, 403.6881211, 405.6825287, 357.3846372,
          386.0593, 396.760118, 402.3527646,
        ],
      },
      {
        groupType: 'High Flow',
        type: 'F500',
        title:
          'High Flow\n≤ 0.15m' +
          (this.props.version === 'international' ? 'l' : 'L'),
        color: '#F1592D',
        underlayColor: 'rgba(241,81,45,0.4)',
        tubingSetType: styles.tubingSetType,
        data: [
          500, 219.5737521, 195.4191033, 190.2933105, 263.5265733,
          317.7745497, 339.0206419, 366.1234505, 380.8504931,
          379.6920115, 405.0494692, 398.2271164, 287.8065135,
          328.2530588, 357.9876279, 404.2270356, 246.1928934,
          329.9319728, 372.1227621, 397.5409836, 414.5299145,
          426.686217, 435.8151476, 442.9223744, 350.4082359,
          375.3991277, 428.8319646, 450.1914591, 461.6894992,
          468.2797145, 473.3696879, 477.0520195, 479.8397036,
          413.7097888, 452.6272905, 467.4071756, 475.1883206,
        ],
      },
      {
        groupType: 'High Flow',
        type: 'F600',
        title:
          'High Flow\n≤ 0.15m' +
          (this.props.version === 'international' ? 'l' : 'L'),
        color: '#F1592D',
        underlayColor: 'rgba(241,81,45,0.4)',
        tubingSetType: styles.tubingSetType,
        data: [
          600, 236.913767, 209.0356212, 203.1813263, 288.9045851,
          355.4226394, 382.2133842, 417.016641, 436.229958,
          434.7107438, 468.2742092, 459.1797219, 318.3473247,
          368.5825036, 406.4942674, 467.1753359, 268.202765,
          370.7006369, 424.8175182, 458.2677165, 480.9917355,
          497.4358974, 509.8873592, 519.6428571, 396.7496888,
          429.0928176, 500.3546544, 529.6767798, 545.6655115,
          554.8950851, 562.0565292, 567.2554764, 571.2014085,
          479.8878954, 533.0519034, 553.6703387, 564.6222939,
        ],
      },
      {
        groupType: 'High Flow',
        type: 'F900',
        title:
          'High Flow\n≤ 0.15m' +
          (this.props.version === 'international' ? 'l' : 'L'),
        color: '#F1592D',
        underlayColor: 'rgba(241,81,45,0.4)',
        tubingSetType: styles.tubingSetType,
        data: [
          900, 272.8222997, 236.5006553, 229.0343878, 344.1399186,
          442.8705367, 485.2522121, 542.7613781, 575.7671017,
          573.1234867, 632.9332828, 616.4312346, 386.7473086,
          463.4905665, 525.071167, 630.9274035, 315.1624549,
          466.8449198, 556.0509554, 614.7887324, 656.3909774,
          687.4015748, 711.4086147, 730.5439331, 508.9251961,
          563.3985156, 692.987807, 750.5319816, 783.0430635,
          802.1903546, 817.2439019, 828.2818037, 836.7217723,
          654.3370132, 757.3265461, 799.6332276, 822.6796743,
        ],
      },
      {
        groupType: 'High Flow',
        type: 'F1200',
        title:
          'High Flow\n≤ 0.15m' +
          (this.props.version === 'international' ? 'l' : 'L'),
        color: '#F1592D',
        underlayColor: 'rgba(241,81,45,0.4)',
        tubingSetType: styles.tubingSetType,
        data: [
          1200, 295.1932139, 253.1299316, 244.5957304, 380.5150332,
          504.9947905, 560.8505351, 639.1195464, 685.3842398,
          681.6414687, 767.9503143, 743.7912845, 433.2962405,
          531.9818336, 614.7316911, 764.9993656, 345.4005935,
          536.40553, 657.6271186, 741.4012739, 802.7586207,
          849.6350365, 886.6158868, 916.5354331, 592.7163922,
          667.9291525, 858.1856351, 948.2173923, 1000.709309,
          1032.195054, 1057.253293, 1075.800021, 1090.081466,
          799.6886467, 959.0885517, 1027.965211, 1066.36847,
        ],
      },
      {
        groupType: 'High Flow',
        type: 'F2400',
        title:
          'High Flow\n≤ 0.15m' +
          (this.props.version === 'international' ? 'l' : 'L'),
        color: '#F1592D',
        underlayColor: 'rgba(241,81,45,0.4)',
        tubingSetType: styles.tubingSetType,
        data: [
          2400, 336.5932294, 282.9755954, 272.3525054, 452.2123684,
          639.5694804, 731.8824869, 871.0908842, 959.3532346,
          952.0361991, 1129.304316, 1077.822539, 528.7583207,
          683.4817903, 826.4057851, 1122.934413, 403.4662045,
          690.8011869, 905.8365759, 1072.81106, 1206.217617,
          1315.254237, 1406.039689, 1482.802548, 787.1035488,
          925.4990744, 1335.858305, 1567.536165, 1716.37127,
          1811.126751, 1889.714484, 1949.796172, 1997.220017,
          1199.299591, 1597.469801, 1798.144278, 1919.03406,
        ],
      },
      // ,
      // {
      //     groupType: "Very High Flow",
      //     type: "VHF",
      //     title: "Very High Flow",
      //     color: "#DD1F31",
      //     underlayColor: "rgba(221,31,49,0.4)",
      //     tubingSetType: styles.tubingSetType,
      //     data: [
      //
      //         20000,
      //         383.9835225,
      //         315.735601,
      //         302.5676979,
      //         542.0983467,
      //         835.5020781,
      //         1000.327207,
      //         1279.886677,
      //         1479.941775,
      //         1462.600797,
      //         1927.397839,
      //         1782.118694,
      //         655.9284501,
      //         912.0508427,
      //         1185.687388,
      //         1908.916824,
      //         473.5172077,
      //         925.1311397,
      //         1356.327196,
      //         1768.459435,
      //         2162.764771,
      //         2540.375382,
      //         2902.329558,
      //         3249.58124,
      //         1106.422092,
      //         1400.890939,
      //         2618.378727,
      //         3686.267012,
      //         4630.532999,
      //         5391.538816,
      //         6153.32345,
      //         6839.596496,
      //         7461.055351,
      //         2140.624721,
      //         3856.190949,
      //         5278.096752,
      //         6475.474964
      //     ],
      // }
    ];

    this.state = {
      needleSet: needleSet,
      tubingSet: tubingSet,
      flowData: flowData,
      frpsData: frpsData,
      todData: todData,
      tfr: '',
      selectedNeedleSet: {},
      selectedTubingSet: {},
      showModalWindow: false,
      combinationSet: '',
      patientName: '',
    };
  }

  setDefaultNeedlesAndTubingSets = () => {
    if (this.props.selectedDrug.id === 17) {
      // let defaultNeedle = this.state.needleSet.find((needle) => {
      //   return needle.id.c1 === 17;
      // });
      // if (defaultNeedle) {
      //   this.setSelectedNeedleset(defaultNeedle);
      // }
    } else if (this.props.selectedDrug.id === 22) {
      if (this.props.selectedDosage === '20') {
        let defaultNeedle = this.state.needleSet.find((needle) => {
          return needle.id.c1 === 16;
        });
        if (defaultNeedle) {
          this.setSelectedNeedleset(defaultNeedle);
        }
      } else if (this.props.selectedDosage === '60') {
        let defaultNeedle = this.state.needleSet.find((needle) => {
          return needle.id.c1 === 17;
        });
        if (defaultNeedle) {
          this.setSelectedNeedleset(defaultNeedle);
        }
      } else if (this.props.selectedDosage === '100') {
        let defaultNeedle = this.state.needleSet.find((needle) => {
          return needle.id.c1 === 19;
        });
        if (defaultNeedle) {
          this.setSelectedNeedleset(defaultNeedle);
        }
      }
    } else if (this.props.selectedDrug.id === 23) {
      if (this.props.selectedDosage === '20') {
        let defaultNeedle = this.state.needleSet.find((needle) => {
          return needle.id.c1 === 17;
        });
        if (defaultNeedle) {
          this.setSelectedNeedleset(defaultNeedle);
        }
      } else if (this.props.selectedDosage === '30') {
        let defaultNeedle = this.state.needleSet.find((needle) => {
          return needle.id.c1 === 16;
        });
        if (defaultNeedle) {
          this.setSelectedNeedleset(defaultNeedle);
        }
      }
    }
  };

  setDefaultTubingSet = (ns) => {
    if (this.props.selectedDrug.id === 23) {
      if (this.props.selectedDosage === '20') {
        let defaultTubingSet = this.state.tubingSet.find((tubing) => {
          return tubing.type === 'F120';
        });
        if (defaultTubingSet) {
          this.setSelectedTubingset(defaultTubingSet, null);
        }
      } else if (
        this.props.selectedDosage === '30' &&
        ns &&
        ns.id &&
        ns.id.c1 === 16
      ) {
        let defaultTubingSet = this.state.tubingSet.find((tubing) => {
          return tubing.type === 'F120';
        });
        if (defaultTubingSet) {
          this.setSelectedTubingset(defaultTubingSet, null);
        }
      } else if (
        this.props.selectedDosage === '30' &&
        ns &&
        ns.id &&
        ns.id.c1 === 17
      ) {
        let defaultTubingSet = this.state.tubingSet.find((tubing) => {
          return tubing.type === 'F180';
        });
        if (defaultTubingSet) {
          this.setSelectedTubingset(defaultTubingSet, null);
        }
      }
    } else if (this.props.selectedDrug.id === 22) {
      if (this.props.selectedDosage === '20') {
        let defaultTubingSet = this.state.tubingSet.find((tubing) => {
          return tubing.type === 'F45';
        });
        if (defaultTubingSet) {
          this.setSelectedTubingset(defaultTubingSet, null);
        }
      } else if (this.props.selectedDosage === '60') {
        let defaultTubingSet = this.state.tubingSet.find((tubing) => {
          return tubing.type === 'F120';
        });
        if (defaultTubingSet) {
          this.setSelectedTubingset(defaultTubingSet, null);
        }
      } else if (this.props.selectedDosage === '100') {
        let defaultTubingSet = this.state.tubingSet.find((tubing) => {
          return tubing.type === 'F420';
        });
        if (defaultTubingSet) {
          this.setSelectedTubingset(defaultTubingSet, null);
        }
      }
    } else if (this.props.selectedDrug.id === 17) {
      // let defaultTubingSet = this.state.tubingSet.find((tubing) => {
      //   return tubing.type === 'F2400';
      // });
      // if (defaultTubingSet) {
      //   this.setSelectedTubingset(defaultTubingSet, null);
      // }
    }
  };

  componentWillMount() {
    //this.setState({selectedNeedleSet: this.state.needleSet[7]});
    //this.setState({selectedTubingSet: this.state.tubingSet[9]});
    //let tfr = this.calcTFR(this.props.selectedDrug.value, this.state.needleSet[7].id.c1, this.state.tubingSet[9].data);
    //this.setState({tfr: tfr});
    //this.setState({tod: this.calcTOD(this.props.selectedDosage, tfr)});
    //this.setState({frps: this.calcFRPS(this.state.needleSet[7].id.c2, tfr)});
    //this.setState({tvps: this.calcTVPS(this.props.selectedDosage, this.state.needleSet[7].id.c2)});
  }

  componentDidMount() {
    // var elmnt = document.ElementById("19");
    // if(elmnt) {
    //     elmnt.scrollIntoView({
    //         behavior: 'auto',
    //         block: 'center',
    //         inline: 'center'
    //     });
    // }
    //
    // elmnt = document.getElementById("F600");
    // if(elmnt) {
    //     elmnt.scrollIntoView({
    //         behavior: 'auto',
    //         block: 'center',
    //         inline: 'center'
    //     });
    // }

    this.setDefaultNeedlesAndTubingSets();
  }

  getFlowData = (drugId, ns, ts) => {
    for (var i = 0; i < this.state.flowData.length; i++) {
      if (this.state.flowData[i].drugId === drugId) {
        for (
          var j = 0;
          j < this.state.flowData[i].flowValues.length;
          j++
        ) {
          if (
            this.state.flowData[i].flowValues[j]['NeedleSet'] === ns
          ) {
            var fData = this.state.flowData[i].flowValues[j][ts];
            if (fData) {
              if (
                this.state.flowData[i].drugId === 13 ||
                this.state.flowData[i].drugId === 14 ||
                this.state.flowData[i].drugId === 15 ||
                this.state.flowData[i].drugId === 16 ||
                this.state.flowData[i].drugId === 19 ||
                this.state.flowData[i].drugId === 17 ||
                this.state.flowData[i].drugId === 20 ||
                this.state.flowData[i].drugId === 21
              ) {
                return fData;
              } else {
                return parseFloat(fData.toFixed(2));
              }
            }
          }
        }
      }
    }

    return '';
  };

  getFrpsData = (drugId, ns, ts) => {
    for (var i = 0; i < this.state.frpsData.length; i++) {
      if (
        this.state.frpsData[i].drugId === drugId &&
        (!this.state.frpsData[i].syringeId ||
          this.state.frpsData[i].syringeId ===
            this.props.selectedSyringe.id)
      ) {
        for (
          var j = 0;
          j < this.state.frpsData[i].flowValues.length;
          j++
        ) {
          if (
            this.state.frpsData[i].flowValues[j]['NeedleSet'] === ns
          ) {
            var fData = this.state.frpsData[i].flowValues[j][ts];
            return fData;
          }
        }
      }
    }

    return '';
  };

  calculate = (NS, Data, TS) => {
    let needleset = this.state.selectedNeedleSet;
    let tubingsetData = [];
    if (this.state.selectedTubingSet) {
      tubingsetData = this.state.selectedTubingSet.data;
    }
    if (NS) {
      needleset = NS;
    }
    if (Data) {
      tubingsetData = Data;
    }
    if (needleset.id) {
      let tfr = this.calcTFR(
        this.props.selectedDrug.value,
        needleset.id.c1,
        tubingsetData,
        TS
      );
      this.setState({ tfr: tfr });
      this.setState({
        tod: this.calcTOD(this.props.selectedDosage, tfr),
      });
      let frps = this.calcFRPS(
        needleset.id.c2,
        tfr,
        TS,
        needleset.id.c1
      );
      this.setState({ frps: frps });
      this.setState({
        tvps: this.calcTVPS(
          this.props.selectedDosage,
          needleset.id.c2
        ),
      });
    }
  };

  getTfrFromFrps = () => {
    if (
      !this.state.selectedNeedleSet ||
      !this.state.selectedTubingSet
    ) {
      return '';
    }
    const frps = this.getFrpsData(
      this.props.selectedDrug.id,
      this.state.selectedNeedleSet.id.c1,
      this.state.selectedTubingSet.type
    );
    if (frps && frps.range) {
      if (frps.range.indexOf('-') > -1) {
        var frpsParts = frps.range
          .replace('-', '')
          .replace('(', '')
          .replace(')', '')
          .split(' ');

        if (frpsParts.length === 4) {
          const tfrAvg = (
            parseFloat(frpsParts[0]) *
            this.state.selectedNeedleSet.id.c2
          ).toFixed(1);
          const tfrMin = (
            parseFloat(frpsParts[1]) *
            this.state.selectedNeedleSet.id.c2
          ).toFixed(1);
          const tfrMax = (
            parseFloat(frpsParts[3]) *
            this.state.selectedNeedleSet.id.c2
          ).toFixed(1);

          return `${tfrAvg} (${tfrMin} - ${tfrMax})`;
        }
      } else {
        const val = (
          parseFloat(frps.range) * this.state.selectedNeedleSet.id.c2
        ).toFixed(1);
        return val;
      }
    }

    return '';
  };

  calcTFR = (drug, NS, TS, selectedTubingSet) => {
    if (NS && TS) {
      if (
        this.props.selectedDrug.id === 16 ||
        this.props.selectedDrug.id === 15 ||
        this.props.selectedDrug.id === 13 ||
        this.props.selectedDrug.id === 12 ||
        this.props.selectedDrug.id === 14 ||
        this.props.selectedDrug.id === 17 ||
        this.props.selectedDrug.id === 18 ||
        this.props.selectedDrug.id === 19 ||
        this.props.selectedDrug.id === 20 ||
        this.props.selectedDrug.id === 21 ||
        this.props.selectedDrug.id === 24 ||
        this.props.selectedDrug.id === 4
      ) {
        return this.getTfrFromFrps();
      } else if (
        this.props.selectedDrug.id === 6 ||
        this.props.selectedDrug.id === 7 ||
        this.props.selectedDrug.id === 2 ||
        this.props.selectedDrug.id === 22 ||
        this.props.selectedDrug.id === 23
      ) {
        if (selectedTubingSet) {
          return this.getFlowData(
            this.props.selectedDrug.id,
            NS,
            selectedTubingSet.type
          );
        }
      } else {
        let tfr = drug * TS[NS] * this.props.selectedSyringe.value;
        return Math.round(tfr * 100) / 100;
      }
    }

    return '';
  };

  getTodData = (drugId) => {
    for (var i = 0; i < this.state.todData.length; i++) {
      if (this.state.todData[i].drugId === drugId) {
        for (
          var j = 0;
          j < this.state.todData[i].todValues.length;
          j++
        ) {
          if (
            this.state.todData[i].todValues[j]['NeedleSet'] ===
            this.state.selectedNeedleSet.id.c1
          ) {
            var tData =
              this.state.todData[i].todValues[j][
                this.state.selectedTubingSet.type
              ];
            if (tData) {
              return tData;
            }
          }
        }
      }
    }
  };

  calcTOD = (dosage, TFR) => {
    if (
      this.props.selectedDrug.id === 17 &&
      this.state.selectedNeedleSet &&
      this.state.selectedNeedleSet.id &&
      this.state.selectedTubingSet &&
      this.state.selectedTubingSet.type
    ) {
      return this.getTodData(this.props.selectedDrug.id);
    } else if (dosage && TFR) {
      if (
        this.props.selectedDrug.id === 14 ||
        this.props.selectedDrug.id === 13 ||
        this.props.selectedDrug.id === 12 ||
        this.props.selectedDrug.id === 15 ||
        this.props.selectedDrug.id === 16 ||
        this.props.selectedDrug.id === 18 ||
        this.props.selectedDrug.id === 19 ||
        this.props.selectedDrug.id === 20 ||
        this.props.selectedDrug.id === 21 ||
        this.props.selectedDrug.id === 24
      ) {
        var tfrParts = TFR.replace('-', '')
          .replace('(', '')
          .replace(')', '')
          .split(' ');
        var todAvg = dosage / parseFloat(tfrParts[0]);
        var todMin = dosage / parseFloat(tfrParts[1]);
        var todMax = dosage / parseFloat(tfrParts[3]);

        var timeAvg = this.getTODstr(todAvg);
        var timeMin = this.getTODstr(todMin);
        var timeMax = this.getTODstr(todMax);
        return `${timeAvg} (${timeMax} - ${timeMin})`;
      } else {
        let tod = dosage / TFR;
        return this.getTODstr(tod);
      }
    }

    return '';
  };

  getTODstr = (tod) => {
    let h = parseFloat(tod.toString().split('.')[0]);
    let min = (tod - h) * 60;
    let m = Math.ceil(Math.floor(min * 1000) / 1000);
    if (m === 60) {
      h += 1;
      m = 0;
    }
    if (m < 10) {
      //temp
      m = '0' + m.toString();
    }
    return h + 'h ' + m + 'm';
  };

  calcFRPS = (NS, TFR, selectedTubingSet, selectedNeedleSet) => {
    if (NS && TFR) {
      if (
        this.props.selectedDrug.id === 16 ||
        this.props.selectedDrug.id === 15 ||
        this.props.selectedDrug.id === 13 ||
        this.props.selectedDrug.id === 12 ||
        this.props.selectedDrug.id === 14 ||
        this.props.selectedDrug.id === 17 ||
        this.props.selectedDrug.id === 18 ||
        this.props.selectedDrug.id === 19 ||
        this.props.selectedDrug.id === 20 ||
        this.props.selectedDrug.id === 21 ||
        this.props.selectedDrug.id === 24 ||
        this.props.selectedDrug.id === 4
      ) {
        if (selectedTubingSet && selectedNeedleSet) {
          let frps = this.getFrpsData(
            this.props.selectedDrug.id,
            selectedNeedleSet,
            selectedTubingSet.type
          );
          if (frps) {
            let maxVal = this.extractMaxValueFromString(frps.range);
            if (
              maxVal > this.props.selectedDrug.maxRATEValue ||
              maxVal > this.props.selectedDrug.maxRateValueOver
            ) {
              this.setState({
                overfrps: true,
              });
            } else {
              this.setState({ overfrps: false });
            }
          } else {
            this.setState({ overfrps: false });
          }
          return frps.range;
        }
      } else {
        this.setState({ overfrps: false });
        let frps = TFR / NS;
        return Math.round(frps * 100) / 100;
      }
    }

    return '';
  };

  calcTVPS = (dosage, NS) => {
    if (dosage && NS) {
      let tvps = dosage / NS;
      return (Math.round(tvps * 100) / 100).toFixed(1);
    }

    return '';
  };

  storeToDb = (paramName, value, itemId) => {
    if (itemId) {
      var body = {};
      body[paramName] = value;
      body['itemId'] = itemId;
      fetch(
        'https://jnp6us085b.execute-api.us-east-2.amazonaws.com/default/addSelectedDrug',
        {
          method: 'post',
          headers: {
            'x-api-key': 'va04Xxh1Jr47FmYyrZIDuacnFVR38gxdS6fomix5',
          },
          body: JSON.stringify(body),
        }
      );
    }
  };

  setSelectedNeedleset = (item) => {
    this.storeToDb('needleset', item.id.ct, this.props.dbItemId);
    this.setState({ selectedNeedleSet: item }, () => {
      this.setDefaultTubingSet(item);
      this.calculate(item, null, this.state.selectedTubingSet);
    });
  };

  setSelectedTubingset = (item, e) => {
    this.storeToDb('tubing', item.type, this.props.dbItemId);
    if (item.type === 'Combination\nSet') {
      this.showModal(e);
    } else {
      this.setState({ selectedTubingSet: item }, () => {
        this.calculate(null, item.data, item);
      });
    }
  };

  showModal(e) {
    this.setState({ showModalWindow: true });
    if (e) {
      e.stopPropagation();
    }
  }

  closeModal(e) {
    this.setState({ showModalWindow: false });
    if (e) {
      e.preventDefault();
    }
  }

  sendResultsToPatient = () => {
    let msg =
      'Dear FREEDOM® User,\n\nPlease find below your configuration:\n\nPatient Name: ' +
      this.state.patientName +
      '\nSyringe Driver: ' +
      this.props.selectedSyringe.title +
      (this.props.version === 'international'
        ? '\nMedicinal Product: '
        : '\nDrug: ') +
      this.props.selectedDrug.title +
      '\nDosage: ' +
      this.props.selectedDosage +
      `m${
        this.props.version === 'international' ? 'l' : 'L'
      }\nNeedle Set: ` +
      this.state.selectedNeedleSet.title.replace('\n', ' ') +
      ', ' +
      this.state.selectedNeedleSet.size +
      '\nTubing Set: ' +
      this.state.selectedTubingSet.type +
      ' ' +
      this.state.selectedTubingSet.title.replace('\n', ' ') +
      '\nTime of Delivery: ' +
      this.calcTOD(this.props.selectedDosage, this.state.tfr) +
      '\nTotal Flow Rate: ' +
      this.state.tfr +
      ` m${
        this.props.version === 'international' ? 'l' : 'L'
      }/h\nFlow Rate Per Site: ` +
      this.state.frps +
      ` m${
        this.props.version === 'international' ? 'l' : 'L'
      }/h\nTotal Volume Per Site: ` +
      this.calcTVPS(
        this.props.selectedDosage,
        this.state.selectedNeedleSet.id.c2
      ) +
      ` m${this.props.version === 'international' ? 'l' : 'L'}`;
    console.log(msg);
    // ses.sendEmail(emailParams, function(error, data) {
    //     if (error) {
    //        // handle error
    //     } else {
    //        // handle success
    //     }
    //   });
  };

  setCombinationSetValue = (e) => {
    var element = document.getElementById('combSetInput');
    if (element) {
      this.setState({ selectedTubingSet: this.state.tubingSet[0] });
      this.calculateCombinationSet(e, element.value);
      this.setState({ combinationSet: element.value });
    }
    this.closeModal(e);
  };

  printPage = () => {
    window.print();
  };

  setPatientName = (e) => {
    let patientnameinput = document.getElementById(
      'patientnameinput'
    );
    if (patientnameinput) {
      this.setState({
        patientName: patientnameinput.value,
      });
    }
  };

  formatNumberForRegion = (numVal) => {
    try {
      if (numVal) {
        let numStr = numVal.toString();
        if (numStr && this.props.version === 'international') {
          let formattedStr = numStr.replace(/\./g, ',');
          return formattedStr;
        }
        return numVal;
      }
    } catch (error) {
      console.log(error);
    }
  };

  sendEmail = () => {
    let subject = 'Your KORU FREEDOM Flow Rate Calculator Results';
    let body =
      'Dear FREEDOM® User,\n\nPlease find below your configuration:\n\nPatient Name: ' +
      this.state.patientName +
      '\nSyringe Driver: ' +
      this.props.selectedSyringe.title +
      (this.props.version === 'international'
        ? '\nMedicinal Product: '
        : '\nDrug: ') +
      this.props.selectedDrug.title +
      '\nDosage: ' +
      this.props.selectedDosage +
      `m${
        this.props.version === 'international' ? 'l' : 'L'
      }\nNeedle Set: ` +
      (this.state.selectedNeedleSet.title
        ? this.state.selectedNeedleSet.title.replace('\n', ' ')
        : '') +
      ', ' +
      this.state.selectedNeedleSet.size +
      '\nTubing Set: ' +
      this.state.selectedTubingSet.type +
      '\nTime of Delivery: ' +
      this.calcTOD(this.props.selectedDosage, this.state.tfr) +
      '\nTotal Flow Rate: ' +
      (this.props.selectedDrug.id === 17
        ? 'Not Applicable'
        : this.state.tfr +
          ` m${
            this.props.version === 'international' ? 'l' : 'L'
          }/h`) +
      `\nFlow Rate Per Site: ` +
      (this.props.selectedDrug.id === 17
        ? 'Not Applicable'
        : this.state.frps +
          ` m${
            this.props.version === 'international' ? 'l' : 'L'
          }/h`) +
      `\nTotal Volume Per Site: ` +
      this.calcTVPS(
        this.props.selectedDosage,
        this.state.selectedNeedleSet.id
          ? this.state.selectedNeedleSet.id.c2
          : null
      ) +
      ` m${this.props.version === 'international' ? 'l' : 'L'}`;
    let uri = 'mailto:?subject=';
    uri += encodeURIComponent(subject);
    uri += '&body=';
    uri += encodeURIComponent(body);
    window.open(uri);
  };

  calculateCombinationSet = (e, combinationSetValue) => {
    let cs_value = parseFloat(combinationSetValue);
    let cs1 =
      (cs_value * this.state.tubingSet[0].data[0]) /
      (cs_value + this.state.tubingSet[0].data[0]);
    let cs2 =
      (cs_value * this.state.tubingSet[0].data[1]) /
      (cs_value + this.state.tubingSet[0].data[1]);
    let cs3 =
      (cs_value * this.state.tubingSet[0].data[2]) /
      (cs_value + this.state.tubingSet[0].data[2]);
    let cs4 =
      (cs_value * this.state.tubingSet[0].data[3]) /
      (cs_value + this.state.tubingSet[0].data[3]);
    let cs5 =
      (cs_value * this.state.tubingSet[0].data[4]) /
      (cs_value + this.state.tubingSet[0].data[4]);
    let cs6 =
      (cs_value * this.state.tubingSet[0].data[5]) /
      (cs_value + this.state.tubingSet[0].data[5]);
    let cs7 =
      (cs_value * this.state.tubingSet[0].data[6]) /
      (cs_value + this.state.tubingSet[0].data[6]);
    let cs8 =
      (cs_value * this.state.tubingSet[0].data[7]) /
      (cs_value + this.state.tubingSet[0].data[7]);
    let cs9 =
      (cs_value * this.state.tubingSet[0].data[8]) /
      (cs_value + this.state.tubingSet[0].data[8]);
    let cs10 =
      (cs_value * this.state.tubingSet[0].data[9]) /
      (cs_value + this.state.tubingSet[0].data[9]);
    let cs11 =
      (cs_value * this.state.tubingSet[0].data[10]) /
      (cs_value + this.state.tubingSet[0].data[10]);
    let cs12 =
      (cs_value * this.state.tubingSet[0].data[11]) /
      (cs_value + this.state.tubingSet[0].data[11]);
    let cs13 =
      (cs_value * this.state.tubingSet[0].data[12]) /
      (cs_value + this.state.tubingSet[0].data[12]);
    let cs14 =
      (cs_value * this.state.tubingSet[0].data[13]) /
      (cs_value + this.state.tubingSet[0].data[13]);
    let cs15 =
      (cs_value * this.state.tubingSet[0].data[14]) /
      (cs_value + this.state.tubingSet[0].data[14]);
    let cs16 =
      (cs_value * this.state.tubingSet[0].data[15]) /
      (cs_value + this.state.tubingSet[0].data[15]);
    let cs17 =
      (cs_value * this.state.tubingSet[0].data[16]) /
      (cs_value + this.state.tubingSet[0].data[16]);
    let cs18 =
      (cs_value * this.state.tubingSet[0].data[17]) /
      (cs_value + this.state.tubingSet[0].data[17]);
    let cs19 =
      (cs_value * this.state.tubingSet[0].data[18]) /
      (cs_value + this.state.tubingSet[0].data[18]);
    let cs20 =
      (cs_value * this.state.tubingSet[0].data[19]) /
      (cs_value + this.state.tubingSet[0].data[19]);
    let cs21 =
      (cs_value * this.state.tubingSet[0].data[20]) /
      (cs_value + this.state.tubingSet[0].data[20]);
    let cs22 =
      (cs_value * this.state.tubingSet[0].data[21]) /
      (cs_value + this.state.tubingSet[0].data[21]);
    let cs23 =
      (cs_value * this.state.tubingSet[0].data[22]) /
      (cs_value + this.state.tubingSet[0].data[22]);
    let cs24 =
      (cs_value * this.state.tubingSet[0].data[23]) /
      (cs_value + this.state.tubingSet[0].data[23]);
    let cs25 =
      (cs_value * this.state.tubingSet[0].data[24]) /
      (cs_value + this.state.tubingSet[0].data[24]);
    let cs26 =
      (cs_value * this.state.tubingSet[0].data[25]) /
      (cs_value + this.state.tubingSet[0].data[25]);
    let cs27 =
      (cs_value * this.state.tubingSet[0].data[26]) /
      (cs_value + this.state.tubingSet[0].data[26]);
    let cs28 =
      (cs_value * this.state.tubingSet[0].data[27]) /
      (cs_value + this.state.tubingSet[0].data[27]);
    let cs29 =
      (cs_value * this.state.tubingSet[0].data[28]) /
      (cs_value + this.state.tubingSet[0].data[28]);
    let cs30 =
      (cs_value * this.state.tubingSet[0].data[29]) /
      (cs_value + this.state.tubingSet[0].data[29]);
    let cs31 =
      (cs_value * this.state.tubingSet[0].data[30]) /
      (cs_value + this.state.tubingSet[0].data[30]);
    let cs32 =
      (cs_value * this.state.tubingSet[0].data[31]) /
      (cs_value + this.state.tubingSet[0].data[31]);
    let cs33 =
      (cs_value * this.state.tubingSet[0].data[32]) /
      (cs_value + this.state.tubingSet[0].data[32]);
    let cs34 =
      (cs_value * this.state.tubingSet[0].data[33]) /
      (cs_value + this.state.tubingSet[0].data[33]);
    let cs35 =
      (cs_value * this.state.tubingSet[0].data[34]) /
      (cs_value + this.state.tubingSet[0].data[34]);
    let cs36 =
      (cs_value * this.state.tubingSet[0].data[35]) /
      (cs_value + this.state.tubingSet[0].data[35]);

    let data = [
      cs_value,
      cs1,
      cs2,
      cs3,
      cs4,
      cs5,
      cs6,
      cs7,
      cs8,
      cs9,
      cs10,
      cs11,
      cs12,
      cs13,
      cs14,
      cs15,
      cs16,
      cs17,
      cs18,
      cs19,
      cs20,
      cs21,
      cs22,
      cs23,
      cs24,
      cs25,
      cs26,
      cs27,
      cs28,
      cs29,
      cs30,
      cs31,
      cs32,
      cs33,
      cs34,
      cs35,
      cs36,
    ];

    //this.setState({tfr: this.calcTFR(this.props.selectedDrug.value, this.state.selectedNeedleSet.id.c1, data)});
    this.calculate(this.state.selectedNeedleSet, data);
  };

  getHeaderStyle = (key) => {
    if (key === '24G') {
      return styles.resultGrpHdr24;
    } else if (key === '26G') {
      return styles.resultGrpHdr26;
    } else if (key === 'S26G') {
      return styles.resultGrpHdrS26;
    } else if (key === 'Combination' || key === 'Low Flow') {
      return styles.resultCombination;
    } else if (key === 'High Flow') {
      return styles.resultHighFlow;
    } else if (key === 'Very High Flow') {
      return styles.resultVeryHighFlow;
    } else {
      return styles.resultGrpHdr;
    }
  };

  getHeaderLabel = (key) => {
    switch (key) {
      case '24G':
        return '24G (24 gauge standard)';
      case '26G':
        return '26G (26 gauge standard)';
      case 'S26G':
        return '26G (Super 26 faster flow 26 gauge)';
    }
  };

  getReferenceText = () => {
    switch (this.props.selectedDrug.id) {
      case 4:
        return `*Reference: Gammanorm® Prescribing Information Revised 10/2023`;
      case 12:
        return `*Reference: Cuvitru® Prescribing Information Issued 02/02/2024`;
      case 13:
        return `*Reference: Cutaquig® Prescribing Information Updated 05-May-2022`;
      case 14:
        return `*Reference: Xembify® Prescribing Information Last Revised 22/10/2021`;
      case 17:
        return `*Reference: Aspaveli® / Empaveli® Prescribing Information Issued 14/06/2022`;
      case 18:
        return `*Reference: Hizentra® Product Information - published 01/13/2022`;
      case 2:
      case 22:
      case 23:
        return '*Reference: GAMMAGARD LIQUID® Prescribing Information Issued 01/2024';
      case 19:
      case 24:
        return `*Reference: Hizentra® Product Information - published 09/26/2025`;
      default:
        return ``;
    }
  };

  getLegendText = () => {
    if (
      this.props.selectedDrug.id === 12 ||
      this.props.selectedDrug.id === 13 ||
      this.props.selectedDrug.id === 14 ||
      this.props.selectedDrug.id === 15 ||
      this.props.selectedDrug.id === 16 ||
      this.props.selectedDrug.id === 18 ||
      this.props.selectedDrug.id === 24
    ) {
      return 'Average (Min-Max) Flow Rates';
    } else if (this.props.selectedDrug.id === 17) {
      return 'Average (Min-Max) Infusion Time';
    }
  };

  isNeedleDisplayed = (needleCt) => {
    if (this.props.selectedDrug.id === 22) {
      if (
        (needleCt === '26g1n' &&
          this.props.selectedDosage === '20') ||
        (needleCt === '26g2n' &&
          this.props.selectedDosage === '60') ||
        (needleCt === '26g4n' && this.props.selectedDosage === '100')
      ) {
        return true;
      } else {
        return false;
      }
    }
    if (this.props.selectedDrug.id === 23) {
      if (
        (needleCt === '26g1n' &&
          this.props.selectedDosage === '30') ||
        (needleCt === '26g2n' &&
          (this.props.selectedDosage === '20' ||
            this.props.selectedDosage === '30'))
      ) {
        return true;
      } else {
        return false;
      }
    }
    if (
      (needleCt === '26g1n' || needleCt === '24g1n') &&
      this.props.selectedDrug.id === 20 &&
      this.props.version !== 'international'
    ) {
      return false;
    }
    if (
      (needleCt === '26g1n' ||
        needleCt === '24g1n' ||
        needleCt === '24g2n') &&
      (this.props.selectedDrug.id === 2 ||
        this.props.selectedDrug.id === 22 ||
        this.props.selectedDrug.id === 23) &&
      this.props.version !== 'international'
    ) {
      return false;
    }
    if (
      (needleCt === '24g5n' || needleCt === '24g6n') &&
      this.props.selectedDrug.id === 12 &&
      this.props.selectedSyringe.id === 1
    ) {
      return true;
    }
    if (
      (needleCt === '24g5n' || needleCt === '24g6n') &&
      (this.props.selectedDrug.id !== 13 ||
        this.props.version === 'international') &&
      this.props.selectedDrug.id !== 14 &&
      this.props.selectedDrug.id !== 15 &&
      this.props.selectedDrug.id !== 16 &&
      this.props.selectedDrug.id !== 18 &&
      this.props.selectedDrug.id !== 19 &&
      this.props.selectedDrug.id !== 24 &&
      this.props.selectedDrug.id !== 20 &&
      this.props.selectedDrug.id !== 21 &&
      this.props.selectedDrug.id !== 2 &&
      this.props.selectedDrug.id !== 7 &&
      this.props.selectedDrug.id !== 6
    ) {
      return false;
    } else if (
      (needleCt === '24g7n' || needleCt === '24g8n') &&
      this.props.selectedDrug.id !== 15 &&
      this.props.selectedDrug.id !== 16 &&
      this.props.selectedDrug.id !== 18 &&
      this.props.selectedDrug.id !== 19 &&
      this.props.selectedDrug.id !== 24 &&
      this.props.selectedDrug.id !== 2 &&
      this.props.selectedDrug.id !== 7 &&
      this.props.selectedDrug.id !== 6
    ) {
      return false;
    } else if (
      (needleCt === '26g7n' || needleCt === '26g8n') &&
      (((this.props.selectedDrug.id === 12 ||
        this.props.selectedDrug.id === 4) &&
        this.props.version === 'international') ||
        this.props.selectedDrug.id === 12 ||
        this.props.selectedDrug.id === 13 ||
        this.props.selectedDrug.id === 14 ||
        this.props.selectedDrug.id === 20 ||
        this.props.selectedDrug.id === 21)
    ) {
      return false;
    } else if (
      needleCt !== '26g1n' &&
      needleCt !== '26g2n' &&
      this.props.selectedDrug.id === 17
    ) {
      return false;
    } else if (
      (needleCt === '26g5n' || needleCt === '26g6n') &&
      this.props.selectedDrug.id === 12 &&
      this.props.version === 'us'
    ) {
      return false;
    }

    return true;
  };

  roundValue = (value) => {
    if (value) {
      if (
        this.props.selectedDrug.id === 13 ||
        this.props.selectedDrug.id === 12 ||
        this.props.selectedDrug.id === 14 ||
        this.props.selectedDrug.id === 15 ||
        this.props.selectedDrug.id === 16 ||
        this.props.selectedDrug.id === 17 ||
        this.props.selectedDrug.id === 18 ||
        this.props.selectedDrug.id === 19 ||
        this.props.selectedDrug.id === 20 ||
        this.props.selectedDrug.id === 21 ||
        this.props.selectedDrug.id === 24
      ) {
        return value;
      } else {
        var rounded = Math.round(value * 10) / 10;
        return rounded.toFixed(1);
      }
    }
  };

  isNeedleSetDisplayed = (key) => {
    if (
      key === 'S26G' ||
      (this.props.selectedDrug.id === 17 && key === '24G') ||
      (this.props.selectedDrug.id === 2 && key === '24G') ||
      (this.props.selectedDrug.id === 22 && key === '24G') ||
      (this.props.selectedDrug.id === 23 && key === '24G')
    ) {
      return false;
    }

    return true;
  };

  isTubingSetGroupDisplayed = (key) => {
    if (
      key.indexOf('Combination') > -1 ||
      (this.props.selectedDrug.id === 17 && key === 'Low Flow') ||
      (this.props.selectedDrug.id === 22 &&
        this.props.selectedDosage === '100' &&
        key === 'Low Flow') ||
      (this.props.selectedDrug.id === 22 &&
        (this.props.selectedDosage === '30' ||
          this.props.selectedDosage === '60') &&
        key === 'High Flow') ||
      (this.props.selectedDrug.id === 23 &&
        (this.props.selectedDosage === '20' ||
          this.props.selectedDosage === '30') &&
        key === 'High Flow')
    ) {
      return false;
    }
    return true;
  };

  isTubingSetDisplayed = (item) => {
    if (this.props.version === 'international') {
      if (
        (item.type === 'F30' ||
          item.type === 'F45' ||
          item.type === 'F60' ||
          item.type.indexOf('Combination') > -1) &&
        ((this.props.selectedDrug.id === 4 &&
          this.props.version === 'international') ||
          this.props.selectedDrug.id === 13 ||
          this.props.selectedDrug.id === 14 ||
          this.props.selectedDrug.id === 12 ||
          this.props.selectedDrug.id === 7 ||
          this.props.selectedDrug.id === 6 ||
          this.props.selectedDrug.id === 15 ||
          this.props.selectedDrug.id === 16 ||
          this.props.selectedDrug.id === 18 ||
          this.props.selectedDrug.id === 24 ||
          this.props.selectedDrug.id === 19)
      ) {
        return false;
      }

      if (
        this.props.selectedDrug.id === 17 &&
        item.type !== 'F500' &&
        item.type !== 'F600' &&
        item.type !== 'F900' &&
        item.type !== 'F1200' &&
        item.type !== 'F2400'
      ) {
        return false;
      }

      return true;
    } else {
      if (this.props.selectedDrug.id === 22) {
        if (
          (item.type === 'F45' &&
            this.props.selectedDosage === '20') ||
          (item.type === 'F120' &&
            this.props.selectedDosage === '60') ||
          (item.type === 'F420' &&
            this.props.selectedDosage === '100')
        ) {
          return true;
        } else {
          return false;
        }
      }
      if (this.props.selectedDrug.id === 23) {
        if (
          (item.type === 'F120' &&
            this.props.selectedDosage === '20') ||
          (item.type === 'F180' &&
            this.props.selectedDosage === '30' &&
            this.state.selectedNeedleSet &&
            this.state.selectedNeedleSet.id &&
            this.state.selectedNeedleSet.id.c1 === 17) ||
          (item.type === 'F120' &&
            this.props.selectedDosage === '30' &&
            this.state.selectedNeedleSet &&
            this.state.selectedNeedleSet.id &&
            this.state.selectedNeedleSet.id.c1 === 16)
        ) {
          return true;
        } else {
          return false;
        }
      }
      if (
        item.type === 'F30' ||
        item.type === 'F45' ||
        item.type === 'F60'
      ) {
        return false;
      }
      const ns = this.state.selectedNeedleSet.id;
      if (!ns) {
        return true;
      }

      switch (this.props.selectedDrug.id) {
        case 13:
          switch (ns.c1) {
            case 33:
              switch (item.type) {
                case 'F60':
                case 'F275':
                case 'F420':
                case 'F500':
                case 'F600':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 34:
              switch (item.type) {
                case 'F60':
                case 'F500':
                case 'F600':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 35:
            case 36:
              switch (item.type) {
                case 'F60':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 37:
              switch (item.type) {
                case 'F60':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 38:
              switch (item.type) {
                case 'F60':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 16:
              switch (item.type) {
                case 'F60':
                case 'F420':
                case 'F500':
                case 'F600':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 17:
              switch (item.type) {
                case 'F60':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 18:
              switch (item.type) {
                case 'F60':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 19:
            case 20:
            case 21:
              switch (item.type) {
                case 'F60':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
          }
          return true;
        case 12:
          switch (ns.c1) {
            case 33:
              switch (item.type) {
                case 'F60':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 34:
              switch (item.type) {
                case 'F60':
                case 'F120':
                case 'F180':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 35:
              switch (item.type) {
                case 'F60':
                case 'F120':
                case 'F180':
                case 'F275':
                  return false;
                default:
                  return true;
              }
            case 36:
              switch (item.type) {
                case 'F60':
                case 'F120':
                case 'F180':
                case 'F275':
                case 'F420':
                  return false;
                default:
                  return true;
              }
            case 16:
              switch (item.type) {
                case 'F60':
                case 'F120':
                  return false;
                default:
                  return true;
              }
            case 17:
              switch (item.type) {
                case 'F60':
                case 'F120':
                case 'F180':
                case 'F275':
                  return false;
                default:
                  return true;
              }
            case 18:
              switch (item.type) {
                case 'F60':
                case 'F120':
                case 'F180':
                case 'F275':
                case 'F420':
                  return false;
                default:
                  return true;
              }
            case 19:
              switch (item.type) {
                case 'F60':
                case 'F120':
                case 'F180':
                case 'F275':
                case 'F420':
                case 'F500':
                case 'F600':
                  return false;
                default:
                  return true;
              }
          }
          return true;
        case 2:
          switch (ns.c1) {
            case 35:
            case 36:
            case 17:
              switch (item.type) {
                case 'F60':
                case 'F275':
                case 'F420':
                case 'F500':
                case 'F600':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 37:
            case 38:
            case 39:
            case 18:
            case 19:
              switch (item.type) {
                case 'F60':
                case 'F420':
                case 'F500':
                case 'F600':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 40:
            case 20:
              switch (item.type) {
                case 'F60':
                case 'F500':
                case 'F600':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 21:
              switch (item.type) {
                case 'F60':
                case 'F600':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 22:
            case 23:
              switch (item.type) {
                case 'F60':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
          }
          return true;
        case 7:
          switch (ns.c1) {
            case 16:
              switch (item.type) {
                case 'F60':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 18:
            case 17:
              switch (item.type) {
                case 'F60':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 33:
              switch (item.type) {
                case 'F60':
                case 'F420':
                case 'F500':
                case 'F600':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 34:
              switch (item.type) {
                case 'F60':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 35:
              switch (item.type) {
                case 'F60':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 36:
            case 37:
            case 38:
            case 39:
            case 40:
              switch (item.type) {
                case 'F60':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 19:
            case 20:
            case 21:
            case 22:
            case 23:
              switch (item.type) {
                case 'F60':
                  return false;
                default:
                  return true;
              }
          }
          return true;
        case 20:
          switch (ns.c1) {
            case 16:
              switch (item.type) {
                case 'F600':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 17:
              switch (item.type) {
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 18:
            case 19:
              switch (item.type) {
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 33:
              switch (item.type) {
                case 'F420':
                case 'F500':
                case 'F600':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 34:
              switch (item.type) {
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 35:
              switch (item.type) {
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 36:
            case 37:
            case 38:
              switch (item.type) {
                case 'F2400':
                  return false;
                default:
                  return true;
              }
          }
          return true;
        case 6:
          switch (ns.c1) {
            case 16:
            case 17:
            case 18:
            case 19:
            case 20:
            case 21:
            case 22:
            case 23:
            case 36:
            case 37:
            case 38:
            case 39:
            case 40:
              switch (item.type) {
                case 'F60':
                  return false;
                default:
                  return true;
              }
            case 33:
              switch (item.type) {
                case 'F60':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 34:
            case 35:
              switch (item.type) {
                case 'F60':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
          }
          return true;
        case 21:
          switch (ns.c1) {
            case 33:
              switch (item.type) {
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 34:
            case 35:
              switch (item.type) {
                case 'F2400':
                  return false;
                default:
                  return true;
              }
          }
          return true;
        case 16:
          switch (ns.c1) {
            case 16:
              switch (item.type) {
                case 'F60':
                case 'F420':
                case 'F500':
                case 'F600':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 17:
            case 35:
            case 36:
              switch (item.type) {
                case 'F60':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 18:
            case 37:
              switch (item.type) {
                case 'F60':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 19:
            case 20:
            case 21:
            case 22:
            case 38:
            case 39:
            case 40:
              switch (item.type) {
                case 'F60':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 23:
              switch (item.type) {
                case 'F60':
                  return false;
                default:
                  return true;
              }
            case 33:
              switch (item.type) {
                case 'F60':
                case 'F275':
                case 'F420':
                case 'F500':
                case 'F600':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 34:
              switch (item.type) {
                case 'F60':
                case 'F500':
                case 'F600':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
          }
          return true;
        case 15:
          switch (ns.c1) {
            case 16:
              switch (item.type) {
                case 'F60':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 17:
            case 18:
            case 19:
            case 20:
            case 21:
            case 22:
            case 23:
            case 38:
            case 39:
            case 40:
              switch (item.type) {
                case 'F60':
                  return false;
                default:
                  return true;
              }
            case 33:
              switch (item.type) {
                case 'F60':
                case 'F600':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 34:
              switch (item.type) {
                case 'F60':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 35:
            case 36:
            case 37:
              switch (item.type) {
                case 'F60':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
          }
          return true;
        case 14:
          switch (ns.c1) {
            case 16:
              switch (item.type) {
                case 'F60':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 17:
              switch (item.type) {
                case 'F60':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 18:
            case 19:
              switch (item.type) {
                case 'F60':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 20:
            case 21:
              switch (item.type) {
                case 'F60':
                  return false;
                default:
                  return true;
              }
            case 33:
              switch (item.type) {
                case 'F60':
                case 'F420':
                case 'F500':
                case 'F600':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 34:
              switch (item.type) {
                case 'F60':
                case 'F900':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 35:
              switch (item.type) {
                case 'F60':
                case 'F1200':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
            case 36:
            case 37:
            case 38:
              switch (item.type) {
                case 'F60':
                case 'F2400':
                  return false;
                default:
                  return true;
              }
          }
        case 17:
          switch (ns.c1) {
            case 16:
            case 17:
              switch (item.type) {
                case 'F60':
                case 'F180':
                case 'F275':
                case 'F420':
                  return false;
                default:
                  return true;
              }
          }
        default:
          return true;
      }
    }
  };

  convertTimeStringToFloat = (timeString) => {
    const timeParts = timeString.split(' ');

    let hours = 0;
    let minutes = 0;

    for (const part of timeParts) {
      if (part.includes('h')) {
        hours = parseFloat(part.replace('h', ''));
      } else if (part.includes('m')) {
        minutes = parseFloat(part.replace('m', ''));
      }
    }

    const totalTime = hours + minutes / 60;
    return totalTime;
  };

  checkMaxTod = (timeString, maxValue) => {
    const numberParts = timeString.replace('-', '').match(/-?\d+/g);

    if (numberParts) {
      for (const numberPart of numberParts) {
        if (numberPart > maxValue) {
          return true;
        }
      }
    }
  };

  extractTfrFromString = (tfrString) => {
    const tfrParts = tfrString.split(' ');
    if (tfrParts[0]) {
      return parseFloat(tfrParts[0].trim());
    } else {
      return 0;
    }
  };

  extractMaxValueFromString = (tfrString) => {
    const tfrParts = tfrString.match(/\b\d+(\.\d+)?\b/g);
    if (tfrParts && tfrParts.length > 0) {
      return parseFloat(tfrParts[tfrParts.length - 1].trim());
    } else {
      return 0;
    }
  };

  getOffLabelTfrString = () => {
    if (this.props.version !== 'international') {
      switch (this.props.selectedDrug.id) {
        case 2:
        case 22:
        case 23:
          return (
            <span>
              May exceed drug manufacturer's maximum total flow rate
              for certain body weights.
              <br />
              Manufacturer's maximum total flow rate:
              <br />
              &le;240 mL/hr (&ge;40kg body weight)
              <br />
              &le;160 mL/hr (&lt;40kg body weight)
            </span>
          );
        default:
          return 'May exceed drug manufacturer’s maximum indicated flow rate';
      }
    } else {
      switch (this.props.selectedDrug.id) {
        case 4:
          return (
            <span>
              May exceed medicinal product's maximum total flow rate.
              <br />
              Manufacturer's maximum total flow rate:
              <br />
              ≤100 ml/h
            </span>
          );
        case 12:
        case 14:
        case 24:
        case 13:
        case 18:
          return '';
        default:
          return "May exceed medicinal product's maximum indicated total flow rate.";
      }
    }
  };

  getOffLabelFrpsString = () => {
    if (this.props.version !== 'international') {
      switch (this.props.selectedDrug.id) {
        case 14:
          return 'Flow rate maximum is ≤25 ml/hr/site.';
        case 6:
        case 15:
          return "Flow rate for initial infusion is ≤20 mL/hr/site. Flow rate for maintenance infusions ≤50 mL/hr/site. May exceed drug manufacturer's maximum indicated flow rate.";
        case 7:
        case 16:
          return "Flow rate for initial infusion is ≤15 mL/hr/site. Flow rate for maintenance infusions ≤25 mL/hr/site. May exceed drug manufacturer's maximum indicated flow rate.";
        case 2:
        case 22:
        case 23:
          return (
            <span>
              May exceed drug manufacturer's maximum flow rate per
              site for certain body weights.
              <br />
              Manufacturer's maximum flow rate per site for the first
              infusion:
              <br />
              &le;20 mL/hr/site (&ge;40kg body weight)
              <br />
              &le;15 mL/hr/site (&lt;40kg body weight)
              <br />
              Manufacturer's maximum flow rate per site for subsequent
              infusions:
              <br />
              &le;30 mL/hr/site (&ge;40kg body weight)
              <br />
              &le;20 mL/hr/site (&lt;40kg body weight)
            </span>
          );
        case 13:
          return "Adult Initial flow rate is ≤20 mL/hr/site. Flow rate after 6th infusion is 52 mL/site/hr. May exceed drug manufacturer's maximum indicated flow rate.";
        case 12:
          return "Flow rate for first two infusions is 10-20 mL/hr/site. Flow rate for subsequent infusions is ≤60 mL/hr/site. May exceed drug manufacturer's maximum indicated flow rate.";
        case 20:
          return "Flow rate for initial infusion is ≤15 mL/hr/site. Flow rate for maintenance infusions ≤25 mL/hr/site. May exceed drug manufacturer's maximum indicated flow rate.";
        case 21:
          return "Flow rate for initial infusion is ≤20 mL/hr/site. Flow rate for maintenance infusions ≤50 mL/hr/site. May exceed drug manufacturer's maximum indicated flow rate.";
        default:
          return 'May exceed drug manufacturer’s maximum indicated flow rate';
      }
    } else {
      switch (this.props.selectedDrug.id) {
        case 14:
          return (
            <span>
              Flow rates for initial infusion (≤10 ml/h/site).
              <br />
              Pediatrics: Flow rates for the first two infusions (≤20
              ml/h/site).
              <br />
              Adults: Flow rates for the first two infusions (≤25
              ml/h/site).
              <br />
              Flow rates for subsequent infusions (≤35 ml/h/site).
            </span>
          );
        case 18:
          if (this.props.selectedSyringe.id === 1) {
            return (
              <span>
                Flow rates for initial infusion (maximum flow rate ≤20
                ml/hr/site).
                <br />
                Flow rates for second and third infusions (maximum
                flow rate ≤35 ml/hr/site).
                <br />
                Flow rates for subsequent infusions can be increased
                based on patient's tolerability.
              </span>
            );
          }
          return (
            <span>
              Flow rates for initial infusion (maximum flow rate ≤20
              ml/hr/site).
              <br />
              Flow rates for second and third infusions (maximum flow
              rate ≤35 ml/hr/site).
              <br />
              Flow rates for subsequent infusions can be increased
              based on patient's tolerability.
            </span>
          );
        case 19:
        case 24:
          return (
            <span>
              Flow rates for initial infusion (maximum flow rate ≤20
              ml/hr/site).
              <br />
              Flow rates for second and third infusions (maximum flow
              rate ≤35 ml/hr/site).
              <br />
              Flow rates for subsequent infusions can be increased
              based on patient's tolerability.
            </span>
          );
        case 4:
          return (
            <span>
              Manufacturer's maximum flow rate per site for the first
              infusion:
              <br />
              ≤15 ml/h/site
              <br />
              Manufacturer's maximum flow rate per site for subsequent
              infusions:
              <br />
              ≤25 ml/h/site
            </span>
          );
        case 12:
          return (
            <span>
              Flow rates for initial infusion (maximum flow rate ≤ 10
              ml/hr/site).
              <br />
              Flow rates for first two infusions (maximum flow rate
              ≤20 ml/hr/site).
              <br />
              Flow rates for subsequent infusions can be increased
              based on patient's tolerability.
            </span>
          );
        case 13:
          return (
            <span>
              Flow rate for initial infusion for patients naïve on
              SCIg ≤15 ml/h/site.
              <br />
              Patients already on SCIg: continue with earlier flow
              rate.
              <br />
              Subsequent infusions: patients ≥ 40 kg: infusion rate
              can be gradually increased by 10 ml/h/site every two (2)
              to four (4) weeks.
              <br />
              Subsequent infusions: patients &lt;40 kg: infusion rate
              can be gradually increased by 10 ml/h/site every four
              (4) weeks.
              <br />
              Patients ≥ 40 kg maximum flow rate is 67,5 ml/h/site.
              <br />
              Patients &lt;40 kg maximum flow rate is 25 ml/h/site.
            </span>
          );
        default:
          return 'Flow rates for initial infusion is ≤15 ml/hr/site. Flow rate for second and subsequent infusions is ≤ 25.';
      }
    }
  };

  getOffLabelTvpsString = () => {
    if (this.props.version !== 'international') {
      switch (this.props.selectedDrug.id) {
        case 14:
          return 'Initial infusion max volume per site is 25 mL.';
        case 6:
        case 15:
          return "Initial infusion max volume per site is 20 mL. Subsequent infusions max volume per site is 50 mL. May exceed drug manufacturer's maximum indicated volume per site.";
        case 7:
        case 16:
          return "Initial infusion max volume per site is 15 mL. Subsequent infusions max volume per site is 25 mL. May exceed drug manufacturer's maximum indicated volume per site.";
        case 2:
        case 22:
        case 23:
          return (
            <span>
              May exceed drug manufacturer's maximum total volume per
              site for certain body weights.
              <br />
              Manufacturer's maximum total volume per site for the
              first infusion:
              <br />
              &le;30 mL/site (&ge;40kg body weight)
              <br />
              &le;20 mL/site (&lt;40kg body weight)
              <br />
              Manufacturer's maximum total volume per site for
              subsequent infusions:
              <br />
              &le;30 mL/site (&ge;40kg body weight)
              <br />
              &le;20 mL/site (&lt;40kg body weight)
            </span>
          );
        case 12:
          return "Patients <40kg max volume per site is ≤20 mL/site. Patients ≥ 40kg max volume per site is 60 mL. May exceed drug manufacturer's maximum indicated total volume per site.";
        case 13:
          return "Max volume per site is 40 mL. May exceed drug manufacturer's maximum indicated total volume per site.";
        case 20:
          return "Initial infusion max volume per site is 15 mL. Subsequent infusions max volume per site is 25 mL. May exceed drug manufacturer's maximum indicated volume per site.";
        case 21:
          return "Initial infusion max volume per site is 20 mL. Subsequent infusions max volume per site is 50 mL. May exceed drug manufacturer's maximum indicated volume per site.";
        default:
          return 'May exceed drug manufacturer’s maximum indicated total';
      }
    } else {
      switch (this.props.selectedDrug.id) {
        case 18:
          return '';
        case 19:
          return '';
        case 4:
          return (
            <span>
              May exceed medicinal product's maximum total volume per
              site for certain age groups.
              <br />
              Manufacturer's maximum total volume per site:
              <br />
              ≤15 ml/site (infants and children)
              <br />
              ≤25 ml/site (adults; first ten (10) infusions)
              <br />
              ≤35 ml/site (adults; infusions eleven (11) and on)
            </span>
          );
        case 12:
          return <span></span>;
        case 13:
          return '';
        case 14:
          return '';
        case 24:
          return '';
        default:
          return "Pediatric max volume per site is 15 ml. Adult max volume per site is 30 ml. May exceed medicinal product's maximum indicated total volume per site.";
      }
    }
  };

  getOffLabelDisclaimerTfr = () => {
    if (this.props.version !== 'international') {
      switch (this.props.selectedDrug.id) {
        default:
          return 'Please refer to drug product labeling for more information.';
      }
    } else {
      switch (this.props.selectedDrug.id) {
        default:
          // return 'Please refer to medicinal product labeling for more information.';
          return '';
      }
    }
  };

  getOffLabelDisclaimerFrps = () => {
    if (this.props.version !== 'international') {
      switch (this.props.selectedDrug.id) {
        case 13:
          return 'Please refer to drug product labeling for pediatric parameters and more information.';
        default:
          return 'Please refer to drug product labeling for more information.';
      }
    } else {
      switch (this.props.selectedDrug.id) {
        default:
          // return 'Please refer to medicinal product labeling for more information.';
          return '';
      }
    }
  };

  getOffLabelDisclaimerTvps = () => {
    if (this.props.version !== 'international') {
      switch (this.props.selectedDrug.id) {
        default:
          return 'Please refer to drug product labeling for more information.';
      }
    } else {
      switch (this.props.selectedDrug.id) {
        case 12:
          return '';
        default:
          // return 'Please refer to medicinal product labeling for more information.';
          return '';
      }
    }
  };

  getNotificationDisclaimer = () => {
    switch (this.props.selectedDrug.id) {
      case 18:
      case 19:
      case 24:
      case 13:
      case 14:
        return 'The Online Calculator indicates suggested flow rates based on the medicinal product labeling. Please refer to medicinal product labeling for detailed information on the maximum recommended flow rate and volume per infusion site for initial and subsequent infusions.';
      case 12:
        return 'The Online Calculator indicates suggested flow rates based on the medicinal product labeling. Please refer to medicinal product labeling for detailed information on the maximum recommended flow rate and volume per infusion site for initial and subsequent infusions.';
      case 17:
        return 'Clinical studies were performed using F2400 Precision Flow Rate Tubing with either a 1- leg or 2-leg 26G HIgH-Flo needle set. Typical infusion times were approximately 60 minutes with one infusion site and 30 minutes with two infusion sites. Alternatives may be selected if a longer infusion time is desired.';
      default:
        return '';
    }
  };

  render() {
    let offLabelErrorTfr = false;
    let offLabelErrorFrps = false;
    let offLabelErrorVol = false;
    let offLabelErrorTod = false;
    let offLabelTfr = '';
    let offLabelFrps = '';
    let offLabelVol = '';
    let offLabelTod = '';
    let offLabelDisclaimerVol = '';
    let offLabelDisclaimerFrps = '';
    let offLabelDisclaimerTfr = '';
    let maxTfr = this.props.selectedDrug.maxTFRValue;
    let maxRate = this.props.selectedDrug.maxRATEValue;
    let maxVol = this.props.selectedDrug.maxVOLValue;

    if (this.props.version === 'international' && this.state.tod) {
      let tod = this.convertTimeStringToFloat(this.state.tod);
      offLabelTod = '';
      offLabelErrorTod = false;
    }

    if (
      this.props.selectedWeight &&
      this.props.selectedWeight === 'over'
    ) {
      if (this.props.selectedDrug.maxTFRValueOver) {
        maxTfr = this.props.selectedDrug.maxTFRValueOver;
      }
      if (this.props.selectedDrug.maxRateValueOver) {
        maxRate = this.props.selectedDrug.maxRateValueOver;
      }
      if (this.props.selectedDrug.maxVolValueOver) {
        maxVol = this.props.selectedDrug.maxRateValueOver;
      }
    }

    if (
      (this.props.selectedDrug.id === 13 &&
        this.extractMaxValueFromString(this.state.tfr) > maxTfr) ||
      (this.state.tfr > maxTfr &&
        this.props.selectedDrug.id !== 14 &&
        this.props.selectedDrug.id !== 13)
    ) {
      offLabelTfr = (
        <span style={styles.offLabel}>
          {this.getOffLabelTfrString()}
        </span>
      );
      offLabelDisclaimerTfr = (
        <span style={styles.offLabelDisclaimer}>
          {this.getOffLabelDisclaimerTfr()}
        </span>
      );
      offLabelErrorTfr = true;
    } else {
      offLabelTfr = '';
      offLabelDisclaimerTfr = '';
      offLabelErrorTfr = false;
    }

    if (this.state.frps > maxRate || this.state.overfrps) {
      offLabelFrps = (
        <span style={styles.offLabel}>
          {this.getOffLabelFrpsString()}
        </span>
      );
      offLabelDisclaimerFrps = (
        <span style={styles.offLabelDisclaimer}>
          {this.getOffLabelDisclaimerFrps()}
        </span>
      );
      offLabelErrorFrps = true;
    } else {
      offLabelFrps = '';
      offLabelDisclaimerFrps = '';
      offLabelErrorFrps = false;
    }

    if (this.state.tvps > maxVol) {
      offLabelVol = (
        <span style={styles.offLabel}>
          {this.getOffLabelTvpsString()}
        </span>
      );
      offLabelDisclaimerVol = (
        <span style={styles.offLabelDisclaimer}>
          {this.getOffLabelDisclaimerTvps()}
        </span>
      );
      offLabelErrorVol = true;
    } else {
      offLabelVol = '';
      offLabelDisclaimerVol = '';
      offLabelErrorVol = false;
    }

    let groupItems = this.state.needleSet.reduce(
      (existingItems, item) => {
        if (!existingItems[item.size]) {
          existingItems[item.size] = { size: item.size, sets: [] };
        }
        existingItems[item.size].sets.push(item);
        return existingItems;
      },
      {}
    );

    let tubingGroupItems = this.state.tubingSet.reduce(
      (existingItems, item) => {
        if (!existingItems[item.groupType]) {
          existingItems[item.groupType] = {
            groupType: item.groupType,
            sets: [],
          };
        }
        existingItems[item.groupType].sets.push(item);
        return existingItems;
      },
      {}
    );

    let listItems = Object.keys(groupItems).map((key) => {
      // if(key !== 'S26G' || ((this.props.selectedDrug.id === 6
      //                     || this.props.selectedDrug.id === 13 || this.props.selectedDrug.id === 12
      //                     || this.props.selectedDrug.id === 14 || this.props.selectedDrug.id === 7) && this.props.selectedSyringe.title === 'Freedom 60')
      //                   || ((this.props.selectedDrug.id === 15 || this.props.selectedDrug.id === 16) && this.props.selectedSyringe.title === 'Freedom EDGE 20ML Syringe') ) {
      if (this.isNeedleSetDisplayed(key)) {
        return (
          <div key={key}>
            <div className="row" style={this.getHeaderStyle(key)}>
              <span>
                <b>Size:</b>&emsp;{this.getHeaderLabel(key)}
              </span>
            </div>
            <div className="row" style={styles.itemRowContainer}>
              {groupItems[key].sets.map((item) => {
                if (this.isNeedleDisplayed(item.id.ct)) {
                  return (
                    <div
                      id={item.id.c1}
                      key={item.id.c1}
                      onClick={() => this.setSelectedNeedleset(item)}
                      style={{
                        ...item.needleSetContainer,
                        ...(this.state.selectedNeedleSet &&
                        this.state.selectedNeedleSet.id &&
                        item.id.ct ===
                          this.state.selectedNeedleSet.id.ct
                          ? {
                              backgroundColor: item.selectedNeedleSet,
                            }
                          : {}),
                      }}
                    >
                      <div style={item.needleSetSizeTitleContainer}>
                        <span style={styles.needleSetSizeTitle}>
                          {item.size}
                        </span>
                      </div>
                      <div style={{ height: 60, marginLeft: 25 }}>
                        <img
                          alt={item.size}
                          style={styles.needleImage}
                          src={item.url}
                        />
                      </div>
                      <div style={item.needleSetTitleContainer}>
                        <span style={styles.needleSetTitle}>
                          {item.title}
                        </span>
                      </div>
                    </div>
                  );
                }
              })}
            </div>
          </div>
        );
      }
    });

    let tubingItems = Object.keys(tubingGroupItems).map((key) => {
      if (this.isTubingSetGroupDisplayed(key)) {
        return (
          <div key={key}>
            <div className="row" style={this.getHeaderStyle(key)}>
              <span>
                <b>Type:</b>&emsp;{key}
              </span>
            </div>
            <div className="row" style={styles.itemRowContainer}>
              {tubingGroupItems[key].sets.map((item) => {
                if (this.isTubingSetDisplayed(item)) {
                  return (
                    <div
                      id={item.type}
                      key={item.type}
                      onClick={(e) => {
                        if (
                          this.state.selectedNeedleSet &&
                          this.state.selectedNeedleSet.id
                        ) {
                          this.setSelectedTubingset(item, e);
                        }
                      }}
                      style={{
                        ...styles.tubingSetContainer,
                        ...{
                          borderColor:
                            this.state.selectedNeedleSet &&
                            this.state.selectedNeedleSet.id
                              ? item.color
                              : 'lightgrey',
                        },
                        ...(item.type ===
                        this.state.selectedTubingSet.type
                          ? { backgroundColor: item.underlayColor }
                          : {}),
                      }}
                    >
                      <div style={styles.tubingSetTypeContainer}>
                        <span style={item.tubingSetType}>
                          {item.type}
                        </span>
                      </div>
                      <div
                        style={{
                          ...styles.tubingSetTitleContainer,
                          ...{
                            backgroundColor:
                              this.state.selectedNeedleSet &&
                              this.state.selectedNeedleSet.id
                                ? item.color
                                : 'lightgrey',
                          },
                        }}
                      >
                        {/* <span style={styles.tubingSetTitle}>
                          {item.title}
                        </span> */}
                      </div>
                    </div>
                  );
                }
              })}
            </div>
          </div>
        );
      }
    });

    // let listItems = this.state.needleSet.map((item) =>{
    //    return(
    //        <div id={item.id.c1} key={item.id.c1} onClick={() => this.setSelectedNeedleset(item)} style={{...item.needleSetContainer, ...(item.id.ct === this.state.selectedNeedleSet.id.ct ? {backgroundColor: item.selectedNeedleSet} : {})}}>
    //            <div style={item.needleSetSizeTitleContainer}>
    //                <span style={styles.needleSetSizeTitle}>{item.size}</span>
    //            </div>
    //            <div style={{height:60, justifyContent:"center", alignItems:"center"}}>
    //                <img alt={item.size} style={styles.needleImage} src={item.url} />
    //            </div>
    //            <div style={item.needleSetTitleContainer}>
    //                <span style={styles.needleSetTitle}>{item.title}</span>
    //            </div>
    //        </div>
    //    );
    // });

    // let tubingItems = this.state.tubingSet.map((item) => {
    //    return(
    //        <div id={item.type} key={item.type} onClick={(e) => this.setSelectedTubingset(item, e)} style={{...styles.tubingSetContainer, ...{borderColor: item.color}, ...(item.type === this.state.selectedTubingSet.type ? {backgroundColor: item.underlayColor} : {})}}>
    //            <div style={styles.tubingSetTypeContainer}>
    //                <span style={item.tubingSetType}>{item.type}</span>
    //            </div>
    //            <div style={{...styles.tubingSetTitleContainer, ...{backgroundColor: item.color}}}>
    //                <span style={styles.tubingSetTitle}>{item.title}</span>
    //            </div>
    //        </div>
    //    );
    // });

    return (
      <div>
        <div className="row results-screen">
          <div className="col-lg-12" style={styles.wrapper}>
            <div className="row">
              <div className="col-lg-12 col-xs-12 drug-title">
                <h4>
                  <img
                    className="backbutton"
                    src={backIcon}
                    alt="Go Back"
                    onClick={() =>
                      this.props.changePage('RMSSelectDrug')
                    }
                  />{' '}
                  <span className="page-title">Results</span>
                </h4>
                <h4 className="page-title results-sub-hdr">
                  {VersionService.getVersionLabel()}
                </h4>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-8 offset-lg-2 col-xs-12 mb-2 reference-hdr-lg">
                <p>{this.getNotificationDisclaimer()}</p>
              </div>
            </div>
            <div className="row">
              <div className="result-bg"></div>
              <div className="col-lg-5" style={styles.tubingSetCol}>
                <div className="row" style={styles.setDisplayTitle}>
                  <div className="col-lg-12">
                    <span>Select a Needle Set</span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">{listItems}</div>
                </div>
              </div>
              <div className="col-lg-5" style={styles.tubingSetCol}>
                <div className="row" style={styles.setDisplayTitle}>
                  <div className="col-lg-12">
                    <span>Select a Tubing Set</span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">{tubingItems}</div>
                </div>
              </div>
            </div>
            {/*<div>*/}
            {/*{listItems}*/}
            {/*</div>*/}
            {/*<div className="row" style={styles.setDisplayTitle}>*/}
            {/*<div className="col-lg-6">*/}
            {/*<span>TUBING SET</span>*/}
            {/*</div>*/}
            {/*</div>*/}
            {/*<div className="d-flex flex-row" style={styles.tubingRowContainer}>*/}
            {/*{tubingItems}*/}
            {/*</div>*/}
            {this.props.selectedDrug.id == 17 &&
              this.props.version !== 'international' && (
                <div className="row">
                  <div
                    className="col-lg-8"
                    style={styles.resultsBlock}
                  >
                    <div>
                      <span style={styles.offLabel2}>
                        Patients can use F2400 tubing and 2-leg 26G
                        needle (RMS226XX) for the shortest infusion
                        time.<sup>1,2</sup> If a longer infusion time
                        is desired, consider selecting a 1-leg needle
                        or a slower Flow Rate Tubing set.
                      </span>
                    </div>
                    <div>
                      <span style={styles.offLabel}>
                        1. Patients treated with pegcetacoplan in the
                        PEGASUS clinical trial were treated utilizing
                        F2400 tubing and either a 2-leg or 1-leg 26
                        gauge needle set.
                      </span>
                    </div>
                    <div>
                      <span style={styles.offLabel}>
                        2. Hillmen P et al., “Pegcetacoplan versus
                        Eculizumab in Paroxysmal Nocturnal
                        Hemoglobinuria.” N Engl J Med 2021;
                        384:1028-37.
                      </span>
                    </div>
                    <div>
                      <a
                        href="https://pi.apellis.com/files/PI_Empaveli.pdf"
                        style={styles.insertLink}
                      >
                        Package Insert
                      </a>
                    </div>
                  </div>
                </div>
              )}
            <div className="row">
              <div className="col-lg-8" style={styles.resultsBlock}>
                <div
                  className="row"
                  style={{
                    ...styles.setDisplayTitle,
                    ...styles.resultsTitle,
                  }}
                >
                  <div className="col-lg-12">
                    <div>
                      <span>
                        RESULTS FOR {this.props.selectedSyringe.title}{' '}
                        &bull; {this.props.selectedDosage}
                        {this.props.version === 'international'
                          ? 'ml'
                          : 'mL'}
                      </span>
                    </div>
                    <div>
                      <span>
                        {this.props.selectedDrug.title}*&emsp;
                        {this.getLegendText()}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div
                    className="col-lg-12"
                    style={styles.resultValueRow}
                  >
                    <div className="row">
                      <div
                        style={styles.resultValueLabel}
                        className="col-lg-4 col-4"
                      >
                        <span>Time of Delivery</span>
                      </div>
                      <div className="col-lg-4 col-5">
                        <div>{offLabelTod}</div>
                      </div>
                      <div
                        style={
                          offLabelErrorTod
                            ? styles.resultValueOffLabel
                            : styles.resultValue
                        }
                        className="col-lg-4 col-3"
                      >
                        <span>{this.state.tod}</span>
                      </div>
                    </div>
                  </div>
                </div>
                {this.props.selectedDrug.id !== 17 && (
                  <div>
                    <div className="row">
                      <div
                        className="col-lg-12"
                        style={styles.resultValueRow}
                      >
                        <div className="row">
                          <div
                            style={styles.resultValueLabel}
                            className="col-lg-4 col-4"
                          >
                            <span>Total Flow Rate</span>
                          </div>
                          <div className="col-lg-4 col-5">
                            <div>{offLabelTfr}</div>
                            <div>{offLabelDisclaimerTfr}</div>
                          </div>
                          <div
                            style={
                              offLabelErrorTfr
                                ? styles.resultValueOffLabel
                                : styles.resultValue
                            }
                            className="col-lg-4 col-3"
                          >
                            <span>
                              {this.formatNumberForRegion(
                                this.roundValue(this.state.tfr)
                              )}{' '}
                              {this.state.tfr
                                ? `m${
                                    this.props.version ===
                                    'international'
                                      ? 'l'
                                      : 'L'
                                  }/h`
                                : ''}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-lg-12"
                        style={styles.resultValueRow}
                      >
                        <div className="row">
                          <div
                            style={styles.resultValueLabel}
                            className="col-lg-4 col-4"
                          >
                            <span>Flow Rate Per Site</span>
                          </div>
                          <div className="col-lg-4 col-5">
                            <div>{offLabelFrps}</div>
                            <div>{offLabelDisclaimerFrps}</div>
                          </div>
                          <div
                            style={
                              offLabelErrorFrps
                                ? styles.resultValueOffLabel
                                : styles.resultValue
                            }
                            className="col-lg-4 col-3"
                          >
                            <span>
                              {this.formatNumberForRegion(
                                isNaN(this.state.frps)
                                  ? this.state.frps
                                  : this.roundValue(this.state.frps)
                              )}{' '}
                              {this.state.frps
                                ? `m${
                                    this.props.version ===
                                    'international'
                                      ? 'l'
                                      : 'L'
                                  }/h`
                                : ''}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="row">
                  <div
                    className="col-lg-12"
                    style={styles.resultValueRow}
                  >
                    <div className="row">
                      <div
                        style={styles.resultValueLabel}
                        className="col-lg-4 col-4"
                      >
                        <span>Total Volume Per Site</span>
                      </div>
                      <div className="col-lg-4 col-5">
                        <div>{offLabelVol}</div>
                        <div>{offLabelDisclaimerVol}</div>
                      </div>
                      <div
                        style={
                          offLabelErrorVol
                            ? styles.resultValueOffLabel
                            : styles.resultValue
                        }
                        className="col-lg-4 col-3"
                      >
                        <span>
                          {this.formatNumberForRegion(
                            this.roundValue(this.state.tvps)
                          )}{' '}
                          {this.state.tvps
                            ? `m${
                                this.props.version === 'international'
                                  ? 'l'
                                  : 'L'
                              }`
                            : ''}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-12 patientctr">
                    <span className="patientlabel">
                      Enter patient's name:{' '}
                    </span>
                    <input
                      id="patientnameinput"
                      type="text"
                      onKeyUp={(e) => this.setPatientName(e)}
                    />
                    <p style={styles.referenceText}>
                      {this.getReferenceText()}
                    </p>
                  </div>
                </div>
                <div
                  className="row"
                  style={styles.sendPatientButton}
                  onClick={() => this.printPage()}
                >
                  <div className="col-lg-12">
                    <span>Print</span>
                  </div>
                </div>
                <div
                  className="row"
                  style={styles.sendEmailButton}
                  onClick={() => this.sendEmail()}
                >
                  <div className="col-lg-12">
                    <span>Email</span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-8 offset-lg-2 col-xs-12 mt-5 reference-hdr">
                    <p>
                      The calculator is intended for reference only.
                      Always refer to the Instructions for Use for the
                      infusion system and the{' '}
                      {this.props.version !== 'us'
                        ? 'medicinal product'
                        : 'drug'}
                      /biologic prescribing information (PI) prior to
                      using the device.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalCombinationSet
          showModal={() => this.showModal()}
          closeModal={(e) => this.closeModal(e)}
          showModalWindow={this.state.showModalWindow}
          setCombinationSetValue={(e) =>
            this.setCombinationSetValue(e)
          }
        />
        <div className="results-print">
          <span>
            Dear FREEDOM® User,
            <br />
            <br />
            Please find below your configuration:
            <br />
            <br />
            <b>Patient Name: </b> {this.state.patientName}
            <br />
            <b>Syringe Driver:</b> {this.props.selectedSyringe.title}
            <br />
            <b>
              {this.props.version === 'international'
                ? 'Medicinal Product:'
                : 'Drug:'}
            </b>{' '}
            {this.props.selectedDrug.title}
            <br />
            <b>Dosage:</b> {this.props.selectedDosage}m
            {this.props.version === 'international' ? 'l' : 'L'}
            <br />
            <b>Needle Set:</b>{' '}
            {this.state.selectedNeedleSet.title
              ? this.state.selectedNeedleSet.title.replace('\n', ' ')
              : ''}
            , {this.state.selectedNeedleSet.size}
            <br />
            <b>Tubing Set:</b> {this.state.selectedTubingSet.type}
            <br />
            <b>Time of Delivery:</b>{' '}
            {this.calcTOD(this.props.selectedDosage, this.state.tfr)}{' '}
            <br />
            {this.props.selectedDrug.id === 17 ? (
              <React.Fragment>
                <b>Total Flow Rate:</b> Not Applicable
                <br />
              </React.Fragment>
            ) : (
              <React.Fragment>
                <b>Total Flow Rate:</b>{' '}
                {this.formatNumberForRegion(this.state.tfr)} m
                {this.props.version === 'international' ? 'l' : 'L'}/h
                <br />
              </React.Fragment>
            )}
            {this.props.selectedDrug.id === 17 ? (
              <React.Fragment>
                <b>Flow Rate Per Site:</b> Not Applicable
                <br />
              </React.Fragment>
            ) : (
              <React.Fragment>
                <b>Flow Rate Per Site:</b>{' '}
                {this.state.selectedNeedleSet.id
                  ? this.formatNumberForRegion(this.state.frps)
                  : ''}{' '}
                m{this.props.version === 'international' ? 'l' : 'L'}
                /h
                <br />
              </React.Fragment>
            )}
            <b>Total Volume Per Site:</b>{' '}
            {this.state.selectedNeedleSet.id
              ? this.formatNumberForRegion(
                  this.calcTVPS(
                    this.props.selectedDosage,
                    this.state.selectedNeedleSet.id.c2
                  )
                )
              : ''}{' '}
            m{this.props.version === 'international' ? 'l' : 'L'}
          </span>
        </div>
      </div>
    );
  }
}

export default RMSResults;



// WEBPACK FOOTER //
// ./src/RMSResults.js